// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/market/472096920_10160995047266938_7458755462453693494_n.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

 =========================================================
 * Paper Kit React - v1.3.2 based on Paper Kit - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/paper-kit-2
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*      light colors - used for select dropdown         */
/* light colors - used for select dropdown (adjust based on new palette) */
/* ========================================================================
 * bootstrap-switch - v3.3.2
 * http://www.bootstrap-switch.org
 * ========================================================================
 * Copyright 2012-2013 Mattia Larentis
 * http://www.apache.org/licenses/LICENSE-2.0
 */
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 12px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #66615B;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {
  color: #fff;
  background: #1C4922;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {
  color: #fff;
  background: #A38354;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {
  color: #fff;
  background: #1C4922;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {
  background: #A38354;
  color: #fff;
}

.bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,
.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {
  color: #fff;
  background: #F1582C;
}

.bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {
  color: #fff;
  background: #122318;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #FFFFFF;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch input[type=radio].form-control,
.bootstrap-switch input[type=checkbox].form-control {
  height: auto;
}

.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}

.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {
  padding: 6px 16px;
  font-size: 18px;
  line-height: 1.33;
}

.bootstrap-switch.bootstrap-switch-disabled,
.bootstrap-switch.bootstrap-switch-readonly,
.bootstrap-switch.bootstrap-switch-indeterminate {
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,
.bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,
.bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {
  background-color: #66615B;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {
  background-color: #cfcfca;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #F1582C;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #A38354;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #1C4922;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #1C4922;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #A38354;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #122318;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1; /* Fix 401 */
}

.noUi-connect {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
}

.noUi-origin {
  position: absolute;
  height: 0;
  width: 0;
  margin: 0;
  border-radius: 0;
  height: 2px;
  background: #c8c8c8;
}
.noUi-origin[style^="left: 0"] .noUi-handle {
  background-color: #fff;
  border: 2px solid #c8c8c8;
}
.noUi-origin[style^="left: 0"] .noUi-handle.noUi-active {
  border-width: 1px;
}

.noUi-handle {
  position: relative;
  z-index: 1;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Painting and performance;
 * Browsers can paint handles in their own layer.
 */
.noUi-base,
.noUi-handle {
  transform: translate3d(0, 0, 0);
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 2px;
  margin: 15px 0;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

/* Styling;
 */
.noUi-target {
  background: #c8c8c8;
  border-radius: 4px;
}

.noUi-connect {
  background: #3FB8AF;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: w-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: n-resize;
}

.noUi-handle {
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  left: -10px;
  top: -6px;
  cursor: pointer;
  border-radius: 100%;
  transition: all 0.2s ease-out;
  border: 1px solid;
  background: #FFFFFF;
}
.noUi-handle.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

.slider {
  background: #c8c8c8;
}
.slider .noUi-connect {
  background-color: #1C4922;
  border-radius: 4px;
}
.slider .noUi-handle {
  border-color: #1C4922;
}
.slider.slider-info .noUi-connect {
  background-color: #A38354;
}
.slider.slider-info .noUi-handle {
  border-color: #A38354;
}
.slider.slider-success .noUi-connect {
  background-color: #1C4922;
}
.slider.slider-success .noUi-handle {
  border-color: #1C4922;
}
.slider.slider-warning .noUi-connect {
  background-color: #A38354;
}
.slider.slider-warning .noUi-handle {
  border-color: #A38354;
}
.slider.slider-danger .noUi-connect {
  background-color: #F1582C;
}
.slider.slider-danger .noUi-handle {
  border-color: #F1582C;
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.sr-only,
.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after,
.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after,
.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after,
.bootstrap-datetimepicker-widget .btn[data-action=clear]::after,
.bootstrap-datetimepicker-widget .btn[data-action=today]::after,
.bootstrap-datetimepicker-widget .picker-switch::after,
.bootstrap-datetimepicker-widget table th.prev::after,
.bootstrap-datetimepicker-widget table th.next::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}

.bootstrap-datetimepicker-widget a .btn:hover {
  background-color: transparent;
}

.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 4px;
  width: 16em;
}

@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  border-bottom: 11px solid #cfe6ba;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: auto;
  top: -12px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: auto;
  top: -11px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
  margin-bottom: -20px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
  margin-bottom: 5px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}

.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}

.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}

.bootstrap-datetimepicker-widget a[data-action] {
  padding: 6px 0;
  border-width: 0;
  color: #66615B;
  background-color: transparent;
}

.bootstrap-datetimepicker-widget a[data-action=togglePicker],
.bootstrap-datetimepicker-widget a[data-action=togglePicker]:hover {
  color: #429cb6 !important;
}

.bootstrap-datetimepicker-widget a[data-action]:hover {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.85);
}

.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}

.bootstrap-datetimepicker-widget .timepicker-hour,
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-weight: 300;
  font-size: 1.5em;
  margin: 3px;
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget button[data-action] {
  width: 38px;
  height: 38px;
  padding: 0;
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  content: "Increment Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after {
  content: "Increment Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after {
  content: "Decrement Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after {
  content: "Decrement Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after {
  content: "Show Hours";
}

.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after {
  content: "Show Minutes";
}

.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after {
  content: "Toggle AM/PM";
}

.bootstrap-datetimepicker-widget .btn[data-action=clear]::after {
  content: "Clear the picker";
}

.bootstrap-datetimepicker-widget .btn[data-action=today]::after {
  content: "Set the date to today";
}

.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 4px;
}

.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}

.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}

.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 4px;
  margin: 2px 0px !important;
}

.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
}

.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}

.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
}

.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}

.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}

.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}

.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  border-bottom: 1px solid #E3E3E3;
  font-size: 12px;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #E3E3E3;
}

.bootstrap-datetimepicker-widget table td > div {
  border-radius: 4px;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.day > div {
  height: 30px;
  line-height: 31px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  position: relative;
}

.table-condensed .day:hover div {
  transition: all 150ms linear;
}

.bootstrap-datetimepicker-widget table td.minute > div, .bootstrap-datetimepicker-widget table td.hour > div {
  border-radius: 50%;
}

.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #E3E3E3;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #68B3C8;
  color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}

.bootstrap-datetimepicker-widget table td span:hover {
  background: #E3E3E3;
}

.bootstrap-datetimepicker-widget table td span.active {
  background-color: #68B3C8;
  color: #FFFFFF;
}

.bootstrap-datetimepicker-widget table td span.old {
  color: #cfcfca;
}

.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #cfcfca;
  cursor: not-allowed;
}

.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}

.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
  text-align: center;
  z-index: 1;
  cursor: pointer;
}

.bootstrap-datetimepicker-widget {
  opacity: 0;
  transform: translate3d(0px, -10px, 0px);
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
}
.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0px, 0px, 0px);
}
.bootstrap-datetimepicker-widget.open {
  opacity: 1;
  transform: translate3d(0, 5px, 0);
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}

.bootstrap-datetimepicker-widget.open.top {
  transform: translate3d(0, -10px, 0);
}
.bootstrap-datetimepicker-widget.open.top:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -12px;
}
.bootstrap-datetimepicker-widget.open.top:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  bottom: -11px;
}

.btn {
  box-sizing: border-box;
  border-width: 2px;
  font-size: 12px;
  font-weight: 600;
  padding: 0.5rem 18px;
  line-height: 1.75;
  cursor: pointer;
  text-transform: uppercase;
  background-color: #122318;
  border-color: #122318;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
  transition: all 150ms linear;
}
.btn.btn-border, .btn.btn-link {
  background-color: transparent;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .btn:active:focus, .btn:active:hover, .btn.active:focus, .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active, .btn:not(:disabled):not(.disabled).active:focus, .show > .btn.dropdown-toggle {
  background-color: #23452f;
  color: #FFFFFF;
  border-color: #23452f;
  box-shadow: none;
}
.btn .caret {
  border-top-color: #FFFFFF;
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active {
  background-color: #23452f;
  border-color: #23452f;
}
.btn.btn-link {
  color: #122318;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active, .btn.btn-link.active, .btn.btn-link:focus:active, .open > .btn.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #23452f !important;
}
.btn.btn-link .caret {
  border-top-color: #122318;
}
.btn .caret {
  border-top-color: #FFFFFF;
}
.btn:hover, .btn:focus {
  outline: 0 !important;
  box-shadow: none;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn[class*=btn-outline-] {
  background-image: none;
  background-color: transparent;
}
.btn .nc-icon {
  position: relative;
  top: 2px;
}

.btn-just-icon {
  border-radius: 50px;
  height: 40px;
  width: 40px;
  min-width: 40px;
  padding: 8px;
}
.btn-just-icon.btn-sm {
  padding: 4px !important;
}
.btn-just-icon i {
  font-size: 16px;
  padding: 2px 0px;
}

.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -2px;
}

.btn-primary {
  background-color: #1C4922;
  border-color: #1C4922;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle {
  background-color: #112c14;
  color: #FFFFFF;
  border-color: #112c14;
  box-shadow: none;
}
.btn-primary .caret {
  border-top-color: #FFFFFF;
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #112c14;
  border-color: #112c14;
}
.btn-primary.btn-link {
  color: #1C4922;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active, .btn-primary.btn-link.active, .btn-primary.btn-link:focus:active, .open > .btn-primary.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #112c14 !important;
}
.btn-primary.btn-link .caret {
  border-top-color: #1C4922;
}
.btn-primary .caret {
  border-top-color: #FFFFFF;
}

.btn-success {
  background-color: #1C4922;
  border-color: #1C4922;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .btn-success:active:focus, .btn-success:active:hover, .btn-success.active:focus, .btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle {
  background-color: #112c14;
  color: #FFFFFF;
  border-color: #112c14;
  box-shadow: none;
}
.btn-success .caret {
  border-top-color: #FFFFFF;
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #112c14;
  border-color: #112c14;
}
.btn-success.btn-link {
  color: #1C4922;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active, .btn-success.btn-link.active, .btn-success.btn-link:focus:active, .open > .btn-success.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #112c14 !important;
}
.btn-success.btn-link .caret {
  border-top-color: #1C4922;
}
.btn-success .caret {
  border-top-color: #FFFFFF;
}

.btn-info {
  background-color: #A38354;
  border-color: #A38354;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .btn-info:active:focus, .btn-info:active:hover, .btn-info.active:focus, .btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle {
  background-color: #886d46;
  color: #FFFFFF;
  border-color: #886d46;
  box-shadow: none;
}
.btn-info .caret {
  border-top-color: #FFFFFF;
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #886d46;
  border-color: #886d46;
}
.btn-info.btn-link {
  color: #A38354;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active, .btn-info.btn-link.active, .btn-info.btn-link:focus:active, .open > .btn-info.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #886d46 !important;
}
.btn-info.btn-link .caret {
  border-top-color: #A38354;
}
.btn-info .caret {
  border-top-color: #FFFFFF;
}

.btn-warning {
  background-color: #A38354;
  border-color: #A38354;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .btn-warning:active:focus, .btn-warning:active:hover, .btn-warning.active:focus, .btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle {
  background-color: #886d46;
  color: #FFFFFF;
  border-color: #886d46;
  box-shadow: none;
}
.btn-warning .caret {
  border-top-color: #FFFFFF;
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #886d46;
  border-color: #886d46;
}
.btn-warning.btn-link {
  color: #A38354;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active, .btn-warning.btn-link.active, .btn-warning.btn-link:focus:active, .open > .btn-warning.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #886d46 !important;
}
.btn-warning.btn-link .caret {
  border-top-color: #A38354;
}
.btn-warning .caret {
  border-top-color: #FFFFFF;
}

.btn-danger {
  background-color: #F1582C;
  border-color: #F1582C;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .btn-danger:active:focus, .btn-danger:active:hover, .btn-danger.active:focus, .btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle {
  background-color: #e53f0f;
  color: #FFFFFF;
  border-color: #e53f0f;
  box-shadow: none;
}
.btn-danger .caret {
  border-top-color: #FFFFFF;
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #e53f0f;
  border-color: #e53f0f;
}
.btn-danger.btn-link {
  color: #F1582C;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active, .btn-danger.btn-link.active, .btn-danger.btn-link:focus:active, .open > .btn-danger.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #e53f0f !important;
}
.btn-danger.btn-link .caret {
  border-top-color: #F1582C;
}
.btn-danger .caret {
  border-top-color: #FFFFFF;
}

.btn-neutral {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle {
  background-color: #23452f;
  color: #FFFFFF;
  border-color: #23452f;
  box-shadow: none;
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #23452f;
  border-color: #23452f;
}
.btn-neutral.btn-link {
  color: #FFFFFF;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active, .btn-neutral.btn-link.active, .btn-neutral.btn-link:focus:active, .open > .btn-neutral.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #23452f !important;
}
.btn-neutral.btn-link .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}

.btn-outline-default {
  border-color: #122318;
  color: #122318;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-default:hover, .btn-outline-default:focus, .btn-outline-default:active, .btn-outline-default.active, .btn-outline-default:active:focus, .btn-outline-default:active:hover, .btn-outline-default.active:focus, .show > .btn-outline-default.dropdown-toggle {
  background-color: #122318 !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #122318 !important;
}
.btn-outline-default:hover .caret, .btn-outline-default:focus .caret, .btn-outline-default:active .caret, .btn-outline-default.active .caret, .btn-outline-default:active:focus .caret, .btn-outline-default:active:hover .caret, .btn-outline-default.active:focus .caret, .show > .btn-outline-default.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-default .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-default.disabled, .btn-outline-default.disabled:hover, .btn-outline-default.disabled:focus, .btn-outline-default.disabled.focus, .btn-outline-default.disabled:active, .btn-outline-default.disabled.active, .btn-outline-default:disabled, .btn-outline-default:disabled:hover, .btn-outline-default:disabled:focus, .btn-outline-default:disabled.focus, .btn-outline-default:disabled:active, .btn-outline-default:disabled.active, .btn-outline-default[disabled], .btn-outline-default[disabled]:hover, .btn-outline-default[disabled]:focus, .btn-outline-default[disabled].focus, .btn-outline-default[disabled]:active, .btn-outline-default[disabled].active, fieldset[disabled] .btn-outline-default, fieldset[disabled] .btn-outline-default:hover, fieldset[disabled] .btn-outline-default:focus, fieldset[disabled] .btn-outline-default.focus, fieldset[disabled] .btn-outline-default:active, fieldset[disabled] .btn-outline-default.active {
  background-color: transparent;
  border-color: #122318;
}

.btn-outline-primary {
  border-color: #1C4922;
  color: #1C4922;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary:active:focus, .btn-outline-primary:active:hover, .btn-outline-primary.active:focus, .show > .btn-outline-primary.dropdown-toggle {
  background-color: #1C4922 !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #1C4922 !important;
}
.btn-outline-primary:hover .caret, .btn-outline-primary:focus .caret, .btn-outline-primary:active .caret, .btn-outline-primary.active .caret, .btn-outline-primary:active:focus .caret, .btn-outline-primary:active:hover .caret, .btn-outline-primary.active:focus .caret, .show > .btn-outline-primary.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-primary .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-primary.disabled, .btn-outline-primary.disabled:hover, .btn-outline-primary.disabled:focus, .btn-outline-primary.disabled.focus, .btn-outline-primary.disabled:active, .btn-outline-primary.disabled.active, .btn-outline-primary:disabled, .btn-outline-primary:disabled:hover, .btn-outline-primary:disabled:focus, .btn-outline-primary:disabled.focus, .btn-outline-primary:disabled:active, .btn-outline-primary:disabled.active, .btn-outline-primary[disabled], .btn-outline-primary[disabled]:hover, .btn-outline-primary[disabled]:focus, .btn-outline-primary[disabled].focus, .btn-outline-primary[disabled]:active, .btn-outline-primary[disabled].active, fieldset[disabled] .btn-outline-primary, fieldset[disabled] .btn-outline-primary:hover, fieldset[disabled] .btn-outline-primary:focus, fieldset[disabled] .btn-outline-primary.focus, fieldset[disabled] .btn-outline-primary:active, fieldset[disabled] .btn-outline-primary.active {
  background-color: transparent;
  border-color: #1C4922;
}

.btn-outline-success {
  border-color: #1C4922;
  color: #1C4922;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success:active:focus, .btn-outline-success:active:hover, .btn-outline-success.active:focus, .show > .btn-outline-success.dropdown-toggle {
  background-color: #1C4922 !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #1C4922 !important;
}
.btn-outline-success:hover .caret, .btn-outline-success:focus .caret, .btn-outline-success:active .caret, .btn-outline-success.active .caret, .btn-outline-success:active:focus .caret, .btn-outline-success:active:hover .caret, .btn-outline-success.active:focus .caret, .show > .btn-outline-success.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-success .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-success.disabled, .btn-outline-success.disabled:hover, .btn-outline-success.disabled:focus, .btn-outline-success.disabled.focus, .btn-outline-success.disabled:active, .btn-outline-success.disabled.active, .btn-outline-success:disabled, .btn-outline-success:disabled:hover, .btn-outline-success:disabled:focus, .btn-outline-success:disabled.focus, .btn-outline-success:disabled:active, .btn-outline-success:disabled.active, .btn-outline-success[disabled], .btn-outline-success[disabled]:hover, .btn-outline-success[disabled]:focus, .btn-outline-success[disabled].focus, .btn-outline-success[disabled]:active, .btn-outline-success[disabled].active, fieldset[disabled] .btn-outline-success, fieldset[disabled] .btn-outline-success:hover, fieldset[disabled] .btn-outline-success:focus, fieldset[disabled] .btn-outline-success.focus, fieldset[disabled] .btn-outline-success:active, fieldset[disabled] .btn-outline-success.active {
  background-color: transparent;
  border-color: #1C4922;
}

.btn-outline-info {
  border-color: #A38354;
  color: #A38354;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info:active:focus, .btn-outline-info:active:hover, .btn-outline-info.active:focus, .show > .btn-outline-info.dropdown-toggle {
  background-color: #A38354 !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #A38354 !important;
}
.btn-outline-info:hover .caret, .btn-outline-info:focus .caret, .btn-outline-info:active .caret, .btn-outline-info.active .caret, .btn-outline-info:active:focus .caret, .btn-outline-info:active:hover .caret, .btn-outline-info.active:focus .caret, .show > .btn-outline-info.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-info .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-info.disabled, .btn-outline-info.disabled:hover, .btn-outline-info.disabled:focus, .btn-outline-info.disabled.focus, .btn-outline-info.disabled:active, .btn-outline-info.disabled.active, .btn-outline-info:disabled, .btn-outline-info:disabled:hover, .btn-outline-info:disabled:focus, .btn-outline-info:disabled.focus, .btn-outline-info:disabled:active, .btn-outline-info:disabled.active, .btn-outline-info[disabled], .btn-outline-info[disabled]:hover, .btn-outline-info[disabled]:focus, .btn-outline-info[disabled].focus, .btn-outline-info[disabled]:active, .btn-outline-info[disabled].active, fieldset[disabled] .btn-outline-info, fieldset[disabled] .btn-outline-info:hover, fieldset[disabled] .btn-outline-info:focus, fieldset[disabled] .btn-outline-info.focus, fieldset[disabled] .btn-outline-info:active, fieldset[disabled] .btn-outline-info.active {
  background-color: transparent;
  border-color: #A38354;
}

.btn-outline-warning {
  border-color: #A38354;
  color: #A38354;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning:active:focus, .btn-outline-warning:active:hover, .btn-outline-warning.active:focus, .show > .btn-outline-warning.dropdown-toggle {
  background-color: #A38354 !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #A38354 !important;
}
.btn-outline-warning:hover .caret, .btn-outline-warning:focus .caret, .btn-outline-warning:active .caret, .btn-outline-warning.active .caret, .btn-outline-warning:active:focus .caret, .btn-outline-warning:active:hover .caret, .btn-outline-warning.active:focus .caret, .show > .btn-outline-warning.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-warning .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-warning.disabled, .btn-outline-warning.disabled:hover, .btn-outline-warning.disabled:focus, .btn-outline-warning.disabled.focus, .btn-outline-warning.disabled:active, .btn-outline-warning.disabled.active, .btn-outline-warning:disabled, .btn-outline-warning:disabled:hover, .btn-outline-warning:disabled:focus, .btn-outline-warning:disabled.focus, .btn-outline-warning:disabled:active, .btn-outline-warning:disabled.active, .btn-outline-warning[disabled], .btn-outline-warning[disabled]:hover, .btn-outline-warning[disabled]:focus, .btn-outline-warning[disabled].focus, .btn-outline-warning[disabled]:active, .btn-outline-warning[disabled].active, fieldset[disabled] .btn-outline-warning, fieldset[disabled] .btn-outline-warning:hover, fieldset[disabled] .btn-outline-warning:focus, fieldset[disabled] .btn-outline-warning.focus, fieldset[disabled] .btn-outline-warning:active, fieldset[disabled] .btn-outline-warning.active {
  background-color: transparent;
  border-color: #A38354;
}

.btn-outline-danger {
  border-color: #F1582C;
  color: #F1582C;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger:active:focus, .btn-outline-danger:active:hover, .btn-outline-danger.active:focus, .show > .btn-outline-danger.dropdown-toggle {
  background-color: #F1582C !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #F1582C !important;
}
.btn-outline-danger:hover .caret, .btn-outline-danger:focus .caret, .btn-outline-danger:active .caret, .btn-outline-danger.active .caret, .btn-outline-danger:active:focus .caret, .btn-outline-danger:active:hover .caret, .btn-outline-danger.active:focus .caret, .show > .btn-outline-danger.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-danger .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-danger.disabled, .btn-outline-danger.disabled:hover, .btn-outline-danger.disabled:focus, .btn-outline-danger.disabled.focus, .btn-outline-danger.disabled:active, .btn-outline-danger.disabled.active, .btn-outline-danger:disabled, .btn-outline-danger:disabled:hover, .btn-outline-danger:disabled:focus, .btn-outline-danger:disabled.focus, .btn-outline-danger:disabled:active, .btn-outline-danger:disabled.active, .btn-outline-danger[disabled], .btn-outline-danger[disabled]:hover, .btn-outline-danger[disabled]:focus, .btn-outline-danger[disabled].focus, .btn-outline-danger[disabled]:active, .btn-outline-danger[disabled].active, fieldset[disabled] .btn-outline-danger, fieldset[disabled] .btn-outline-danger:hover, fieldset[disabled] .btn-outline-danger:focus, fieldset[disabled] .btn-outline-danger.focus, fieldset[disabled] .btn-outline-danger:active, fieldset[disabled] .btn-outline-danger.active {
  background-color: transparent;
  border-color: #F1582C;
}

.btn-outline-neutral {
  border-color: #FFFFFF;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-outline-neutral:hover, .btn-outline-neutral:focus, .btn-outline-neutral:active, .btn-outline-neutral.active, .btn-outline-neutral:active:focus, .btn-outline-neutral:active:hover, .btn-outline-neutral.active:focus, .show > .btn-outline-neutral.dropdown-toggle {
  background-color: #FFFFFF !important;
  color: rgba(255, 255, 255, 0.8);
  border-color: #FFFFFF !important;
}
.btn-outline-neutral:hover .caret, .btn-outline-neutral:focus .caret, .btn-outline-neutral:active .caret, .btn-outline-neutral.active .caret, .btn-outline-neutral:active:focus .caret, .btn-outline-neutral:active:hover .caret, .btn-outline-neutral.active:focus .caret, .show > .btn-outline-neutral.dropdown-toggle .caret {
  border-top-color: rgba(255, 255, 255, 0.8);
}
.btn-outline-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-outline-neutral.disabled, .btn-outline-neutral.disabled:hover, .btn-outline-neutral.disabled:focus, .btn-outline-neutral.disabled.focus, .btn-outline-neutral.disabled:active, .btn-outline-neutral.disabled.active, .btn-outline-neutral:disabled, .btn-outline-neutral:disabled:hover, .btn-outline-neutral:disabled:focus, .btn-outline-neutral:disabled.focus, .btn-outline-neutral:disabled:active, .btn-outline-neutral:disabled.active, .btn-outline-neutral[disabled], .btn-outline-neutral[disabled]:hover, .btn-outline-neutral[disabled]:focus, .btn-outline-neutral[disabled].focus, .btn-outline-neutral[disabled]:active, .btn-outline-neutral[disabled].active, fieldset[disabled] .btn-outline-neutral, fieldset[disabled] .btn-outline-neutral:hover, fieldset[disabled] .btn-outline-neutral:focus, fieldset[disabled] .btn-outline-neutral.focus, fieldset[disabled] .btn-outline-neutral:active, fieldset[disabled] .btn-outline-neutral.active {
  background-color: transparent;
  border-color: #FFFFFF;
}
.btn-outline-neutral:hover, .btn-outline-neutral:focus, .btn-outline-neutral:active {
  color: #23452f !important;
  background-color: #FFFFFF;
}

.btn-neutral {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
  color: #122318;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle {
  background-color: #FFFFFF;
  color: #FFFFFF;
  border-color: #FFFFFF;
  box-shadow: none;
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.btn-link {
  color: #FFFFFF;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active, .btn-neutral.btn-link.active, .btn-neutral.btn-link:focus:active, .open > .btn-neutral.btn-link.dropdown-toggle {
  background-color: transparent !important;
  color: #FFFFFF !important;
}
.btn-neutral.btn-link .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active {
  color: #23452f !important;
}
.btn-neutral.btn-border:hover, .btn-neutral.btn-border:focus {
  color: #122318;
}
.btn-neutral.btn-border:active, .btn-neutral.btn-border.active, .open > .btn-neutral.btn-border.dropdown-toggle {
  background-color: #FFFFFF;
  color: #122318;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active {
  color: #FFFFFF !important;
}
.btn-neutral.btn-link:focus:active {
  color: #23452f !important;
}
.btn-neutral.btn-link:active, .btn-neutral.btn-link.active {
  background-color: transparent;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.btn-link {
  border-color: transparent !important;
  padding: 7px 18px;
}
.btn-link:hover, .btn-link:focus, .btn-link:active {
  text-decoration: none;
  border-color: transparent;
}
.btn-link.btn-icon {
  padding: 7px;
}

.btn-lg {
  font-size: 14px;
  padding: 11px 30px;
}
.btn-lg.btn-simple {
  padding: 13px 30px;
}

.btn-sm {
  font-size: 12px;
  padding: 4px 10px;
}
.btn-sm.btn-simple {
  padding: 6px 10px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-just-icon.btn-sm {
  height: 30px;
  width: 30px;
  min-width: 30px;
  padding: 0;
}
.btn-just-icon.btn-sm i {
  font-size: 12px;
  top: 1px !important;
}
.btn-just-icon.btn-lg {
  height: 50px;
  width: 50px;
  min-width: 50px;
  padding: 13px;
}
.btn-just-icon.btn-lg i {
  font-size: 18px;
  padding: 0;
}
.btn-just-icon.btn-link {
  padding: 8px !important;
}

.btn-round {
  border-radius: 30px;
}

.btn.btn-link:focus {
  box-shadow: none !important;
  text-decoration: none;
}

.column .btn-link {
  padding: 7px 0;
}

.share-buttons .btn-outline-default {
  margin-top: 24px;
}

.btn-group.select {
  overflow: visible !important;
}

.media .media-body .media-footer .btn-neutral {
  margin: 15px 3px;
  font-size: 14px;
}
.media .media-body .media-footer .btn-neutral i {
  margin-right: 0 !important;
}

::-moz-placeholder {
  color: #9A9A9A;
}

:-ms-input-placeholder {
  color: #9A9A9A;
}

::-webkit-input-placeholder {
  color: #9A9A9A;
}

.form-control:focus + .input-group-text {
  border: 1px solid black;
}

.form-control {
  background-color: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  color: #122318;
  font-size: 14px;
  transition: background-color 0.3s ease 0s;
  padding-right: 0 !important;
  padding: 7px 12px;
  height: 40px;
  box-shadow: none;
}
.form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #ccc;
  box-shadow: none;
  outline: 0 !important;
}
.form-control:focus + .input-group-prepend .input-group-text,
.form-control:focus + .input-group-append .input-group-text {
  border: 1px solid #ccc;
  border-left: none;
}
.form-control.no-border {
  border: medium none !important;
}
.form-control.no-border:focus + .input-group-prepend .input-group-text,
.form-control.no-border:focus + .input-group-append .input-group-text {
  border: none;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-success .form-control {
  border: 1px solid #ccc;
  color: #122318;
}
.has-success .form-control.form-control-success {
  padding-right: 2.5em !important;
}
.has-success .form-control:focus {
  border: 1px solid #1C4922;
  color: #1C4922;
}
.has-danger .form-control {
  background-color: #fcdcd3;
  border: 1px solid #F1582C;
  color: #F1582C;
}
.has-danger .form-control.form-control-danger {
  padding-right: 2.5em !important;
}
.has-danger .form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #F1582C;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 14px;
  color: #F1582C;
  font-size: 0.8rem;
  position: absolute;
  top: 100%;
  padding-left: 12px;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 4px 4px 0 0;
  border-bottom-color: transparent;
}
.form-control.form-control-lg {
  height: 55px;
  padding: 11px 13px;
  font-size: 1.25rem;
  line-height: 1.5;
}
.form-control.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  height: 31px;
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #F1582C;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #1C4922;
}

.input-group-prepend + .form-control {
  margin-left: -1px;
  border-left: none;
}

.form-control + .input-group-append .input-group-text {
  border-right: 1px solid #ddd;
}

.input-group > .custom-select:not(:last-child),
.input-group > .form-control:not(:last-child) {
  border-right: none;
}

.input-group-text {
  background-color: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #ddd;
  border-right: none;
}
.has-success .input-group-text, .has-error .input-group-text {
  background-color: #FFFFFF;
}
.has-error .form-control:focus + .input-group-text {
  color: #F1582C;
}
.has-success .form-control:focus + .input-group-text {
  color: #1C4922;
}
.form-control:focus + .input-group-text, .form-control:focus ~ .input-group-text {
  background-color: #FFFFFF;
}

.input-group.no-border .input-group-text {
  border: 0;
}

textarea.form-control {
  padding: 10px 18px;
  height: auto;
}

.form-group {
  position: relative;
}

.register-form .form-control {
  border: 1px solid transparent !important;
}
.register-form .input-group .form-control {
  margin-left: -1px;
}
.register-form .input-group-prepend,
.register-form .input-group-append {
  border: 1px solid transparent !important;
}

#inputs .input-group {
  margin-bottom: 1rem;
}

.card-form-horizontal .card-body .form-group {
  margin-bottom: 0;
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check {
  padding-left: 0;
  margin-bottom: 0.5rem;
}
.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 24px;
  height: 24px;
  left: 0;
  cursor: pointer;
  border-radius: 6px;
  top: 0;
  background-color: #AAA7A4;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f00c";
  top: -1px;
  text-align: center;
  font-size: 15px;
  opacity: 0;
  color: #FFF;
  border: 0;
  background-color: inherit;
}
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.form-check-radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check .form-check-label input[type=checkbox]:disabled + .form-check-sign,
.form-check-radio input[type=radio]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check-radio {
  margin-left: -3px;
}
.form-check-radio .form-check-label {
  padding-left: 2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "FontAwesome";
  content: "\\f10c";
  font-size: 22px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 5px;
  top: -5px;
}

.form-check-label input[type=checkbox]:checked + .form-check-sign:before {
  background-color: #66615B;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f192";
  top: -5px;
  position: absolute;
  left: 5px;
  opacity: 1;
  font-size: 22px;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.progress {
  background-color: #DDDDDD;
  border-radius: 3px;
  box-shadow: none;
  height: 8px;
}

.progress-thin {
  height: 4px;
}

.progress-bar {
  background-color: #1C4922;
}

.progress-bar-primary {
  background-color: #1C4922;
}

.progress-bar-info {
  background-color: #A38354;
}

.progress-bar-success {
  background-color: #1C4922;
}

.progress-bar-warning {
  background-color: #A38354;
}

.progress-bar-danger {
  background-color: #F1582C;
}

/*           badges & Progress-bar              */
.badge {
  padding: 0.4em 0.9em;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 0.75em;
  text-transform: uppercase;
  display: inline-block;
  margin-bottom: 3px;
  padding-top: 5px;
}
.badge:focus {
  outline: none;
}
.badge span[data-role=remove]:focus {
  outline: none;
}

.badge-primary {
  background-color: #1C4922;
}

.badge-info {
  background-color: #A38354;
}

.badge-success {
  background-color: #1C4922;
}

.badge-warning {
  background-color: #A38354;
}

.badge-danger {
  background-color: #F1582C;
}

.badge-default {
  background-color: #122318;
}

.pagination > li > a,
.pagination > li > span,
.pagination > li:first-child > a,
.pagination > li:first-child > span,
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  background-color: transparent;
  border: 2px solid #F1582C;
  border-radius: 20px;
  color: #F1582C;
  height: 36px;
  margin: 0 2px;
  min-width: 36px;
  padding: 8px 12px;
  font-weight: 600;
}

.nav-pills-default > li > a,
.pagination > li > a:hover,
.pagination > li > a:focus,
.pagination > li > a:active,
.pagination > li.active > a,
.pagination > li.active > span,
.pagination > li.active > a:hover,
.pagination > li.active > span:hover,
.pagination > li.active > a:focus,
.pagination > li.active > span:focus {
  background-color: #122318;
  border-color: #122318;
  color: #FFFFFF;
}

.nav-pills-primary > li > a,
.pagination-primary > li > a,
.pagination-primary > li > span,
.pagination-primary > li:first-child > a,
.pagination-primary > li:first-child > span,
.pagination-primary > li:last-child > a,
.pagination-primary > li:last-child > span {
  border: 2px solid #1C4922;
  color: #1C4922;
}

.nav-pills-primary > li.active > a,
.nav-pills-primary > li.active > a:hover,
.nav-pills-primary > li.active > a:focus,
.pagination-primary > li > a:hover,
.pagination-primary > li > a:focus,
.pagination-primary > li > a:active,
.pagination-primary > li.active > a,
.pagination-primary > li.active > span,
.pagination-primary > li.active > a:hover,
.pagination-primary > li.active > span:hover,
.pagination-primary > li.active > a:focus,
.pagination-primary > li.active > span:focus {
  background-color: #1C4922 !important;
  border-color: #1C4922 !important;
  color: #FFFFFF;
}

.nav-pills-info > li > a,
.pagination-info > li > a,
.pagination-info > li > span,
.pagination-info > li:first-child > a,
.pagination-info > li:first-child > span,
.pagination-info > li:last-child > a,
.pagination-info > li:last-child > span {
  border: 2px solid #A38354;
  color: #A38354;
}

.nav-pills-info > li.active > a,
.nav-pills-info > li.active > a:hover,
.nav-pills-info > li.active > a:focus,
.pagination-info > li > a:hover,
.pagination-info > li > a:focus,
.pagination-info > li > a:active,
.pagination-info > li.active > a,
.pagination-info > li.active > span,
.pagination-info > li.active > a:hover,
.pagination-info > li.active > span:hover,
.pagination-info > li.active > a:focus,
.pagination-info > li.active > span:focus {
  background-color: #A38354 !important;
  border-color: #A38354 !important;
  color: #FFFFFF;
}

.nav-pills-success > li > a,
.pagination-success > li > a,
.pagination-success > li > span,
.pagination-success > li:first-child > a,
.pagination-success > li:first-child > span,
.pagination-success > li:last-child > a,
.pagination-success > li:last-child > span {
  border: 2px solid #1C4922;
  color: #1C4922;
}

.nav-pills-success > li.active > a,
.nav-pills-success > li.active > a:hover,
.nav-pills-success > li.active > a:focus,
.pagination-success > li > a:hover,
.pagination-success > li > a:focus,
.pagination-success > li > a:active,
.pagination-success > li.active > a,
.pagination-success > li.active > span,
.pagination-success > li.active > a:hover,
.pagination-success > li.active > span:hover,
.pagination-success > li.active > a:focus,
.pagination-success > li.active > span:focus {
  background-color: #1C4922 !important;
  border-color: #1C4922 !important;
  color: #FFFFFF;
}

.nav-pills-warning > li > a,
.pagination-warning > li > a,
.pagination-warning > li > span,
.pagination-warning > li:first-child > a,
.pagination-warning > li:first-child > span,
.pagination-warning > li:last-child > a,
.pagination-warning > li:last-child > span {
  border: 2px solid #A38354;
  color: #A38354;
}

.nav-pills-warning > li.active > a,
.nav-pills-warning > li.active > a:hover,
.nav-pills-warning > li.active > a:focus,
.pagination-warning > li > a:hover,
.pagination-warning > li > a:focus,
.pagination-warning > li > a:active,
.pagination-warning > li.active > a,
.pagination-warning > li.active > span,
.pagination-warning > li.active > a:hover,
.pagination-warning > li.active > span:hover,
.pagination-warning > li.active > a:focus,
.pagination-warning > li.active > span:focus {
  background-color: #A38354 !important;
  border-color: #A38354 !important;
  color: #FFFFFF;
}

.nav-pills-danger > li > a,
.pagination-danger > li > a,
.pagination-danger > li > span,
.pagination-danger > li:first-child > a,
.pagination-danger > li:first-child > span,
.pagination-danger > li:last-child > a,
.pagination-danger > li:last-child > span {
  border: 2px solid #F1582C;
  color: #F1582C;
}

.nav-pills-danger > li.active > a,
.nav-pills-danger > li.active > a:hover,
.nav-pills-danger > li.active > a:focus,
.pagination-danger > li > a:hover,
.pagination-danger > li > a:focus,
.pagination-danger > li > a:active,
.pagination-danger > li.active > a,
.pagination-danger > li.active > span,
.pagination-danger > li.active > a:hover,
.pagination-danger > li.active > span:hover,
.pagination-danger > li.active > a:focus,
.pagination-danger > li.active > span:focus {
  background-color: #F1582C !important;
  border-color: #F1582C !important;
  color: #FFFFFF;
}

.nav-text, .nav-icons {
  margin: 0 0 10px 0;
}
.nav-text > li > a, .nav-icons > li > a {
  display: block;
  padding: 0px 18px;
  color: #9A9A9A;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text > li > a:hover, .nav-text > li > a:focus, .nav-icons > li > a:hover, .nav-icons > li > a:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text > li:first-child a, .nav-icons > li:first-child a {
  padding-left: 0;
}
.nav-text > li.active a, .nav-icons > li.active a {
  color: #A38354;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.6em;
  margin-bottom: 10px;
  width: 1.6em;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #1C4922;
}

.nav-azure > li.active a {
  color: #A38354;
}

.nav-green > li.active a {
  color: #1C4922;
}

.nav-orange > li.active a {
  color: #A38354;
}

.nav-red > li.active a {
  color: #F1582C;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 0.9em;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 500;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.page-item:first-child .page-link,
.page-item:last-child .page-link {
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
}

.nav-pills-default .nav-item.show .nav-link,
.nav-pills-default .nav-link.active {
  background-color: #122318 !important;
}

.nav-pills-primary .nav-item.show .nav-link,
.nav-pills-primary .nav-link.active {
  background-color: #1C4922 !important;
}

.nav-pills-info .nav-item.show .nav-link,
.nav-pills-info .nav-link.active {
  background-color: #A38354 !important;
}

.nav-pills-warning .nav-item.show .nav-link,
.nav-pills-warning .nav-link.active {
  background-color: #A38354 !important;
}

.nav-pills-success .nav-item.show .nav-link,
.nav-pills-success .nav-link.active {
  background-color: #1C4922 !important;
}

.nav-pills-danger .nav-item.show .nav-link,
.nav-pills-danger .nav-link.active {
  background-color: #F1582C !important;
}

.pagination > li > a:hover,
.pagination > li > a:focus,
.pagination > li > a:active,
.pagination > li.active > a,
.pagination > li.active > span,
.pagination > li.active > a:hover,
.pagination > li.active > span:hover,
.pagination > li.active > a:focus,
.pagination > li.active > span:focus {
  background-color: #F1582C;
  border-color: #F1582C;
  color: #FFFFFF;
}

.page-item.active .page-link {
  background-color: #F1582C;
  color: white;
  border-color: #F1582C;
}

.nav-pills .nav-link {
  border-radius: 0;
}

.pagination .page-link {
  box-shadow: none;
}

/*           Font Smoothing      */
h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, p, .navbar, .brand, a, .td-name, td, button, input, select, textarea {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: "Montserrat", "Helvetica", Arial, sans-serif;
  font-weight: 300;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4 {
  margin: 30px 0 0;
}

h1, .h1 {
  font-size: 3.6em;
}

h2, .h2 {
  font-size: 2.8em;
}

h3, .h3 {
  font-size: 1.825em;
  line-height: 1.4;
  margin: 20px 0 0px;
}

h4, .h4 {
  font-size: 1.6em;
  line-height: 1.2em;
}

h5, .h5 {
  font-size: 1.35em;
  line-height: 1.4em;
}

h6, .h6 {
  font-size: 0.9em;
  font-weight: 600;
  text-transform: uppercase;
  line-height: 1.5em;
}

p {
  font-size: 15px;
  line-height: 1.5em;
  margin-bottom: 5px;
}

h1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {
  color: #9A9A9A;
  line-height: 1.5em;
}

h1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {
  font-size: 60%;
}

.title,
.card-title,
.info-title,
.footer-brand,
.footer-big h5,
.footer-big h4,
.media .media-heading {
  font-family: "Montserrat", "Helvetica", Arial, sans-serif;
}
.title,
.title a,
.card-title,
.card-title a,
.info-title,
.info-title a,
.footer-brand,
.footer-brand a,
.footer-big h5,
.footer-big h5 a,
.footer-big h4,
.footer-big h4 a,
.media .media-heading,
.media .media-heading a {
  color: #333333;
  text-decoration: none;
}

.title-uppercase {
  text-transform: uppercase;
}

.description {
  color: #9A9A9A;
}

blockquote small {
  font-style: normal;
}

.text-muted {
  color: #DDDDDD;
}

.text-primary, .text-primary:hover {
  color: #1C4922 !important;
}

.text-info, .text-info:hover {
  color: #A38354 !important;
}

.text-success, .text-success:hover {
  color: #1C4922 !important;
}

.text-warning, .text-warning:hover {
  color: #A38354 !important;
}

.text-danger, .text-danger:hover {
  color: #F1582C !important;
}

.glyphicon {
  line-height: 1;
}

.heart {
  color: #EB5E28;
  animation: heathing 1s ease infinite;
}

@keyframes heathing {
  0% {
    transform: scale(0.75);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.75);
  }
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(0.75);
  }
}
.footer .credits,
.footer-nav {
  line-height: 85px;
}

.footer .btn {
  margin-bottom: 0;
}

.blockquote {
  border-left: 0 none;
  border-bottom: 1px solid #CCC5B9;
  border-top: 1px solid #CCC5B9;
  font-weight: 300;
  margin: 15px 0 10px;
  text-align: center;
}

.title {
  margin-top: 30px;
  margin-bottom: 25px;
  min-height: 32px;
}

.title.text-center {
  margin-bottom: 50px;
}

/*     General overwrite     */
body {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat", "Helvetica", Arial, sans-serif;
}

a {
  color: #A38354;
}
a:hover, a:focus {
  color: #886d46;
  text-decoration: none;
}

hr {
  border-color: #cfe6ba;
}

.icon {
  fill: #122318;
}

.fa-base {
  font-size: 1.25em !important;
}

a:focus, a:active,
button::-moz-focus-inner,
input[type=reset]::-moz-focus-inner,
input[type=button]::-moz-focus-inner,
input[type=submit]::-moz-focus-inner,
select::-moz-focus-inner,
input[type=file] > input[type=button]::-moz-focus-inner {
  outline: 0;
}

.ui-slider-handle:focus,
.navbar-toggle {
  outline: 0 !important;
}

/*           Animations              */
.form-control,
.input-group-addon,
.tagsinput,
.navbar,
.navbar .alert,
.carousel-control.right,
.carousel-control.left {
  transition: all 300ms linear;
}

.tagsinput .tag,
.tagsinput-remove-link,
.filter,
.btn-hover,
[data-toggle=collapse] i,
.animation-transition-fast,
.dropdown-menu .dropdown-item {
  transition: all 150ms linear;
}

.btn-morphing .fa,
.btn-morphing .circle,
.gsdk-collapse {
  transition: all 300ms linear;
}

.fa {
  width: 18px;
  text-align: center;
}

.margin-top {
  margin-top: 50px;
}

.iframe-container iframe {
  box-shadow: 0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

/*       CT colors          */
.ct-blue {
  color: #1C4922;
}

.ct-azure {
  color: #A38354;
}

.ct-green {
  color: #1C4922;
}

.ct-orange {
  color: #A38354;
}

.ct-red {
  color: #F1582C;
}

.pagination .page-item .page-link .fa {
  width: auto;
  font-weight: 600;
}

.bg-primary {
  background-color: #26632e !important;
}

.bg-info {
  background-color: #c0a784 !important;
}

.bg-success {
  background-color: #26632e !important;
}

.bg-warning {
  background-color: #c0a784 !important;
}

.bg-danger {
  background-color: #f3724d !important;
}

.wrapper {
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  left: 0;
  background-color: #FFFFFF;
  position: relative;
  z-index: 1;
}

.heart {
  color: #EB5E28;
  animation: heathing 1s ease infinite;
}

@keyframes heathing {
  0% {
    transform: scale(0.75);
  }
  20% {
    transform: scale(1);
  }
  40% {
    transform: scale(0.75);
  }
  60% {
    transform: scale(1);
  }
  80% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(0.75);
  }
}
.bd-docs .page-header {
  min-height: 50vh;
}

.offline-doc .navbar.navbar-transparent {
  padding-top: 25px;
  border-bottom: none;
}
.offline-doc .navbar.navbar-transparent .navbar-minimize {
  display: none;
}
.offline-doc .navbar.navbar-transparent .navbar-brand,
.offline-doc .navbar.navbar-transparent .collapse .navbar-nav .nav-link {
  color: #FFFFFF !important;
}
.offline-doc .footer {
  position: absolute;
  width: 100%;
  background: transparent;
  bottom: 0;
  z-index: 3;
}
.offline-doc .footer nav > ul a:not(.btn),
.offline-doc .footer .copyright {
  color: #FFFFFF !important;
}
.offline-doc .page-header .page-header-image {
  position: absolute;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.offline-doc .page-header .container {
  z-index: 3;
}
.offline-doc .page-header:after {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.main .section:first-of-type {
  position: relative;
  z-index: 2;
}

/*           Labels & Progress-bar              */
.label {
  padding: 0.2em 0.6em;
  border-radius: 10px;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 0.75em;
  text-transform: uppercase;
  display: inline-block;
  margin-bottom: 3px;
  line-height: 17px;
}

.label-primary {
  background-color: #1C4922;
}

.label-info {
  background-color: #A38354;
}

.label-success {
  background-color: #1C4922;
}

.label-warning {
  background-color: #A38354;
}

.label-danger {
  background-color: #F1582C;
}

.label-default {
  background-color: #122318;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alert-circle-i::before {
  content: "\\ea04";
}

.nc-align-center::before {
  content: "\\ea03";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-app::before {
  content: "\\ea07";
}

.nc-atom::before {
  content: "\\ea08";
}

.nc-badge::before {
  content: "\\ea09";
}

.nc-bag-16::before {
  content: "\\ea0a";
}

.nc-bank::before {
  content: "\\ea0b";
}

.nc-basket::before {
  content: "\\ea0c";
}

.nc-bell-55::before {
  content: "\\ea0d";
}

.nc-bold::before {
  content: "\\ea0e";
}

.nc-book-bookmark::before {
  content: "\\ea0f";
}

.nc-bookmark-2::before {
  content: "\\ea10";
}

.nc-box-2::before {
  content: "\\ea11";
}

.nc-box::before {
  content: "\\ea12";
}

.nc-briefcase-24::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-calendar-60::before {
  content: "\\ea1a";
}

.nc-camera-compact::before {
  content: "\\ea1b";
}

.nc-caps-small::before {
  content: "\\ea1c";
}

.nc-cart-simple::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-36::before {
  content: "\\ea1f";
}

.nc-chat-33::before {
  content: "\\ea20";
}

.nc-check-2::before {
  content: "\\ea21";
}

.nc-circle-10::before {
  content: "\\ea22";
}

.nc-cloud-download-93::before {
  content: "\\ea23";
}

.nc-cloud-upload-94::before {
  content: "\\ea24";
}

.nc-compass-05::before {
  content: "\\ea25";
}

.nc-controller-modern::before {
  content: "\\ea26";
}

.nc-credit-card::before {
  content: "\\ea27";
}

.nc-delivery-fast::before {
  content: "\\ea28";
}

.nc-diamond::before {
  content: "\\ea29";
}

.nc-email-85::before {
  content: "\\ea2a";
}

.nc-favourite-28::before {
  content: "\\ea2b";
}

.nc-glasses-2::before {
  content: "\\ea2c";
}

.nc-globe-2::before {
  content: "\\ea2d";
}

.nc-globe::before {
  content: "\\ea2e";
}

.nc-hat-3::before {
  content: "\\ea2f";
}

.nc-headphones::before {
  content: "\\ea30";
}

.nc-html5::before {
  content: "\\ea31";
}

.nc-image::before {
  content: "\\ea32";
}

.nc-istanbul::before {
  content: "\\ea33";
}

.nc-key-25::before {
  content: "\\ea34";
}

.nc-laptop::before {
  content: "\\ea35";
}

.nc-layout-11::before {
  content: "\\ea36";
}

.nc-lock-circle-open::before {
  content: "\\ea37";
}

.nc-map-big::before {
  content: "\\ea38";
}

.nc-minimal-down::before {
  content: "\\ea39";
}

.nc-minimal-left::before {
  content: "\\ea3a";
}

.nc-minimal-right::before {
  content: "\\ea3b";
}

.nc-minimal-up::before {
  content: "\\ea3c";
}

.nc-mobile::before {
  content: "\\ea3d";
}

.nc-money-coins::before {
  content: "\\ea3e";
}

.nc-note-03::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-refresh-69::before {
  content: "\\ea44";
}

.nc-ruler-pencil::before {
  content: "\\ea45";
}

.nc-satisfied::before {
  content: "\\ea46";
}

.nc-scissors::before {
  content: "\\ea47";
}

.nc-send::before {
  content: "\\ea48";
}

.nc-settings-gear-65::before {
  content: "\\ea49";
}

.nc-settings::before {
  content: "\\ea4a";
}

.nc-share-66::before {
  content: "\\ea4b";
}

.nc-shop::before {
  content: "\\ea4c";
}

.nc-simple-add::before {
  content: "\\ea4d";
}

.nc-simple-delete::before {
  content: "\\ea4e";
}

.nc-simple-remove::before {
  content: "\\ea4f";
}

.nc-single-02::before {
  content: "\\ea50";
}

.nc-single-copy-04::before {
  content: "\\ea51";
}

.nc-sound-wave::before {
  content: "\\ea52";
}

.nc-spaceship::before {
  content: "\\ea53";
}

.nc-sun-fog-29::before {
  content: "\\ea54";
}

.nc-support-17::before {
  content: "\\ea55";
}

.nc-tablet-2::before {
  content: "\\ea56";
}

.nc-tag-content::before {
  content: "\\ea57";
}

.nc-tap-01::before {
  content: "\\ea58";
}

.nc-tie-bow::before {
  content: "\\ea59";
}

.nc-tile-56::before {
  content: "\\ea5a";
}

.nc-time-alarm::before {
  content: "\\ea5b";
}

.nc-touch-id::before {
  content: "\\ea5c";
}

.nc-trophy::before {
  content: "\\ea5d";
}

.nc-tv-2::before {
  content: "\\ea5e";
}

.nc-umbrella-13::before {
  content: "\\ea5f";
}

.nc-user-run::before {
  content: "\\ea60";
}

.nc-vector::before {
  content: "\\ea61";
}

.nc-watch-time::before {
  content: "\\ea62";
}

.nc-world-2::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
.btn-twitter {
  color: #55acee !important;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active {
  color: #55acee !important;
}

.btn-facebook {
  color: #3b5998 !important;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active {
  color: #3b5998 !important;
}

.btn-google {
  color: #dd4b39 !important;
}
.btn-google:hover, .btn-google:focus, .btn-google:active {
  color: #dd4b39 !important;
}

.btn-linkedin {
  color: #0976b4 !important;
}
.btn-linkedin:hover, .btn-linkedin:focus, .btn-linkedin:active {
  color: #0976b4 !important;
}

.btn-twitter-bg {
  background-color: #55acee !important;
  border-color: #55acee !important;
}
.btn-twitter-bg:hover {
  background-color: #3ea1ec !important;
  border-color: #3ea1ec !important;
}

.btn-facebook-bg {
  background-color: #3b5998 !important;
  border-color: #3b5998 !important;
}
.btn-facebook-bg:hover {
  background-color: #344e86 !important;
  border-color: #344e86 !important;
}

.btn-google-bg {
  background-color: #dd4b39 !important;
  border-color: #dd4b39 !important;
}
.btn-google-bg:hover {
  background-color: #d73925 !important;
  border-color: #d73925 !important;
}

.btn-github-bg {
  background-color: #767676 !important;
  border-color: #767676 !important;
}
.btn-github-bg:hover {
  background-color: dimgray !important;
  border-color: dimgray !important;
}

/*             Navigation menu                */
/*             Navigation Tabs                 */
.nav-tabs-navigation {
  text-align: center;
  border-bottom: 1px solid #cfe6ba;
  margin-bottom: 30px;
}
.nav-tabs-navigation .nav > .nav-item > .nav-link {
  padding-bottom: 20px;
}

.nav-tabs-wrapper {
  display: inline-block;
  margin-bottom: -6px;
  margin-left: 1.25%;
  margin-right: 1.25%;
  position: relative;
  width: auto;
}

.nav-tabs {
  border-bottom: 0 none;
  font-size: 16px;
  font-weight: 600;
}
.nav-tabs .nav-item .nav-link {
  border: 0 none;
  color: #A38354;
  background-color: transparent;
}
.nav-tabs .nav-item .nav-link:hover {
  color: #122318;
}
.nav-tabs .nav-item .nav-link.active {
  color: #122318;
}
.nav-tabs .nav-item {
  color: #122318;
  position: relative;
}
.nav-tabs .nav-item .nav-link.active,
.nav-tabs .nav-item .nav-link.active:hover,
.nav-tabs .nav-item .nav-link.active:focus {
  background-color: transparent;
  border: 0 none;
}
.nav-tabs .nav-item .nav-link.active:after,
.nav-tabs .nav-item .nav-link.active:hover:after,
.nav-tabs .nav-item .nav-link.active:focus:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 5px;
}
.nav-tabs .nav-item .nav-link.active:before,
.nav-tabs .nav-item .nav-link.active:hover:before,
.nav-tabs .nav-item .nav-link.active:focus:before {
  border-bottom: 11px solid #cfe6ba;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 40%;
  bottom: 6px;
}
.nav-tabs .nav-item.show .nav-link {
  background-color: transparent;
}
.nav-tabs .dropdown-menu {
  margin-top: -6px;
  margin-left: -46px;
  border-radius: 8px;
}
.nav-tabs .dropdown-menu .dropdown-item:hover,
.nav-tabs .dropdown-menu .dropdown-item.active {
  color: #FFFFFF;
  background-color: #68B3C8;
}
.nav-tabs .dropdown-menu :before {
  border-bottom: 11px solid #cfe6ba;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}
.nav-tabs .dropdown-menu :after {
  border-bottom: 11px solid #DCEDCD;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -10px;
}

.profile-content .tab-content .tab-pane {
  min-height: 200px;
}
.profile-content .tab-content #tweets, .profile-content .tab-content #connections, .profile-content .tab-content #media {
  height: 100%;
}

/*             Navigation Pills               */
.nav-pills .nav-item + .nav-link {
  margin-left: 0;
}
.nav-pills .nav-item .nav-link {
  border: 1px solid #122318;
  border-radius: 0;
  color: #122318;
  font-weight: 600;
  margin-left: -1px;
  padding: 10px 25px;
}
.nav-pills .nav-item.active .nav-link,
.nav-pills .nav-item.active .nav-link:hover,
.nav-pills .nav-item.active .nav-link:focus {
  background-color: #122318;
  color: #FFFFFF;
}
.nav-pills .nav-item:first-child .nav-link {
  border-radius: 30px 0 0 30px !important;
  margin: 0;
}
.nav-pills .nav-item:last-child .nav-link {
  border-radius: 0 30px 30px 0 !important;
}
.nav-pills .nav-item .nav-link.active {
  background-color: #122318;
  color: #FFFFFF;
}

.nav-pills-primary .nav-item .nav-link {
  border: 1px solid #1C4922 !important;
  color: #1C4922 !important;
}
.nav-pills-primary .nav-item .nav-link.active {
  border: 1px solid #1C4922 !important;
  color: #FFFFFF !important;
}

.nav-pills-danger .nav-item .nav-link {
  border: 1px solid #F1582C !important;
  color: #F1582C !important;
}
.nav-pills-danger .nav-item .nav-link.active {
  border: 1px solid #F1582C !important;
  color: #FFFFFF !important;
}

.nav-pills-info .nav-item .nav-link {
  border: 1px solid #A38354 !important;
  color: #A38354 !important;
}
.nav-pills-info .nav-item .nav-link.active {
  border: 1px solid #A38354 !important;
  color: #FFFFFF !important;
}

.nav-pills-success .nav-item .nav-link {
  border: 1px solid #1C4922 !important;
  color: #1C4922 !important;
}
.nav-pills-success .nav-item .nav-link.active {
  border: 1px solid #1C4922 !important;
  color: #FFFFFF !important;
}

.nav-pills-warning .nav-item .nav-link {
  border: 1px solid #A38354 !important;
  color: #A38354 !important;
}
.nav-pills-warning .nav-item .nav-link.active {
  border: 1px solid #A38354 !important;
  color: #FFFFFF !important;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: transparent;
}

.navbar {
  border: 0;
  font-size: 14px;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  padding: 0;
  background: #FFFFFF;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
}
.navbar .navbar-brand {
  font-weight: 600;
  margin: 5px 0px;
  padding: 20px 15px;
  font-size: 14px;
  color: #122318;
  text-transform: uppercase;
}
.navbar .navbar-toggler:focus {
  outline: none;
}
.navbar .form-control-feedback {
  padding-left: 0px;
}
.navbar:not([class*=bg]) .navbar-toggler .navbar-toggler-bar {
  background: #122318 !important;
}
.navbar .navbar-nav .nav-item .nav-link {
  line-height: 1.6;
  margin: 15px 3px;
  padding: 10px 15px;
  opacity: 0.8;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  color: #122318;
}
.navbar .navbar-nav .nav-item .nav-link p {
  margin: 0px 0px;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.5em;
  padding: 15px 0;
}
.navbar .navbar-nav .nav-item .nav-link.btn {
  margin: 15px 3px;
  padding: 9px;
}
.navbar .navbar-nav .nav-item .nav-link [class^=fa] {
  font-size: 17px;
  position: relative;
  right: 5px;
}
.navbar .navbar-nav .dropdown-menu {
  border-radius: 12px;
  margin-top: 1px;
}
.navbar .navbar-nav .nav-item .btn i {
  color: #FFFFFF;
}
.navbar .navbar-collapse .nav-item .nav-link p {
  display: inline;
}
.navbar .navbar-collapse .nav-item .dropdown-item i {
  margin: 0 10px;
  margin: 0 10px 0px 5px;
  font-size: 18px;
  position: relative;
  top: 3px;
}
.navbar .navbar-collapse.show .navbar-nav .nav-item {
  padding-right: 10px;
}
.navbar .navbar-collapse:after {
  background-color: #FFFCF5;
}
.navbar #navbarSupportedContent .nav-item {
  position: relative;
}
.navbar .notification-bubble {
  padding: 0.4em 0.6em;
  position: absolute;
  top: 10px;
  right: -2px;
}
.navbar .btn {
  margin: 14px 3px;
  font-size: 12px;
}
.navbar .btn i {
  font-size: 14px;
  position: relative;
  top: 2px;
}
.navbar .btn-simple {
  font-size: 16px;
}
.navbar .caret {
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  position: absolute;
}
.navbar.navbar-transparent {
  background: transparent !important;
  padding-top: 25px;
  box-shadow: none;
}
.navbar.navbar-transparent .navbar-brand {
  color: #FFFFFF;
}
.navbar.navbar-transparent .navbar-nav .nav-item .nav-link {
  color: #FFFFFF;
}
.navbar.navbar-transparent .navbar-toggler .navbar-toggler-bar {
  background: #FFFFFF !important;
}
.navbar .logo-container {
  margin-top: 5px;
}
.navbar .logo-container .logo {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #333333;
  width: 50px;
  float: left;
}
.navbar .logo-container .logo img {
  width: 100%;
}
.navbar .logo-container .brand {
  font-size: 18px;
  color: #FFFFFF;
  line-height: 20px;
  float: left;
  margin-left: 10px;
  margin-top: 5px;
  width: 75px;
  height: 50px;
}
.navbar .navbar-toggler .navbar-toggler-bar + .navbar-toggler-bar,
.navbar .navbar-toggler .navbar-toggler-icon + .navbar-toggler-icon {
  margin-top: 4px;
}
.navbar .navbar-toggler .navbar-toggler-bar {
  background: #FFFFFF !important;
  display: block;
  position: relative;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  margin: 0 auto;
}

.navbar-transparent .navbar-brand, [class*=bg] .navbar-brand {
  color: #FFFFFF;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .navbar-brand:focus, .navbar-transparent .navbar-brand:hover, [class*=bg] .navbar-brand:focus, [class*=bg] .navbar-brand:hover {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
  color: #FFFFFF;
}
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn), [class*=bg] .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.navbar-transparent .navbar-nav .active .nav-link .active .nav-link:hover,
.navbar-transparent .navbar-nav .active .nav-link:focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:focus, [class*=bg] .navbar-nav .active .nav-link .active .nav-link:hover,
[class*=bg] .navbar-nav .active .nav-link:focus,
[class*=bg] .navbar-nav .nav-item .nav-link:hover,
[class*=bg] .navbar-nav .nav-item .nav-link:focus {
  background-color: transparent;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .navbar-nav .nav .nav-item a.btn:hover, [class*=bg] .navbar-nav .nav .nav-item a.btn:hover {
  background-color: transparent;
}
.navbar-transparent .navbar-nav .dropdown .nav-link .caret,
.navbar-transparent .navbar-nav .dropdown .nav-link:hover .caret,
.navbar-transparent .navbar-nav .dropdown .nav-link:focus .caret, [class*=bg] .navbar-nav .dropdown .nav-link .caret,
[class*=bg] .navbar-nav .dropdown .nav-link:hover .caret,
[class*=bg] .navbar-nav .dropdown .nav-link:focus .caret {
  border-bottom-color: #FFFFFF;
  border-top-color: #FFFFFF;
}
.navbar-transparent .navbar-nav .open .nav-link,
.navbar-transparent .navbar-nav .open .nav-link:hover,
.navbar-transparent .navbar-nav .open .nav-link:focus, [class*=bg] .navbar-nav .open .nav-link,
[class*=bg] .navbar-nav .open .nav-link:hover,
[class*=bg] .navbar-nav .open .nav-link:focus {
  background-color: transparent;
  color: #122318;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .btn-default.btn-fill, [class*=bg] .btn-default.btn-fill {
  color: #9A9A9A;
  background-color: #FFFFFF;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .btn-default.btn-fill:hover,
.navbar-transparent .btn-default.btn-fill:focus,
.navbar-transparent .btn-default.btn-fill:active,
.navbar-transparent .btn-default.btn-fill.active,
.navbar-transparent .open .dropdown-toggle.btn-fill.btn-default, [class*=bg] .btn-default.btn-fill:hover,
[class*=bg] .btn-default.btn-fill:focus,
[class*=bg] .btn-default.btn-fill:active,
[class*=bg] .btn-default.btn-fill.active,
[class*=bg] .open .dropdown-toggle.btn-fill.btn-default {
  border-color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-absolute {
  position: absolute;
  width: 100%;
  padding-top: 10px;
  z-index: 1029;
}

.bd-docs .navigation-example .navbar.navbar-transparent {
  padding-top: 0;
  padding: 20px 0;
  margin-top: 20px;
}

.dropdown > .dropdown-menu:first-of-type {
  display: block;
  transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;
}
.dropdown .dropdown-menu {
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);
  visibility: hidden;
  position: absolute;
}
.dropdown .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, 0px, 0) !important;
}
.dropdown .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, 0px, 0) !important;
}
.dropdown.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.dropdown.show .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, -50px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.dropdown.show .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, 40px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}

.dropdown-menu {
  background-color: #FFFFFF;
  border: 0 none;
  border-radius: 12px;
  margin-top: 10px;
  padding: 0px;
}
.dropdown-menu .divider {
  background-color: #cfe6ba;
  margin: 0px;
}
.dropdown-menu .dropdown-header {
  color: #9A9A9A;
  font-size: 12px;
  padding: 10px 15px;
}
.dropdown-menu .no-notification {
  color: #9A9A9A;
  font-size: 1.2em;
  padding: 30px 30px;
  text-align: center;
}
.dropdown-menu .dropdown-item {
  color: #122318;
  font-size: 14px;
  padding: 10px 45px 10px 15px;
  clear: both;
  white-space: nowrap;
  width: 100%;
  display: block;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.dropdown-menu .dropdown-item.dropdown-toggle:last-of-type {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.dropdown-menu .dropdown-item.dropdown-toggle:last-of-type + .dropdown-menu.show {
  left: 100% !important;
}
.dropdown-menu .dropdown-item.dropdown-toggle:last-of-type + .dropdown-menu .dropdown-item.dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.dropdown-menu .dropdown-item.dropdown-toggle:last-of-type + .dropdown-menu li .dropdown-item.dropdown-toggle {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.select .dropdown-menu .dropdown-item:first-child {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  color: #FFFFFF !important;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #122318;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: #26632e;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: #c0a784;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: #26632e;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: #c0a784;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: #f3724d;
}

.dropdown-divider {
  margin: 0 !important;
}

.btn-group.select.open {
  overflow: visible;
}

.dropdown-menu-right {
  right: -2px;
  left: auto;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #FFFFFF;
  padding: 10px 15px;
  font-size: 14px;
}
.alert .close {
  font-size: 20px;
  color: #FFFFFF;
}
.container .alert {
  border-radius: 4px;
}
.navbar .alert {
  border-radius: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 85px;
  width: 100%;
  z-index: 3;
}
.navbar:not(.navbar-transparent) .alert {
  top: 70px;
}
.alert .alert-icon {
  display: block;
  font-size: 30px;
  left: 15px;
  position: absolute;
  top: 50%;
  margin-top: -22px;
}
.alert .alert-wrapper.message {
  padding-right: 60px;
}
.alert .alert-wrapper i {
  position: relative;
  font-size: 20px;
  top: 5px;
  margin-top: -5px;
  font-weight: 600;
}

.alert-info {
  background-color: #c0a784;
}

.alert-success {
  background-color: #26632e;
}

.alert-warning {
  background-color: #c0a784;
}

.alert-danger {
  background-color: #f3724d;
}

.img-rounded {
  border-radius: 12px;
  transition: opacity 0.5s ease 0s;
  max-width: 100%;
}

.img-details {
  min-height: 50px;
  padding: 0 4px 0.5em;
}

.img-details img {
  width: 50px;
}

.img-details .author {
  margin-left: 10px;
  margin-top: -21px;
  width: 40px;
}

.img-circle {
  background-color: #FFFFFF;
  margin-bottom: 10px;
  padding: 4px;
  border-radius: 50% !important;
  max-width: 100%;
}

.img-thumbnail {
  border: 0 none;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(164, 158, 147, 0.6);
  margin-bottom: 10px;
}

.img-no-padding {
  padding: 0px;
}

.example-page .img-rounded {
  margin: 50px 0 20px;
}

.img-shadow {
  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
}

.images-title {
  margin-bottom: 20px;
  height: 50px;
}

.nav-link .profile-photo-small {
  width: 40px;
  height: 30px;
  margin: -10px 0 0 -15px;
}

.profile-picture {
  margin: 0 auto;
}
.profile-picture .fileinput-new img {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.profile-picture .fileinput-exists img {
  max-width: 150px;
  max-height: 150px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.tooltip {
  font-size: 12px;
  font-weight: 400;
}

.tooltip-inner {
  background-color: #FFFFFF;
  border-radius: 4px;
  box-shadow: 0 1px 13px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(115, 71, 38, 0.23);
  color: #122318;
  max-width: 200px;
  padding: 10px 10px;
  text-align: center;
  text-decoration: none;
}

.tooltip-inner:after {
  content: "";
  display: inline-block;
  position: absolute;
}

.tooltip-inner:before {
  content: "";
  display: inline-block;
  position: absolute;
}

.tooltip.fade.bs-tooltip-left,
.tooltip.fade.bs-tooltip-left.show {
  left: -5px !important;
}
.tooltip.fade.bs-tooltip-left .arrow,
.tooltip.fade.bs-tooltip-left.show .arrow {
  border-left: 11px solid rgba(0, 0, 0, 0.2);
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  right: -6px;
  left: auto;
  margin-left: 0;
  top: -8px;
}
.tooltip.fade.bs-tooltip-left .arrow::before,
.tooltip.fade.bs-tooltip-left.show .arrow::before {
  border-left: 11px solid #FFFFFF;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  right: 1px;
  left: auto;
  margin-left: 0;
  top: -8px;
}

.tooltip.fade.bs-tooltip-right,
.tooltip.fade.bs-tooltip-right.show {
  left: 6px !important;
}
.tooltip.fade.bs-tooltip-right .arrow,
.tooltip.fade.bs-tooltip-right.show .arrow {
  border-right: 11px solid rgba(0, 0, 0, 0.2);
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  left: -6px;
  right: auto;
  margin-right: 0;
  top: -8px;
}
.tooltip.fade.bs-tooltip-right .arrow::before,
.tooltip.fade.bs-tooltip-right.show .arrow::before {
  border-right: 11px solid #FFFFFF;
  border-top: 11px solid transparent;
  border-bottom: 11px solid transparent;
  left: 1px;
  right: auto;
  margin-right: 0;
  top: -8px;
}

.tooltip.fade.bs-tooltip-top,
.tooltip.fade.bs-tooltip-top.show {
  top: -6px !important;
}
.tooltip.fade.bs-tooltip-top .arrow,
.tooltip.fade.bs-tooltip-top.show .arrow {
  border-top: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  right: auto;
  margin-right: 0;
  top: 43px;
}
.tooltip.fade.bs-tooltip-top .arrow::before,
.tooltip.fade.bs-tooltip-top.show .arrow::before {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  left: -8px;
  right: auto;
  top: -12px;
}

.tooltip.fade.bs-tooltip-bottom,
.tooltip.fade.bs-tooltip-bottom.show {
  top: 6px !important;
}
.tooltip.fade.bs-tooltip-bottom .arrow,
.tooltip.fade.bs-tooltip-bottom.show .arrow {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  right: auto;
  margin-right: 0;
  top: -6px;
}
.tooltip.fade.bs-tooltip-bottom .arrow::before,
.tooltip.fade.bs-tooltip-bottom.show .arrow::before {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  left: -8px;
  right: auto;
  top: 1px;
}

.tooltip.show {
  opacity: 1 !important;
}

.popover {
  border: 0;
  border-radius: 4px;
  background-color: #FFFFFF;
  color: #66615b;
  font-weight: 400;
  padding: 0;
  z-index: 1031;
  box-shadow: none;
  text-align: center;
}

.popover-header {
  background-color: #FFFCF5;
  border-bottom: 0 none;
  font-size: 15px;
  font-weight: normal;
  line-height: 22px;
  padding: 15px 15px 0px 15px;
  margin: 0;
  color: #66615b;
  text-align: center;
  border-radius: 4px 4px 0 0;
  margin-bottom: -10px;
}

.popover-header {
  background-color: #FFFFFF !important;
  text-align: center;
}

.popover-body {
  padding: 15px;
  text-align: center;
}

.popover .arrow {
  border: 0;
}

.popover.top .arrow {
  margin-left: 0;
}

.popover.bottom .arrow:after {
  border-bottom-color: #f3724d;
}

.popover-filter {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background-color: #000000;
  opacity: 0;
  filter: alpha(opacity=0);
  visibility: hidden;
  transition: visibility 0s linear 0.3s, opacity 0.3s linear;
}

.popover-filter.in {
  visibility: visible;
  opacity: 0.2;
  filter: alpha(opacity=20);
  transition-delay: 0s;
}

.popover.left > .arrow::after {
  border-left-color: #f3724d;
  bottom: -20px;
}

.popover.top > .arrow::after {
  border-top-color: #f3724d;
}

.popover.right > .arrow::after {
  border-right-color: #f3724d;
}

.popover.left::before {
  border-left-color: #f3724d;
  bottom: -20px;
}

.popover-filter.in {
  visibility: visible;
  opacity: 0.2;
  filter: alpha(opacity=20);
  transition-delay: 0s;
}

.popover-primary {
  background-color: #26632e;
  color: #FFFFFF;
}
.popover-primary .popover-title {
  background-color: #26632e;
  color: rgba(0, 0, 0, 0.56);
}
.popover-primary.bottom .arrow:after {
  border-bottom-color: #26632e;
}
.popover-primary.left > .arrow::after {
  border-left-color: #26632e;
}
.popover-primary.top > .arrow::after {
  border-top-color: #26632e;
}
.popover-primary.right > .arrow::after {
  border-right-color: #26632e;
}

.popover-info {
  background-color: #c0a784;
  color: #FFFFFF;
}
.popover-info .popover-title {
  background-color: #c0a784;
  color: rgba(0, 0, 0, 0.56);
}
.popover-info.bottom .arrow:after {
  border-bottom-color: #c0a784;
}
.popover-info.left > .arrow::after {
  border-left-color: #c0a784;
}
.popover-info.top > .arrow::after {
  border-top-color: #c0a784;
}
.popover-info.right > .arrow::after {
  border-right-color: #c0a784;
}

.popover-success {
  background-color: #26632e;
  color: #FFFFFF;
}
.popover-success .popover-title {
  background-color: #26632e;
  color: rgba(0, 0, 0, 0.56);
}
.popover-success.bottom .arrow:after {
  border-bottom-color: #26632e;
}
.popover-success.left > .arrow::after {
  border-left-color: #26632e;
}
.popover-success.top > .arrow::after {
  border-top-color: #26632e;
}
.popover-success.right > .arrow::after {
  border-right-color: #26632e;
}

.popover-warning {
  background-color: #c0a784;
  color: #FFFFFF;
}
.popover-warning .popover-title {
  background-color: #c0a784;
  color: rgba(0, 0, 0, 0.56);
}
.popover-warning.bottom .arrow:after {
  border-bottom-color: #c0a784;
}
.popover-warning.left > .arrow::after {
  border-left-color: #c0a784;
}
.popover-warning.top > .arrow::after {
  border-top-color: #c0a784;
}
.popover-warning.right > .arrow::after {
  border-right-color: #c0a784;
}

.popover-danger {
  background-color: #f3724d;
  color: #FFFFFF;
}
.popover-danger .popover-title {
  background-color: #f3724d;
  color: rgba(0, 0, 0, 0.56);
}
.popover-danger.bottom .arrow:after {
  border-bottom-color: #f3724d;
}
.popover-danger.left > .arrow::after {
  border-left-color: #f3724d;
}
.popover-danger.top > .arrow::after {
  border-top-color: #f3724d;
}
.popover-danger.right > .arrow::after {
  border-right-color: #f3724d;
}

.popover-primary.bs-tether-element-attached-bottom::after,
.popover-primary.bs-tether-element-attached-bottom::before,
.popover-primary.popover-top::after,
.popover-primary.popover-top::before {
  border-top-color: #26632e !important;
}

.popover.popover-info.bs-tether-element-attached-top::after,
.popover.popover-info.popover-bottom::after,
.popover.popover-info.bs-tether-element-attached-top::before,
.popover.popover-info.popover-bottom::before {
  border-bottom-color: #c0a784 !important;
}

.popover-success.bs-tether-element-attached-left::after,
.popover-success.bs-tether-element-attached-left::before,
.popover-success.popover-right::after,
.popover-success.popover-right::before {
  border-right-color: #26632e !important;
}

.popover.popover-warning.bs-tether-element-attached-right::after,
.popover.popover-warning.bs-tether-element-attached-right::before,
.popover.popover-warning.popover-left::after,
.popover.popover-warning.popover-left::before {
  border-left-color: #c0a784 !important;
}

.popover.popover-danger.bs-tether-element-attached-right::after,
.popover.popover-danger.bs-tether-element-attached-right::before,
.popover.popover-danger.popover-left::after,
.popover.popover-danger.popover-left::before {
  border-left-color: #f3724d !important;
}

.popover.bs-tether-element-attached-top::after, .popover.popover-bottom::after,
.popover.bs-tether-element-attached-top::before, .popover.popover-bottom::before {
  border-bottom-color: #fff !important;
}

.modal-header {
  border-bottom: 1px solid #DDDDDD;
  padding: 20px;
  text-align: center;
  display: block !important;
}
.modal-header.no-border-header {
  border-bottom: 0 none !important;
}
.modal-header.no-border-header .modal-title {
  margin-top: 20px;
}
.modal-header button.close:focus {
  outline: none;
}

.modal-dialog.modal-sm .modal-header button.close, .modal-dialog.modal-register .modal-header button.close {
  margin-top: 0;
}

.modal-content {
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}
.modal-content .modal-header h6 {
  margin-top: 10px;
}

.modal-dialog {
  padding-top: 60px;
}

.modal-body {
  padding: 20px 50px;
  color: #000;
}

.modal-footer {
  border-top: 1px solid #DDDDDD;
  padding: 0px;
}
.modal-footer.no-border-footer {
  border-top: 0 none;
}

.modal-footer .left-side, .modal-footer .right-side {
  display: inline-block;
  text-align: center;
  width: 49%;
}

.modal-footer .btn-link {
  padding: 20px;
  width: 100%;
}

.modal-footer .divider {
  background-color: #DDDDDD;
  display: inline-block;
  float: inherit;
  height: 63px;
  margin: 0px -3px;
  width: 1px;
}

.modal-register .modal-footer {
  text-align: center;
  margin-bottom: 25px;
  padding: 20px 0 15px;
}
.modal-register .modal-footer span {
  width: 100%;
}

.modal-header:after {
  display: table;
  content: " ";
}

.modal-header:before {
  display: table;
  content: " ";
}

.section-nucleo-icons {
  padding: 100px 0;
}
.section-nucleo-icons .icons-container {
  position: relative;
  max-width: 450px;
  height: 300px;
  max-height: 300px;
  margin: 0 auto;
}
.section-nucleo-icons .icons-container i {
  font-size: 34px;
  position: absolute;
  top: 0;
  left: 0;
}
.section-nucleo-icons .icons-container i:nth-child(1) {
  top: 5%;
  left: 7%;
}
.section-nucleo-icons .icons-container i:nth-child(2) {
  top: 28%;
  left: 24%;
}
.section-nucleo-icons .icons-container i:nth-child(3) {
  top: 40%;
}
.section-nucleo-icons .icons-container i:nth-child(4) {
  top: 18%;
  left: 62%;
}
.section-nucleo-icons .icons-container i:nth-child(5) {
  top: 74%;
  left: 3%;
}
.section-nucleo-icons .icons-container i:nth-child(6) {
  top: 36%;
  left: 44%;
  font-size: 65px;
  color: #F1582C;
  padding: 1px;
}
.section-nucleo-icons .icons-container i:nth-child(7) {
  top: 59%;
  left: 26%;
}
.section-nucleo-icons .icons-container i:nth-child(8) {
  top: 60%;
  left: 69%;
}
.section-nucleo-icons .icons-container i:nth-child(9) {
  top: 72%;
  left: 47%;
}
.section-nucleo-icons .icons-container i:nth-child(10) {
  top: 88%;
  left: 27%;
}
.section-nucleo-icons .icons-container i:nth-child(11) {
  top: 31%;
  left: 80%;
}
.section-nucleo-icons .icons-container i:nth-child(12) {
  top: 88%;
  left: 68%;
}
.section-nucleo-icons .icons-container i:nth-child(13) {
  top: 5%;
  left: 81%;
}
.section-nucleo-icons .icons-container i:nth-child(14) {
  top: 58%;
  left: 90%;
}
.section-nucleo-icons .icons-container i:nth-child(15) {
  top: 6%;
  left: 40%;
}

.section-dark .icons-container {
  color: #FFFFFF;
}

.info .icon {
  margin-top: 0;
  font-size: 3.4em;
}

.icon-primary {
  color: #1C4922;
}

.icon-info {
  color: #A38354;
}

.icon-success {
  color: #1C4922;
}

.icon-warning {
  color: #A38354;
}

.icon-danger {
  color: #F1582C;
}

.icon-neutral {
  color: #FFFFFF;
}

.carousel-control {
  background-color: #F1582C;
  border-radius: 50%;
  opacity: 1;
  text-shadow: none;
}
.carousel-control:hover, .carousel-control:focus {
  opacity: 1;
  background-color: #e53f0f;
}

.carousel-control.left {
  height: 30px;
  top: 50%;
  width: 30px;
  left: 25px;
  opacity: 0;
}

.carousel-control.right {
  height: 30px;
  right: 25px;
  top: 50%;
  width: 30px;
  opacity: 0;
}

.carousel-control .icon-prev, .carousel-control .icon-next, .carousel-control .fa, .carousel-control .fa {
  display: inline-block;
  z-index: 5;
}

.carousel-control .fa {
  font-size: 26px;
  margin: 2px;
}

.carousel-control.left, .carousel-control.right {
  background-image: none;
}

.page-carousel {
  border-radius: 12px !important;
  border: none !important;
  width: 100%;
}

.carousel-inner > .carousel-item > img,
.carousel-inner > .carousel-item > a > img {
  border-radius: 12px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
}
.carousel-inner .carousel-item img {
  width: 100%;
}

.carousel-indicators > li {
  background-color: rgba(204, 204, 204, 0.49);
  border: 0 none;
}

.carousel-indicators .active {
  background-color: #F1582C;
}

.page-carousel:hover .carousel-control.right,
.page-carousel:hover .carousel-control.left {
  opacity: 1;
  z-index: 1;
}

.card .carousel .carousel-indicators {
  bottom: 0;
}
.card .carousel a {
  position: absolute;
  color: #FFFFFF !important;
}
.card .carousel a:hover {
  color: #FFFFFF !important;
}
.card .carousel a .fa-angle-left:before {
  padding-right: 3px;
}
.card .carousel a .fa-angle-right:before {
  padding-left: 3px;
}

.footer {
  background-attachment: fixed;
  position: relative;
  line-height: 20px;
}
.footer .footer-nav ul {
  padding-left: 0;
  margin-bottom: 0;
}

.footer nav > ul {
  list-style: none;
  font-weight: normal;
}

.footer nav > ul > li {
  display: inline-block;
  padding: 10px 15px;
  margin: 15px 3px;
  line-height: 20px;
  text-align: center;
}

.footer nav > ul a:not(.btn) {
  color: #777777;
  display: block;
  margin-bottom: 3px;
  line-height: 1.6;
  opacity: 0.8;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
}

.footer nav > ul a:not(.btn):hover,
.footer nav > ul a:not(.btn):focus {
  color: #777777;
  opacity: 1;
}

.footer .copyright {
  color: #777777;
  padding: 10px 0px;
  font-size: 14px;
  margin: 15px 3px;
  line-height: 20px;
  text-align: center;
}

.footer .heart {
  color: #EB5E28;
}

.footer {
  background-color: #FFFFFF;
  line-height: 36px;
}
.footer.footer-black h4 {
  color: #FFFFFF;
}
.footer .links {
  display: inline-block;
}
.footer .links ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: 600;
}
.footer .links ul > li {
  display: inline-block;
  padding-right: 20px;
}
.footer .links ul > li:last-child {
  padding-right: 0px;
}
.footer .links ul a:not(.btn) {
  color: #122318;
  display: block;
  font-size: 0.9em;
  margin-bottom: 3px;
}
.footer .links ul a:not(.btn):hover, .footer .links ul a:not(.btn):focus {
  color: #23452f;
}
.footer .links ul.uppercase-links {
  text-transform: uppercase;
}
.footer .links ul.stacked-links {
  margin-top: 10px;
}
.footer .links ul.stacked-links > li {
  display: block;
  line-height: 26px;
}
.footer .links ul.stacked-links h4 {
  margin-top: 0px;
}
.footer .social-area {
  padding: 15px 0;
}
.footer .social-area .btn {
  margin-bottom: 3px;
  padding: 8px;
}
.footer .social-area .btn i {
  margin-right: 0 !important;
  color: #fff;
}
.footer hr {
  border-color: #DDDDDD;
  border-width: 1px 0 0;
  margin-top: 5px;
  margin-bottom: 5px;
}
.footer .copyright {
  color: #A49E9E;
  font-size: 0.9em;
}
.footer .copyright ul > li {
  padding-right: 0px;
}
.footer .title {
  color: #23452f;
}

.card {
  border-radius: 12px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #FFFFFF;
  color: #333333;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  border: 0 none;
  transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;
}
.card:not(.card-plain):hover {
  box-shadow: 0px 12px 19px -7px rgba(0, 0, 0, 0.3);
  transform: translateY(-10px);
  -webkit-transform: translateY(-10px);
  -ms-transform: translateY(-10px);
  -moz-transform: translateY(-10px);
}
.card.no-transition:hover, .card.page-carousel:hover, .card.card-refine:hover, .card.card-register:hover {
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  transform: none;
  -webkit-transform: none;
  -ms-transform: none;
  -moz-transform: none;
}
.card a:not(.btn) {
  color: #356646;
}
.card a:not(.btn):hover, .card a:not(.btn):focus {
  color: #122318;
}
.card .card-description {
  color: #9A9A9A;
  margin-bottom: 5px;
  margin-top: 15px;
}
.card img {
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px 12px 0 0;
}
.card[data-radius=none] {
  border-radius: 0px;
}
.card[data-radius=none] .header {
  border-radius: 0px 0px 0 0;
}
.card[data-radius=none] .header img {
  border-radius: 0px 0px 0 0;
}
.card.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card.card-plain .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card.card-plain img {
  border-radius: 12px;
}
.card .card-link {
  color: #FFFFFF;
}
.card .card-background-image ul li {
  color: #FFF;
  border-color: rgba(255, 255, 255, 0.3);
}
.card.card-blog, .card.card-testimonial .card-description + .card-title {
  margin-top: 30px;
}
.card.card-blog .card-image .img, .card.card-testimonial .card-description + .card-title .card-image .img {
  border-radius: 12px;
}
.card.card-blog .card-image .card-title, .card.card-testimonial .card-description + .card-title .card-image .card-title {
  text-align: center;
}
.card.card:not(.card-plain) .card-image .img {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.card.card-blog {
  margin-top: 5px;
}
.card.card-blog .btn {
  margin: 0 auto;
}
.card .author {
  display: inline-block;
}
.card .author .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.card .author .avatar-big {
  width: 100px;
  height: 100px;
  border-radius: 50% !important;
  position: relative;
  margin-bottom: 15px;
}
.card .author .avatar-big.border-white {
  border: 4px solid #FFFFFF;
}
.card .author .avatar-big.border-gray {
  border: 4px solid #ccc;
}
.card .clearfix + .author {
  margin-top: 15px;
}
.card .stats {
  display: inline-block;
  float: right;
  color: #9A9A9A;
  font-size: 12px;
  margin-top: 6px;
}
.card .stats i {
  font-size: 16px;
  position: relative;
  text-align: center;
  top: 1px;
  margin-left: 5px;
  margin-top: -1px;
  opacity: 0.6;
}
.card .card-category {
  color: #9A9A9A;
}
.card .category-social .fa {
  font-size: 24px;
  position: relative;
  margin-top: -4px;
  top: 2px;
  margin-right: 5px;
}
.card .card-title-uppercase {
  text-transform: uppercase;
}
.card .header {
  position: relative;
  border-radius: 3px 3px 0 0;
  z-index: 3;
}
.card .header.header-with-icon {
  height: 150px;
}
.card .header img {
  width: 100%;
}
.card .header .card-category {
  padding: 15px;
}
.card .card-body .card-footer {
  padding: 0;
}
.card .card-body .card-description + .card-footer {
  padding-top: 10px;
}
.card .more {
  float: right;
  z-index: 4;
  display: block;
  padding-top: 10px;
  padding-right: 10px;
  position: relative;
}
.card .filter,
.card .header .actions {
  position: absolute;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.76);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
}
.card .header .actions {
  background-color: transparent;
  z-index: 3;
}
.card .header .actions .btn {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.card:hover .filter {
  opacity: 0.7;
}
.card:hover .header .social-line,
.card:hover .header .actions {
  opacity: 1;
}
.card .card-category i,
.card .label i {
  font-size: 15px;
}
.card > .card-title {
  margin: 0;
  padding: 30px 0 0;
}
.card .card-body {
  padding: 20px;
}
.card .card-body .card-title {
  margin: 5px 0 0 0;
}
.card .card-body .card-category ~ .card-title {
  margin-top: 5px;
}
.card .card-text {
  font-size: 15px;
  color: #122318;
  padding-bottom: 15px;
}
.card h6 {
  font-size: 12px;
  margin: 0;
}
.card .card-footer {
  padding: 15px;
  background: transparent;
  border-top: 0 none;
}
.card .card-footer .social-line .btn:first-child {
  border-radius: 0 0 0 6px;
}
.card .card-footer .social-line .btn:last-child {
  border-radius: 0 0 6px 0;
}
.card.card-separator:after {
  height: 100%;
  right: -15px;
  top: 0;
  width: 1px;
  background-color: #DDDDDD;
  content: "";
  position: absolute;
}
.card .card-icon {
  display: block;
  margin: 0 auto;
  position: relative;
  text-align: center;
  padding: 30px 0 10px;
}
.card .card-icon i {
  font-size: 40px;
  width: 105px;
  border: 2px solid #ccc;
  border-radius: 50%;
  height: 105px;
  line-height: 105px;
}
.col-lg-4 .card .card-icon i {
  font-size: 80px;
  padding: 22px;
}
.card.card-with-border .card-body {
  padding: 15px 15px 25px 15px;
}
.card.card-with-border .card-footer {
  padding-bottom: 25px;
}
.card.card-with-border:after {
  position: absolute;
  display: block;
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  content: "";
  top: 5px;
  left: 5px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  z-index: 1;
  border-radius: 5px;
}
.card.card-just-text .card-body {
  padding: 50px 65px;
  text-align: center;
}
.card.card-just-text #dLabel {
  float: right;
}
.card.card-just-text #dLabel i {
  font-size: 20px;
}
.card.card-just-text .dropdown-menu {
  margin-top: 55px;
}
.card[data-background=image] {
  background-position: center center;
  background-size: cover;
  text-align: center;
}
.card[data-background=image] .card-body {
  position: relative;
  z-index: 2;
  min-height: 280px;
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 440px;
  margin: 0 auto;
  text-align: center;
}
.card[data-background=image] .card-title {
  color: #FFF;
  margin-top: 10px;
}
.card[data-background=image]:after {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.56);
  border-radius: 12px;
}
.card[data-background=image] .card-category {
  color: #FFFFFF;
}
.card[data-background=image] .image, .card[data-background=color] .image, .card[data-color] .image {
  border-radius: 6px;
}
.card[data-background=image] .filter, .card[data-background=color] .filter, .card[data-color] .filter {
  border-radius: 6px;
}
.card[data-background=image] .card-description, .card[data-background=color] .card-description, .card[data-color] .card-description {
  color: rgba(255, 255, 255, 0.8);
}
.card[data-background=image] .card-title,
.card[data-background=image] .card-category,
.card[data-background=image] .card-text,
.card[data-background=image] .card-body,
.card[data-background=image] .card-footer,
.card[data-background=image] .stats,
.card[data-background=image] small,
.card[data-background=image] [class*=text-],
.card[data-background=image] ul li b,
.card[data-background=image] a:not(.btn), .card[data-background=color] .card-title,
.card[data-background=color] .card-category,
.card[data-background=color] .card-text,
.card[data-background=color] .card-body,
.card[data-background=color] .card-footer,
.card[data-background=color] .stats,
.card[data-background=color] small,
.card[data-background=color] [class*=text-],
.card[data-background=color] ul li b,
.card[data-background=color] a:not(.btn), .card[data-color] .card-title,
.card[data-color] .card-category,
.card[data-color] .card-text,
.card[data-color] .card-body,
.card[data-color] .card-footer,
.card[data-color] .stats,
.card[data-color] small,
.card[data-color] [class*=text-],
.card[data-color] ul li b,
.card[data-color] a:not(.btn) {
  color: #FFFFFF !important;
}
.card[data-background=image] a:not(.btn):hover,
.card[data-background=image] a:not(.btn):focus, .card[data-background=color] a:not(.btn):hover,
.card[data-background=color] a:not(.btn):focus, .card[data-color] a:not(.btn):hover,
.card[data-color] a:not(.btn):focus {
  color: #FFFFFF;
}
.card[data-background=image] .card-icon i, .card[data-background=color] .card-icon i, .card[data-color] .card-icon i {
  color: #FFFFFF;
  border: 2px solid rgba(255, 255, 255, 0.3);
}
.card[data-background=image].card-with-border:after, .card[data-background=color].card-with-border:after, .card[data-color].card-with-border:after {
  border: 1px solid rgba(255, 255, 255, 0.45);
}
.card[data-background=image] .filter {
  opacity: 0.55;
  filter: alpha(opacity=55);
}
.card[data-background=image]:hover .filter {
  opacity: 0.75;
  filter: alpha(opacity=75);
}
.card[data-color=blue] {
  background: #c0a784;
}
.card[data-color=green] {
  background: #26632e;
}
.card[data-color=yellow] {
  background: #c0a784;
}
.card[data-color=brown] {
  background: #b29469;
}
.card[data-color=purple] {
  background: #cc90cc;
}
.card[data-color=orange] {
  background: #f3724d;
}

.btn-center {
  text-align: center;
}

.card-big-shadow {
  max-width: 320px;
  position: relative;
}
.card-big-shadow:before {
  background-image: url("http://static.tumblr.com/i21wc39/coTmrkw40/shadow.png");
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  bottom: -12%;
  content: "";
  display: block;
  left: -12%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
}

.card-image.card-big-shadow {
  max-width: 100%;
}
.card-image .card {
  background-size: cover;
  min-height: 430px;
  width: 100%;
}
.card-image .img-raised {
  margin-top: -20px;
}

.page-header .card-pricing.card-plain .card-category,
.page-header .card-pricing.card-plain .card-title {
  color: #FFFFFF;
}

.card-plain .card-avatar {
  margin-top: 0;
}

.card-refine .panel-title {
  font-size: 1em;
}

.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card-plain .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card-plain img {
  border-radius: 12px;
}

.card-register {
  background-color: #FF8F5E;
  border-radius: 8px;
  color: #fff;
  max-width: 350px;
  margin: 20px 0 70px;
  min-height: 400px;
  padding: 30px;
}
.card-register label {
  margin-top: 15px;
}
.card-register .card-title {
  color: #B33C12;
  text-align: center;
}
.card-register .btn {
  margin-top: 30px;
}
.card-register .forgot {
  text-align: center;
}
.card-register .input-group-text {
  border: 1px solid #FFFFFF;
}

.card-profile {
  margin-top: 30px;
  text-align: center;
}
.card-profile .card-cover {
  height: 130px;
  background-position: center center;
  background-size: cover;
  border-radius: 12px 12px 0 0;
}
.card-profile .card-body .card-title {
  margin-top: 5px !important;
}
.card-profile .card-body .card-category {
  margin-bottom: 5px;
  margin-top: 5px;
}
.card-profile .card-avatar {
  max-width: 120px;
  max-height: 120px;
  margin: -60px auto 0;
  border-radius: 50%;
  overflow: hidden;
}
.card-profile .card-avatar.border-white {
  border: 4px solid #FFFFFF;
}
.card-profile .card-avatar.border-gray {
  border: 4px solid #ccc;
}

.section .card-profile {
  margin-top: 100px;
}

.landing-alert {
  margin-bottom: 0;
}

.page-header {
  background-color: #B2AFAB;
  background-position: center center;
  background-size: cover;
  min-height: 100vh;
  max-height: 999px;
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-header .filter::after {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.page-header.page-header-small {
  min-height: 65vh !important;
  max-height: 700px;
}
.page-header.page-header-xs {
  min-height: 30vh !important;
}
.page-header.section-dark .content-center,
.page-header.section-dark .category-absolute {
  z-index: 1;
}

.page-header .motto {
  text-align: left;
  z-index: 3;
  color: #fff;
  position: relative;
}

.landing-section {
  padding: 100px 0;
  z-index: 1;
}

.section-buttons {
  z-index: 1;
}

.landing-section .btn-simple {
  padding: 0;
}

.landing-section .column {
  padding: 0 75px 0 25px;
}

.team-player .img-circle, .team-player .img-thumbnail {
  display: block;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 120px;
}

.contact-form {
  margin-top: 30px;
}

.contact-form label {
  margin-top: 15px;
}

.contact-form .btn {
  margin-top: 30px;
}

.navbar-relative {
  position: relative;
  z-index: 2;
}

#register-navbar a {
  color: #FFF;
}

.register-background .container {
  margin-top: 11%;
  position: relative;
  z-index: 3;
}

.register-footer {
  bottom: 20px;
  position: absolute;
  z-index: 1;
  width: 100%;
  background: transparent;
  color: #FFFFFF;
}

.register-footer .fa-heart {
  color: #EB5E28;
}

.register-card label {
  margin-top: 15px;
}

.register-card .title {
  color: #B33C12;
  text-align: center;
}

.register-card .btn {
  margin-top: 30px;
}

.register-card .forgot {
  text-align: center;
}

.profile-content {
  position: relative;
}

.owner {
  text-align: center;
}

.owner .avatar {
  padding: 15px;
  max-width: 180px;
  margin: -85px auto 0;
  display: inline-block;
}

.owner .name h4 {
  margin-top: 10px;
}

.profile-tabs {
  margin: 50px 0;
  min-height: 300px;
}

#following h3 {
  margin: 20px 0 40px 0;
}

#follows .follows .unfollow .checkbox {
  margin-top: -15px;
}

#follows .follows h6 {
  margin-top: 15px;
}

.follows hr {
  margin-top: 10px;
}

.title-brand {
  max-width: 730px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  color: #FFFFFF;
  display: block;
}
.title-brand .type {
  position: absolute;
  font-size: 20px;
  background: #132026;
  padding: 6px 10px;
  border-radius: 4px;
  top: 0;
  font-weight: 600;
  margin-top: 10px;
  right: -15px;
}

.presentation-title {
  font-size: 8em;
  font-weight: 700;
  margin: 0;
  color: #FFFFFF;
  background: #fbf8ec;
  background: linear-gradient(to bottom, #FFFFFF 35%, #4e6773 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.presentation-subtitle {
  font-size: 1.7em;
  color: #FFFFFF;
}

.category-absolute {
  position: absolute;
  text-align: center;
  top: 100vh;
  margin-top: -60px;
  padding: 0 15px;
  width: 100%;
  color: rgba(255, 255, 255, 0.5);
}
.category-absolute .creative-tim-logo {
  max-width: 140px;
  top: -2px;
  left: 3px;
  position: relative;
}

.fog-low {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-left: -35%;
  margin-bottom: -50px;
  width: 110%;
  opacity: 0.85;
}
.fog-low img {
  width: 100%;
}
.fog-low.right {
  margin-left: 30%;
  opacity: 1;
}

.page-header .content-center {
  margin-top: 85px;
}

.moving-clouds {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 250.625em;
  height: 43.75em;
  animation: cloudLoop 80s linear infinite;
}

@keyframes cloudLoop {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-50%, 0, 0);
  }
}
.following img {
  max-width: 70px;
}

.profile-content .tab-content .tab-pane {
  min-height: 200px;
}
.profile-content .tab-content #tweets, .profile-content .tab-content #connections, .profile-content .tab-content #media {
  height: 100%;
}

.section {
  padding: 70px 0;
  position: relative;
  background-color: #FFFFFF;
}

.section-with-space {
  padding: 60px 0;
}

.section-gray {
  background-color: #EEEEEE;
}

.section-nude {
  background-color: #DCEDCD;
}

.section-gold {
  background-color: #caac90;
  color: #FFFFFF;
}

.section-brown {
  background-color: #A59E94;
  color: #FFFFFF;
}

.section-light-blue {
  background-color: #1C4922;
  color: #FFFFFF;
}

.section-dark-blue {
  background-color: #506367;
  color: #FFFFFF;
}

.section-dark {
  background-color: #000000;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.section-image,
.section-gold,
.section-dark {
  position: relative;
}
.section-image .title,
.section-image .info-title,
.section-image .card-plain .card-title,
.section-gold .title,
.section-gold .info-title,
.section-gold .card-plain .card-title,
.section-dark .title,
.section-dark .info-title,
.section-dark .card-plain .card-title {
  color: #FFFFFF !important;
}
.section-image .category,
.section-image .description,
.section-image .card-plain .card-description,
.section-image .card-plain .card-category,
.section-gold .category,
.section-gold .description,
.section-gold .card-plain .card-description,
.section-gold .card-plain .card-category,
.section-dark .category,
.section-dark .description,
.section-dark .card-plain .card-description,
.section-dark .card-plain .card-category {
  color: rgba(255, 255, 255, 0.7);
}
.section-image hr,
.section-gold hr,
.section-dark hr {
  border-color: rgba(255, 255, 255, 0.19);
}

.page-header .title,
.page-header .info-title,
.carousel-caption .title,
.carousel-caption .info-title {
  color: #FFFFFF;
}

[class*=features-],
[class*=team-],
[class*=projects-],
[class*=pricing-],
[class*=testimonials-],
[class*=contactus-] {
  padding: 80px 0;
}

.section-image {
  background-position: center center;
  background-size: cover;
}
.section-image:before {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.section-image .container {
  position: relative;
  z-index: 2;
}

.section-login {
  min-height: 700px;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .page-header .content-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -75%);
  }
  .page-header .presentation-title {
    background: none !important;
  }
}
[class*=features-],
[class*=team-],
[class*=projects-],
[class*=pricing-],
[class*=testimonials-],
[class*=contactus-] {
  padding: 80px 0;
}

.section-image {
  background-position: center center;
  background-size: cover;
}
.section-image:before {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  display: block;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.section-image .container {
  position: relative;
  z-index: 2;
}

/*          Changes for small display      */
@media (max-width: 767px) {
  #cd-vertical-nav {
    display: none !important;
  }
  .coloured-cards .card-big-shadow {
    margin: 0 auto;
  }
  .register-page .page-header {
    max-height: 2000px;
  }
  .section-testimonials .our-clients {
    margin-top: 0 !important;
  }
  .navbar-transparent {
    background-color: rgba(0, 0, 0, 0.45);
  }
  .register .page-header {
    max-height: fit-content;
  }
  .form-group.has-danger {
    margin-bottom: 30px;
  }
  body {
    position: relative;
    font-size: 12px;
  }
  h6 {
    font-size: 1em;
  }
  .navbar .container {
    left: 0;
    width: 100%;
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    position: relative;
  }
  .navbar .navbar-nav .dropdown-menu {
    height: 400px;
    overflow-y: scroll;
  }
  .demo-header .motto {
    padding-top: 30% !important;
  }
  .navbar-toggle .icon-bar {
    display: block;
    position: relative;
    background: #fff;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    margin: 0 auto;
  }
  .navbar-header .navbar-toggle {
    margin-top: 12px;
    width: 40px;
    height: 40px;
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .navbar-nav {
    margin: 1px -15px;
  }
  .navbar-nav .open .dropdown-menu > li > a {
    padding: 15px 15px 5px 50px;
  }
  .navbar-nav .open .dropdown-menu > li:first-child > a {
    padding: 5px 15px 5px 50px;
  }
  .navbar-nav .open .dropdown-menu > li:last-child > a {
    padding: 15px 15px 25px 50px;
  }
  [class*=navbar-] .navbar-nav > li > a, [class*=navbar-] .navbar-nav > li > a:hover, [class*=navbar-] .navbar-nav > li > a:focus, [class*=navbar-] .navbar-nav .active > a, [class*=navbar-] .navbar-nav .active > a:hover, [class*=navbar-] .navbar-nav .active > a:focus, [class*=navbar-] .navbar-nav .open .dropdown-menu > li > a, [class*=navbar-] .navbar-nav .open .dropdown-menu > li > a:hover, [class*=navbar-] .navbar-nav .open .dropdown-menu > li > a:focus, [class*=navbar-] .navbar-nav .navbar-nav .open .dropdown-menu > li > a:active {
    color: white;
  }
  [class*=navbar-] .navbar-nav > li > a:not(.btn),
  [class*=navbar-] .navbar-nav > li > a:hover,
  [class*=navbar-] .navbar-nav > li > a:focus,
  [class*=navbar-] .navbar-nav .open .dropdown-menu > li > a:not(.btn),
  [class*=navbar-] .navbar-nav .open .dropdown-menu > li > a:hover,
  [class*=navbar-] .navbar-nav .open .dropdown-menu > li > a:focus {
    opacity: 0.7;
    background: transparent;
  }
  [class*=navbar-] .navbar-nav.navbar-nav .open .dropdown-menu > li > a:active {
    opacity: 1;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:hover .caret {
    border-bottom-color: #777;
    border-top-color: #777;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:active .caret {
    border-bottom-color: white;
    border-top-color: white;
  }
  .footer .footer-nav,
  .footer .credits {
    margin: 0 auto;
  }
  #typography .typography-line .note {
    margin-left: 7px !important;
  }
  .dropdown-menu {
    display: none;
  }
  .navbar-fixed-top {
    -webkit-backface-visibility: hidden;
  }
  .social-line .btn {
    margin: 0 0 10px 0;
  }
  .subscribe-line .form-control {
    margin: 0 0 10px 0;
  }
  .social-line.pull-right {
    float: none;
  }
  .footer nav.pull-left {
    float: none !important;
  }
  .footer:not(.footer-big) nav > ul li {
    float: none;
  }
  .social-area.pull-right {
    float: none !important;
  }
  .form-control + .form-control-feedback {
    margin-top: 5px;
  }
  .form-control.form-control-danger.no-border {
    margin-top: 15px;
  }
  .navbar-toggle:hover, .navbar-toggle:focus {
    background-color: transparent !important;
  }
  .btn.dropdown-toggle {
    margin-bottom: 0;
  }
  .media-post .author {
    width: 25%;
    float: none !important;
    display: block;
    margin: 0 auto 10px;
  }
  .media-post .media-body {
    width: 100%;
  }
  .modal-footer .btn-simple {
    padding: 15px;
  }
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    border: 1px solid #dddddd;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
  .typography-line {
    padding-left: 100px !important;
  }
  .projects-1 .project-pills .nav.nav-pills {
    display: block !important;
  }
  .projects-1 .project-pills .nav.nav-pills .nav-item:first-child .nav-link {
    border-radius: 12px 12px 0 0 !important;
    margin-left: -1px;
  }
  .projects-1 .project-pills .nav.nav-pills .nav-item.active:first-child .nav-link {
    border-radius: 12px 12px 0 0 !important;
    margin-left: -1px;
  }
  .projects-1 .project-pills .nav.nav-pills .nav-item:last-child .nav-link {
    border-radius: 0 0 12px 12px !important;
    margin-left: -1px;
  }
  .testimonials-2 .testimonials-people img,
  .section-testimonials .testimonials-people img {
    display: none !important;
  }
  .presentation-page .components-container .card {
    margin-bottom: 40px !important;
  }
  .btn-wd {
    min-width: 280px;
  }
  .presentation-page .title-brand .type {
    font-size: 16px;
    transform: translateY(-28px);
    -webkit-transform: translateY(-28px);
    -moz-transform: translateY(-28px);
    -o-transform: translateY(-28px);
  }
  .presentation-page .section-cards,
  .presentation-page .section-components {
    overflow: hidden;
  }
  .presentation-page .section-cards .first-card,
  .presentation-page .section-components .first-card {
    top: 750px !important;
  }
  .presentation-page .section-cards .first-card .grid__link,
  .presentation-page .section-components .first-card .grid__link {
    max-width: 200px !important;
  }
  .presentation-page .section-cards .fourth-card,
  .presentation-page .section-components .fourth-card {
    top: 940px !important;
  }
  .presentation-page .section-cards .fourth-card .grid__link,
  .presentation-page .section-components .fourth-card .grid__link {
    max-width: 200px !important;
  }
  .presentation-page .section-cards .fifth-card,
  .presentation-page .section-components .fifth-card {
    top: 950px !important;
    left: 220px !important;
  }
  .presentation-page .section-cards .fifth-card .grid__link,
  .presentation-page .section-components .fifth-card .grid__link {
    max-width: 200px !important;
  }
  .presentation-page .section-cards .sixth-card,
  .presentation-page .section-components .sixth-card {
    top: 1335px !important;
    left: 220px !important;
  }
  .presentation-page .section-cards .sixth-card .grid__link,
  .presentation-page .section-components .sixth-card .grid__link {
    max-width: 200px !important;
  }
  .presentation-page .section-cards .seventh-card,
  .presentation-page .section-components .seventh-card {
    top: 1155px !important;
  }
  .presentation-page .section-cards .seventh-card .grid__link,
  .presentation-page .section-components .seventh-card .grid__link {
    max-width: 200px !important;
  }
  .presentation-page .section-content .image-container .add-animation {
    max-height: 250px !important;
    max-width: 180px !important;
  }
  .presentation-page .section-components .image-container .components-macbook {
    max-width: 580px !important;
    max-height: 400px !important;
  }
  .presentation-page .section-components .image-container .social-img,
  .presentation-page .section-components .image-container .share-btn-img {
    display: none;
  }
  .presentation-page .section-components .title {
    margin-top: -100px !important;
  }
  .presentation-page .section-examples {
    padding-top: 0 !important;
    margin-top: 10px !important;
  }
  .presentation-page .section-icons .icons-nucleo .nc-icon:not(.ninth-left-icon):not(.seventh-left-icon):not(.third-left-icon) {
    display: none !important;
  }
  .bootstrap-datetimepicker-widget {
    visibility: visible !important;
  }
  .presentation-page .fog-low {
    margin-bottom: -35px;
  }
  .presentation-page .presentation-title {
    font-size: 5em;
  }
  .presentation-page .presentation-subtitle {
    margin-top: 40px;
  }
  .presentation-page .title-brand {
    max-width: 450px;
  }
  .presentation-page .title-brand .type {
    font-size: 16px;
  }
  .demo-icons ul li {
    width: 20%;
    float: left;
  }
  .info.info-separator:after {
    display: none;
  }
  .pricing-5 .choose-plan {
    text-align: center;
  }
  .pricing-5 .choose-plan .nav.nav-pills {
    display: inline-flex;
  }
  .pricing-5 .description {
    text-align: center;
  }
  .page-carousel .carousel-inner [class*=col-md] {
    margin-left: 0 !important;
  }
  .page-carousel .right.carousel-control {
    margin-right: 0 !important;
  }
  .page-carousel .left.carousel-control {
    margin-left: 0 !important;
  }
  .subscribe-line .form-control {
    border: 1px solid #DDDDDD;
    padding-left: 10px;
  }
  .subscribe-line .btn {
    margin: 0 auto;
  }
}
@media screen and (max-width: 991px) {
  .navbar-collapse {
    position: fixed;
    display: block !important;
    top: 0;
    height: 100%;
    width: 230px;
    right: 0;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    border-left: 1px solid #CCC5B9;
    padding-right: 0px;
    padding-left: 40px;
    padding-top: 15px;
    transform: translateX(230px);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .navbar-collapse ul {
    position: relative;
    z-index: 3;
    height: 95%;
  }
  .navbar-collapse .navbar-nav > .nav-item:last-child {
    border-bottom: 0;
  }
  .navbar-collapse .navbar-nav > .nav-item > .nav-link {
    margin: 0px 0px;
    color: #9A9A9A !important;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    line-height: 1.5em;
    padding: 15px 0;
  }
  .navbar-collapse .navbar-nav > .nav-item > .nav-link:hover, .navbar-collapse .navbar-nav > .nav-item > .nav-link:active {
    color: #23452f !important;
  }
  .navbar-collapse::after {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #DCEDCD;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(112, 112, 112, 0) 60%, rgba(186, 186, 186, 0.15) 100%);
    display: block;
    content: "";
    z-index: 1;
  }
  .navbar-collapse.has-image::after {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: rgba(17, 17, 17, 0.8);
    display: block;
    content: "";
    z-index: 1;
  }
  .nav-open .navbar-collapse {
    transform: translateX(0px);
  }
  .nav-open .wrapper {
    left: 0;
    transform: translateX(-230px);
  }
  .nav-open .navbar-translate {
    transform: translateX(-230px);
  }
  .wrapper .navbar-collapse {
    display: none;
  }
  .register-page.full-screen .page-header .container {
    margin-top: 30%;
  }
  .dropdown.show .dropdown-menu,
  .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    height: auto;
  }
  .dropdown.show .dropdown-menu .dropdown-item:hover,
  .dropdown.show .dropdown-menu .dropdown-item:focus,
  .dropdown .dropdown-menu .dropdown-item:hover,
  .dropdown .dropdown-menu .dropdown-item:focus {
    background-color: transparent;
    border-radius: 0;
  }
  .dropdown.show .dropdown-menu .dropdown-item a:hover, .dropdown.show .dropdown-menu .dropdown-item a:focus,
  .dropdown .dropdown-menu .dropdown-item a:hover,
  .dropdown .dropdown-menu .dropdown-item a:focus {
    color: #23452f;
  }
  .dropdown.show .dropdown-menu:before, .dropdown.show .dropdown-menu:after,
  .dropdown .dropdown-menu:before,
  .dropdown .dropdown-menu:after {
    display: none;
  }
  .dropdown .dropdown-menu {
    display: none;
  }
  .dropdown.show .dropdown-menu {
    display: block;
    position: static;
    float: none;
    background: transparent !important;
  }
  .navbar-translate {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    transform: translateX(0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 230px;
    content: "";
    z-index: 1029;
    overflow-x: hidden;
  }
  .wrapper {
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    left: 0;
    background-color: white;
  }
  .container-cards [class*=col-md-] {
    padding-left: 5px;
    padding-right: 5px;
  }
  .container-cards .social-buttons {
    z-index: 1;
  }
  .full-screen.login .page-header {
    display: grid;
  }
  .comments.media-area .media {
    display: block;
  }
  .comments.media-area .media .media-body {
    margin-left: 2em;
  }
  .comments.media-area .media .media-body p {
    margin-top: 15px;
  }
  .section-navbars .navbar-collapse,
  .section-navigation .navbar-collapse,
  #navbar-dropdown .navbar-collapse {
    display: none !important;
  }
  .header-4 video {
    width: auto;
    height: 100vh;
  }
  .subscribe-line .btn.btn-block {
    width: auto;
  }
  .form-control + .form-control-feedback {
    padding-left: 0 !important;
  }
}
@media screen and (min-width: 991px) {
  .burger-menu .navbar-collapse {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 230px;
    right: 0px;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    border-left: 1px solid #CCC5B9;
    padding-right: 0px;
    padding-left: 40px;
    padding-top: 15px;
    transform: translateX(230px);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .navbar-collapse .navbar-nav .nav-item:last-child {
    border-bottom: 0;
  }
  .burger-menu .navbar-collapse .navbar-nav {
    height: 100%;
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .burger-menu .navbar-collapse::after {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #DCEDCD;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(112, 112, 112, 0) 60%, rgba(186, 186, 186, 0.15) 100%);
    display: block;
    content: "";
    z-index: 1;
  }
  .burger-menu .navbar-collapse.has-image::after {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: rgba(17, 17, 17, 0.8);
    display: block;
    content: "";
    z-index: 1;
  }
  .burger-menu .navbar .container .navbar-toggler {
    display: block;
    margin-top: 20px;
  }
  .burger-menu .navbar-translate {
    width: 100%;
    position: relative;
    transform: translateX(0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .burger-menu .wrapper {
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
    left: 0;
    background-color: white;
  }
  .burger-menu .body .navbar-collapse.collapse {
    height: 100vh !important;
  }
  .burger-menu .navbar-collapse:before, .burger-menu .navbar-collapse:after,
  .burger-menu .navbar-nav:before,
  .burger-menu .navbar-nav:after {
    display: table;
    content: " ";
  }
  .nav-open .burger-menu .navbar-collapse.collapse {
    transform: translateX(0px);
  }
  .nav-open .burger-menu .wrapper {
    left: 0;
    transform: translateX(-230px);
  }
  .nav-open .burger-menu .navbar-translate {
    transform: translateX(-230px);
  }
  .burger-menu .dropdown.show .dropdown-menu,
  .burger-menu .dropdown .dropdown-menu {
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
  }
  .burger-menu .dropdown.show .dropdown-menu .dropdown-item:hover,
  .burger-menu .dropdown.show .dropdown-menu .dropdown-item:focus,
  .burger-menu .dropdown .dropdown-menu .dropdown-item:hover,
  .burger-menu .dropdown .dropdown-menu .dropdown-item:focus {
    background-color: transparent;
    border-radius: 0;
  }
  .burger-menu .dropdown.show .dropdown-menu .dropdown-item a:hover, .burger-menu .dropdown.show .dropdown-menu .dropdown-item a:focus,
  .burger-menu .dropdown .dropdown-menu .dropdown-item a:hover,
  .burger-menu .dropdown .dropdown-menu .dropdown-item a:focus {
    color: #23452f;
  }
  .burger-menu .dropdown.show .dropdown-menu:before, .burger-menu .dropdown.show .dropdown-menu:after,
  .burger-menu .dropdown .dropdown-menu:before,
  .burger-menu .dropdown .dropdown-menu:after {
    display: none;
  }
  .burger-menu .dropdown .dropdown-menu {
    display: none;
  }
  .burger-menu .dropdown.show .dropdown-menu {
    display: block;
  }
  .lightbox .modal-dialog {
    width: 960px;
  }
}
@media screen and (min-width: 767px) {
  .section-sections .section-cols {
    position: relative;
    z-index: 1;
  }
  .register-page .page-header .container {
    margin-top: 150px;
  }
}
@media (max-width: 1023px) and (min-width: 767px) {
  .presentation-page .section-content .image-container .area-img {
    max-width: 190px;
    max-height: 270px;
  }
  .presentation-page .section-content .image-container .info-img {
    max-width: 190px;
    max-height: 270px;
    left: -20%;
  }
  .presentation-page .section-content .section-description {
    margin-top: 0 !important;
  }
  .presentation-page .section-components .components-macbook {
    left: -75px !important;
  }
  .presentation-page .section-cards .codrops-header {
    margin-top: 10px !important;
  }
}
@media (max-width: 1367px) and (min-width: 1024px) {
  .presentation-page .section-components .basic-container {
    margin-left: 5em;
  }
}
@media (max-width: 500px) {
  .presentation-page .section-header .card {
    min-height: 230px;
  }
  #cards .card-profile {
    margin-top: 50px;
  }
  .pricing-5 .title {
    text-align: center;
  }
  .presentation-page .presentation-title {
    font-size: 4em;
  }
  .presentation-page .title-brand .type {
    font-size: 12px;
    padding: 4px 7px;
    border-radius: 4px;
    top: 0;
    font-weight: 600;
    margin-top: 20px;
    right: 2px;
  }
  .presentation-page .section-cards .codrops-header .description {
    max-width: 220px;
  }
  .register-page .page-header .container .info:first-of-type {
    margin-top: 50px;
  }
}
@media screen and (max-width: 1367px) {
  .presentation-page .section-cards,
  .presentation-page .section-components {
    overflow: hidden;
  }
}
@media screen and (min-width: 1025) {
  .section-sections .section-cols {
    position: relative;
    z-index: 1;
  }
  .section-sections .section-cols .row:first-of-type {
    margin-top: 50px;
    margin-right: -120px;
    margin-left: -15px;
    transform: translateX(-80px);
  }
  .section-sections .section-cols .row:nth-of-type(2) {
    margin-left: -100px;
    margin-right: -15px;
    transform: translateX(80px);
  }
  .section-sections .section-cols .row:nth-of-type(3) {
    margin-right: -120px;
    margin-left: 0px;
    transform: translateX(-120px);
  }
  .section-sections .section-cols .row:nth-of-type(4) {
    margin-right: -100px;
    margin-left: -15px;
    transform: translateX(-50px);
  }
}
@media only screen and (min-width: 1024px) {
  .demo-icons ul li {
    width: 12.5%;
    float: left;
    padding: 32px 0;
  }
}
@media (max-width: 1200px) {
  .presentation-page .presentation-title {
    font-size: 7em;
  }
  .presentation-page .title-brand {
    max-width: 650px;
  }
}
@media (max-width: 1200px) {
  .presentation .section-images .image img {
    width: 100%;
  }
}
@media screen and (max-width: 374px) {
  .footer.footer-big .copyright .pull-left, .footer.footer-big .copyright .pull-right {
    float: none !important;
  }
  .full-screen.login .card.card-register {
    margin-bottom: 20px;
  }
  .full-screen.login .demo-footer {
    margin-left: -15px;
  }
  .about-us .header-wrapper {
    height: auto !important;
  }
  .presentation-page .section-content .image-container .area-img {
    max-width: 170px !important;
  }
}
/*! nouislider - 14.0.2 - 6/28/2019 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
/*

This file was modified by Creative-Tim

*/
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
  outline: none;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 1px;
}

.noUi-horizontal .noUi-handle {
  width: 15px;
  height: 15px;
  left: -7px;
  top: -6px;
  border-radius: 50%;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 15px;
  height: 15px;
  left: 0px;
  top: -7px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -7px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.125rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #FFFFFF;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #FFFFFF;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #FFFFFF !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #1C4922 !important;
  color: #FFFFFF;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #E3E3E3;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #DDDDDD;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #1C4922;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #1C4922;
  border-radius: 50%;
  border: 1px solid #1C4922;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #DDDDDD;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #1C4922 !important;
  color: #FFFFFF;
}

.form-group .rdt {
  margin-bottom: 0;
  flex: 1 1 auto;
  width: 1%;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  padding-left: 0;
  border-right: 1px solid #DDDDDD;
}

.input-group > .rdt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  padding-right: 0;
  border-left: 1px solid #DDDDDD;
  padding-left: 0.75rem;
}

.dropdown .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, 0px, 0) !important;
}
.dropdown .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, 0px, 0) !important;
}
.dropdown.show .dropdown-menu[x-placement=top-start] {
  transform: translate3d(0, -50px, 0) !important;
  top: auto !important;
  bottom: 0 !important;
}
.dropdown.show .dropdown-menu[x-placement=bottom-start] {
  transform: translate3d(0, 40px, 0) !important;
  bottom: auto !important;
  top: 0 !important;
}

.input-group .input-group-append .input-group-text {
  border-right: 1px solid #DDDDDD;
}

@media screen and (max-width: 991px) {
  .navbar-collapse {
    height: 100% !important;
  }
}
@media screen and (max-width: 320px) {
  .index .presentation-subtitle {
    margin-bottom: 100px;
  }
  .index .category.category-absolute {
    margin-top: 20px;
  }
}
@media screen and (max-width: 374px) {
  .index .presentation-subtitle {
    margin-bottom: 100px;
  }
  nav[aria-label=pagination] {
    justify-content: center;
    text-align: center;
  }
  nav[aria-label=pagination] .pagination {
    display: inline-block;
  }
  nav[aria-label=pagination] .pagination .page-item {
    margin-bottom: 5px;
  }
  .register-page .page-header .container {
    margin-top: 7rem !important;
  }
}
.custom-switch {
  padding-left: 3.25rem;
  min-height: 2rem;
  display: flex;
}
.custom-switch .custom-control-label {
  display: inline-flex;
  align-items: center;
}
.custom-switch .custom-control-label::after {
  height: calc(1.625rem - 4px);
  width: calc(1.625rem - 4px);
  left: calc(-3.25rem + 2px);
  border-radius: 2.5rem;
  background-color: white;
}
.custom-switch .custom-control-label::before {
  height: 1.625rem;
  width: 3rem;
  left: -3.25rem;
  border-radius: 2.5rem;
  background-color: #adb5bd;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(1.35rem);
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #A38354;
  border-color: #A38354;
}
.popover {
  box-shadow: 0 10px 50px 0 rgba(0, 0, 0, 0.2);
  z-index: 1050;
}

.bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-tooltip-auto[x-placement^=top] .arrow::after, .bs-tooltip-top .arrow::after,
.bs-tooltip-auto[x-placement^=left] .arrow::after, .bs-tooltip-left .arrow::after,
.bs-tooltip-auto[x-placement^=right] .arrow::after, .bs-tooltip-right .arrow::after,
.bs-tooltip-auto[x-placement^=bottom] .arrow::after, .bs-tooltip-bottom .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-auto[x-placement^=left] .arrow::after, .bs-tooltip-left .arrow::after {
  right: 1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #fff;
}

.bs-tooltip-auto[x-placement^=top] .arrow::after, .bs-tooltip-top .arrow::after {
  bottom: 1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #fff;
}

.bs-tooltip-auto[x-placement^=right] .arrow::after, .bs-tooltip-right .arrow::after {
  left: 1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #fff;
}

.bs-tooltip-auto[x-placement^=bottom] .arrow::after, .bs-tooltip-bottom .arrow::after {
  top: 1px;
  border-width: 0 0.4rem 0.4rem 0.4rem;
  border-bottom-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/paper-kit.scss","webpack://./src/assets/scss/paper-kit/_variables.scss","webpack://./src/assets/scss/paper-kit/plugins/_plugin-bootstrap-switch.scss","webpack://./src/assets/scss/paper-kit/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/paper-kit/plugins/_plugin-datepicker.scss","webpack://./src/assets/scss/paper-kit/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/paper-kit/_buttons.scss","webpack://./src/assets/scss/paper-kit/mixins/_buttons.scss","webpack://./src/assets/scss/paper-kit/mixins/_transparency.scss","webpack://./src/assets/scss/paper-kit/mixins/_inputs.scss","webpack://./src/assets/scss/paper-kit/_inputs.scss","webpack://./src/assets/scss/paper-kit/_checkbox-radio.scss","webpack://./src/assets/scss/paper-kit/_progress-bars.scss","webpack://./src/assets/scss/paper-kit/_badges.scss","webpack://./src/assets/scss/paper-kit/_pagination.scss","webpack://./src/assets/scss/paper-kit/_typography.scss","webpack://./src/assets/scss/paper-kit/_misc.scss","webpack://./src/assets/scss/paper-kit/mixins/_navbars.scss","webpack://./src/assets/scss/paper-kit/_labels.scss","webpack://./src/assets/scss/paper-kit/_nucleo-icons.scss","webpack://./src/assets/scss/paper-kit/_social-buttons.scss","webpack://./src/assets/scss/paper-kit/_tabs-navs.scss","webpack://./src/assets/scss/paper-kit/_navbars.scss","webpack://./src/assets/scss/paper-kit/_dropdown.scss","webpack://./src/assets/scss/paper-kit/_alerts.scss","webpack://./src/assets/scss/paper-kit/_images.scss","webpack://./src/assets/scss/paper-kit/_tooltips-and-popovers.scss","webpack://./src/assets/scss/paper-kit/mixins/_popovers.scss","webpack://./src/assets/scss/paper-kit/_modal.scss","webpack://./src/assets/scss/paper-kit/_icons.scss","webpack://./src/assets/scss/paper-kit/_carousel.scss","webpack://./src/assets/scss/paper-kit/_footers.scss","webpack://./src/assets/scss/paper-kit/_cards.scss","webpack://./src/assets/scss/paper-kit/cards/_card-plain.scss","webpack://./src/assets/scss/paper-kit/cards/_card-register.scss","webpack://./src/assets/scss/paper-kit/cards/_card-profile.scss","webpack://./src/assets/scss/paper-kit/_examples.scss","webpack://./src/assets/scss/paper-kit/_sections.scss","webpack://./src/assets/scss/paper-kit/_responsive.scss","webpack://./src/assets/scss/react/plugins/_plugin-nouislider.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/paper-kit/_dropdown.scss","webpack://./src/assets/scss/react/paper-kit/_inputs.scss","webpack://./src/assets/scss/react/paper-kit/_navbars.scss","webpack://./src/assets/scss/react/paper-kit/_responsive.scss","webpack://./src/assets/scss/react/paper-kit/_switch.scss","webpack://./src/assets/scss/react/paper-kit/_tooltips-and-popovers.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAAA;AC4EA,yDAAA;AAEA,0EAAA;AC9EA;;;;;;EAAA;AAYC;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;AFcH;;AEXC;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AFcH;;AEXC;;;EAKI,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;AFcL;AEZK;;;EACI,eAAA;EACA,iBAAA;AFgBT;;AEZC;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;AFeH;;AEZC;;EAEE,WAAA;EACA,mBDhF0B;AD+F7B;;AEZC;;EAEE,WAAA;EACA,mBDrF0B;ADoG7B;;AEZC;;EAEE,WAAA;EACA,mBD5F0B;AD2G7B;;AEZC;;EAEE,mBDhG0B;ECiG1B,WAAA;AFeH;;AEZC;;EAEE,WAAA;EACA,mBDtG0B;ADqH7B;;AEXC;EACE,WAAA;EACA,mBD1G0B;ADwH7B;;AEXC;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kEAAA;AFcH;;AEXC;EACE,8BAAA;EACA,2BAAA;AFcH;;AEXC;EACE,gBAAA;AFcH;;AEXC;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AFcH;;AEXC;;EAEE,YAAA;AFcH;;AEXC;;;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;AFcH;;AEXC;;;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;AFcH;;AEXC;;;EAGE,iBAAA;EACA,eAAA;EACA,iBAAA;AFcH;;AEXC;;;EAGE,0BAAA;AFcH;;AEXC;;;;;;;;;EASE,YAAA;EACA,yBAAA;EACA,0BAAA;AFcH;;AEXC;EAEE,4BAAA;AFcH;;AEXC;EACE,4BAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;AFcH;;AEXC;EACE,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,2BAAA;AFcH;;AEXC;EACE,4BAAA;AFcH;;AEXC;EACE,6BAAA;AFcH;;AEXC;EACE,sBAAA;EACA,iBAAA;AFcH;;AEXC;EACE,sBAAA;EACA,6BAAA;AFcH;;AEXC;EACE,yBAAA;AFcH;;AEXC;EACE,yBAAA;AFcH;;AEXC;EACE,yBDjP0B;AD+P7B;;AEXC;EACE,yBDtP0B;ADoQ7B;;AEXC;EACE,yBD3P0B;ADyQ7B;;AEXC;EACE,yBD/P0B;AD6Q7B;;AEXC;EACE,yBDlQ0B;ADgR7B;;AEZC;EACE,yBDlQ0B;ADiR7B;;AEZC;;;;;EAKE,yBAAA;AFeH;;AG9RA;;;EAAA;AAIA;;EAEA,2BAAA;EACA,yBAAA;EAEC,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AHiSD;;AG/RA;EACC,kBAAA;EACA,cAAA;AHkSD;;AGhSA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA,EAAA,YAAA;AHmSD;;AGjSA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;AHoSD;;AGlSA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EAEG,SAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AHoSJ;AGnSI;EACI,sBAAA;EACA,yBAAA;AHqSR;AGpSQ;EACI,iBAAA;AHsSZ;;AGlSA;EACC,kBAAA;EACA,UAAA;AHqSD;;AGnSA;;EAGC,wDAAA;AHsSD;;AGpSA;EACC,0BAAA;AHuSD;;AGpSA;;EAAA;AAGA;;EAGC,+BAAA;AHuSD;;AGpSA;EAAA;AAEA;EACC,WAAA;EACG,cAAA;AHuSJ;;AGrSA;EACC,WAAA;AHwSD;;AGtSA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AHySD;;AGtSA;EAAA;AAEA;EACC,mBAAA;EACA,kBAAA;AHySD;;AGvSA;EACC,mBAAA;EAEA,4BAAA;AH0SD;;AGvSA;EAAA;AAEA;EACC,gBAAA;AH0SD;;AGxSA;EACC,gBAAA;AH2SD;;AGzSA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBFtGyB;ADkZ7B;AG1SI;EACI,+BAAA;AH4SR;;AGzSA;;EAEC,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AH4SD;;AG1SA;EACC,SAAA;AH6SD;;AG1SA;EAAA;AAGA;EACC,mBAAA;AH4SD;;AG1SA;;;EAGC,mBAAA;AH6SD;;AG1SA;EACI,mBAAA;AH6SJ;AG3SI;EACI,yBFtJqB;EEuJrB,kBAAA;AH6SR;AG1SI;EACI,qBF3JqB;ADuc7B;AGxSQ;EACI,yBF/JiB;ADyc7B;AGvSQ;EACI,qBFnKiB;AD4c7B;AGrSQ;EACI,yBFzKiB;ADgd7B;AGpSQ;EACI,qBF7KiB;ADmd7B;AGlSQ;EACI,yBFjLiB;ADqd7B;AGjSQ;EACI,qBFrLiB;ADwd7B;AG/RQ;EACK,yBFzLgB;AD0d7B;AG9RS;EACI,qBF7LgB;AD6d7B;;AIjeA;;;;EAAA;AAKA;;;;;;;;;;;;;EAaE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AJoeF;;AIjeA;EACE,gBAAA;AJoeF;;AIleA;EACE,6BAAA;AJqeF;;AIneA;EACE,YAAA;EACA,WAAA;AJseF;;AIpeA;EACE;IACE,WAAA;EJueF;AACF;AIreA;EACE;IACE,WAAA;EJueF;AACF;AIreA;EACE;IACE,WAAA;EJueF;AACF;AIreA;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AJueJ;;AIreA;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AJweJ;;AIteA;EACE,gBAAA;EACA,oBAAA;AJyeF;;AIveA;EACE,gBAAA;EACA,kBAAA;AJ0eF;;AIxeA;EACE,UAAA;EACA,UAAA;AJ2eF;;AIzeA;EACE,UAAA;EACA,UAAA;AJ4eF;;AI1eA;EACE,SAAA;AJ6eF;;AI3eA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,6BAAA;AJ8eF;;AI5eA;;EAEI,yBAAA;AJ+eJ;;AI7eA;EACE,6BAAA;EACA,gCAAA;AJgfF;;AI9eA;EACE,gBAAA;AJifF;;AI/eA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AJkfF;;AIhfA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AJmfF;;AIhfA;EACE,0BAAA;AJmfF;;AIjfA;EACE,4BAAA;AJofF;;AIlfA;EACE,0BAAA;AJqfF;;AInfA;EACE,4BAAA;AJsfF;;AIpfA;EACE,qBAAA;AJufF;;AIrfA;EACE,uBAAA;AJwfF;;AItfA;EACE,uBAAA;AJyfF;;AIvfA;EACE,2BAAA;AJ0fF;;AIxfA;EACE,gCAAA;AJ2fF;;AIzfA;EACE,kBAAA;EACA,kBAAA;AJ4fF;;AI1fA;EACE,uCAAA;AJ6fF;;AI3fA;EACE,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AJ8fF;;AI5fA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,0BAAA;AJ+fF;;AI7fA;EACE,WAAA;EACA,SAAA;AJggBF;;AI9fA;EACE,kBAAA;AJigBF;;AI/fA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AJkgBF;;AIhgBA;EACE,YAAA;AJmgBF;;AIjgBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AJogBF;;AIlgBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AJqgBF;;AIngBA;EACE,yBAAA;AJsgBF;;AIpgBA;EACE,qBAAA;AJugBF;;AIrgBA;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AJwgBF;;AItgBA;EACE,eAAA;AJygBF;;AIvgBA;EACE,mBAAA;AJ0gBF;;AIxgBA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AJ2gBF;;AIzgBA;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AJ4gBF;;AI1gBA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AJ6gBF;;AIzgBQ;ECjOJ,4BAAA;ALkvBJ;;AI5gBA;EACE,kBAAA;AJ+gBF;;AI7gBA;EACE,mBAAA;EACA,eAAA;AJghBF;;AI9gBA;EACE,cAAA;AJihBF;;AI9gBA;EACE,yBAAA;EACA,cAAA;AJihBF;;AI/gBA;EACE,4BAAA;AJkhBF;;AIhhBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AJmhBF;;AIjhBA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AJohBF;;AIlhBA;EACE,mBAAA;AJqhBF;;AInhBA;EACE,yBAAA;EACA,cAAA;AJshBF;;AIphBA;EACE,cAAA;AJuhBF;;AIrhBA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AJwhBF;;AIthBA;;;EAGE,6BAAA;AJyhBF;;AIvhBA;EACE,YAAA;EACA,iBAAA;AJ0hBF;;AIvhBA;EACE,eAAA;AJ0hBF;;AIvhBA;;;;;;EAME,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AJ0hBF;;AIxhBA;EACI,UAAA;EAKA,uCAAA;EAEA,yEAAA;AJ2hBJ;AIzhBI;EAKI,qCAAA;AJ2hBR;AIzhBI;EACI,UAAA;EAKA,iCAAA;EACA,iEAAA;AJ2hBR;;AIxhBA;EAKI,mCAAA;AJ2hBJ;AIzhBI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AJ2hBR;AIzhBI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AJ2hBR;;AM15BA;EACI,sBAAA;EACA,iBLayB;EKZzB,eL6I2B;EK5I3B,gBL+JyB;EK9JzB,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;ECNA,yBNIyB;EMHzB,qBNGyB;EMFzB,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;EHsBE,4BAAA;ALm5BJ;AMp6BI;EAEI,6BL8BqB;ADu4B7B;AO36BI;EAYI,yBN6BqB;EM5BrB,cNHqB;EMIrB,qBN2BqB;EM1BrB,gBAAA;APk6BR;AO/5BI;EACI,yBNTqB;AD06B7B;AO15BM;EAME,yBNSqB;EMRrB,qBNQqB;AD+4B7B;AOn5BI;EACI,cNvCqB;AD47B7B;AOn5BQ;EAMI,wCAAA;EACA,yBAAA;APg5BZ;AO74BQ;EACI,yBNpDiB;ADm8B7B;AO34BI;EACE,yBN9CuB;AD27B7B;AMz7BI;EAEI,qBAAA;EDTE,gBCUF;AN27BR;AMz7BI;EDZM,gBCeD;EACA,qBAAA;AN07BT;AMv7BI;EACI,sBAAA;EACA,6BAAA;ANy7BR;AMt7BI;EACI,kBAAA;EACA,QAAA;ANw7BR;;AMr7BA;EACI,mBL8E2B;EK7E3B,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;ANw7BJ;AMt7BI;EACI,uBAAA;ANw7BR;AMt7BI;EACI,eL6FuB;EK5FvB,gBAAA;ANw7BR;;AMp7BA;;;;EAII,iBAAA;ANu7BJ;;AMl7BA;EChEI,yBAAA;EACA,qBNDyB;EMEzB,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;ARs/BF;AOr/BI;EAYI,yBNgCqB;EM/BrB,cNHqB;EMIrB,qBN8BqB;EM7BrB,gBAAA;AP4+BR;AOz+BI;EACI,yBNTqB;ADo/B7B;AOp+BM;EAME,yBNYqB;EMXrB,qBNWqB;ADs9B7B;AO79BI;EACI,cN3CqB;AD0gC7B;AO79BQ;EAMI,wCAAA;EACA,yBAAA;AP09BZ;AOv9BQ;EACI,yBNxDiB;ADihC7B;AOr9BI;EACE,yBN9CuB;ADqgC7B;;AMn9BA;ECjEI,yBAAA;EACA,qBNDyB;EMEzB,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;ARwhCF;AOvhCI;EAYI,yBNmCqB;EMlCrB,cNHqB;EMIrB,qBNiCqB;EMhCrB,gBAAA;AP8gCR;AO3gCI;EACI,yBNTqB;ADshC7B;AOtgCM;EAME,yBNeqB;EMdrB,qBNcqB;ADq/B7B;AO//BI;EACI,cN3CqB;AD4iC7B;AO//BQ;EAMI,wCAAA;EACA,yBAAA;AP4/BZ;AOz/BQ;EACI,yBNxDiB;ADmjC7B;AOv/BI;EACE,yBN9CuB;ADuiC7B;;AMp/BA;EClEI,yBNCyB;EMAzB,qBAAA;EACA,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;AR0jCF;AOzjCI;EAYI,yBNsCqB;EMrCrB,cNHqB;EMIrB,qBNoCqB;EMnCrB,gBAAA;APgjCR;AO7iCI;EACI,yBNTqB;ADwjC7B;AOxiCM;EAME,yBNkBqB;EMjBrB,qBNiBqB;ADohC7B;AOjiCI;EACI,cN1CqB;AD6kC7B;AOjiCQ;EAMI,wCAAA;EACA,yBAAA;AP8hCZ;AO3hCQ;EACI,yBNvDiB;ADolC7B;AOzhCI;EACE,yBN9CuB;ADykC7B;;AMrhCA;ECnEI,yBNCyB;EMAzB,qBAAA;EACA,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;AR4lCF;AO3lCI;EAYI,yBNyCqB;EMxCrB,cNHqB;EMIrB,qBNuCqB;EMtCrB,gBAAA;APklCR;AO/kCI;EACI,yBNTqB;AD0lC7B;AO1kCM;EAME,yBNqBqB;EMpBrB,qBNoBqB;ADmjC7B;AOnkCI;EACI,cN1CqB;AD+mC7B;AOnkCQ;EAMI,wCAAA;EACA,yBAAA;APgkCZ;AO7jCQ;EACI,yBNvDiB;ADsnC7B;AO3jCI;EACE,yBN9CuB;AD2mC7B;;AMtjCA;ECpEI,yBNEyB;EMDzB,qBNCyB;EMAzB,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;AR8nCF;AO7nCI;EAYI,yBN4CqB;EM3CrB,cNHqB;EMIrB,qBN0CqB;EMzCrB,gBAAA;APonCR;AOjnCI;EACI,yBNTqB;AD4nC7B;AO5mCM;EAME,yBNwBqB;EMvBrB,qBNuBqB;ADklC7B;AOrmCI;EACI,cNzCqB;ADgpC7B;AOrmCQ;EAMI,wCAAA;EACA,yBAAA;APkmCZ;AO/lCQ;EACI,yBNtDiB;ADupC7B;AO7lCI;EACE,yBN9CuB;AD6oC7B;;AMvlCA;ECrEI,yBNeyB;EMdzB,qBNcyB;EMbzB,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;ARgqCF;AO/pCI;EAYI,yBN6BqB;EM5BrB,cNHqB;EMIrB,qBN2BqB;EM1BrB,gBAAA;APspCR;AOnpCI;EACI,yBNTqB;AD8pC7B;AO9oCM;EAME,yBNSqB;EMRrB,qBNQqB;ADmoC7B;AOvoCI;EACI,cN5BqB;ADqqC7B;AOvoCQ;EAMI,wCAAA;EACA,yBAAA;APooCZ;AOjoCQ;EACI,yBNzCiB;AD4qC7B;AO/nCI;EACE,yBN9CuB;AD+qC7B;;AMvnCA;ECLI,qBN9DyB;EM+DzB,cN/DyB;EOH3B,UDmEmB;EChEnB,0BAAA;ARisCF;AO/nCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;AP0nCN;AOznCM;EACI,0CN1EmB;ADqsC7B;AOvnCI;EACI,yBNxEqB;ADisC7B;AOlnCM;EAME,6BN3DqB;EM4DrB,qBNjGqB;ADgtC7B;;AM5oCA;ECNI,qBNlEyB;EMmEzB,cNnEyB;EOC3B,UDmEmB;EChEnB,0BAAA;ARutCF;AOrpCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;APgpCN;AO/oCM;EACI,0CN1EmB;AD2tC7B;AO7oCI;EACI,yBNxEqB;ADutC7B;AOxoCM;EAME,6BN3DqB;EM4DrB,qBNrGqB;AD0uC7B;;AMjqCA;ECPI,qBNlEyB;EMmEzB,cNnEyB;EOC3B,UDmEmB;EChEnB,0BAAA;AR6uCF;AO3qCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;APsqCN;AOrqCM;EACI,0CN1EmB;ADivC7B;AOnqCI;EACI,yBNxEqB;AD6uC7B;AO9pCM;EAME,6BN3DqB;EM4DrB,qBNrGqB;ADgwC7B;;AMtrCA;ECRI,qBNjEyB;EMkEzB,cNlEyB;EOA3B,UDmEmB;EChEnB,0BAAA;ARmwCF;AOjsCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;AP4rCN;AO3rCM;EACI,0CN1EmB;ADuwC7B;AOzrCI;EACI,yBNxEqB;ADmwC7B;AOprCM;EAME,6BN3DqB;EM4DrB,qBNpGqB;ADqxC7B;;AM3sCA;ECTI,qBNjEyB;EMkEzB,cNlEyB;EOA3B,UDmEmB;EChEnB,0BAAA;ARyxCF;AOvtCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;APktCN;AOjtCM;EACI,0CN1EmB;AD6xC7B;AO/sCI;EACI,yBNxEqB;ADyxC7B;AO1sCM;EAME,6BN3DqB;EM4DrB,qBNpGqB;AD2yC7B;;AMhuCA;ECVI,qBNhEyB;EMiEzB,cNjEyB;EOD3B,UDmEmB;EChEnB,0BAAA;AR+yCF;AO7uCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;APwuCN;AOvuCM;EACI,0CN1EmB;ADmzC7B;AOruCI;EACI,yBNxEqB;AD+yC7B;AOhuCM;EAME,6BN3DqB;EM4DrB,qBNnGqB;ADg0C7B;;AMrvCA;ECXI,qBNnDyB;EMoDzB,cNpDyB;EOd3B,UDmEmB;EChEnB,0BAAA;ARq0CF;AOnwCI;EAQE,oCAAA;EACA,+BNvEuB;EMwEvB,gCAAA;AP8vCN;AO7vCM;EACI,0CN1EmB;ADy0C7B;AO3vCI;EACI,yBNxEqB;ADq0C7B;AOtvCM;EAME,6BN3DqB;EM4DrB,qBNtFqB;ADy0C7B;AM1wCI;EAGI,yBAAA;EACA,yBLnEqB;AD60C7B;;AMvwCA;ECrFI,yBNeyB;EMdzB,qBNcyB;EMbzB,cNayB;EOd3B,UDEmB;ECCnB,0BAAA;EFmFE,cLnFyB;ADi2C7B;AOh2CI;EAYI,yBNFqB;EMGrB,cNHqB;EMIrB,qBNJqB;EMKrB,gBAAA;APu1CR;AOp1CI;EACI,yBNTqB;AD+1C7B;AO/0CM;EAME,yBNtBqB;EMuBrB,qBNvBqB;ADm2C7B;AOx0CI;EACI,cN5BqB;ADs2C7B;AOx0CQ;EAMI,wCAAA;EACA,yBAAA;APq0CZ;AOl0CQ;EACI,yBNzCiB;AD62C7B;AOh0CI;EACE,yBN9CuB;ADg3C7B;AMtyCI;EAGI,yBAAA;ANsyCR;AMlyCQ;EAEE,cL9FmB;ADi4C7B;AMhyCQ;EAGK,yBLzFgB;EK0FhB,cLrGgB;ADq4C7B;AM7xCI;EAGE,yBAAA;AN6xCN;AM1xCI;EACE,yBAAA;AN4xCN;AMzxCI;EAEI,6BAAA;AN0xCR;;AMrxCK;EE5HH,YF+HuB;EE5HvB,yBAAA;ARm5CF;;AMpxCA;EACI,oCAAA;EACA,iBAAA;ANuxCJ;AMrxCI;EAGI,qBAAA;EACA,yBAAA;ANqxCR;AMlxCI;EACI,YLzDwB;AD60ChC;;AMhxCA;ECxCG,eNkC4B;EMjC5B,kBAAA;AP4zCH;AO1zCG;EACI,kBAAA;AP4zCP;;AMrxCA;EC3CG,eNmC4B;EMlC5B,iBAAA;APo0CH;AOl0CG;EACI,iBAAA;APo0CP;;AM1xCA;EACI,gBAAA;AN6xCJ;;AM1xCA;EACI,WAAA;AN6xCJ;;AM3xCA;EACI,gBAAA;AN8xCJ;;AM5xCA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AN+xCJ;;AM5xCI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AN+xCR;AM7xCQ;EACI,eLnCmB;EKoCnB,mBAAA;AN+xCZ;AM5xCI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;AN8xCR;AM5xCQ;EACI,eAAA;EACA,UAAA;AN8xCZ;AM3xCI;EACI,uBAAA;AN6xCR;;AM1xCA;EACI,mBAAA;AN6xCJ;;AM3xCA;EACI,2BAAA;EACA,qBAAA;AN8xCJ;;AM3xCA;EACI,cAAA;AN8xCJ;;AM5xCA;EACI,gBAAA;AN+xCJ;;AM7xCA;EACI,4BAAA;ANgyCJ;;AM3xCY;EACG,gBLdkB;EKelB,eL7EgB;AD22C/B;AM7xCe;EACI,0BAAA;AN+xCnB;;AS/+CS;ECbP,cTkC2B;AD89C7B;;ASn/CS;ECbP,cTkC2B;ADk+C7B;;ASv/CS;ECbP,cTkC2B;ADs+C7B;;AUrgDA;EACI,uBAAA;AVwgDJ;;AUtgDA;EACI,yBTUyB;ESTzB,yBAAA;EACA,kBTmH4B;ESlH5B,cTLyB;ESMzB,eTmI2B;ESlI3B,yCAAA;EACA,2BAAA;EDbA,iBAAA;EACA,YR2I2B;EIjIrB,gBKIN;AV2gDJ;AUzgDI;EACG,yBTDsB;ESEtB,sBAAA;ELRG,gBKSH;EACA,qBAAA;AV4gDP;AUxgDY;;EACE,sBAAA;EACA,iBAAA;AV2gDd;AUtgDI;EACI,8BAAA;AVwgDR;AUngDe;;EACE,YAAA;AVsgDjB;AUhgDI;ELlCM,gBKsCF;AVggDR;AU7/CI;EACI,sBAAA;EACA,cTjDqB;ADgjD7B;AU7/CQ;EACI,+BAAA;AV+/CZ;AU5/CI;EACI,yBAAA;EACA,cT7DqB;AD2jD7B;AU5/CI;EACI,yBT1BqB;ES2BrB,yBAAA;EACA,cThEqB;AD8jD7B;AU5/CQ;EACI,+BAAA;AV8/CZ;AU3/CI;EACI,yBT1DqB;ES2DrB,yBAAA;AV6/CR;AU1/CI;EACI,kBT8CwB;ES7CxB,eT8DuB;ES7DvB,cT9EqB;ES+ErB,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBTqBuB;ESpBvB,sBAAA;AV4/CR;AUz/CI;EACI,0BAAA;EACA,gCAAA;AV2/CR;AUx/CI;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AV0/CN;AUv/CI;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AVy/CN;;AUp/CI;EACI,cT5GqB;ADmmD7B;;AUn/CI;EACI,cTnHqB;ADymD7B;;AUl/CA;EACE,iBAAA;EACA,iBAAA;AVq/CF;;AUn/CA;EACE,4BAAA;AVs/CF;;AUn/CA;;EAEE,kBAAA;AVs/CF;;AUn/CA;EACI,yBTrHyB;ESsHzB,kBTX4B;ESY5B,sBAAA;EACA,kBAAA;AVs/CJ;AUp/CI;EAEI,yBT7HqB;ADknD7B;AUn/CI;EACI,cT7IqB;ADkoD7B;AUn/CI;EACI,cTlJqB;ADuoD7B;AUn/CI;EAEI,yBTvIqB;AD2nD7B;;AU9+CI;EACE,SAAA;AVi/CN;;AU3+CA;EACI,kBAAA;EACA,YAAA;AV8+CJ;;AU5+CA;EACI,kBAAA;AV++CJ;;AU3+CE;EACE,wCAAA;AV8+CJ;AU5+CE;EACE,iBAAA;AV8+CJ;AU3+CE;;EAEE,wCAAA;AV6+CJ;;AUv+CI;EACI,mBAAA;AV0+CR;;AUp+CQ;EACI,gBAAA;AVu+CZ;;AW5qDA;;EAEI,mBAAA;EACA,kBAAA;AX+qDJ;;AW5qDA;EACE,eAAA;EACA,qBAAA;AX+qDF;AW7qDI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AX+qDR;AW5qDI;;EAEI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,yBAAA;EAKA,+BAAA;AX8qDR;AW5qDI;EACI,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AX8qDR;AW3qDQ;EACI,cVfiB;EUgBjB,YAAA;EACA,mBAAA;AX6qDZ;;AWlqDA;;EAEI,UAAA;EACA,kBAAA;EACA,kBAAA;AXqqDJ;;AWnqDA;EACI,UAAA;AXsqDJ;;AWnqDA;;EAEI,mBAAA;AXsqDJ;;AWnqDA;;EAEI,+BAAA;AXsqDJ;;AWnqDA;EACE,iBAAA;AXsqDF;AWpqDI;EACI,kBAAA;AXsqDR;AWnqDQ;EACI,cVxDiB;EUyDjB,YAAA;EACA,mBAAA;AXqqDZ;;AWhqDA;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AXmqDJ;;AWhqDA;EACI,yBAAA;AXmqDJ;;AWhqDA;;EAEI,UAAA;ENjFA,+BAAA;EMmFA,YAAA;EACA,cAAA;AXuqDJ;;AWpqDA;EACI,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AXuqDJ;;AWpqDA;EACI,UAAA;AXuqDJ;;AWnqDA;;EAEI,cVzGyB;AD+wD7B;;AYlzDA;EACI,yBXiCyB;EWhCzB,kBX0H4B;EWzH5B,gBAAA;EACA,WAAA;AZqzDJ;;AYnzDA;EACI,WAAA;AZszDJ;;AYpzDA;EACI,yBXRyB;AD+zD7B;;AYrzDA;EACI,yBXXyB;ADm0D7B;;AYtzDA;EACI,yBXbyB;ADs0D7B;;AYvzDA;EACI,yBXjByB;AD20D7B;;AYxzDA;EACI,yBXnByB;AD80D7B;;AYzzDA;EACI,yBXrByB;ADi1D7B;;Aar1DA,iDAAA;AACA;EACI,oBAAA;EACA,cZcyB;EYbzB,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;Abw1DJ;Aat1DE;EACE,aAAA;Abw1DJ;Aat1DE;EACE,aAAA;Abw1DJ;;Aar1DA;EACI,yBZjByB;ADy2D7B;;Aat1DA;EACI,yBZnByB;AD42D7B;;Aav1DA;EACI,yBZvByB;ADi3D7B;;Aax1DA;EACI,yBZzByB;ADo3D7B;;Aaz1DA;EACI,yBZ3ByB;ADu3D7B;;Aa11DA;EACI,yBZ5ByB;ADy3D7B;;Ac93DA;;;;;;EAMI,6BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cbNyB;EaOzB,Yb4J0B;Ea3J1B,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBboJyB;AD6uD7B;;Ac/3DA;;;;;;;;;;EAUI,yBbrByB;EasBzB,qBbtByB;EauBzB,cbZyB;AD84D7B;;Ac/3DA;;;;;;;EAOI,yBAAA;EACA,cbtCyB;ADw6D7B;;Ac/3DA;;;;;;;;;;;;EAYG,oCAAA;EACA,gCAAA;EACA,cbxC0B;AD06D7B;;Ac/3DA;;;;;;;EAOI,yBAAA;EACA,cbjEyB;ADm8D7B;;Ac/3DA;;;;;;;;;;;;EAYG,oCAAA;EACA,gCAAA;EACA,cbpE0B;ADs8D7B;;Ac/3DA;;;;;;;EAOI,yBAAA;EACA,cb9FyB;ADg+D7B;;Ac/3DA;;;;;;;;;;;;EAYG,oCAAA;EACA,gCAAA;EACA,cbhG0B;ADk+D7B;;Ac/3DA;;;;;;;EAOI,yBAAA;EACA,cbzHyB;AD2/D7B;;Ac/3DA;;;;;;;;;;;;EAYG,oCAAA;EACA,gCAAA;EACA,cb5H0B;AD8/D7B;;Ac/3DA;;;;;;;EAOI,yBAAA;EACA,cbpJyB;ADshE7B;;Ac/3DA;;;;;;;;;;;;EAYG,oCAAA;EACA,gCAAA;EACA,cbxJ0B;AD0hE7B;;Ac/3DA;EACI,kBblD2B;ADo7D/B;Ach4DI;EACI,cAAA;EACA,iBAAA;EACA,cb/IqB;EagJrB,kBAAA;ENhLN,YMiLuB;EN9KvB,yBAAA;ARijEF;Acj4DQ;EAEI,6Bb7IiB;EOxC3B,UMsL2B;ENnL3B,0BAAA;ARsjEF;Ach4DI;EACI,eAAA;Adk4DR;Ach4DI;EACG,cb7LsB;AD+jE7B;;Ac/3DA;EACI,qBAAA;Adk4DJ;Acj4DK;EACG,eAAA;EACA,mBAAA;Adm4DR;Acj4DI;EACI,gBblDuB;EamDvB,mBAAA;EACA,YbpDuB;ADu7D/B;;Ach4DA;EACI,cAAA;Adm4DJ;Acl4DI;EACI,mBAAA;Ado4DR;;Acj4DA;EACI,cbpNyB;ADwlE7B;;Acl4DA;EACI,cbtNyB;AD2lE7B;;Acn4DA;EACI,cb1NyB;ADgmE7B;;Acp4DA;EACI,cb5NyB;ADmmE7B;;Acr4DA;EACI,cb9NyB;ADsmE7B;;Acr4DA;EACI,kBb3G2B;ADm/D/B;Act4DI;EACI,gBb/EuB;EagFvB,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBb3EqB;ADm9D7B;Acr4DI;EACI,cAAA;Adu4DR;Acr4DI;EACI,aAAA;Adu4DR;;Acl4DI;EACI,qBAAA;Adq4DR;Acn4DI;EACI,kBAAA;Adq4DR;;Ac93DA;;EAEI,+BAAA;EACH,4BAAA;EACG,gCAAA;EACA,6BAAA;Adi4DJ;;Ac/3DA;;EAEI,oCAAA;Adk4DJ;;Ach4DA;;EAEI,oCAAA;Adm4DJ;;Acj4DA;;EAEI,oCAAA;Ado4DJ;;Acl4DA;;EAEI,oCAAA;Adq4DJ;;Acn4DA;;EAEI,oCAAA;Ads4DJ;;Acp4DA;;EAEI,oCAAA;Adu4DJ;;Acr4DA;;;;;;;;;EASI,yBbxSyB;EaySzB,qBbzSyB;Ea0SzB,cb7RyB;ADqqE7B;;Acr4DA;EACI,yBb9SyB;Ea+SzB,YAAA;EACA,qBbhTyB;ADwrE7B;;Act4DA;EACI,gBAAA;Ady4DJ;;Acr4DE;EACE,gBAAA;Adw4DJ;;AepsEA,kCAAA;AACA;EACI,kCAAA;EACA,mCAAA;EACA,yDdOyB;EcNzB,gBd2JyB;AD4iE7B;;AepsEA;EACI,gBAAA;AfusEJ;;AersEA;EACI,gBdyI2B;AD+jE/B;;AetsEA;EACI,gBduI2B;ADkkE/B;;AevsEA;EACI,kBdqI2B;EcpI3B,gBAAA;EACA,kBAAA;Af0sEJ;;AexsEA;EACI,gBdiI2B;EchI3B,kBAAA;Af2sEJ;;AezsEA;EACI,iBd8H2B;Ec7H3B,kBAAA;Af4sEJ;;Ae1sEA;EACI,gBd2H2B;Ec1H3B,gBdmIyB;EclIzB,yBAAA;EACA,kBAAA;Af6sEJ;;Ae3sEA;EACI,edsH2B;EcrH3B,kBdgI2B;Ec/H3B,kBAAA;Af8sEJ;;Ae3sEA;EACI,cdRyB;EcSzB,kBd0H2B;ADolE/B;;Ae3sEA;EACI,cAAA;Af8sEJ;;Ae3sEA;;;;;;;EAOI,yDd/CyB;AD6vE7B;Ae5sEI;;;;;;;;;;;;;;EAEI,cduOqB;EctOrB,qBAAA;Af0tER;;AevtEA;EACI,yBAAA;Af0tEJ;;AextEA;EACI,cdnCyB;AD8vE7B;;AeztEA;EACI,kBAAA;Af4tEJ;;Ae1tEA;EACI,cd1CyB;ADuwE7B;;Ae3tEA;EACI,yBAAA;Af8tEJ;;Ae5tEA;EACI,yBAAA;Af+tEJ;;Ae7tEA;EACI,yBAAA;AfguEJ;;Ae9tEA;EACI,yBAAA;AfiuEJ;;Ae/tEA;EACI,yBAAA;AfkuEJ;;AehuEA;EACI,cAAA;AfmuEJ;;Ae/tEA;EACE,cAAA;EACA,oCAAA;AfkuEF;;Ae/tEA;EACE;IAAK,sBAAA;EfmuEL;EeluEA;IAAM,mBAAA;EfquEN;EepuEA;IAAM,sBAAA;EfuuEN;EetuEA;IAAM,mBAAA;EfyuEN;EexuEA;IAAM,sBAAA;Ef2uEN;Ee1uEA;IAAO,sBAAA;Ef6uEP;AACF;Ae5uEA;;EAEI,iBAAA;Af8uEJ;;Ae5uEA;EACI,gBAAA;Af+uEJ;;Ae7uEA;EACI,mBAAA;EACA,gCAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AfgvEJ;;Ae9uEA;EACI,gBAAA;EACA,mBAAA;EACA,gBAAA;AfivEJ;;Ae/uEA;EACI,mBAAA;AfkvEJ;;AgBt3EA,8BAAA;AACA;EACI,cfeyB;EedzB,ef4I2B;Ee3I3B,gBf+JyB;Ee9JzB,yDAAA;AhBy3EJ;;AgBv3EA;EACE,cfL2B;AD+3E7B;AgBx3EE;EACG,cf8CwB;Ee7CxB,qBAAA;AhB03EL;;AgBr3EA;EACI,qBfKyB;ADm3E7B;;AgBt3EA;EACI,affyB;ADw4E7B;;AgBv3EA;EACI,4BAAA;AhB03EJ;;AgBx3EA;;;;;;;EAOI,UAAA;AhB23EJ;;AgBz3EA;;EAEI,qBAAA;AhB43EJ;;AgBx3EA,sCAAA;AACA;;;;;;;EXdI,4BAAA;ALo5EJ;;AgB53EA;;;;;;;EXxBI,4BAAA;ALk6EJ;;AgBh4EA;;;EXlCI,4BAAA;AL46EJ;;AgBp4EA;EACI,WAAA;EACA,kBAAA;AhBu4EJ;;AgBr4EA;EACI,gBAAA;AhBw4EJ;;AgBr4EA;EACI,uHAAA;AhBw4EJ;;AgBr4EA,6BAAA;AACA;EACI,cfhFyB;ADw9E7B;;AgBt4EA;EACI,cflFyB;AD29E7B;;AgBv4EA;EACI,cftFyB;ADg+E7B;;AgBx4EA;EACI,cfxFyB;ADm+E7B;;AgBz4EA;EACI,cf1FyB;ADs+E7B;;AgBv4EA;EACI,WAAA;EACA,gBf8DyB;AD40E7B;;AgBv4EA;ECvGI,oCDwGsB;AhB04E1B;;AgBx4EA;EC1GI,oCD2GsB;AhB24E1B;;AgBz4EA;EC7GI,oCD8GsB;AhB44E1B;;AgB14EA;EChHI,oCDiHsB;AhB64E1B;;AgB34EA;ECnHI,oCDoHsB;AhB84E1B;;AgB14EA;EAEE,0DAAA;EACA,OAAA;EACA,yBf5G2B;Ee6G3B,kBAAA;EACA,UAAA;AhB64EF;;AgBz4EA;EACE,cAAA;EACA,oCAAA;AhB44EF;;AgBz4EA;EACE;IAAK,sBAAA;EhB64EL;EgB54EA;IAAM,mBAAA;EhB+4EN;EgB94EA;IAAM,sBAAA;EhBi5EN;EgBh5EA;IAAM,mBAAA;EhBm5EN;EgBl5EA;IAAM,sBAAA;EhBq5EN;EgBp5EA;IAAO,sBAAA;EhBu5EP;AACF;AgBn5EE;EACE,gBAAA;AhBq5EJ;;AgBh5EE;EACE,iBAAA;EACA,mBAAA;AhBm5EJ;AgBj5EI;EACE,aAAA;AhBm5EN;AgBj5EI;;EAEE,yBAAA;AhBm5EN;AgB/4EE;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AhBi5EJ;AgB/4EI;;EAEE,yBAAA;AhBi5EN;AgB54EM;EACE,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AhB84ER;AgB54EI;EACE,UAAA;AhB84EN;AgB54EI;EACE,oCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AhB84EN;;AgBz4EA;EACI,kBAAA;EACA,UAAA;AhB44EJ;;AkB3lFA,iDAAA;AACA;EACI,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AlB8lFJ;;AkB5lFA;EACI,yBjBXyB;AD0mF7B;;AkB7lFA;EACI,yBjBbyB;AD6mF7B;;AkB9lFA;EACI,yBjBjByB;ADknF7B;;AkB/lFA;EACI,yBjBnByB;ADqnF7B;;AkBhmFA;EACI,yBjBrByB;ADwnF7B;;AkBjmFA;EACI,yBjBtByB;AD0nF7B;;AmBhoFA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AnBmoFF;AmBjoFA;;0BAAA;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;AnBmoFF;;AmBjoFA;;0BAAA;AAGA;EACE,uBAAA;EACA,oBAAA;AnBooFF;;AmBloFA;EACE,cAAA;AnBqoFF;;AmBnoFA;EACE,cAAA;AnBsoFF;;AmBpoFA;;oCAAA;AAGA;;EAEE,qBAAA;EACA,oBAAA;EACA,sBAAA;AnBuoFF;;AmBroFA;EACE,kBAAA;AnBwoFF;;AmBtoFA;;0BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;AnByoFF;;AmBvoFA;EACE,kBAAA;AnB0oFF;;AmBxoFA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AnB2oFF;;AmBzoFA;EACE,MAAA;EACA,mBAAA;AnB4oFF;;AmB1oFA;;EAEE,kBAAA;EACA,kBAAA;AnB6oFF;;AmB3oFA;;0BAAA;AAGA;EAGE,0CAAA;AnB8oFF;AmB5nFA;EACE;IAKE,uBAAA;EnB+oFF;EmB7oFA;IAKE,yBAAA;EnB+oFF;AACF;AmB7oFA;;0BAAA;AAGA;EACE,gEAAA;EAKA,wBAAA;AnB+oFF;;AmB7oFA;EACE,gEAAA;EAKA,yBAAA;AnBgpFF;;AmB9oFA;EACE,gEAAA;EAKA,yBAAA;AnBipFF;;AmB/oFA;EACE,gEAAA;EAKA,uBAAA;AnBkpFF;;AmBhpFA;EACE,gEAAA;EAKA,uBAAA;AnBmpFF;;AmBjpFA;;0BAAA;AAIA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmBhpFA;EACI,gBAAA;AnBmpFJ;;AmB/oFA,oCAAA;ACrjBA;EACI,yBAAA;ApBwsGJ;AoBtsGI;EAGI,yBAAA;ApBssGR;;AoBlsGA;EACI,yBAAA;ApBqsGJ;AoBnsGI;EAGI,yBAAA;ApBmsGR;;AoB/rGA;EACI,yBAAA;ApBksGJ;AoBhsGI;EAGI,yBAAA;ApBgsGR;;AoB5rGA;EACI,yBAAA;ApB+rGJ;AoB7rGI;EAGI,yBAAA;ApB6rGR;;AoB1rGA;EACI,oCAAA;EACA,gCAAA;ApB6rGJ;AoB5rGI;EACI,oCAAA;EACA,gCAAA;ApB8rGR;;AoB3rGA;EACI,oCAAA;EACA,gCAAA;ApB8rGJ;AoB7rGI;EACI,oCAAA;EACA,gCAAA;ApB+rGR;;AoB5rGA;EACI,oCAAA;EACA,gCAAA;ApB+rGJ;AoB9rGI;EACI,oCAAA;EACA,gCAAA;ApBgsGR;;AoB7rGA;EACI,oCAAA;EACA,gCAAA;ApBgsGJ;AoB/rGI;EACI,oCAAA;EACA,gCAAA;ApBisGR;;AqBrwGA,+CAAA;AAEA,gDAAA;AACA;EACI,kBAAA;EACA,gCAAA;EACA,mBAAA;ArBuwGJ;AqBrwGI;EACI,oBAAA;ArBuwGR;;AqBpwGA;EACI,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;ArBuwGJ;;AqBrwGA;EACQ,qBAAA;EACA,epB2HuB;EoB1HvB,gBpB4IqB;AD4nG7B;AqBtwGY;EACI,cAAA;EACA,cpBxBa;EoByBb,6BAAA;ArBwwGhB;AqBtwGY;EACI,cpBzBa;ADiyG7B;AqBtwGY;EACI,cpB5Ba;ADoyG7B;AqBpwGQ;EACI,cpBjCiB;EoBkCjB,kBAAA;ArBswGZ;AqBnwGY;;;EAGI,6BAAA;EACA,cAAA;ArBqwGhB;AqBnwGgB;;;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;ArBuwGpB;AqBpwGgB;;;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;ArBwwGpB;AqBnwGQ;EACI,6BAAA;ArBqwGZ;AqBnwGQ;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;ArBqwGZ;AqBnwGY;;EAEI,cAAA;EACA,yBAAA;ArBqwGhB;AqBnwGY;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ArBqwGhB;AqBnwGY;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ArBqwGhB;;AqB/vGQ;EACI,iBAAA;ArBkwGZ;AqBhwGQ;EACI,YAAA;ArBkwGZ;;AqB9vGA,+CAAA;AAGI;EACI,cAAA;ArB+vGR;AqB7vGI;EACI,yBAAA;EACA,gBAAA;EACA,cpBzHqB;EoB0HrB,gBpBmCqB;EoBlCrB,iBAAA;EACA,kBAAA;ArB+vGR;AqB5vGI;;;EAGI,yBpBlIqB;EoBmIrB,cAAA;ArB8vGR;AqB5vGI;EACI,uCAAA;EACA,SAAA;ArB8vGR;AqB5vGI;EACI,uCAAA;ArB8vGR;AqB5vGI;EACI,yBpB7IqB;EoB8IrB,cpBnIqB;ADi4G7B;;AqBxvGQ;EACI,oCAAA;EACA,yBAAA;ArB2vGZ;AqB1vGY;EACI,oCAAA;EACA,yBAAA;ArB4vGhB;;AqBrvGQ;EACI,oCAAA;EACA,yBAAA;ArBwvGZ;AqBvvGY;EACI,oCAAA;EACA,yBAAA;ArByvGhB;;AqBlvGQ;EACI,oCAAA;EACA,yBAAA;ArBqvGZ;AqBpvGY;EACI,oCAAA;EACA,yBAAA;ArBsvGhB;;AqB/uGQ;EACI,oCAAA;EACA,yBAAA;ArBkvGZ;AqBjvGY;EACI,oCAAA;EACA,yBAAA;ArBmvGhB;;AqB5uGQ;EACI,oCAAA;EACA,yBAAA;ArB+uGZ;AqB9uGY;EACI,oCAAA;EACA,yBAAA;ArBgvGhB;;AsB57GI;;EAEI,6BAAA;AtB+7GR;;AsB37GA;EACI,SrBGyB;EqBFzB,erBoI2B;EqBnI3B,oBAAA;EACA,4BAAA;EACA,UAAA;EACA,mBrBEyB;EqBDzB,+CAAA;AtB87GJ;AsB57GI;EACI,gBrBgJqB;EqB/IrB,erBqL0B;EqBpL1B,kBrBmLyB;EqBlLzB,erByHuB;EqBxHvB,crBjBqB;EqBkBrB,yBAAA;AtB87GR;AsB57GI;EACE,aAAA;AtB87GN;AsB57GI;EACE,iBAAA;AtB87GN;AsBz7GQ;EACE,8BAAA;AtB27GV;AsBr7GQ;EACI,gBAAA;EACA,gBrBkJqB;EqBjJrB,kBrBgJqB;EqB/IrB,YAAA;EACA,erBiGmB;EqBhGnB,yBAAA;EACA,gBAAA;EACA,crB5CiB;ADm+G7B;AsBr7GY;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AtBu7Gd;AsBp7GQ;EACI,gBrBoIqB;EqBnIrB,YAAA;AtBs7GZ;AsBn7GQ;EACI,eAAA;EACA,kBAAA;EACA,UAAA;AtBq7GZ;AsBn7GQ;EACI,mBrBwDoB;EqBvDpB,eAAA;AtBq7GZ;AsBj7GY;EACE,crB7De;ADg/G7B;AsB36GgB;EACI,eAAA;AtB66GpB;AsBz6GgB;EACI,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AtB26GpB;AsBr6GgB;EACI,mBAAA;AtBu6GpB;AsBl6GQ;EACE,yBAAA;AtBo6GV;AsBh6GQ;EACI,kBAAA;AtBk6GZ;AsB/5GI;EACI,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AtBi6GR;AsB/5GI;EACG,gBAAA;EACA,erBmBwB;AD84G/B;AsBh6GO;EACI,eAAA;EACA,kBAAA;EACA,QAAA;AtBk6GX;AsB/5GI;EACI,erBYuB;ADq5G/B;AsB/5GI;ELlIA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AjBoiHJ;AsBn6GI;EACE,kCAAA;EACA,iBAAA;EACA,gBAAA;AtBq6GN;AsBn6GM;EACE,crB/HqB;ADoiH7B;AsBj6GQ;EACE,crBpImB;ADuiH7B;AsB95GQ;EACE,8BAAA;AtBg6GV;AsB55GI;EACI,eAAA;AtB85GR;AsB75GQ;EACI,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;AtB+5GZ;AsB75GY;EACI,WAAA;AtB+5GhB;AsB55GQ;EACI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AtB85GZ;AsB35GI;;EAEI,eAAA;AtB65GR;AsB15GM;EACE,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AtB45GR;;AsBt5GI;EACI,crBzLqB;EOd3B,YcwMuB;EdrMvB,yBAAA;AR+lHF;AsBx5GQ;EAEI,6BAAA;Ed5MV,Uc6M2B;Ed1M3B,0BAAA;Ec2MU,crBhMiB;AD0lH7B;AsBr5GQ;EACI,crBtMiB;EqBuMjB,qBrBvMiB;AD8lH7B;AsBr5GQ;;;;;;;EAKI,6BAAA;EACA,crB/MiB;EOd3B,Uc8N2B;Ed3N3B,0BAAA;ARqnHF;AsBx5GQ;EACI,6BAAA;AtB05GZ;AsBv5GQ;;;;;EAGI,4BrBzNiB;EqB0NjB,yBrB1NiB;ADqnH7B;AsBx5GQ;;;;;EAGI,6BAAA;EACA,crB5OiB;EOH3B,UcgP2B;Ed7O3B,0BAAA;AR0oHF;AsBz5GI;EACI,crBrNqB;EqBsNrB,yBrBxOqB;EOd3B,YcuPuB;EdpPvB,yBAAA;ARgpHF;AsB15GI;;;;;;;;;EAKI,qBrBhPqB;EOd3B,Uc+PuB;Ed5PvB,0BAAA;AR6pHF;;AsB55GA;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AtB+5GJ;;AsB15GI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AtB65GN;;AuB/qHE;EACE,cAAA;EACA,yGAAA;AvBkrHJ;AuBhrHE;EfFA,UeGqB;EfArB,wBAAA;EHMQ,yEkBLJ;EACA,kBAAA;EACA,kBAAA;AvBorHN;AuBlrHM;ElBkEE,4CAAA;ALunHR;AuBrrHM;ElB8DE,4CAAA;AL8nHR;AuBvrHE;EfjBA,UekBqB;EffrB,0BAAA;EegBI,mBAAA;AvB0rHN;AuBxrHM;ElBqDE,8CAAA;EkBnDE,oBAAA;EACA,oBAAA;AvB8rHV;AuB3rHM;ElB+CE,6CAAA;EkB7CE,uBAAA;EACA,iBAAA;AvBisHV;;AuB5rHA;EACI,yBtBtByB;EsBuBzB,cAAA;EACA,mBtBuF4B;EsBtF5B,gBAAA;EACA,YAAA;AvB+rHJ;AuB7rHI;EACI,yBtBvBqB;EsBwBrB,WAAA;AvB+rHR;AuB5rHI;EACI,ctBhBqB;EsBiBrB,etB4FuB;EsB3FvB,kBAAA;AvB8rHR;AuB3rHI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AvB6rHR;AuB1rHI;EACI,ctB1DqB;EsB2DrB,etB8EuB;EsB7EvB,4BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AvB4rHR;AuB1rHO;EACI,gBAAA;AvB4rHX;AuBxrHI;EACI,qBAAA;AvB0rHR;AuBvrHI;EACI,eAAA;AvByrHR;AuBtrHI;EACG,4BtB0CyB;EsBzCzB,6BtByCyB;AD+oHhC;AuBrrHI;EACI,+BtBqCwB;EsBpCxB,gCtBoCwB;ADmpHhC;AuBprHI;EACE,+BtBgC0B;EsB/B1B,gCtB+B0B;ADupHhC;AuBnrHQ;EACE,qBAAA;AvBqrHV;AuBnrHQ;EACE,4BAAA;EACA,6BAAA;AvBqrHV;AuBnrHQ;EACE,yBAAA;EACA,0BAAA;EACA,+BtBkBsB;EsBjBtB,gCtBiBsB;ADoqHhC;AuBhrHI;EACI,gBAAA;EACA,qBAAA;AvBkrHR;AuB/qHI;;EAEI,yBAAA;EACA,UAAA;EACA,qBAAA;AvBirHR;AuB9qHI;;EAEI,yBtB5HqB;AD4yH7B;AuB7qHI;EAEI,yBtBuGgB;ADukHxB;AuB5qHI;EAEI,yBtBoGgB;ADykHxB;AuB3qHI;EAEI,yBtBiGgB;AD2kHxB;AuB1qHI;EAEI,yBtB8FgB;AD6kHxB;AuBzqHI;EAEI,yBtB2FgB;AD+kHxB;;AuBtqHA;EACI,oBAAA;AvByqHJ;;AuBpqHA;EACE,iBAAA;AvBuqHF;;AuBrqHA;EACE,WAAA;EACA,UAAA;AvBwqHF;;AwB90HA;EACI,SAAA;EACA,gBAAA;EACA,cvBcyB;EuBbzB,kBAAA;EACA,eAAA;AxBi1HJ;AwB/0HI;EACI,evB0IuB;EuBzIvB,cvBQqB;ADy0H7B;AwB90HI;EACI,kBAAA;AxBg1HR;AwB70HI;EACI,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AxB+0HR;AwB70HI;EACI,SAAA;AxB+0HR;AwB70HI;EACI,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AxB+0HR;AwB50HQ;EACI,mBAAA;AxB80HZ;AwB50HQ;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,gBvBsHiB;ADwtH7B;;AwB10HA;EACI,yBvB6LoB;ADgpHxB;;AwB30HA;EACI,yBvB2LoB;ADmpHxB;;AwB50HA;EACI,yBvByLoB;ADspHxB;;AwB70HA;EACI,yBvBuLoB;ADypHxB;;AyB34HA;EACI,mBxB+H4B;EwB9H5B,gCAAA;EACA,eAAA;AzB84HJ;;AyB54HA;EACI,gBAAA;EACA,oBAAA;AzB+4HJ;;AyB54HA;EACI,WAAA;AzB+4HJ;;AyB74HA;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;AzBg5HJ;;AyB94HA;EACI,yBxBFyB;EwBGzB,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AzBi5HJ;;AyB/4HA;EACI,cAAA;EACA,mBxBqG4B;EwBpG5B,8CAAA;EACA,mBAAA;AzBk5HJ;;AyBh5HA;EACI,YAAA;AzBm5HJ;;AyBj5HA;EACI,mBAAA;AzBo5HJ;;AyBl5HA;EACI,qHAAA;AzBq5HJ;;AyBj5HA;EACI,mBAAA;EACA,YAAA;AzBo5HJ;;AyBl5HA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AzBq5HJ;;AyBn5HA;EACI,cAAA;AzBs5HJ;AyBr5HI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AzBu5HR;AyBr5HI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AzBu5HR;;A0Bt9HA;EACI,ezB+I2B;EyB9I3B,gBzB+JyB;AD0zH7B;;A0Bt9HA;EACI,yBzBWyB;EyBVzB,kBzBsH4B;EyBrH5B,6EAAA;EACA,czBHyB;EyBIzB,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A1By9HJ;;A0Bv9HA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;A1B09HJ;;A0Bx9HA;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;A1B29HJ;;A0Bt9HA;;EAEI,qBAAA;A1By9HJ;A0Bx9HI;;EACI,0CAAA;EACA,kCAAA;EACA,qCAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;A1B29HR;A0Bz9HQ;;EACI,+BAAA;EACA,kCAAA;EACA,qCAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;A1B49HZ;;A0Bt9HA;;EAEI,oBAAA;A1By9HJ;A0Bx9HI;;EACI,2CAAA;EACA,kCAAA;EACA,qCAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;A1B29HR;A0Bz9HQ;;EACI,gCAAA;EACA,kCAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;A1B49HZ;;A0Bt9HA;;EAEI,oBAAA;A1By9HJ;A0Bv9HI;;EACI,yCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;A1B09HR;A0Bx9HQ;;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A1B29HZ;;A0Br9HA;;EAEI,mBAAA;A1Bw9HJ;A0Bt9HI;;EACI,4CAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;A1By9HR;A0Bv9HQ;;EACI,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;A1B09HZ;;A0Br9HA;EACI,qBAAA;A1Bw9HJ;;A0Br9HA;EACI,SAAA;EACA,kBAAA;EACA,yBzBnHyB;EyBoHzB,cAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EAEA,gBAAA;EACA,kBAAA;A1Bw9HJ;;A0Bt9HA;EACI,yBAAA;EACA,qBAAA;EACA,ezBW2B;EyBV3B,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,oBAAA;A1By9HJ;;A0Bv9HA;EACI,oCAAA;EACA,kBAAA;A1B09HJ;;A0Bx9HA;EACI,aAAA;EACA,kBAAA;A1B29HJ;;A0Bz9HA;EACI,SAAA;A1B49HJ;;A0B19HA;EACI,cAAA;A1B69HJ;;A0B39HA;EACI,4BzByEoB;ADq5HxB;;A0B59HA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,yBAAA;ElB/KF,UkBgLmB;ElB7KnB,wBAAA;EkB8KE,kBAAA;EAEA,0DAAA;A1B+9HJ;;A0B79HA;EACK,mBAAA;ElBtLH,YkBuLoB;ElBpLpB,yBAAA;EkBqLG,oBAAA;A1Bi+HL;;A0B/9HA;EACI,0BzBoDoB;EyBnDpB,aAAA;A1Bk+HJ;;A0Bh+HA;EACI,yBzBgDoB;ADm7HxB;;A0Bj+HA;EACI,2BzB6CoB;ADu7HxB;;A0Bj+HA;EACI,0BzByCoB;EyBxCpB,aAAA;A1Bo+HJ;;A0Bj+HA;EACK,mBAAA;ElB3MH,YkB4MoB;ElBzMpB,yBAAA;EkB0MG,oBAAA;A1Bq+HL;;A0Bn+HA;ECjNI,yB1B6OoB;E0B5OpB,c1BeyB;ADyqI7B;A2BvrII;EACI,yB1B0OgB;E0BzOhB,0BAAA;A3ByrIR;A2BvrII;EACI,4B1BsOgB;ADm9HxB;A2BvrII;EACI,0B1BmOgB;ADs9HxB;A2BvrII;EACI,yB1BgOgB;ADy9HxB;A2BvrII;EACI,2B1B6NgB;AD49HxB;;A0Br/HA;ECpNI,yB1B8OoB;E0B7OpB,c1BeyB;AD8rI7B;A2B5sII;EACI,yB1B2OgB;E0B1OhB,0BAAA;A3B8sIR;A2B5sII;EACI,4B1BuOgB;ADu+HxB;A2B5sII;EACI,0B1BoOgB;AD0+HxB;A2B5sII;EACI,yB1BiOgB;AD6+HxB;A2B5sII;EACI,2B1B8NgB;ADg/HxB;;A0BvgIA;ECvNI,yB1B+OoB;E0B9OpB,c1BeyB;ADmtI7B;A2BjuII;EACI,yB1B4OgB;E0B3OhB,0BAAA;A3BmuIR;A2BjuII;EACI,4B1BwOgB;AD2/HxB;A2BjuII;EACI,0B1BqOgB;AD8/HxB;A2BjuII;EACI,yB1BkOgB;ADigIxB;A2BjuII;EACI,2B1B+NgB;ADogIxB;;A0BzhIA;EC1NI,yB1BgPoB;E0B/OpB,c1BeyB;ADwuI7B;A2BtvII;EACI,yB1B6OgB;E0B5OhB,0BAAA;A3BwvIR;A2BtvII;EACI,4B1ByOgB;AD+gIxB;A2BtvII;EACI,0B1BsOgB;ADkhIxB;A2BtvII;EACI,yB1BmOgB;ADqhIxB;A2BtvII;EACI,2B1BgOgB;ADwhIxB;;A0B3iIA;EC7NI,yB1BiPoB;E0BhPpB,c1BeyB;AD6vI7B;A2B3wII;EACI,yB1B8OgB;E0B7OhB,0BAAA;A3B6wIR;A2B3wII;EACI,4B1B0OgB;ADmiIxB;A2B3wII;EACI,0B1BuOgB;ADsiIxB;A2B3wII;EACI,yB1BoOgB;ADyiIxB;A2B3wII;EACI,2B1BiOgB;AD4iIxB;;A0B3jIA;;;;EAII,oCAAA;A1B8jIJ;;A0B3jIA;;;;EAII,uCAAA;A1B8jIJ;;A0B3jIA;;;;EAII,sCAAA;A1B8jIJ;;A0B3jIA;;;;EAII,qCAAA;A1B8jIJ;;A0B3jIA;;;;EAII,qCAAA;A1B8jIJ;;A0B3jIA;;EAEI,oCAAA;A1B8jIJ;;A4Bt0IA;EACI,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;A5By0IJ;A4Bv0II;EACI,gCAAA;A5By0IR;A4Bx0IQ;EACI,gBAAA;A5B00IZ;A4Br0IM;EACE,aAAA;A5Bu0IR;;A4B/zIY;EACI,aAAA;A5Bk0IhB;;A4B5zIA;EACI,cAAA;EACA,mBAAA;EACA,wEAAA;A5B+zIJ;A4B7zIQ;EACI,gBAAA;A5B+zIZ;;A4B1zIA;EACI,iBAAA;A5B6zIJ;;A4B3zIA;EACI,kBAAA;EACA,WAAA;A5B8zIJ;;A4B5zIA;EACI,6BAAA;EACA,YAAA;A5B+zIJ;A4B7zII;EACI,kBAAA;A5B+zIR;;A4B5zIA;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;A5B+zIJ;;A4B7zIA;EACI,aAAA;EACA,WAAA;A5Bg0IJ;;A4B9zIA;EACI,yB3BhCyB;E2BiCzB,qBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EAEA,UAAA;A5Bg0IJ;;A4B7zIA;EACI,kBAAA;EACA,mBAAA;EACA,oBAAA;A5Bg0IJ;A4B/zII;EACI,WAAA;A5Bi0IR;;A4B9zIA;EACK,cAAA;EACA,YAAA;A5Bi0IL;;A4B/zIA;EACI,cAAA;EACA,YAAA;A5Bk0IJ;;A6B15IA;EACI,gBAAA;A7B65IJ;A6B35II;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;A7B65IR;A6B35IQ;EACI,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A7B65IZ;A6B35IY;EACI,OAAA;EACA,QAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,QAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;EACA,eAAA;EACA,c5BpCa;E4BqCb,YAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,OAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,QAAA;EACA,SAAA;A7B65IhB;A6B35IY;EACI,OAAA;EACA,SAAA;A7B65IhB;;A6Bv5II;EACI,c5BnEqB;AD69I7B;;A6Bt5II;EACI,aAAA;EACA,gBAAA;A7By5IR;;A6Bt5IA;EACI,c5B5FyB;ADq/I7B;;A6Bv5IA;EACI,c5B9FyB;ADw/I7B;;A6Bx5IA;EACI,c5BlGyB;AD6/I7B;;A6Bz5IA;EACI,c5BpGyB;ADggJ7B;;A6B15IA;EACI,c5BtGyB;ADmgJ7B;;A6B35IA;EACI,c5B5FyB;AD0/I7B;;A8B3gJA;EACI,yB7BGyB;E6BFzB,kBAAA;EACA,UAAA;EACA,iBAAA;A9B8gJJ;A8B5gJI;EAEI,UAAA;EACA,yB7BsDqB;ADu9I7B;;A8BzgJA;EACI,YAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;A9B4gJJ;;A8B1gJA;EACI,YAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;A9B6gJJ;;A8B3gJA;EACI,qBAAA;EACA,UAAA;A9B8gJJ;;A8B5gJA;EACI,eAAA;EACA,WAAA;A9B+gJJ;;A8B7gJA;EACI,sBAAA;A9BghJJ;;A8B7gJC;EACG,8BAAA;EACA,uBAAA;EACA,WAAA;A9BghJJ;;A8B5gJE;;EAEI,mB7BgF0B;E6B/E1B,8CAAA;A9B+gJN;A8B7gJE;EACE,WAAA;A9B+gJJ;;A8B3gJA;EACI,2CAAA;EACA,cAAA;A9B8gJJ;;A8B5gJA;EACI,yB7BzDyB;ADwkJ7B;;A8B5gJI;;EAEI,UAAA;EACA,UAAA;A9B+gJR;;A8B1gJQ;EACI,SAAA;A9B6gJZ;A8B3gJQ;EACI,kBAAA;EACA,yBAAA;A9B6gJZ;A8B5gJQ;EACI,yBAAA;A9B8gJZ;A8B5gJQ;EACI,kBAAA;A9B8gJZ;A8B5gJQ;EACI,iBAAA;A9B8gJZ;;A+BnmJA;EACI,4BAAA;EACA,kBAAA;EACA,iBAAA;A/BsmJJ;A+BnmJQ;EACI,eAAA;EACA,gBAAA;A/BqmJZ;;A+BjmJA;EACE,gBAAA;EACA,mBAAA;A/BomJF;;A+BlmJA;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A/BqmJJ;;A+BnmJA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;A/BsmJJ;;A+BpmJA;;EAEE,cAAA;EACA,UAAA;A/BumJF;;A+BrmJA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;A/BwmJF;;A+BtmJA;EACI,cAAA;A/BymJJ;;A+BvmJA;EACI,yB9BjCyB;E8BkCzB,iB9BoH0B;ADs/I9B;A+BvmJQ;EACI,c9BtCiB;AD+oJ7B;A+BrmJI;EACI,qBAAA;A/BumJR;A+BrmJQ;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gB9BiGiB;ADsgJ7B;A+BrmJY;EACI,qBAAA;EACA,mBAAA;A/BumJhB;A+BrmJY;EACI,kBAAA;A/BumJhB;A+BpmJY;EACI,c9BvEa;E8BwEb,cAAA;EACA,gB9B2Ee;E8B1Ef,kBAAA;A/BsmJhB;A+BrmJgB;EAEI,c9BnCS;ADyoJ7B;A+BlmJY;EACI,yBAAA;A/BomJhB;A+BlmJY;EACI,gBAAA;A/BomJhB;A+BlmJgB;EACI,cAAA;EACA,iBAAA;A/BomJpB;A+BlmJgB;EACI,eAAA;A/BomJpB;A+B/lJI;EACI,eAAA;A/BimJR;A+BhmJQ;EACI,kBAAA;EACA,YAAA;A/BkmJZ;A+BjmJY;EACI,0BAAA;EACA,WAAA;A/BmmJhB;A+B/lJI;EACI,qB9BjFqB;E8BkFrB,qBAAA;EACA,eAAA;EACA,kBAAA;A/BimJR;A+B/lJI;EACI,c9BwKqB;E8BvKrB,gBAAA;A/BimJR;A+BhmJQ;EACI,kBAAA;A/BkmJZ;A+B/lJI;EACI,c9BhFqB;ADirJ7B;;AgCjuJA;EACI,mB/B+H4B;E+B9H5B,+CAAA;EACA,yBAAA;EACA,c/BiSyB;E+BhSzB,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EAMA,gFAAA;AhCmuJJ;AgCjuJI;EACE,iDAAA;EACA,4BAAA;EACA,oCAAA;EACA,gCAAA;EACA,iCAAA;AhCmuJN;AgChuJI;EAII,+CAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AhC+tJR;AgC5tJI;EACI,c/BLqB;ADmuJ7B;AgC5tJQ;EAEI,c/BlCiB;AD+vJ7B;AgC1tJI;EACI,c/BTqB;E+BUrB,kBAAA;EACA,gBAAA;AhC4tJR;AgCztJI;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;AhC2tJR;AgCxtJI;EACI,kB/B4DyB;AD8pJjC;AgCxtJQ;EACI,0B/BsEkB;ADopJ9B;AgCxtJY;EACI,0B/BmEc;ADupJ9B;AgCrtJI;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;AhCutJR;AgCptJQ;EACI,iBAAA;EACA,kBAAA;AhCstJZ;AgCntJQ;EACI,mB/BgDoB;ADqqJhC;AgCjtJI;EACI,c/BpEqB;ADuxJ7B;AgChtJI;EACI,WAAA;EACA,sCAAA;AhCktJR;AgChtJI;EAEI,gBAAA;AhCitJR;AgC9sJY;EACI,mB/B8BgB;ADkrJhC;AgC7sJY;EACI,kBAAA;AhC+sJhB;AgCzsJY;EACI,8BAAA;EACA,+BAAA;AhC2sJhB;AgCvsJI;EACI,eAAA;AhCysJR;AgCvsJQ;EACI,cAAA;AhCysJZ;AgCpsJI;EACI,qBAAA;AhCssJR;AgCrsJQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AhCusJZ;AgCpsJQ;EACI,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;AhCssJZ;AgCpsJY;EACI,yBAAA;AhCssJhB;AgCpsJY;EACI,sBAAA;AhCssJhB;AgChsJI;EACI,gBAAA;AhCksJR;AgC/rJI;EACI,qBAAA;EACA,YAAA;EACA,c/B1HqB;E+B2HrB,e/BduB;E+BevB,eAAA;AhCisJR;AgC/rJQ;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AhCisJZ;AgC9rJI;EACI,c/BzIqB;ADy0J7B;AgC9rJI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,iBAAA;AhCgsJR;AgC9rJI;EACI,yBAAA;AhCgsJR;AgC7rJI;EACI,kBAAA;EACA,0B/BtDuB;E+BuDvB,UAAA;AhC+rJR;AgC7rJQ;EACI,aAAA;AhC+rJZ;AgC7rJQ;EACI,WAAA;AhC+rJZ;AgC5rJQ;EACI,aAAA;AhC8rJZ;AgCxrJQ;EACI,UAAA;AhC0rJZ;AgCxrJQ;EACI,iBAAA;AhC0rJZ;AgCvrJI;EACI,YAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AhCyrJR;AgCtrJI;;EAEI,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA;AhCurJR;AgCprJI;EACI,6BAAA;EACA,UAAA;AhCsrJR;AgCprJQ;E3B1IN,kBAAA;EACA,QAAA;EAGA,2BAAA;ALi0JF;AgCrrJQ;EACI,YAAA;AhCurJZ;AgCprJQ;;EAEI,UAAA;AhCsrJZ;AgChrJQ;;EACI,e/BtGmB;ADyxJ/B;AgC/qJI;EACG,SAAA;EACA,iBAAA;AhCirJP;AgC9qJI;EACI,aAAA;AhCgrJR;AgC9qJQ;EACI,iBAAA;AhCgrJZ;AgC9qJQ;EACI,eAAA;AhCgrJZ;AgC5qJI;EACI,e/B3HuB;E+B4HvB,c/BjRqB;E+BkRrB,oBAAA;AhC8qJR;AgC3qJI;EACI,e/B5IuB;E+B6IvB,SAAA;AhC6qJR;AgC1qJI;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AhC4qJR;AgCzqJY;EACI,wBAAA;AhC2qJhB;AgCzqJY;EACI,wBAAA;AhC2qJhB;AgCrqJI;EACI,YAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;EACA,yB/BnRqB;E+BoRrB,WAAA;EACA,kBAAA;AhCuqJR;AgCpqJI;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;AhCsqJR;AgCpqJQ;EACI,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AhCsqJZ;AgC/pJY;EACI,eAAA;EACA,aAAA;AhCiqJhB;AgC3pJQ;EACI,4BAAA;AhC6pJZ;AgC1pJQ;EACI,oBAAA;AhC4pJZ;AgCxpJI;EACI,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,yBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,UAAA;EACA,kBAAA;AhC0pJR;AgCtpJQ;EACI,kBAAA;EACA,kBAAA;AhCwpJZ;AgCtpJQ;EACI,YAAA;AhCwpJZ;AgCvpJY;EACI,eAAA;AhCypJhB;AgCtpJQ;EACI,gBAAA;AhCwpJZ;AgCppJI;EACI,kCAAA;EACA,sBAAA;EACA,kBAAA;AhCspJR;AgCppJQ;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AhCspJZ;AgCppJQ;EACI,WAAA;EACA,gBAAA;AhCspJZ;AgCppJQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,qCAAA;EACA,mB/BzRoB;AD+6JhC;AgCppJQ;EACI,c/B3YiB;ADiiK7B;AgC/oJQ;EACI,kB/BtSoB;ADu7JhC;AgC9oJQ;EACI,kB/B1SoB;AD07JhC;AgC9oJQ;EACI,+BAAA;AhCgpJZ;AgC7oJQ;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAUI,yBAAA;AhCiqJZ;AgC9pJQ;;;;EAEI,c/B5aiB;AD8kK7B;AgC9pJY;EACI,cAAA;EACA,0CAAA;AhCgqJhB;AgC5pJQ;EACI,2CAAA;AhC8pJZ;AgCxpJQ;ExB3cN,awB4c2B;ExBzc3B,yBAAA;ARomKF;AgCxpJQ;ExB/cN,awBgd2B;ExB7c3B,yBAAA;ARwmKF;AgCtpJI;EACI,mB/B1OgB;ADk4JxB;AgCrpJI;EACI,mB/B7OgB;ADo4JxB;AgCppJI;EACI,mB/BhPgB;ADs4JxB;AgCnpJI;EACI,mB/BlPgB;ADu4JxB;AgClpJI;EACI,mB/BrPgB;ADy4JxB;AgCjpJI;EACI,mB/B3PgB;AD84JxB;;AgC/oJA;EACI,kBAAA;AhCkpJJ;;AgC/oJA;EACI,gBAAA;EACA,kBAAA;AhCkpJJ;AgChpJI;EACI,8EAAA;EACA,kCAAA;EACA,4BAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AhCkpJR;;AgC9oJI;EACI,eAAA;AhCipJR;AgC/oJI;EACI,sBAAA;EACA,iBAAA;EACA,WAAA;AhCipJR;AgC/oJI;EACI,iBAAA;AhCipJR;;AgC1oJQ;;EAEI,c/B1gBiB;ADupK7B;;AgCvoJE;EACI,aAAA;AhC0oJN;;AgCroJE;EACI,cAAA;AhCwoJN;;AiChrKA;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;AjCmrKF;AiCjrKE;EACI,iBAAA;EACA,kBAAA;AjCmrKN;AiChrKE;EACI,mBhCqH0B;AD6jKhC;;AkC7rKA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AlCgsKF;AkC9rKE;EACE,gBAAA;AlCgsKJ;AkC9rKE;EACE,cAAA;EACA,kBAAA;AlCgsKJ;AkC9rKE;EACE,gBAAA;AlCgsKJ;AkC9rKE;EACE,kBAAA;AlCgsKJ;AkC7rKE;EACE,yBAAA;AlC+rKJ;;AmCvtKA;EACE,gBAAA;EACA,kBAAA;AnC0tKF;AmCxtKE;EACE,aAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;AnC0tKJ;AmCttKI;EACE,0BAAA;AnCwtKN;AmCttKI;EACE,kBAAA;EACA,eAAA;AnCwtKN;AmCptKE;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AnCstKJ;AmCptKI;EACI,yBAAA;AnCstKR;AmCptKI;EACI,sBAAA;AnCstKR;;AmC/sKE;EACE,iBAAA;AnCktKJ;;AoC1vKA;EACI,gBAAA;ApC6vKJ;;AoC3vKA;EACI,yBAAA;EACA,kCAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApC8vKJ;AoC5vKI;EACI,oCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ApC8vKR;AoC5vKI;EACI,2BAAA;EACA,iBAAA;ApC8vKR;AoC5vKI;EACI,2BAAA;ApC8vKR;AoC1vKQ;;EAEI,UAAA;ApC4vKZ;;AoCxvKA;EACI,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;ApC2vKJ;;AoCxvKA;EACI,gBAAA;EACA,UAAA;ApC2vKJ;;AoCzvKA;EACI,UAAA;ApC4vKJ;;AoC1vKA;EACI,UAAA;ApC6vKJ;;AoC3vKA;EACI,sBAAA;ApC8vKJ;;AoC5vKA;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;ApC+vKJ;;AoC7vKA;EACI,gBAAA;ApCgwKJ;;AoC9vKA;EACI,gBAAA;ApCiwKJ;;AoC/vKA;EACI,gBAAA;ApCkwKJ;;AoC/vKA;EACI,kBAAA;EACA,UAAA;ApCkwKJ;;AoChwKA;EACI,WAAA;ApCmwKJ;;AoCjwKA;EACI,eAAA;EACA,kBAAA;EACA,UAAA;ApCowKJ;;AoClwKA;EACI,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,cnCjFyB;ADs1K7B;;AoCnwKA;EACI,cAAA;ApCswKJ;;AoCnwKA;EACI,gBAAA;ApCswKJ;;AoCpwKA;EACI,cAAA;EACA,kBAAA;ApCuwKJ;;AoCrwKA;EACI,gBAAA;ApCwwKJ;;AoCtwKA;EACI,kBAAA;ApCywKJ;;AoCtwKA;EACI,kBAAA;ApCywKJ;;AoCvwKA;EACI,kBAAA;ApC0wKJ;;AoCxwKA;EACI,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;ApC2wKJ;;AoCzwKA;EACI,gBAAA;ApC4wKJ;;AoC1wKA;EACI,cAAA;EACA,iBAAA;ApC6wKJ;;AoC3wKA;EACI,qBAAA;ApC8wKJ;;AoC3wKA;EACI,iBAAA;ApC8wKJ;;AoC5wKA;EACI,gBAAA;ApC+wKJ;;AoC7wKA;EACI,gBAAA;ApCgxKJ;;AoC3wKA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;ApC8wKJ;AoC5wKI;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;ApC8wKR;;AoC1wKA;EACI,cAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EAIA,iEAAA;EAEA,6BAAA;EACA,oCAAA;ApC4wKJ;;AoC1wKA;EACI,gBAAA;EACA,cAAA;ApC6wKJ;;AoC1wKA;EACI,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;ApC6wKJ;AoC3wKI;EACI,gBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;ApC6wKR;;AoCzwKA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;ApC4wKJ;AoC1wKI;EACI,WAAA;ApC4wKR;AoCzwKI;EACI,gBAAA;EACA,UAAA;ApC2wKR;;AoCvwKI;EACI,gBAAA;ApC0wKR;;AoCvwKA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EAEA,wCAAA;ApC0wKJ;;AoCvwKA;EAAwB;IAAwC,+BAAA;EpC6wK9D;EoC5wKsB;IACA,kCAAA;EpC+wKtB;AACF;AoC7wKI;EACI,eAAA;ApC+wKR;;AoCxwKQ;EACI,iBAAA;ApC2wKZ;AoCzwKQ;EACI,YAAA;ApC2wKZ;;AqChhLA;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;ArCmhLJ;;AqCjhLA;EACI,eAAA;ArCohLJ;;AqClhLA;EACI,yBAAA;ArCqhLJ;;AqCnhLA;EACI,yBpCPyB;AD6hL7B;;AqCphLA;EACI,yBAAA;EACA,cpCCyB;ADshL7B;;AqCrhLA;EACI,yBAAA;EACA,cpCHyB;AD2hL7B;;AqCthLA;EACI,yBpCrByB;EoCsBzB,cpCPyB;ADgiL7B;;AqCvhLA;EACI,yBAAA;EACA,cpCXyB;ADqiL7B;;AqCxhLA;EACI,yBAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;ArC2hLJ;;AqCzhLA;;;EAGI,kBAAA;ArC4hLJ;AqC1hLI;;;;;;;;;EAGI,yBAAA;ArCkiLR;AqChiLI;;;;;;;;;;;;EAII,+BAAA;ArC0iLR;AqCxiLI;;;EACI,uCAAA;ArC4iLR;;AqCviLI;;;;EAEI,cpC5CqB;ADwlL7B;;AqCziLA;;;;;;EAMI,eAAA;ArC4iLJ;;AqC1iLA;EACI,kCAAA;EACA,sBAAA;ArC6iLJ;AqC3iLI;EACI,oCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ArC6iLR;AqC3iLI;EACI,kBAAA;EACA,UAAA;ArC6iLR;;AqCziLA;EACI,iBAAA;ArC4iLJ;;AqCziLA;EACI,6BAAA;EAEI;IACI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;ErC2iLV;EqCziLM;IACI,2BAAA;ErC2iLV;AACF;AqCtiLA;;;;;;EAMI,eAAA;ArCwiLJ;;AqCtiLA;EACI,kCAAA;EACA,sBAAA;ArCyiLJ;AqCviLI;EACI,oCAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;ArCyiLR;AqCviLI;EACI,kBAAA;EACA,UAAA;ArCyiLR;;AsCnrLA,4CAAA;AAEA;EACI;IACI,wBAAA;EtCqrLN;EsClrLI;IACE,cAAA;EtCorLN;EsC/qLI;IACE,kBAAA;EtCirLN;EsC5qLM;IACI,wBAAA;EtC8qLV;EsC3qLE;IACI,qCAAA;EtC6qLN;EsC1qLM;IACI,uBAAA;EtC4qLV;EsCxqLE;IACE,mBAAA;EtC0qLJ;EsCvqLE;IACK,kBAAA;IACA,erC0GsB;ED+jL7B;EsCvqLE;IACI,cAAA;EtCyqLN;EsCvqLE;IACK,OAAA;IACC,WAAA;IjCjBN,2DAAA;IiCmBK,kBAAA;EtC6qLP;EsC3qLE;IACI,aAAA;IACA,kBAAA;EtC6qLN;EsC3qLE;IACI,2BAAA;EtC6qLN;EsC3qLE;IACM,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;EtC6qLR;EsC1qLE;IACI,gBAAA;IACA,WAAA;IACA,YAAA;EtC4qLN;EsC1qLE;;;IAGE,8BAAA;EtC4qLJ;EsC1qLE;IACE,QAAA;IjC6CD,+BAAA;IAGA,6BAAA;ELkoLH;EsC/qLE;IACE,UAAA;EtCirLJ;EsC/qLE;IACE,WAAA;IjCsCD,kCAAA;IAGA,6BAAA;EL8oLH;EsCprLE;IACE,QAAA;IjCkCD,4BAAA;IAGA,6BAAA;ELupLH;EsCzrLE;IACE,UAAA;EtC2rLJ;EsCzrLE;IACE,WAAA;IjC2BD,+BAAA;IAGA,6BAAA;ELmqLH;EK/pLE;IACE;MAAI,QAAA;MAAU,uBAAA;ILmqLhB;IKlqLE;MAAK,QAAA;MAAU,yBAAA;ILsqLjB;IKrqLE;MAAK,yBAAA;ILwqLP;IKvqLE;MAAM,yBAAA;IL0qLR;EACF;EK1pLE;IACE;MAAK,QAAA;MAAU,yBAAA;IL8rLjB;IK7rLE;MAAM,yBAAA;ILgsLR;IK/rLE;MAAM,uBAAA;ILksLR;IKjsLE;MAAO,QAAA;MAAU,oBAAA;ILqsLnB;EACF;EKnrLE;IACE;MAAI,WAAA;MAAa,uBAAA;ILutLnB;IKttLE;MAAK,WAAA;MAAa,0BAAA;IL0tLpB;IKztLE;MAAK,0BAAA;IL4tLP;IK3tLE;MAAM,0BAAA;IL8tLR;EACF;EK9sLE;IACE;MAAK,WAAA;MAAY,0BAAA;ILkvLnB;IKjvLE;MAAM,wBAAA;ILovLR;IKnvLE;MAAM,wBAAA;ILsvLR;IKrvLE;MAAO,WAAA;MAAY,oBAAA;ILyvLrB;EACF;EsCh1LE;IACE;MAAI,UAAA;ItCm4LN;IsCl4LE;MAAM,UAAA;ItCq4LR;EACF;EsCn4LE;IACI,iBAAA;EtCq4LN;EsCl4LU;IACI,2BAAA;EtCo4Ld;EsCj4LU;IACI,0BAAA;EtCm4Ld;EsCh4LU;IACI,4BAAA;EtCk4Ld;EsC53LM;IACI,YAAA;EtC83LV;EsC13LM;;;;;;IAMI,YAAA;IACA,uBAAA;EtC43LV;EsCz3LM;IACI,UAAA;EtC23LV;EsCv3LU;IACI,yBAAA;IACA,sBAAA;EtCy3Ld;EsCv3LU;IACI,0BAAA;IACA,uBAAA;EtCy3Ld;EsCl3LM;;IAEI,cAAA;EtCo3LV;EsC92LU;IACI,2BAAA;EtCg3Ld;EsC52LE;IACI,aAAA;EtC82LN;EsC52LE;IACI,mCAAA;EtC82LN;EsC32LE;IACI,kBrCnEuB;EDg7L7B;EsC32LE;IACI,kBrCtEuB;EDm7L7B;EsC32LE;IACI,WAAA;EtC62LN;EsC32LE;IACI,sBAAA;EtC62LN;EsC32LE;IACI,WAAA;EtC62LN;EsC32LE;IACI,sBAAA;EtC62LN;EsC32LE;IACI,eAAA;EtC62LN;EsC32LE;IACI,gBAAA;EtC62LN;EsC32LE;IACI,wCAAA;EtC62LN;EsC32LE;IACI,gBAAA;EtC62LN;EsC32LE;IACI,UAAA;IACA,sBAAA;IACA,cAAA;IACA,mBAAA;EtC62LN;EsC32LE;IACI,WAAA;EtC62LN;EsC32LE;IACI,aAAA;EtC62LN;EsC32LE;IACI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,yBAAA;IACA,4CAAA;IACA,iCAAA;EtC62LN;EsC32LE;IACI,8BAAA;EtC62LN;EsCx2LU;IACI,yBAAA;EtC02Ld;EsCx2LkB;IACI,uCAAA;IACA,iBAAA;EtC02LtB;EsCx2LkB;IACI,uCAAA;IACA,iBAAA;EtC02LtB;EsCv2LkB;IACI,uCAAA;IACA,iBAAA;EtCy2LtB;EsCh2LU;;IACI,wBAAA;EtCm2Ld;EsC/1LE;IACI,8BAAA;EtCi2LN;EsC/1LE;IACI,gBAAA;EtCi2LN;EsC/1LE;IACI,eAAA;IACA,4BAAA;IACA,oCAAA;IACA,iCAAA;IACA,+BAAA;EtCi2LN;EsC91LM;;IAEI,gBAAA;EtCg2LV;EsC/1LU;;IACI,qBAAA;EtCk2Ld;EsCj2Lc;;IACI,2BAAA;EtCo2LlB;EsCj2LU;;IACI,qBAAA;EtCo2Ld;EsCn2Lc;;IACI,2BAAA;EtCs2LlB;EsCn2LU;;IACI,qBAAA;IACA,sBAAA;EtCs2Ld;EsCr2Lc;;IACI,2BAAA;EtCw2LlB;EsCr2LU;;IACI,sBAAA;IACA,sBAAA;EtCw2Ld;EsCv2Lc;;IACI,2BAAA;EtC02LlB;EsCv2LU;;IACI,sBAAA;EtC02Ld;EsCz2Lc;;IACI,2BAAA;EtC42LlB;EsCt2Lc;IACI,4BAAA;IACA,2BAAA;EtCw2LlB;EsCj2Lc;IACI,2BAAA;IACA,4BAAA;EtCm2LlB;EsCj2Lc;;IAEI,aAAA;EtCm2LlB;EsCh2LU;IACI,6BAAA;EtCk2Ld;EsC91LM;IACI,yBAAA;IACA,2BAAA;EtCg2LV;EsC31Lc;IACI,wBAAA;EtC61LlB;EsCx1LE;IACI,8BAAA;EtC01LN;EsCt1LM;IACI,oBAAA;EtCw1LV;EsCt1LM;IACI,cAAA;EtCw1LV;EsCt1LM;IACI,gBAAA;EtCw1LV;EsCt1LM;IACI,gBAAA;EtCw1LV;EsCv1LU;IACI,eAAA;EtCy1Ld;EsCp1LE;IACE,UAAA;IACA,WAAA;EtCs1LJ;EsCp1LE;IACI,aAAA;EtCs1LN;EsCl1LM;IACI,kBAAA;EtCo1LV;EsCl1LU;IACI,oBAAA;EtCo1Ld;EsCj1LM;IACI,kBAAA;EtCm1LV;EsC90LU;IACI,yBAAA;EtCg1Ld;EsC70LM;IACI,0BAAA;EtC+0LV;EsC70LM;IACI,yBAAA;EtC+0LV;EsC10LI;IACE,yBAAA;IACA,kBAAA;EtC40LN;EsC10LI;IACE,cAAA;EtC40LN;AACF;AsCz0LA;EACI;IACI,eAAA;IACA,yBAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,8BAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;IjChYA,4BAAA;IAjCJ,2DAAA;ELsvMF;EsCj1LM;IACI,kBAAA;IACA,UAAA;IACA,WAAA;EtCm1LV;EsCh1LU;IACA,gBAAA;EtCk1LV;EsCh1LU;IACI,eAAA;IACA,yBAAA;IACA,yBAAA;IACA,gBAAA;IACA,erC/Te;IqCgUf,kBrC1Se;IqC2Sf,eAAA;EtCk1Ld;EsCj1Lc;IAEI,yBAAA;EtCk1LlB;EsC90LM;IACI,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,yBrCzdiB;IqC0djB,6HAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;EtCg1LV;EsC90LM;I9B1dJ,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,uCAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;ER2yMF;EsCn1LM;IjC7aA,0BAAA;ELuwMN;EsCv1LM;IACI,OAAA;IjCjbJ,6BAAA;EL+wMN;EsC31LM;IjCpbA,6BAAA;ELsxMN;EsC91LE;IACI,aAAA;EtCg2LN;EsC51LI;IACE,eAAA;EtC81LN;EsCz1LE;;IAEI,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,YAAA;EtC21LN;EsCz1LM;;;;IAEI,6BAAA;IACA,gBAAA;EtC61LV;EsCx1LU;;;IAEI,crCnea;ED8zM3B;EsCv1LM;;;IAEI,aAAA;EtC01LV;EsCr1LM;IACG,aAAA;EtCu1LT;EsCp1LK;IACG,cAAA;IACA,gBAAA;IACA,WAAA;IACA,kCAAA;EtCs1LR;EsCl1LE;IACI,WAAA;IACA,kBAAA;IACA,aAAA;IAEA,yCAAA;IAEA,mBAAA;IjCpfA,wBAAA;IAjCJ,2DAAA;ELm3MF;EsCz1LE;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;EtC21LJ;EsCx1LE;IjCviBA,2DAAA;IiC0iBG,OAAA;IACA,uBAAA;EtC61LL;EsC11LM;IACI,iBAAA;IACA,kBAAA;EtC41LV;EsC11LM;IACI,UAAA;EtC41LV;EsCx1LM;IACI,aAAA;EtC01LV;EsCt1LM;IACI,cAAA;EtCw1LV;EsCt1LU;IACI,gBAAA;EtCw1Ld;EsCv1Lc;IACI,gBAAA;EtCy1LlB;EsCj1LM;;;IACI,wBAAA;EtCq1LV;EsCh1LM;IACI,WAAA;IACA,aAAA;EtCk1LV;EsC70LI;IACE,WAAA;EtC+0LN;EsC30LE;IACE,0BAAA;EtC60LJ;AACF;AsCv0LA;EAEQ;IACI,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,8BAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;IjCrlBJ,4BAAA;IAjCJ,2DAAA;ELw8MF;EsC70Lc;IACI,gBAAA;EtC+0LlB;EsC50LU;IACI,YAAA;IACA,UAAA;IACA,kBAAA;IAIA,aAAA;IAKA,sBAAA;EtC80Ld;EsC30LU;IACI,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,yBrC3qBa;IqC4qBb,6HAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;EtC60Ld;EsC30LU;I9B5qBR,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,uCAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;ER0/MF;EsCh1Lc;IACI,cAAA;IACA,gBAAA;EtCk1LlB;EsC70LM;IACI,WAAA;IACA,kBAAA;IjCxoBJ,wBAAA;IAjCJ,2DAAA;ELkgNF;EsCp1LM;IjC9qBJ,2DAAA;IiCirBQ,OAAA;IACA,uBAAA;EtCy1LV;EsCr1LU;IACI,wBAAA;EtCu1Ld;EsCl1LU;;;IAEI,cAAA;IACA,YAAA;EtCq1Ld;EsCh1LU;IjCnqBJ,0BAAA;EL0/MN;EsCp1LU;IACI,OAAA;IjCvqBR,6BAAA;ELkgNN;EsCx1LU;IjC1qBJ,6BAAA;ELygNN;EsC11LM;;IAEI,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;EtC41LV;EsC11LU;;;;IAEI,6BAAA;IACA,gBAAA;EtC81Ld;EsCz1Lc;;;IAEI,crC9sBS;ED0iN3B;EsCx1LU;;;IAEI,aAAA;EtC21Ld;EsCt1LU;IACG,aAAA;EtCw1Lb;EsCr1LS;IACI,cAAA;EtCu1Lb;EsCn1LE;IACI,YAAA;EtCq1LN;AACF;AsCn1LA;EAEM;IACI,kBAAA;IACA,UAAA;EtCo1LR;EsC/0LI;IACE,iBAAA;EtCi1LN;AACF;AsC90LA;EAIgB;IACI,gBAAA;IACA,iBAAA;EtC60LlB;EsC30Lc;IACI,gBAAA;IACA,iBAAA;IACA,UAAA;EtC60LlB;EsC10LU;IACI,wBAAA;EtC40Ld;EsCx0LU;IACI,sBAAA;EtC00Ld;EsCt0LU;IACI,2BAAA;EtCw0Ld;AACF;AsCp0LA;EAGY;IACI,gBAAA;EtCo0Ld;AACF;AsCh0LA;EACI;IACI,iBAAA;EtCk0LN;EsC/zLM;IACI,gBAAA;EtCi0LV;EsC7zLM;IACI,kBAAA;EtC+zLV;EsC5zLE;IACI,cAAA;EtC8zLN;EsC5zLE;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,gBAAA;IACA,gBAAA;IACA,UAAA;EtC8zLN;EsCzzLc;IACI,gBAAA;EtC2zLlB;EsCnzLM;IACE,gBAAA;EtCqzLR;AACF;AsCjzLA;EAEQ;;IAEI,gBAAA;EtCkzLV;AACF;AsC9yLA;EAEQ;IACI,kBAAA;IACA,UAAA;EtC+yLV;EsC7yLc;IACI,gBAAA;IACA,oBAAA;IACA,kBAAA;IjC50BZ,4BAAA;ELgoNN;EsCjzLc;IACI,mBAAA;IACA,mBAAA;IACA,2BAAA;EtCmzLlB;EsCjzLc;IACI,oBAAA;IACA,gBAAA;IACA,6BAAA;EtCmzLlB;EsCjzLc;IACI,oBAAA;IACA,kBAAA;IACA,4BAAA;EtCmzLlB;AACF;AsC5yLA;EACE;IACE,YAAA;IACA,WAAA;IACA,eAAA;EtC8yLF;AACF;AsC3yLA;EAEQ;IACI,cAAA;EtC4yLV;EsC1yLM;IACI,gBAAA;EtC4yLV;AACF;AsCxyLA;EACI;IACI,WAAA;EtC0yLN;AACF;AsCryLA;EAGY;IACI,sBAAA;EtCqyLd;EsChyLM;IACI,mBAAA;EtCkyLV;EsChyLM;IACI,kBAAA;EtCkyLV;EsC9xLM;IACI,uBAAA;EtCgyLV;EsC1xLc;IACI,2BAAA;EtC4xLlB;AACF;AuClvNA,qCAAA;AACA;;;EAAA;AAIA;;;;CAAA;AAKA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AvCovNF;;AuClvNA;EACE,kBAAA;EACA,cAAA;AvCqvNF;;AuCnvNA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AvCsvNF;;AuCpvNA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AvCuvNF;;AuCrvNA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AvCwvNF;;AuCtvNA;EACE,YAAA;EACA,WAAA;AvCyvNF;;AuCvvNA;EACE,WAAA;EACA,UAAA;AvC0vNF;;AuCxvNA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AvC2vNF;;AuCzvNA;;EAAA;AAGA;EACE,QAAA;AvC4vNF;;AuC1vNA;EACE,SAAA;AvC6vNF;;AuC3vNA;EAEE,2BAAA;EACA,kBAAA;EACA,aAAA;AvC8vNF;;AuC5vNA;EACE,YAAA;EACA,WAAA;AvC+vNF;;AuC7vNA;;EAGE,0BAAA;AvCgwNF;;AuC9vNA;EACE,0BAAA;AvCiwNF;;AuC/vNA;EAAA;AAEA;EACE,WAAA;AvCkwNF;;AuChwNA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AvCmwNF;;AuCjwNA;EACE,WAAA;AvCowNF;;AuClwNA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;AvCqwNF;;AuCnwNA;EACE,WAAA;EACA,UAAA;AvCswNF;;AuCpwNA;;EAAA;AAGA;EACE,0CAAA;EACA,kBAAA;AvCuwNF;;AuCrwNA;EACE,kBAAA;AvCwwNF;;AuCtwNA;EACE,mBAAA;AvCywNF;;AuCvwNA;EAAA;AAEA;EACE,iBAAA;AvC0wNF;;AuCxwNA;EACE,iBAAA;AvC2wNF;;AuCzwNA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;AvC4wNF;;AuC1wNA;EACE,yEAAA;AvC6wNF;;AuC3wNA;EAAA;AAEA;EACE,mBAAA;AvC8wNF;;AuC5wNA;;;EAGE,mBAAA;AvC+wNF;;AuC7wNA;;EAAA;AAGA;;EAGE,sBAAA;AvCgxNF;;AuC9wNA;EACE,kBAAA;EACA,WAAA;AvCixNF;;AuC/wNA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AvCkxNF;;AuChxNA;EACE,WAAA;EACA,eAAA;AvCmxNF;;AuCjxNA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AvCoxNF;;AuClxNA;EACE,gBAAA;AvCqxNF;;AuCnxNA;EACE,gBAAA;AvCsxNF;;AuCpxNA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AvCuxNF;;AuCrxNA;EAEE,+BAAA;AvCwxNF;;AuCtxNA;EAEE,8BAAA;AvCyxNF;;AuCvxNA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AvC0xNF;;AuCxxNA;EACE,YAAA;AvC2xNF;;AuCzxNA;EACE,YAAA;AvC4xNF;;AuC1xNA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AvC6xNF;;AuC3xNA;EAEE,6BAAA;EACA,kBAAA;AvC8xNF;;AuC5xNA;EAEE,4BAAA;AvC+xNF;;AuC7xNA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AvCgyNF;;AuC9xNA;EACE,WAAA;AvCiyNF;;AuC/xNA;EACE,WAAA;AvCkyNF;;AuChyNA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AvCmyNF;;AuCjyNA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AvCoyNF;;AuClyNA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AvCqyNF;;AwCxjOA;;CAAA;AAGA;EACE,kBAAA;AxC2jOF;AwC1jOE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AxC4jOJ;AwCzjOI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;AxC2jON;;AwCvjOA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EAEA,4BAAA;EACA,gBAAA;AxC0jOF;AwCxjOE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;AxC0jOJ;AwCxjOE;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AxC0jOJ;;AwCtjOA;EACE,cAAA;EACA,SAAA;AxCyjOF;;AwCvjOA;EACE,gBAAA;EACA,gBAAA;AxC0jOF;;AwCvjOA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;AxC0jOF;;AwCvjOA;EACE,WAAA;EACA,SAAA;EACA,gCAAA;AxC0jOF;;AwCxjOA;;EAEE,kBAAA;EACA,YAAA;AxC2jOF;;AwCzjOA;EACE,eAAA;AxC4jOF;;AwC1jOA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AxC6jOF;AwC5jOE;EAGE,oCAAA;EACA,cvCvFyB;ADmpO7B;;AwCvjOI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AxC0jON;AwCxjOI;;EAEE,cvCtFuB;ADgpO7B;;AwCrjOA;;;;;EAKE,mBAAA;EACA,eAAA;AxCwjOF;;AwCtjOA;EACE,kBAAA;AxCyjOF;;AwCvjOA;EACE,yBAAA;AxC0jOF;;AwCxjOA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AxC2jOF;;AwCxjOA;EACE,cAAA;AxC2jOF;;AwCzjOA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AxC4jOF;;AwC1jOA;EACE,eAAA;EACA,mBAAA;AxC6jOF;;AwC3jOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AxC8jOF;;AwC5jOA;;EAEE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AxC+jOF;;AwC3jOE;;;;;EAKE,cvChLyB;AD8uO7B;;AwCzjOA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AxC4jOF;;AwCxjOA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AxC2jOF;;AwCzjOA;EACE,eAAA;AxC4jOF;;AwC1jOA;EACE,mBAAA;AxC6jOF;;AwCzjOA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AxC4jOF;;AwC1jOA;EACE,sBAAA;AxC6jOF;;AwC1jOA;EACE,WAAA;EACA,YAAA;AxC6jOF;;AwC1jOA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;AxC6jOF;;AwC3jOA;;EAEE,gBAAA;AxC8jOF;;AwC3jOA;EACE,qBAAA;AxC8jOF;;AwC1jOE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AxC6jOJ;AwC3jOE;EACE,QAAA;EACA,6BAAA;AxC6jOJ;;AwCzjOA;EACE,aAAA;AxC4jOF;;AwCzjOA;EACE,WAAA;AxC4jOF;AwC3jOE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;AxC6jOJ;;AwCxjOI;EACE,cvCzQuB;EuC0QvB,kBAAA;EACA,yBAAA;AxC2jON;;AwCtjOA;EACE,YAAA;EACA,kBAAA;AxCyjOF;;AwCvjOA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cvCzP2B;EuC8P3B,4BAAA;EAGA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AxCwjOF;;AwCtjOA;EACE,gBAAA;EACA,cAAA;AxCyjOF;;AwCvjOA;EACE,kBAAA;EACA,iBAAA;AxC0jOF;;AwCvjOA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;AxC0jOF;;AwCvjOA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AxC0jOF;;AwCxjOA;;EAEE,oBAAA;AxC2jOF;AwC1jOE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AxC8jOJ;AwC5jOI;;;;EACE,oCAAA;EACA,cvC7TuB;AD83O7B;;AwC5jOA;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AxC+jOF;;AwC5jOA;EACE,yBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;AxC+jOF;;AwC5jOA;EACE,0BAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AxC+jOF;;AyCp6OI;EpC2EI,4CAAA;ALi2OR;AyCx6OI;EpCuEI,4CAAA;ALw2OR;AyCz6OI;EpCiEI,8CAAA;EoC/DF,oBAAA;EACA,oBAAA;AzC+6ON;AyC76OI;EpC4DI,6CAAA;EoC1DF,uBAAA;EACA,iBAAA;AzCm7ON;;A0Cv8OA;EACE,+BAAA;A1C08OF;;A2C38OA;EACE;IACE,uBAAA;E3C88OF;AACF;A4Cj9OA;EAEI;IACE,oBAAA;E5Ck9OJ;E4Ch9OE;IACE,gBAAA;E5Ck9OJ;AACF;A4C/8OA;EAEI;IACE,oBAAA;E5Cg9OJ;E4C78OA;IACE,uBAAA;IACA,kBAAA;E5C+8OF;E4C98OE;IACE,qBAAA;E5Cg9OJ;E4C/8OI;IACE,kBAAA;E5Ci9ON;E4C78OA;IACE,2BAAA;E5C+8OF;AACF;A6C3+OA;EACE,qBAAA;EACA,gBAAA;EACA,aAAA;A7C6+OF;A6C5+OE;EACE,oBAAA;EACA,mBAAA;A7C8+OJ;A6C7+OI;EACE,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qBAAA;EACA,uBAAA;A7C++ON;A6C7+OI;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;A7C++ON;A6C1+OI;EACE,8BAAA;A7C4+ON;A6C1+OI;EACE,yB5CzBuB;E4C0BvB,qB5C1BuB;ADsgP7B;A8CzgPA;EACE,4CAAA;EACA,aAAA;A9C2gPF;;A8CzgPA;EACE,sCAAA;A9C4gPF;;A8C1gPA;EACE,qCAAA;A9C6gPF;;A8C3gPA;EACE,uCAAA;A9C8gPF;;A8C5gPA;EACE,wCAAA;A9C+gPF;;A8C7gPA;;;;EAIE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;A9CghPF;;A8C9gPA;EACE,UAAA;EACA,oCAAA;EACA,uBAAA;A9CihPF;;A8C/gPA;EACE,WAAA;EACA,6BAAA;EACA,sBAAA;A9CkhPF;;A8ChhPA;EACE,SAAA;EACA,oCAAA;EACA,wBAAA;A9CmhPF;;A8CjhPA;EACE,QAAA;EACA,oCAAA;EACA,yBAAA;A9CohPF","sourcesContent":["/*!\r\n\r\n =========================================================\r\n * Paper Kit React - v1.3.2 based on Paper Kit - v2.2.0\r\n =========================================================\r\n\r\n * Product Page: https://www.creative-tim.com/product/paper-kit-2\r\n * Copyright 2023 Creative Tim (http://www.creative-tim.com)\r\n\r\n * Designed by www.invisionapp.com Coded by www.creative-tim.com\r\n\r\n =========================================================\r\n\r\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\n */\r\n\r\n@import \"paper-kit/variables\";\r\n@import \"paper-kit/mixins\";\r\n\r\n// Plugins CSS\r\n@import \"paper-kit/plugins/plugin-bootstrap-switch\";\r\n@import \"paper-kit/plugins/plugin-nouislider\";\r\n@import \"paper-kit/plugins/plugin-datepicker\";\r\n\r\n// Core CSS\r\n@import \"paper-kit/buttons\";\r\n@import \"paper-kit/inputs\";\r\n@import \"paper-kit/checkbox-radio\";\r\n@import \"paper-kit/progress-bars\";\r\n@import \"paper-kit/badges\";\r\n@import \"paper-kit/pagination\";\r\n@import \"paper-kit/typography\";\r\n@import \"paper-kit/misc\";\r\n@import \"paper-kit/labels\";\r\n\r\n// components\r\n@import \"paper-kit/nucleo-icons\";\r\n@import \"paper-kit/social-buttons\";\r\n@import \"paper-kit/tabs-navs\";\r\n@import \"paper-kit/navbars\";\r\n@import \"paper-kit/dropdown\";\r\n@import \"paper-kit/alerts\";\r\n@import \"paper-kit/images\";\r\n@import \"paper-kit/tooltips-and-popovers\";\r\n@import \"paper-kit/modal\";\r\n@import \"paper-kit/icons\";\r\n@import \"paper-kit/carousel\";\r\n@import \"paper-kit/footers\";\r\n\r\n// Cards\r\n@import \"paper-kit/cards\";\r\n@import \"paper-kit/cards/card-plain\";\r\n@import \"paper-kit/cards/card-register\";\r\n@import \"paper-kit/cards/card-profile\";\r\n\r\n// example pages and sections\r\n@import \"paper-kit/examples\";\r\n@import \"paper-kit/sections\";\r\n\r\n@import \"paper-kit/responsive\";\r\n\r\n// React Differences\r\n@import \"react/react-differences.scss\";\r\n","\r\n// Brand Colors Mapped from Pembroke Farmers Market Guide\r\n$brand-primary:              #1C4922; // Harvest Green\r\n$brand-secondary:            #A38354; // Golden Oats\r\n$brand-accent:               #F1582C; // Tomato Tango\r\n$brand-light-bg:             #DCEDCD; // Fresh Sprout\r\n$brand-dark-text:            #122318; // Cedar Green\r\n\r\n// Theme Variable Overrides\r\n$font-color:                 $brand-dark-text !default; // Cedar Green for main text\r\n$fill-font-color:            rgba(255, 255, 255, 0.8); // Keep for contrast on dark backgrounds\r\n$font-family-sans-serif:     'Montserrat', \"Helvetica\", Arial, sans-serif; // Keep default or change if new fonts installed\r\n\r\n$none:                       0   !default;\r\n$border-thin:                1px !default;\r\n$border-thick:               2px !default;\r\n\r\n$white-color:                #FFFFFF !default;\r\n$white-bg:                   #FFFFFF !default;\r\n$white-states-color:         rgba($white-color, 0.8);\r\n\r\n$smoke-bg:                   #F5F5F5 !default; // Can keep or replace with $brand-light-bg\r\n$pale-bg:                    $brand-light-bg !default; // Fresh Sprout\r\n$medium-pale-bg:             darken($brand-light-bg, 5%) !default; // Darker Fresh Sprout\r\n\r\n$table-line-color:           #ccc !default;\r\n$muted-color:                darken($brand-light-bg, 20%) !default; // Muted based on light bg\r\n\r\n$black-bg:                   rgba(30,30,30,.97) !default; // Keep default dark bg\r\n\r\n$black-color:                $brand-dark-text !default; // Cedar Green\r\n$black-hr:                   lighten($brand-dark-text, 20%) !default; // Lighter Cedar Green\r\n\r\n$light-gray:                 #E3E3E3 !default;\r\n$medium-gray:                #DDDDDD !default;\r\n$dark-gray:                  #9A9A9A !default; // Keep for general UI, or map to $brand-secondary\r\n\r\n$placeholder-gray:           rgba(210, 210, 210, 1)  !default;\r\n\r\n$gray-input-bg:              $white-bg !default; // Use white for input background\r\n$danger-input-bg:            lighten($brand-accent, 35%) !default; // Light Tomato Tango\r\n$success-input-bg:           lighten($brand-primary, 75%) !default; // Very light Harvest Green\r\n$other-medium-gray:          $brand-secondary !default; // Golden Oats for some secondary elements\r\n$transparent-bg:             transparent !default;\r\n\r\n// --- Main Color Variable Definitions ---\r\n$default-color:              $brand-dark-text !default;       // Cedar Green\r\n$default-bg:                 $brand-dark-text !default;\r\n$default-states-color:       lighten($brand-dark-text, 10%) !default;\r\n\r\n$primary-color:              $brand-primary !default;         // Harvest Green\r\n$primary-states-color:       darken($brand-primary, 8%) !default;\r\n\r\n$success-color:              $brand-primary !default;         // Harvest Green (Using primary for success)\r\n$success-states-color:       darken($brand-primary, 8%) !default;\r\n\r\n$info-color:                 $brand-secondary !default;       // Golden Oats\r\n$info-states-color:          darken($brand-secondary, 8%) !default;\r\n\r\n$warning-color:              $brand-secondary !default;       // Golden Oats (Using secondary for warning)\r\n$warning-states-color:       darken($brand-secondary, 8%) !default;\r\n\r\n$danger-color:               $brand-accent !default;          // Tomato Tango\r\n$danger-states-color:        darken($brand-accent, 8%) !default;\r\n\r\n$link-disabled-color:        #666666 !default;\r\n\r\n$purple-color:               #c178c1 !default;\r\n$purple-states-color:        darken($purple-color, 8%) !default;\r\n\r\n$brown-color:                #dcb285 !default;\r\n$brown-states-color:         darken($brown-color, 8%) !default;\r\n\r\n\r\n\r\n\r\n/*      light colors - used for select dropdown         */\r\n\r\n/* light colors - used for select dropdown (adjust based on new palette) */\r\n$light-blue:                 rgba($brand-primary, .2); // Light Harvest Green\r\n$light-azure:                rgba($brand-secondary, .2); // Light Golden Oats\r\n$light-green:                rgba($brand-primary, .2);  // Light Harvest Green\r\n$light-orange:               rgba($brand-accent, .2);   // Light Tomato Tango\r\n$light-red:                  rgba($brand-accent, .2);   // Light Tomato Tango\r\n\r\n\r\n//== Components\r\n//\r\n$padding-base-vertical:         7px !default;\r\n$padding-base-horizontal:       18px !default;\r\n\r\n$padding-round-vertical:        9px !default;\r\n$padding-round-horizontal:     18px !default;\r\n\r\n$padding-simple-vertical:      10px !default;\r\n$padding-simple-horizontal:    18px !default;\r\n\r\n$padding-large-vertical:       11px !default;\r\n$padding-large-horizontal:     30px !default;\r\n\r\n$padding-small-vertical:        4px !default;\r\n$padding-small-horizontal:     10px !default;\r\n\r\n$padding-xs-vertical:           2px !default;\r\n$padding-xs-horizontal:         5px !default;\r\n\r\n$padding-label-vertical:        2px !default;\r\n$padding-label-horizontal:     12px !default;\r\n\r\n// padding for links inside dropdown menu\r\n$padding-dropdown-vertical:     10px !default;\r\n$padding-dropdown-horizontal:   15px !default;\r\n\r\n$margin-large-vertical:        30px !default;\r\n$margin-base-vertical:         15px !default;\r\n\r\n// border radius for buttons\r\n$border-radius-none:             0px !default;\r\n$border-radius-btn-small:      26px !default;\r\n$border-radius-btn-base:       20px !default;\r\n$border-radius-btn-large:      50px !default;\r\n\r\n\r\n$margin-bottom:                0 0 10px 0 !default;\r\n$border-radius-small:           3px !default;\r\n$border-radius-base:            4px !default;\r\n$border-radius-large:           6px !default;\r\n$border-radius-x-large:         8px !default;\r\n$border-radius-extreme:         12px !default;\r\n\r\n$border-radius-none-top:      $border-radius-none $border-radius-none 0 0 !default;\r\n$border-radius-none-bottom:   0 0 $border-radius-none $border-radius-none !default;\r\n\r\n$border-radius-small-top:      $border-radius-small $border-radius-small 0 0 !default;\r\n$border-radius-small-bottom:   0 0 $border-radius-small $border-radius-small !default;\r\n\r\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\r\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\r\n\r\n$btn-round-radius:             30px !default;\r\n\r\n$height-base:                  40px !default;\r\n\r\n$font-size-base:               14px !default;\r\n$font-size-small:              12px !default;\r\n$font-size-medium:             16px !default;\r\n$font-size-large:              20px !default;\r\n$font-size-large-navbar:       22px !default;\r\n\r\n$font-size-h1:                 3.6em !default;\r\n$font-size-h2:                 2.8em !default;\r\n$font-size-h3:                 1.825em !default;\r\n$font-size-h4:                 1.6em !default;\r\n$font-size-h5:                 1.35em !default;\r\n$font-size-h6:                 0.9em !default;\r\n$font-paragraph:               15px !default;\r\n$font-size-navbar:             14px !default;\r\n\r\n$font-size-info-horizontal:    2.5em !default;\r\n\r\n$font-weight-light:          300 !default;\r\n$font-weight-normal:         400 !default;\r\n$font-weight-semi:           500 !default;\r\n$font-weight-bold:           600 !default;\r\n\r\n$line-height-small:            20px !default;\r\n$line-height-general:          1.5em !default;\r\n$line-height:                 36px !default;\r\n$line-height-lg:              54px !default;\r\n\r\n\r\n$border-radius-top:        10px 10px 0 0 !default;\r\n$border-radius-bottom:     0 0 10px 10px !default;\r\n$border-radius-dropdown:   10px 10px !default;\r\n\r\n$dropdown-shadow:          0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\r\n\r\n$general-transition-time:  300ms !default;\r\n\r\n$slow-transition-time:           300ms !default;\r\n$dropdown-coordinates:      29px -50px !default;\r\n\r\n$fast-transition-time:           150ms !default;\r\n$select-coordinates:         50% -40px !default;\r\n\r\n$transition-linear:                                   linear !default;\r\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\r\n$transition-ease:           ease 0s;\r\n\r\n$navbar-padding-a:               10px 15px;\r\n$navbar-margin-a:                15px  3px;\r\n\r\n$padding-social-a:               10px  5px;\r\n\r\n$navbar-margin-a-btn:            15px 3px;\r\n$navbar-margin-a-btn-round:      16px 3px;\r\n\r\n$navbar-padding-a-icons:         6px 15px;\r\n$navbar-margin-a-icons:          6px  3px;\r\n\r\n$navbar-padding-brand:           20px 15px;\r\n$navbar-margin-brand:             5px  0px;\r\n\r\n$navbar-margin-brand-icons:      12px auto;\r\n\r\n$navbar-margin-btn:              15px  3px;\r\n\r\n$height-icon:\t\t\t\t\t 64px !default;\r\n$width-icon:\t\t\t\t\t 64px !default;\r\n$padding-icon:\t\t\t\t\t 12px !default;\r\n$border-radius-icon:\t\t     15px !default;\r\n\r\n$size-icon: \t\t\t\t\t 64px;\r\n$size-icon-sm: \t\t\t\t\t 32px;\r\n\r\n\r\n$height-icon-sm:\t\t\t\t 32px;\r\n$width-icon-sm:\t\t\t\t\t 32px;\r\n$padding-icon-sm:\t\t\t     4px;\r\n$border-radius-icon-sm:\t\t\t 7px;\r\n\r\n$height-icon-message:\t\t\t 40px;\r\n$width-icon-message:\t\t\t 40px;\r\n\r\n$height-icon-message-sm: \t\t 20px;\r\n$width-icon-message-sm:\t\t\t 20px;\r\n\r\n\r\n\r\n$white-navbar:              rgba(#FFFFFF, .96);\r\n$blue-navbar:               rgba(#34ACDC, .98);\r\n$azure-navbar:              rgba(#5BCAFF, .98);\r\n$green-navbar:              rgba(#4CD964, .98);\r\n$orange-navbar:             rgba(#FF9500, .98);\r\n$red-navbar:                rgba(#FF4C40, .98);\r\n\r\n//== Background colors for sections (mapped to brand colors)\r\n$bg-nude:               $brand-light-bg !default;         // Fresh Sprout\r\n$bg-primary:            lighten($brand-primary, 7%) !default; // Lighter Harvest Green\r\n$bg-info:               lighten($brand-secondary, 15%) !default;// Lighter Golden Oats\r\n$bg-success:            lighten($brand-primary, 7%) !default; // Lighter Harvest Green\r\n$bg-warning:            lighten($brand-secondary, 15%) !default;// Lighter Golden Oats\r\n$bg-danger:             lighten($brand-accent, 7%) !default;  // Lighter Tomato Tango\r\n$bg-brown:              lighten($brand-secondary, 7%) !default; // Lighter Golden Oats\r\n$bg-purple:             lighten($purple-color, 7%) !default; // Keep or remove if unused\r\n\r\n$preloader-color:          darken($brand-light-bg, 10%) !default; // Based on Fresh Sprout\r\n\r\n//== Filter colors (darkened versions)\r\n$filter-blue:         darken($brand-primary, 10%);\r\n$filter-azure:        darken($brand-secondary, 10%);\r\n$filter-green:        darken($brand-primary, 10%);\r\n$filter-orange:       darken($brand-accent, 10%);\r\n$filter-red:          darken($brand-accent, 10%);\r\n\r\n\r\n$topbar-x:             topbar-x !default;\r\n$topbar-back:          topbar-back !default;\r\n$bottombar-x:          bottombar-x !default;\r\n$bottombar-back:       bottombar-back !default;\r\n\r\n$social-facebook: \t\t\t#3b5998;\r\n$social-twitter: \t\t\t#55acee;\r\n$social-pinterest: \t\t\t#cc2127;\r\n$social-google: \t\t\t#dd4b39;\r\n$social-linkedin: \t\t\t#0976b4;\r\n$social-dribbble: \t\t\t#ea4c89;\r\n$social-github: \t\t\t#333333;\r\n$social-youtube: \t\t\t#e52d27;\r\n$social-instagram: \t\t    #125688;\r\n$social-reddit: \t\t\t#ff4500;\r\n$social-tumblr: \t\t\t#35465c;\r\n\r\n$background-light-grey:     #E8E7E3 !default;\r\n$background-lighter-grey:   #F0EFEB !default;\r\n$font-background-light-grey: #9C9B99 !default;\r\n$font-hover-background-light-grey: #5E5E5C !default;\r\n\r\n// variables used in headers\r\n$header-background:         #B2AFAB !default;\r\n\r\n$filter-primary:         darken($primary-color, 10%);\r\n$filter-info:        darken($info-color, 10%);\r\n$filter-success:        darken($success-color, 10%);\r\n$filter-warning:       darken($warning-color, 10%);\r\n$filter-danger:          darken($danger-color, 10%);\r\n\r\n// variable used in footers\r\n$black-footer-bg:            #252422 !default;\r\n$brown-font-color:           #A49E9E !default;\r\n$brown-font-color-hover:     #F1EAE0 !default;\r\n\r\n//variables used in cards\r\n$card-black-color:           #333333 !default;\r\n$card-muted-color:           #ccc !default;\r\n\r\n$card-background-blue:      #b8d8d8 !default;\r\n$card-font-blue:            #506568 !default;\r\n$card-subtitle-blue:        #7a9e9f !default;\r\n\r\n$card-background-green:      #d5e5a3 !default;\r\n$card-font-green:            #60773d !default;\r\n$card-subtitle-green:        #92ac56 !default;\r\n\r\n$card-background-yellow:      #ffe28c !default;\r\n$card-font-yellow:            #b25825 !default;\r\n$card-subtitle-yellow:        #d88715 !default;\r\n\r\n$card-background-brown:      #d6c1ab !default;\r\n$card-font-brown:            #75442e !default;\r\n$card-subtitle-brown:        #a47e65 !default;\r\n\r\n$card-background-purple:      #baa9ba !default;\r\n$card-font-purple:            #3a283d !default;\r\n$card-subtitle-purple:        #5a283d !default;\r\n\r\n$card-background-orange:      #ff8f5e !default;\r\n$card-font-orange:            #772510 !default;\r\n$card-subtitle-orange:        #e95e37 !default;\r\n\r\n$card-background-primary:     #427C89 !default;\r\n$card-border-color:           #427C89 !default;\r\n\r\n$color-red-error: rgb(185, 74, 72) !default;\r\n$color-grey-arrow: rgba(204, 204, 204, 0.2) !default;\r\n\r\n$width-default: 220px !default; // 3 960px-grid columns\r\n\r\n$zindex-select-dropdown: 1060 !default; // must be higher than a modal background (1050)\r\n\r\n//** Placeholder text color\r\n$input-color-placeholder: #999 !default;\r\n","/* ========================================================================\r\n * bootstrap-switch - v3.3.2\r\n * http://www.bootstrap-switch.org\r\n * ========================================================================\r\n * Copyright 2012-2013 Mattia Larentis\r\n * http://www.apache.org/licenses/LICENSE-2.0\r\n */\r\n\r\n\r\n\r\n //* IMPORTANT! Creative Tim Notice: this file has major changes to fit the Paper Kit's design. If you want to use the plugin as it was before our changes, please get the old files from http://www.bootstrap-switch.org\r\n\r\n .bootstrap-switch {\r\n   display: inline-block;\r\n   direction: ltr;\r\n   cursor: pointer;\r\n   border-radius: 30px;\r\n   border: 0;\r\n   position: relative;\r\n   text-align: left;\r\n   overflow: hidden;\r\n   margin-bottom: 5px;\r\n   line-height: 8px;\r\n   width: 61px !important;\r\n   height: 26px;\r\n   outline: none;\r\n   z-index: 0;\r\n   margin-right: 1px;\r\n   -webkit-user-select: none;\r\n   -moz-user-select: none;\r\n   -ms-user-select: none;\r\n   user-select: none;\r\n   vertical-align: middle;\r\n   -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n   transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-container {\r\n   display: inline-flex;\r\n   top: 0;\r\n   height: 26px;\r\n   border-radius: 4px;\r\n   -webkit-transform: translate3d(0, 0, 0);\r\n   transform: translate3d(0, 0, 0);\r\n   width: 100px !important;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on,\r\n .bootstrap-switch .bootstrap-switch-handle-off,\r\n .bootstrap-switch .bootstrap-switch-label {\r\n     -webkit-box-sizing: border-box;\r\n     -moz-box-sizing: border-box;\r\n     box-sizing: border-box;\r\n     cursor: pointer;\r\n     display: inline-block !important;\r\n     height: 100%;\r\n     color: #fff;\r\n     padding: 6px 12px;\r\n     font-size: 11px;\r\n     text-indent: -5px;\r\n     line-height: 15px;\r\n     -webkit-transition: 0.25s ease-out;\r\n     transition: 0.25s ease-out;\r\n\r\n     i{\r\n         font-size: 12px;\r\n         line-height: 14px;\r\n   }\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on,\r\n .bootstrap-switch .bootstrap-switch-handle-off {\r\n   text-align: center;\r\n   z-index: 1;\r\n   float: left;\r\n   width: 50% !important;\r\n   background-color: #66615B;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-primary,\r\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-primary {\r\n   color: #fff;\r\n   background: $primary-color;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-info,\r\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-info {\r\n   color: #fff;\r\n   background: $info-color;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-success,\r\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-success {\r\n   color: #fff;\r\n   background: $success-color;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-warning,\r\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-warning {\r\n   background: $warning-color;\r\n   color: #fff;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on.bootstrap-switch-danger,\r\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-danger {\r\n   color: #fff;\r\n   background: $danger-color;\r\n }\r\n\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-off.bootstrap-switch-default {\r\n   color: #fff;\r\n   background: $default-color;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-label {\r\n   text-align: center;\r\n   z-index: 100;\r\n   color: #333333;\r\n   background: #ffffff;\r\n   width: 22px !important;\r\n   height: 22px;\r\n   margin: 2px -11px;\r\n   border-radius: 12px;\r\n   position: relative;\r\n   float: left;\r\n   padding: 0;\r\n   background-color: #FFFFFF;\r\n   box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-on {\r\n   border-bottom-left-radius: 3px;\r\n   border-top-left-radius: 3px;\r\n }\r\n\r\n .bootstrap-switch .bootstrap-switch-handle-off {\r\n   text-indent: 6px;\r\n }\r\n\r\n .bootstrap-switch input[type='radio'],\r\n .bootstrap-switch input[type='checkbox'] {\r\n   position: absolute !important;\r\n   top: 0;\r\n   left: 0;\r\n   opacity: 0;\r\n   filter: alpha(opacity=0);\r\n   z-index: -1;\r\n }\r\n\r\n .bootstrap-switch input[type='radio'].form-control,\r\n .bootstrap-switch input[type='checkbox'].form-control {\r\n   height: auto;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-on,\r\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-handle-off,\r\n .bootstrap-switch.bootstrap-switch-mini .bootstrap-switch-label {\r\n   padding: 1px 5px;\r\n   font-size: 12px;\r\n   line-height: 1.5;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-on,\r\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-handle-off,\r\n .bootstrap-switch.bootstrap-switch-small .bootstrap-switch-label {\r\n   padding: 5px 10px;\r\n   font-size: 12px;\r\n   line-height: 1.5;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-on,\r\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-handle-off,\r\n .bootstrap-switch.bootstrap-switch-large .bootstrap-switch-label {\r\n   padding: 6px 16px;\r\n   font-size: 18px;\r\n   line-height: 1.33;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-disabled,\r\n .bootstrap-switch.bootstrap-switch-readonly,\r\n .bootstrap-switch.bootstrap-switch-indeterminate {\r\n   cursor: default !important;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-on,\r\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-on,\r\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-on,\r\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-handle-off,\r\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-handle-off,\r\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-handle-off,\r\n .bootstrap-switch.bootstrap-switch-disabled .bootstrap-switch-label,\r\n .bootstrap-switch.bootstrap-switch-readonly .bootstrap-switch-label,\r\n .bootstrap-switch.bootstrap-switch-indeterminate .bootstrap-switch-label {\r\n   opacity: 0.5;\r\n   filter: alpha(opacity=50);\r\n   cursor: default !important;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\r\n   -webkit-transition: margin-left 0.5s;\r\n   transition: margin-left 0.5s;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-on {\r\n   border-bottom-left-radius: 0;\r\n   border-top-left-radius: 0;\r\n   border-bottom-right-radius: 3px;\r\n   border-top-right-radius: 3px;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-inverse .bootstrap-switch-handle-off {\r\n   border-bottom-right-radius: 0;\r\n   border-top-right-radius: 0;\r\n   border-bottom-left-radius: 3px;\r\n   border-top-left-radius: 3px;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\r\n   margin-left: -2px !important;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\r\n   margin-left: -37px !important;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\r\n   width: 26px !important;\r\n   margin: 2px -15px;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\r\n   width: 26px !important;\r\n   margin: 2px -15px -13px -11px;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-handle-off {\r\n   background-color: #66615B;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-handle-on {\r\n   background-color: #cfcfca;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger  {\r\n   background-color: $danger-color;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning  {\r\n   background-color: $warning-color;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success  {\r\n   background-color: $success-color;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary  {\r\n   background-color: $primary-color;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info  {\r\n   background-color: $info-color;\r\n }\r\n .bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default  {\r\n   background-color: $default-color;\r\n }\r\n\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\r\n .bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\r\n   background-color: #cfcfca;\r\n }\r\n","\r\n/* Functional styling;\r\n * These styles are required for noUiSlider to function.\r\n * You don't need to change these rules to apply your design.\r\n */\r\n.noUi-target,\r\n.noUi-target * {\r\n-webkit-touch-callout: none;\r\n-webkit-user-select: none;\r\n-ms-touch-action: none;\r\n\ttouch-action: none;\r\n-ms-user-select: none;\r\n-moz-user-select: none;\r\n\tuser-select: none;\r\n-moz-box-sizing: border-box;\r\n\tbox-sizing: border-box;\r\n}\r\n.noUi-target {\r\n\tposition: relative;\r\n\tdirection: ltr;\r\n}\r\n.noUi-base {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tposition: relative;\r\n\tz-index: 1; /* Fix 401 */\r\n}\r\n.noUi-connect {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n}\r\n.noUi-origin {\r\n\tposition: absolute;\r\n\theight: 0;\r\n\twidth: 0;\r\n\r\n    margin: 0;\r\n    border-radius: 0;\r\n    height: 2px;\r\n    background: #c8c8c8;\r\n    &[style^=\"left: 0\"] .noUi-handle {\r\n        background-color: #fff;\r\n        border: 2px solid #c8c8c8;\r\n        &.noUi-active {\r\n            border-width: 1px;\r\n        }\r\n    }\r\n}\r\n.noUi-handle {\r\n\tposition: relative;\r\n\tz-index: 1;\r\n}\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n-webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\r\n\ttransition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\r\n}\r\n.noUi-state-drag * {\r\n\tcursor: inherit !important;\r\n}\r\n\r\n/* Painting and performance;\r\n * Browsers can paint handles in their own layer.\r\n */\r\n.noUi-base,\r\n.noUi-handle {\r\n\t-webkit-transform: translate3d(0,0,0);\r\n\ttransform: translate3d(0,0,0);\r\n}\r\n\r\n/* Slider size and handle placement;\r\n */\r\n.noUi-horizontal {\r\n\theight: 2px;\r\n    margin: 15px 0;\r\n}\r\n.noUi-vertical {\r\n\twidth: 18px;\r\n}\r\n.noUi-vertical .noUi-handle {\r\n\twidth: 28px;\r\n\theight: 34px;\r\n\tleft: -6px;\r\n\ttop: -17px;\r\n}\r\n\r\n/* Styling;\r\n */\r\n.noUi-target {\r\n\tbackground: #c8c8c8;\r\n\tborder-radius: 4px;\r\n}\r\n.noUi-connect {\r\n\tbackground: #3FB8AF;\r\n-webkit-transition: background 450ms;\r\n\ttransition: background 450ms;\r\n}\r\n\r\n/* Handles and cursors;\r\n */\r\n.noUi-draggable {\r\n\tcursor: w-resize;\r\n}\r\n.noUi-vertical .noUi-draggable {\r\n\tcursor: n-resize;\r\n}\r\n.noUi-handle {\r\n    box-sizing: border-box;\r\n    width: 14px;\r\n    height: 14px;\r\n    left: -10px;\r\n    top: -6px;\r\n    cursor: pointer;\r\n    border-radius: 100%;\r\n    transition: all 0.2s ease-out;\r\n    border: 1px solid;\r\n    background: $white-color;\r\n\r\n    &.noUi-active {\r\n        transform: scale3d(1.5, 1.5, 1);\r\n    }\r\n}\r\n.noUi-vertical .noUi-handle:before,\r\n.noUi-vertical .noUi-handle:after {\r\n\twidth: 14px;\r\n\theight: 1px;\r\n\tleft: 6px;\r\n\ttop: 14px;\r\n}\r\n.noUi-vertical .noUi-handle:after {\r\n\ttop: 17px;\r\n}\r\n\r\n/* Disabled state;\r\n */\r\n\r\n[disabled] .noUi-connect {\r\n\tbackground: #B8B8B8;\r\n}\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n\tcursor: not-allowed;\r\n}\r\n\r\n.slider {\r\n    background: #c8c8c8;\r\n\r\n    & .noUi-connect{\r\n        background-color: $primary-color;\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .noUi-handle{\r\n        border-color: $primary-color;\r\n    }\r\n\r\n    &.slider-info{\r\n        & .noUi-connect{\r\n            background-color: $info-color;\r\n        }\r\n\r\n        .noUi-handle{\r\n            border-color: $info-color;\r\n        }\r\n    }\r\n    &.slider-success{\r\n        & .noUi-connect{\r\n            background-color: $success-color;\r\n        }\r\n\r\n        .noUi-handle{\r\n            border-color: $success-color;\r\n        }\r\n    }\r\n    &.slider-warning{\r\n        & .noUi-connect{\r\n            background-color: $warning-color;\r\n        }\r\n\r\n        .noUi-handle{\r\n            border-color: $warning-color;\r\n        }\r\n    }\r\n    &.slider-danger{\r\n        & .noUi-connect{\r\n             background-color: $danger-color;\r\n         }\r\n\r\n         .noUi-handle{\r\n             border-color: $danger-color;\r\n         }\r\n    }\r\n\r\n}\r\n","/*!\r\n * Datetimepicker for Bootstrap 3\r\n * ! version : 4.7.14\r\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\r\n */\r\n.sr-only,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after,\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after,\r\n.bootstrap-datetimepicker-widget .picker-switch::after,\r\n.bootstrap-datetimepicker-widget table th.prev::after,\r\n.bootstrap-datetimepicker-widget table th.next::after {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget {\r\n  list-style: none;\r\n}\r\n.bootstrap-datetimepicker-widget a .btn:hover {\r\n  background-color: transparent;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu {\r\n  padding: 4px;\r\n  width: 16em;\r\n}\r\n@media (min-width: 768px) {\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n@media (min-width: 992px) {\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n@media (min-width: 1200px) {\r\n  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {\r\n    width: 38em;\r\n  }\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before{\r\n    border-bottom: 11px solid $medium-pale-bg;\r\n    border-left: 11px solid transparent;\r\n    border-right: 11px solid transparent;\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n    right: 12px;\r\n    left: auto;\r\n    top: -12px;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after{\r\n    border-bottom: 11px solid $white-color;\r\n    border-left: 11px solid transparent;\r\n    border-right: 11px solid transparent;\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n    right: 12px;\r\n    left: auto;\r\n    top: -11px;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top {\r\n  margin-top: auto;\r\n  margin-bottom: -20px;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.top.open {\r\n  margin-top: auto;\r\n  margin-bottom: 5px;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {\r\n  left: auto;\r\n  right: 6px;\r\n}\r\n.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {\r\n  left: auto;\r\n  right: 7px;\r\n}\r\n.bootstrap-datetimepicker-widget .list-unstyled {\r\n  margin: 0;\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action] {\r\n  padding: 6px 0;\r\n  border-width: 0;\r\n  color: #66615B;\r\n  background-color: transparent;\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"],\r\n.bootstrap-datetimepicker-widget a[data-action=\"togglePicker\"]:hover {\r\n    color: #429cb6 !important;\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action]:hover {\r\n  background-color: transparent;\r\n  color: rgba(255, 255, 255, 0.85);\r\n}\r\n.bootstrap-datetimepicker-widget a[data-action]:active {\r\n  box-shadow: none;\r\n}\r\n.bootstrap-datetimepicker-widget .timepicker-hour,\r\n.bootstrap-datetimepicker-widget .timepicker-minute,\r\n.bootstrap-datetimepicker-widget .timepicker-second {\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  font-weight: 300;\r\n  font-size: 1.5em;\r\n  margin: 3px;\r\n  border-radius: 50%;\r\n}\r\n.bootstrap-datetimepicker-widget button[data-action] {\r\n  width: 38px;\r\n  height: 38px;\r\n  padding: 0;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementHours\"]::after {\r\n  content: \"Increment Hours\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"incrementMinutes\"]::after {\r\n  content: \"Increment Minutes\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementHours\"]::after {\r\n  content: \"Decrement Hours\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"decrementMinutes\"]::after {\r\n  content: \"Decrement Minutes\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showHours\"]::after {\r\n  content: \"Show Hours\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"showMinutes\"]::after {\r\n  content: \"Show Minutes\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"togglePeriod\"]::after {\r\n  content: \"Toggle AM/PM\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"clear\"]::after {\r\n  content: \"Clear the picker\";\r\n}\r\n.bootstrap-datetimepicker-widget .btn[data-action=\"today\"]::after {\r\n  content: \"Set the date to today\";\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch {\r\n  text-align: center;\r\n  border-radius: 4px;\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch::after {\r\n  content: \"Toggle Date and Time Screens\";\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch td {\r\n  padding: 0;\r\n  margin: 0;\r\n  height: auto;\r\n  width: auto;\r\n  line-height: inherit;\r\n}\r\n.bootstrap-datetimepicker-widget .picker-switch td span {\r\n  line-height: 2.5;\r\n  height: 2.5em;\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  margin: 2px 0px !important;\r\n}\r\n.bootstrap-datetimepicker-widget table {\r\n  width: 100%;\r\n  margin: 0;\r\n}\r\n.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {\r\n  text-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table th {\r\n  height: 20px;\r\n  line-height: 20px;\r\n  width: 20px;\r\n}\r\n.bootstrap-datetimepicker-widget table th.picker-switch {\r\n  width: 145px;\r\n}\r\n.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {\r\n  border-radius: 4px;\r\n  height: 27px;\r\n  width: 27px;\r\n  line-height: 28px;\r\n  font-size: 12px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table th.prev::after {\r\n  content: \"Previous Month\";\r\n}\r\n.bootstrap-datetimepicker-widget table th.next::after {\r\n  content: \"Next Month\";\r\n}\r\n.bootstrap-datetimepicker-widget table th.dow {\r\n  text-align: center;\r\n  border-bottom: 1px solid #E3E3E3;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  color: #9A9A9A;\r\n  font-weight: 400;\r\n  padding-bottom: 5px;\r\n  padding-top: 10px;\r\n}\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {\r\n  background: #E3E3E3;\r\n}\r\n.bootstrap-datetimepicker-widget table td > div {\r\n  border-radius: 4px;\r\n  height: 54px;\r\n  line-height: 54px;\r\n  width: 54px;\r\n  text-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table td.cw > div {\r\n  font-size: .8em;\r\n  height: 20px;\r\n  line-height: 20px;\r\n  color: #cfcfca;\r\n}\r\n.bootstrap-datetimepicker-widget table td.day > div {\r\n  height: 30px;\r\n  line-height: 31px;\r\n  width: 30px;\r\n  text-align: center;\r\n  padding: 0px;\r\n  border-radius: 50%;\r\n  margin: 0 auto;\r\n  z-index: -1;\r\n  position: relative;\r\n}\r\n.table-condensed{\r\n    .day:hover{\r\n        div{\r\n            @include transition(150ms, linear);\r\n        }\r\n    }\r\n}\r\n.bootstrap-datetimepicker-widget table td.minute > div, .bootstrap-datetimepicker-widget table td.hour > div {\r\n  border-radius: 50%;\r\n}\r\n.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {\r\n  background: #E3E3E3;\r\n  cursor: pointer;\r\n}\r\n.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {\r\n  color: #cfcfca;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {\r\n  background-color: #68B3C8;\r\n  color: #FFFFFF;\r\n}\r\n.bootstrap-datetimepicker-widget table td.active.today:before > div {\r\n  border-bottom-color: #FFFFFF;\r\n}\r\n.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n.bootstrap-datetimepicker-widget table td span {\r\n  display: inline-block;\r\n  width: 40px;\r\n  height: 40px;\r\n  line-height: 40px;\r\n  margin: 3px 3px;\r\n  cursor: pointer;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table td span:hover {\r\n  background: #E3E3E3;\r\n}\r\n.bootstrap-datetimepicker-widget table td span.active {\r\n  background-color: #68B3C8;\r\n  color: #FFFFFF;\r\n}\r\n.bootstrap-datetimepicker-widget table td span.old {\r\n  color: #cfcfca;\r\n}\r\n.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {\r\n  background: none;\r\n  color: #cfcfca;\r\n  cursor: not-allowed;\r\n}\r\n.bootstrap-datetimepicker-widget .timepicker-picker span,\r\n.bootstrap-datetimepicker-widget .timepicker-hours span,\r\n.bootstrap-datetimepicker-widget .timepicker-minutes span {\r\n  border-radius: 50% !important;\r\n}\r\n.bootstrap-datetimepicker-widget.usetwentyfour td.hour {\r\n  height: 27px;\r\n  line-height: 27px;\r\n}\r\n\r\n.input-group.date .input-group-addon {\r\n  cursor: pointer;\r\n}\r\n\r\n.table-condensed > tbody > tr > td,\r\n.table-condensed > tbody > tr > th,\r\n.table-condensed > tfoot > tr > td,\r\n.table-condensed > tfoot > tr > th,\r\n.table-condensed > thead > tr > td,\r\n.table-condensed > thead > tr > th {\r\n  padding: 1px;\r\n  text-align: center;\r\n  z-index: 1;\r\n  cursor: pointer;\r\n}\r\n.bootstrap-datetimepicker-widget{\r\n    opacity: 0;\r\n    -webkit-transform: translate3d(0px, -10px, 0px);\r\n    -moz-transform: translate3d(0, -10px, 0);\r\n    -o-transform: translate3d(0, -10px, 0);\r\n    -ms-transform: translate3d(0, -10px, 0);\r\n    transform: translate3d(0px, -10px, 0px);\r\n    -webkit-box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\r\n    box-shadow: 0 2px rgba(17, 16, 15, 0.1), 0 2px 10px rgba(17, 16, 15, 0.1);\r\n\r\n    &.top{\r\n        -webkit-transform: translate3d(0px, 0px, 0px);\r\n        -moz-transform: translate3d(0, 0px, 0);\r\n        -o-transform: translate3d(0, 0px, 0);\r\n        -ms-transform: translate3d(0, 0px, 0);\r\n        transform: translate3d(0px, 0px, 0px);\r\n    }\r\n    &.open{\r\n        opacity: 1;\r\n        -webkit-transform: translate3d(0, 5px, 0);\r\n        -moz-transform: translate3d(0, 5px, 0);\r\n        -o-transform: translate3d(0, 5px, 0);\r\n        -ms-transform: translate3d(0, 5px, 0);\r\n        transform: translate3d(0, 5px, 0);\r\n        transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\r\n    }\r\n}\r\n.bootstrap-datetimepicker-widget.open.top{\r\n    -webkit-transform: translate3d(0, -10px, 0);\r\n    -moz-transform: translate3d(0, -10px, 0);\r\n    -o-transform: translate3d(0, -10px, 0);\r\n    -ms-transform: translate3d(0, -10px, 0);\r\n    transform: translate3d(0, -10px, 0);\r\n\r\n    &:before{\r\n        border-top: 11px solid #DCD9D1;\r\n        border-left: 11px solid transparent;\r\n        border-right: 11px solid transparent;\r\n        content: \"\";\r\n        display: inline-block;\r\n        position: absolute;\r\n        right: 12px;\r\n        bottom: -12px;\r\n    }\r\n    &:after{\r\n        border-top: 11px solid $white-color;\r\n        border-left: 11px solid transparent;\r\n        border-right: 11px solid transparent;\r\n        content: \"\";\r\n        display: inline-block;\r\n        position: absolute;\r\n        right: 12px;\r\n        bottom: -11px;\r\n    }\r\n}\r\n","// User select\r\n// For selecting text on the page\r\n\r\n@mixin user-select($select) {\r\n  -webkit-user-select: $select;\r\n     -moz-user-select: $select;\r\n      -ms-user-select: $select; // IE10+\r\n          user-select: $select;\r\n}\r\n\r\n@mixin box-shadow($shadow...) {\r\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\r\n          box-shadow: $shadow;\r\n}\r\n\r\n// Box sizing\r\n@mixin box-sizing($boxmodel) {\r\n  -webkit-box-sizing: $boxmodel;\r\n     -moz-box-sizing: $boxmodel;\r\n          box-sizing: $boxmodel;\r\n}\r\n\r\n\r\n@mixin transition($time, $type){\r\n    -webkit-transition: all $time $type;\r\n    -moz-transition: all $time $type;\r\n    -o-transition: all $time $type;\r\n    -ms-transition: all $time $type;\r\n    transition: all $time $type;\r\n}\r\n\r\n@mixin transition-opacity($time, $type){\r\n    -webkit-transition: opacity $time $type;\r\n    -moz-transition: opacity $time $type;\r\n    -o-transition: opacity $time $type;\r\n    -ms-transition: opacity $time $type;\r\n    transition: opacity $time $type;\r\n}\r\n\r\n@mixin transition-none(){\r\n    -webkit-transition: none;\r\n    -moz-transition: none;\r\n    -o-transition: none;\r\n    -ms-transition: none;\r\n    transition: none;\r\n}\r\n\r\n\r\n@mixin transform-scale($value){\r\n     -webkit-transform: scale($value);\r\n        -moz-transform: scale($value);\r\n        -o-transform: scale($value);\r\n        -ms-transform: scale($value);\r\n        transform: scale($value);\r\n}\r\n\r\n@mixin transform-translate-x($value){\r\n     -webkit-transform:  translateX($value);\r\n        -moz-transform: translateX($value);\r\n        -o-transform: translateX($value);\r\n        -ms-transform: translateX($value);\r\n        transform: translateX($value);\r\n}\r\n\r\n@mixin transform-translate-y($value){\r\n     -webkit-transform:  translate3d(0, $value, 0);\r\n        -moz-transform: translate3d(0, $value, 0);\r\n        -o-transform: translate3d(0, $value, 0);\r\n        -ms-transform: translate3d(0, $value, 0);\r\n        transform: translate3d(0, $value, 0);\r\n}\r\n\r\n@mixin transform-translate-y-dropdown($value){\r\n     -webkit-transform:  translate3d(0, $value, 0) !important;\r\n        -moz-transform: translate3d(0, $value, 0) !important;\r\n        -o-transform: translate3d(0, $value, 0) !important;\r\n        -ms-transform: translate3d(0, $value, 0) !important;\r\n        transform: translate3d(0, $value, 0) !important;\r\n}\r\n\r\n\r\n@mixin transform-origin($coordinates){\r\n      -webkit-transform-origin: $coordinates;\r\n        -moz-transform-origin: $coordinates;\r\n        -o-transform-origin: $coordinates;\r\n        -ms-transform-origin: $coordinates;\r\n        transform-origin: $coordinates;\r\n}\r\n\r\n@mixin icon-gradient ($top-color, $bottom-color){\r\n    background: $top-color;\r\n    background: -moz-linear-gradient(top,  $top-color 0%, $bottom-color 100%);\r\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,$top-color), color-stop(100%,$bottom-color));\r\n    background: -webkit-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\r\n    background: -o-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\r\n    background: -ms-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\r\n    background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\r\n}\r\n\r\n@mixin vertical-align {\r\n  position: relative;\r\n  top: 50%;\r\n  -webkit-transform: translateY(-50%);\r\n  -ms-transform: translateY(-50%);\r\n  transform: translateY(-50%);\r\n}\r\n\r\n@mixin rotate-180(){\r\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n    -webkit-transform: rotate(180deg);\r\n    -ms-transform: rotate(180deg);\r\n    transform: rotate(180deg);\r\n}\r\n@mixin rotate-53(){\r\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n    -webkit-transform: rotate(53deg);\r\n    -ms-transform: rotate(53deg);\r\n    transform: rotate(53deg);\r\n}\r\n@mixin bar-animation($type){\r\n     -webkit-animation: $type 500ms linear 0s;\r\n     -moz-animation: $type 500ms linear 0s;\r\n     animation: $type 500ms 0s;\r\n     -webkit-animation-fill-mode: forwards;\r\n     -moz-animation-fill-mode: forwards;\r\n     animation-fill-mode: forwards;\r\n}\r\n\r\n@mixin topbar-x-rotation(){\r\n    @keyframes topbar-x {\r\n      0% {top: 0px; transform: rotate(0deg); }\r\n      45% {top: 6px; transform: rotate(145deg); }\r\n      75% {transform: rotate(130deg); }\r\n      100% {transform: rotate(135deg); }\r\n    }\r\n    @-webkit-keyframes topbar-x {\r\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\r\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\r\n      75% {-webkit-transform: rotate(130deg); }\r\n      100% { -webkit-transform: rotate(135deg); }\r\n    }\r\n    @-moz-keyframes topbar-x {\r\n      0% {top: 0px; -moz-transform: rotate(0deg); }\r\n      45% {top: 6px; -moz-transform: rotate(145deg); }\r\n      75% {-moz-transform: rotate(130deg); }\r\n      100% { -moz-transform: rotate(135deg); }\r\n    }\r\n}\r\n\r\n@mixin topbar-back-rotation(){\r\n    @keyframes topbar-back {\r\n      0% { top: 6px; transform: rotate(135deg); }\r\n      45% { transform: rotate(-10deg); }\r\n      75% { transform: rotate(5deg); }\r\n      100% { top: 0px; transform: rotate(0); }\r\n    }\r\n\r\n    @-webkit-keyframes topbar-back {\r\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\r\n      45% { -webkit-transform: rotate(-10deg); }\r\n      75% { -webkit-transform: rotate(5deg); }\r\n      100% { top: 0px; -webkit-transform: rotate(0); }\r\n    }\r\n\r\n    @-moz-keyframes topbar-back {\r\n      0% { top: 6px; -moz-transform: rotate(135deg); }\r\n      45% { -moz-transform: rotate(-10deg); }\r\n      75% { -moz-transform: rotate(5deg); }\r\n      100% { top: 0px; -moz-transform: rotate(0); }\r\n    }\r\n}\r\n\r\n@mixin bottombar-x-rotation(){\r\n    @keyframes bottombar-x {\r\n      0% {bottom: 0px; transform: rotate(0deg);}\r\n      45% {bottom: 6px; transform: rotate(-145deg);}\r\n      75% {transform: rotate(-130deg);}\r\n      100% {transform: rotate(-135deg);}\r\n    }\r\n    @-webkit-keyframes bottombar-x {\r\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\r\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\r\n      75% {-webkit-transform: rotate(-130deg);}\r\n      100% {-webkit-transform: rotate(-135deg);}\r\n    }\r\n    @-moz-keyframes bottombar-x {\r\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\r\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\r\n      75% {-moz-transform: rotate(-130deg);}\r\n      100% {-moz-transform: rotate(-135deg);}\r\n    }\r\n}\r\n\r\n@mixin bottombar-back-rotation{\r\n    @keyframes bottombar-back {\r\n      0% { bottom: 6px;transform: rotate(-135deg);}\r\n      45% { transform: rotate(10deg);}\r\n      75% { transform: rotate(-5deg);}\r\n      100% { bottom: 0px;transform: rotate(0);}\r\n    }\r\n    @-webkit-keyframes bottombar-back {\r\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\r\n      45% {-webkit-transform: rotate(10deg);}\r\n      75% {-webkit-transform: rotate(-5deg);}\r\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\r\n    }\r\n    @-moz-keyframes bottombar-back {\r\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\r\n      45% {-moz-transform: rotate(10deg);}\r\n      75% {-moz-transform: rotate(-5deg);}\r\n      100% {bottom: 0px;-moz-transform: rotate(0);}\r\n    }\r\n\r\n}\r\n\r\n\r\n// Styles for switch\r\n\r\n@mixin switch-styles($color){\r\n    .has-switch span.switch-left,\r\n    .has-switch span.switch-right {\r\n        background-color: color;\r\n    }\r\n}\r\n\r\n//For cards\r\n\r\n@mixin card-color-style($background-color, $text-color, $subtitle-color){\r\n    background: $background-color;\r\n    .category{\r\n        color: $subtitle-color;\r\n    }\r\n    .description{\r\n        color: $text-color;\r\n    }\r\n    .icon{\r\n        i{\r\n            color: $text-color;\r\n            border: 2px solid $subtitle-color;\r\n        }\r\n    }\r\n}\r\n\r\n//For filter\r\n@mixin filter($color){\r\n    @if $color == #FFFFFF{\r\n         background-color: rgba($color,.91);\r\n    } @else {\r\n         background-color: rgba($color,.69);\r\n    }\r\n}\r\n",".btn{\r\n    box-sizing: border-box;\r\n    border-width: $border-thick;\r\n    font-size: $font-size-small;\r\n    font-weight: $font-weight-bold;\r\n    padding: .5rem $padding-base-horizontal;\r\n    line-height: 1.75;\r\n    cursor: pointer;\r\n    text-transform: uppercase;\r\n\r\n\r\n    &.btn-border,\r\n    &.btn-link{\r\n        background-color: $transparent-bg;\r\n    }\r\n\r\n    @include btn-styles($default-color, $default-states-color);\r\n    @include transition($fast-transition-time, linear);\r\n\r\n    &:hover,\r\n    &:focus{\r\n        outline: 0 !important;\r\n        @include box-shadow(none);\r\n    }\r\n    &:active,\r\n    &.active,\r\n    .open > &.dropdown-toggle {\r\n         @include box-shadow(none);\r\n         outline: 0 !important;\r\n    }\r\n\r\n    &[class*=\"btn-outline-\"]{\r\n        background-image: none;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .nc-icon{\r\n        position: relative;\r\n        top: 2px;\r\n    }\r\n}\r\n.btn-just-icon{\r\n    border-radius: $border-radius-btn-large;\r\n    height: 40px;\r\n    width: 40px;\r\n    min-width: 40px;\r\n    padding: 8px;\r\n\r\n    &.btn-sm{\r\n        padding: 4px !important;\r\n    }\r\n    i{\r\n        font-size: $font-size-medium;\r\n        padding: 2px 0px;\r\n    }\r\n}\r\n\r\n.btn-group .btn + .btn,\r\n.btn-group .btn + .btn-group,\r\n.btn-group .btn-group + .btn,\r\n.btn-group .btn-group + .btn-group{\r\n    margin-left: -2px;\r\n}\r\n\r\n\r\n// Apply the mixin to the buttons\r\n.btn-primary { @include btn-styles($primary-color, $primary-states-color); }\r\n.btn-success { @include btn-styles($success-color, $success-states-color); }\r\n.btn-info    { @include btn-styles($info-color, $info-states-color); }\r\n.btn-warning { @include btn-styles($warning-color, $warning-states-color); }\r\n.btn-danger  { @include btn-styles($danger-color, $danger-states-color); }\r\n.btn-neutral  { @include btn-styles($white-color, $default-states-color); }\r\n\r\n.btn-outline-default { @include btn-outline-styles($default-color, $default-states-color); }\r\n.btn-outline-primary { @include btn-outline-styles($primary-color, $primary-states-color); }\r\n.btn-outline-success { @include btn-outline-styles($success-color, $success-states-color); }\r\n.btn-outline-info    { @include btn-outline-styles($info-color, $info-states-color); }\r\n.btn-outline-warning { @include btn-outline-styles($warning-color, $warning-states-color); }\r\n.btn-outline-danger  { @include btn-outline-styles($danger-color, $danger-states-color); }\r\n.btn-outline-neutral { @include btn-outline-styles($white-color, $default-states-color);\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $default-states-color !important;\r\n        background-color: $white-color;\r\n    }\r\n}\r\n.btn-neutral {\r\n    @include btn-styles($white-color, $white-color);\r\n    color: $default-color;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $default-states-color !important;\r\n    }\r\n\r\n    &.btn-border{\r\n        &:hover,\r\n        &:focus{\r\n          color: $default-color;\r\n        }\r\n\r\n        &:active,\r\n        &.active,\r\n        .open > &.dropdown-toggle{\r\n             background-color: $white-color;\r\n             color: $default-color;\r\n        }\r\n    }\r\n    &.btn-link:hover,\r\n    &.btn-link:focus,\r\n    &.btn-link:active {\r\n      color: $white-color !important;\r\n    }\r\n\r\n    &.btn-link:focus:active {\r\n      color: $default-states-color !important;\r\n    }\r\n\r\n    &.btn-link:active,\r\n    &.btn-link.active{\r\n        background-color: transparent;\r\n    }\r\n}\r\n\r\n.btn{\r\n     &:disabled,\r\n     &[disabled],\r\n     &.disabled{\r\n        @include opacity(.5);\r\n    }\r\n}\r\n.btn-link{\r\n    border-color: transparent !important;\r\n    padding: $padding-base-vertical $padding-base-horizontal;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active{\r\n        text-decoration: none;\r\n        border-color: transparent;\r\n    }\r\n\r\n    &.btn-icon{\r\n        padding: $padding-base-vertical;\r\n    }\r\n}\r\n\r\n.btn-lg{\r\n   @include btn-size($padding-large-vertical, $padding-large-horizontal, $font-size-base, $line-height-small);\r\n}\r\n.btn-sm{\r\n    @include btn-size($padding-small-vertical, $padding-small-horizontal, $font-size-small, $line-height-small);\r\n}\r\n.btn-wd {\r\n    min-width: 140px;\r\n}\r\n\r\n.btn-group.select{\r\n    width: 100%;\r\n}\r\n.btn-group.select .btn{\r\n    text-align: left;\r\n}\r\n.btn-group.select .caret{\r\n    position: absolute;\r\n    top: 50%;\r\n    margin-top: -1px;\r\n    right: 8px;\r\n}\r\n.btn-just-icon{\r\n    &.btn-sm{\r\n        height: 30px;\r\n        width: 30px;\r\n        min-width: 30px;\r\n        padding: 0;\r\n\r\n        i{\r\n            font-size: $font-size-small;\r\n            top: 1px !important;\r\n        }\r\n    }\r\n    &.btn-lg{\r\n        height: 50px;\r\n        width: 50px;\r\n        min-width: 50px;\r\n        padding: 13px;\r\n\r\n        i{\r\n            font-size: 18px;\r\n            padding: 0;\r\n        }\r\n    }\r\n    &.btn-link{\r\n        padding: 8px !important;\r\n    }\r\n}\r\n.btn-round{\r\n    border-radius: 30px;\r\n}\r\n.btn.btn-link:focus{\r\n    box-shadow: none !important;\r\n    text-decoration: none;\r\n}\r\n\r\n.column .btn-link{\r\n    padding: 7px 0;\r\n}\r\n.share-buttons .btn-outline-default{\r\n    margin-top: 24px;\r\n}\r\n.btn-group.select{\r\n    overflow: visible !important;\r\n}\r\n.media{\r\n    .media-body{\r\n        .media-footer{\r\n            .btn-neutral{\r\n               margin: $navbar-margin-btn;\r\n               font-size: $font-size-base;\r\n               i{\r\n                   margin-right: 0 !important;\r\n               }\r\n           }\r\n        }\r\n    }\r\n}\r\n","// Mixin for generating new styles\r\n@mixin btn-styles($btn-color, $btn-states-color) {\r\n    background-color: $btn-color;\r\n    border-color: $btn-color;\r\n    color: $white-color;\r\n    @include opacity(1);\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active,\r\n    &.active,\r\n    &:active:focus,\r\n    &:active:hover,\r\n    &.active:focus,\r\n    &:not(:disabled):not(.disabled):active:focus,\r\n    &:not(:disabled):not(.disabled):active,\r\n    &:not(:disabled):not(.disabled).active,\r\n    &:not(:disabled):not(.disabled).active:focus,\r\n    .show > &.dropdown-toggle{\r\n        background-color: $btn-states-color;\r\n        color: $white-color;\r\n        border-color: $btn-states-color;\r\n        box-shadow: none;\r\n    }\r\n\r\n    .caret{\r\n        border-top-color: $white-color;\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled,\r\n    &[disabled],\r\n    fieldset[disabled] & {\r\n      &,\r\n      &:hover,\r\n      &:focus,\r\n      &.focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: $btn-states-color;\r\n        border-color: $btn-states-color;\r\n      }\r\n    }\r\n\r\n    &.btn-link {\r\n        color: $btn-color;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active,\r\n        &.active,\r\n        &:focus:active,\r\n        .open > &.dropdown-toggle{\r\n            background-color: $transparent-bg !important;\r\n            color: $btn-states-color !important;\r\n        }\r\n\r\n        .caret{\r\n            border-top-color: $btn-color;\r\n        }\r\n    }\r\n\r\n    .caret{\r\n      border-top-color: $white-color;\r\n    }\r\n}\r\n\r\n@mixin btn-outline-styles($btn-color, $btn-states-color){\r\n    border-color: $btn-color;\r\n    color: $btn-color;\r\n    @include opacity(1);\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active,\r\n    &.active,\r\n    &:active:focus,\r\n    &:active:hover,\r\n    &.active:focus,\r\n    .show > &.dropdown-toggle {\r\n      background-color: $btn-color !important;\r\n      color: $fill-font-color;\r\n      border-color: $btn-color !important;\r\n      .caret{\r\n          border-top-color: $fill-font-color;\r\n      }\r\n    }\r\n\r\n    .caret{\r\n        border-top-color: $white-color;\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled,\r\n    &[disabled],\r\n    fieldset[disabled] & {\r\n      &,\r\n      &:hover,\r\n      &:focus,\r\n      &.focus,\r\n      &:active,\r\n      &.active {\r\n        background-color: $transparent-bg;\r\n        border-color: $btn-color;\r\n      }\r\n    }\r\n}\r\n\r\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $line-height){\r\n   font-size: $font-size;\r\n   padding: $padding-vertical $padding-horizontal;\r\n\r\n   &.btn-simple{\r\n       padding: $padding-vertical + 2 $padding-horizontal;\r\n   }\r\n\r\n}\r\n","// Opacity\r\n\r\n@mixin opacity($opacity) {\r\n  opacity: $opacity;\r\n  // IE8 filter\r\n  $opacity-ie: ($opacity * 100);\r\n  filter: #{alpha(opacity=$opacity-ie)};\r\n}\r\n\r\n@mixin black-filter($opacity){\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    width: 100%;\r\n    position: absolute;\r\n    background-color: rgba(17,17,17,$opacity);\r\n    display: block;\r\n    content: \"\";\r\n    z-index: 1; \r\n}","@mixin input-size($padding-vertical, $padding-horizontal, $height){\r\n    padding: $padding-vertical $padding-horizontal;\r\n    height: $height;\r\n}\r\n\r\n@mixin light-form(){\r\n    border-radius: 0;\r\n    border:0;\r\n    padding: 0;\r\n    background-color: transparent;\r\n\r\n}\r\n\r\n@mixin optional-at-root($sel) {\r\n@at-root #{if(not &, $sel, selector-append(&, $sel))} {@content;}\r\n}\r\n@mixin placeholder() {\r\n  @include optional-at-root('::-moz-placeholder') {@content;} // Firefox\r\n  @include optional-at-root(':-ms-input-placeholder') {@content;} // Internet Explorer 10+\r\n  @include optional-at-root('::-webkit-input-placeholder') {@content;} // Safari and Chrome\r\n}\r\n","@include placeholder() {\r\n  color: $dark-gray;\r\n};\r\n\r\n.form-control:focus + .input-group-text{\r\n    border: 1px solid black;\r\n}\r\n.form-control {\r\n    background-color: $white-bg;\r\n    border: 1px solid $medium-gray;\r\n    border-radius: $border-radius-base;\r\n    color: $font-color;\r\n    font-size: $font-size-base;\r\n    transition: background-color 0.3s ease 0s;\r\n    padding-right: 0 !important;\r\n    @include input-size($padding-base-vertical, $padding-label-horizontal, $height-base);\r\n    @include box-shadow(none);\r\n\r\n    &:focus{\r\n       background-color: $white-bg;\r\n       border: 1px solid $table-line-color;\r\n       @include box-shadow(none);\r\n       outline: 0 !important;\r\n\r\n       + .input-group-prepend,\r\n       + .input-group-append {\r\n            .input-group-text {\r\n              border: 1px solid $table-line-color;\r\n              border-left: none;\r\n            }\r\n       }\r\n    }\r\n\r\n    &.no-border{\r\n        border: medium none !important;\r\n\r\n        &:focus {\r\n          + .input-group-prepend,\r\n          + .input-group-append {\r\n               .input-group-text {\r\n                 border: none;\r\n               }\r\n          }\r\n        }\r\n    }\r\n\r\n    .has-success &,\r\n    .has-error &,\r\n    .has-success &:focus,\r\n    .has-error &:focus{\r\n        @include box-shadow(none);\r\n    }\r\n\r\n    .has-success &{\r\n        border: 1px solid $table-line-color;\r\n        color: $font-color;\r\n\r\n        &.form-control-success{\r\n            padding-right: 2.5em !important;\r\n        }\r\n    }\r\n    .has-success &:focus{\r\n        border: 1px solid $success-color;\r\n        color: $success-color;\r\n    }\r\n    .has-danger &{\r\n        background-color: $danger-input-bg;\r\n        border: 1px solid $danger-color;\r\n        color: $danger-color;\r\n\r\n        &.form-control-danger{\r\n            padding-right: 2.5em !important;\r\n        }\r\n    }\r\n    .has-danger &:focus{\r\n        background-color: $white-color;\r\n        border: 1px solid $danger-color;\r\n    }\r\n\r\n    & + .form-control-feedback{\r\n        border-radius: $border-radius-large;\r\n        font-size: $font-size-base;\r\n        color: $danger-color;\r\n        font-size: .8rem;\r\n        position: absolute;\r\n        top: 100%;\r\n        padding-left: $padding-label-horizontal;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .open &{\r\n        border-radius: $border-radius-base $border-radius-base 0 0;\r\n        border-bottom-color: transparent;\r\n    }\r\n\r\n    &.form-control-lg {\r\n      height: 55px;\r\n      padding: $padding-large-vertical 13px;\r\n      font-size: 1.25rem;\r\n      line-height: 1.5;\r\n    }\r\n\r\n    &.form-control-sm {\r\n      padding: .25rem .5rem;\r\n      font-size: .875rem;\r\n      line-height: 1.5;\r\n      height: 31px;\r\n    }\r\n}\r\n\r\n.has-error{\r\n    .form-control-feedback, .control-label{\r\n        color: $danger-color;\r\n    }\r\n}\r\n.has-success{\r\n    .form-control-feedback, .control-label{\r\n        color: $success-color;\r\n    }\r\n}\r\n\r\n.input-group-prepend + .form-control {\r\n  margin-left: -1px;\r\n  border-left: none;\r\n}\r\n.form-control + .input-group-append .input-group-text {\r\n  border-right: 1px solid #ddd;\r\n}\r\n\r\n.input-group>.custom-select:not(:last-child),\r\n.input-group>.form-control:not(:last-child) {\r\n  border-right: none;\r\n}\r\n\r\n.input-group-text {\r\n    background-color: $white-bg;\r\n    border-radius: $border-radius-base;\r\n    border: 1px solid #ddd;\r\n    border-right: none;\r\n\r\n    .has-success &,\r\n    .has-error &{\r\n        background-color: $white-color;\r\n    }\r\n    .has-error .form-control:focus + &{\r\n        color: $danger-color;\r\n    }\r\n    .has-success .form-control:focus + &{\r\n        color: $success-color;\r\n    }\r\n    .form-control:focus + &,\r\n    .form-control:focus ~ &{\r\n        background-color: $white-color;\r\n    }\r\n}\r\n\r\n.input-group {\r\n  &.no-border{\r\n    .input-group-text {\r\n      border: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\ntextarea.form-control{\r\n    padding: 10px 18px;\r\n    height: auto;\r\n}\r\n.form-group{\r\n    position: relative;\r\n}\r\n\r\n.register-form {\r\n  .form-control {\r\n    border: 1px solid transparent !important;\r\n  }\r\n  .input-group .form-control {\r\n    margin-left: -1px;\r\n  }\r\n\r\n  .input-group-prepend,\r\n  .input-group-append {\r\n    border: 1px solid transparent !important;\r\n  }\r\n}\r\n\r\n#inputs {\r\n\r\n    .input-group{\r\n        margin-bottom: 1rem;\r\n    }\r\n}\r\n\r\n.card-form-horizontal{\r\n    .card-body{\r\n        .form-group{\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n",".from-check,\r\n.form-check-radio {\r\n    margin-bottom: 12px;\r\n    position: relative;\r\n}\r\n\r\n.form-check {\r\n  padding-left: 0;\r\n  margin-bottom: .5rem;\r\n\r\n    .form-check-label{\r\n        display: inline-block;\r\n        position: relative;\r\n        cursor: pointer;\r\n        padding-left: 35px;\r\n        line-height: 26px;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .form-check-sign::before,\r\n    .form-check-sign::after {\r\n        content: \" \";\r\n        display: inline-block;\r\n        position: absolute;\r\n        width: 24px;\r\n        height: 24px;\r\n        left: 0;\r\n        cursor: pointer;\r\n        border-radius: 6px;\r\n        top: 0;\r\n        background-color: #AAA7A4;\r\n        -webkit-transition: opacity 0.3s linear;\r\n        -moz-transition: opacity 0.3s linear;\r\n        -o-transition: opacity 0.3s linear;\r\n        -ms-transition: opacity 0.3s linear;\r\n        transition: opacity 0.3s linear;\r\n    }\r\n    .form-check-sign::after {\r\n        font-family: 'FontAwesome';\r\n        content: \"\\f00c\";\r\n        top: -1px;\r\n        text-align: center;\r\n        font-size: 15px;\r\n        opacity: 0;\r\n        color: #FFF;\r\n        border: 0;\r\n        background-color: inherit;\r\n    }\r\n    &.disabled{\r\n        .form-check-label{\r\n            color: $dark-gray;\r\n            opacity: .5;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.form-check.disabled .form-check-label,\r\n.form-check.disabled .form-check-label {\r\n\r\n}\r\n\r\n.form-check input[type=\"checkbox\"],\r\n.form-check-radio input[type=\"radio\"]{\r\n    opacity: 0;\r\n    position: absolute;\r\n    visibility: hidden;\r\n}\r\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\r\n    opacity: 1;\r\n}\r\n\r\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\r\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-check .form-check-label input[type=\"checkbox\"]:disabled + .form-check-sign,\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign{\r\n    pointer-events: none !important;\r\n}\r\n\r\n.form-check-radio{\r\n  margin-left: -3px;\r\n\r\n    .form-check-label{\r\n        padding-left: 2rem;\r\n    }\r\n    &.disabled{\r\n        .form-check-label{\r\n            color: $dark-gray;\r\n            opacity: .5;\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n}\r\n\r\n.form-check-radio .form-check-sign::before{\r\n    font-family: 'FontAwesome';\r\n    content: \"\\f10c\";\r\n    font-size: 22px;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    display: inline-block;\r\n    position: absolute;\r\n    opacity: .50;\r\n    left: 5px;\r\n    top: -5px;\r\n}\r\n\r\n.form-check-label input[type=\"checkbox\"]:checked + .form-check-sign:before{\r\n    background-color: #66615B;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\r\n.form-check-radio input[type=\"radio\"] {\r\n    opacity: 0;\r\n    @include transition-opacity(0.3s, linear);\r\n    content:\" \";\r\n    display: block;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\r\n    font-family: 'FontAwesome';\r\n    content: \"\\f192\";\r\n    top: -5px;\r\n    position: absolute;\r\n    left: 5px;\r\n    opacity: 1;\r\n    font-size: 22px;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\r\n    opacity: 1;\r\n}\r\n\r\n\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\r\n    color: $dark-gray;\r\n}\r\n",".progress {\r\n    background-color: $medium-gray;\r\n    border-radius: $border-radius-small;\r\n    box-shadow: none;\r\n    height: 8px;\r\n}\r\n.progress-thin{\r\n    height: 4px;\r\n}\r\n.progress-bar{\r\n    background-color: $primary-color;\r\n}\r\n.progress-bar-primary{\r\n    background-color: $primary-color;\r\n}\r\n.progress-bar-info{\r\n    background-color: $info-color;\r\n}\r\n.progress-bar-success{\r\n    background-color: $success-color;\r\n}\r\n.progress-bar-warning{\r\n    background-color: $warning-color;\r\n}\r\n.progress-bar-danger{\r\n    background-color: $danger-color;\r\n}","/*           badges & Progress-bar              */\r\n.badge{\r\n    padding: 0.4em 0.9em;\r\n    color: $white-color;\r\n    font-weight: 500;\r\n    font-size: 0.75em;\r\n    text-transform: uppercase;\r\n    display: inline-block;\r\n    margin-bottom: 3px;\r\n    padding-top: 5px;\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n  span[data-role=\"remove\"]:focus {\r\n    outline: none;\r\n  }\r\n}\r\n.badge-primary{\r\n    background-color: $primary-color;\r\n}\r\n.badge-info{\r\n    background-color: $info-color;\r\n}\r\n.badge-success{\r\n    background-color: $success-color;\r\n}\r\n.badge-warning{\r\n    background-color: $warning-color;\r\n}\r\n.badge-danger{\r\n    background-color: $danger-color;\r\n}\r\n.badge-default{\r\n    background-color: $default-color;\r\n}\r\n","\r\n.pagination > li > a,\r\n.pagination > li > span,\r\n.pagination > li:first-child > a,\r\n.pagination > li:first-child > span,\r\n.pagination > li:last-child > a,\r\n.pagination > li:last-child > span{\r\n    background-color: transparent;\r\n    border: 2px solid $danger-color;\r\n    border-radius: 20px;\r\n    color: $danger-color;\r\n    height: $line-height;\r\n    margin: 0 2px;\r\n    min-width: 36px;\r\n    padding: 8px 12px;\r\n    font-weight: $font-weight-bold;\r\n}\r\n.nav-pills-default > li > a,\r\n.pagination > li > a:hover,\r\n.pagination > li > a:focus,\r\n.pagination > li > a:active,\r\n.pagination > li.active > a,\r\n.pagination > li.active > span,\r\n.pagination > li.active > a:hover,\r\n.pagination > li.active > span:hover,\r\n.pagination > li.active > a:focus,\r\n.pagination > li.active > span:focus {\r\n    background-color: $default-color;\r\n    border-color: $default-color;\r\n    color: $white-color;\r\n}\r\n\r\n.nav-pills-primary > li > a,\r\n.pagination-primary > li > a,\r\n.pagination-primary > li > span,\r\n.pagination-primary > li:first-child > a,\r\n.pagination-primary > li:first-child > span,\r\n.pagination-primary > li:last-child > a,\r\n.pagination-primary > li:last-child > span{\r\n    border: 2px solid $primary-color;\r\n    color: $primary-color;\r\n}\r\n\r\n.nav-pills-primary > li.active > a,\r\n.nav-pills-primary > li.active > a:hover,\r\n.nav-pills-primary > li.active > a:focus,\r\n.pagination-primary > li > a:hover,\r\n.pagination-primary > li > a:focus,\r\n.pagination-primary > li > a:active,\r\n.pagination-primary > li.active > a,\r\n.pagination-primary > li.active > span,\r\n.pagination-primary > li.active > a:hover,\r\n.pagination-primary > li.active > span:hover,\r\n.pagination-primary > li.active > a:focus,\r\n.pagination-primary > li.active > span:focus{\r\n   background-color: $primary-color !important;\r\n   border-color: $primary-color !important;\r\n   color: $white-color;\r\n}\r\n\r\n.nav-pills-info > li > a,\r\n.pagination-info > li > a,\r\n.pagination-info > li > span,\r\n.pagination-info > li:first-child > a,\r\n.pagination-info > li:first-child > span,\r\n.pagination-info > li:last-child > a,\r\n.pagination-info > li:last-child > span{\r\n    border: 2px solid $info-color;\r\n    color: $info-color;\r\n}\r\n\r\n.nav-pills-info > li.active > a,\r\n.nav-pills-info > li.active > a:hover,\r\n.nav-pills-info > li.active > a:focus,\r\n.pagination-info > li > a:hover,\r\n.pagination-info > li > a:focus,\r\n.pagination-info > li > a:active,\r\n.pagination-info > li.active > a,\r\n.pagination-info > li.active > span,\r\n.pagination-info > li.active > a:hover,\r\n.pagination-info > li.active > span:hover,\r\n.pagination-info > li.active > a:focus,\r\n.pagination-info > li.active > span:focus{\r\n   background-color: $info-color !important;\r\n   border-color: $info-color !important;\r\n   color: $white-color;\r\n}\r\n\r\n.nav-pills-success > li > a,\r\n.pagination-success > li > a,\r\n.pagination-success > li > span,\r\n.pagination-success > li:first-child > a,\r\n.pagination-success > li:first-child > span,\r\n.pagination-success > li:last-child > a,\r\n.pagination-success > li:last-child > span{\r\n    border: 2px solid $success-color;\r\n    color: $success-color;\r\n}\r\n\r\n.nav-pills-success > li.active > a,\r\n.nav-pills-success > li.active > a:hover,\r\n.nav-pills-success > li.active > a:focus,\r\n.pagination-success > li > a:hover,\r\n.pagination-success > li > a:focus,\r\n.pagination-success > li > a:active,\r\n.pagination-success > li.active > a,\r\n.pagination-success > li.active > span,\r\n.pagination-success > li.active > a:hover,\r\n.pagination-success > li.active > span:hover,\r\n.pagination-success > li.active > a:focus,\r\n.pagination-success > li.active > span:focus{\r\n   background-color: $success-color !important;\r\n   border-color: $success-color !important;\r\n   color: $white-color;\r\n}\r\n\r\n.nav-pills-warning > li > a,\r\n.pagination-warning > li > a,\r\n.pagination-warning > li > span,\r\n.pagination-warning > li:first-child > a,\r\n.pagination-warning > li:first-child > span,\r\n.pagination-warning > li:last-child > a,\r\n.pagination-warning > li:last-child > span{\r\n    border: 2px solid $warning-color;\r\n    color: $warning-color;\r\n}\r\n\r\n.nav-pills-warning > li.active > a,\r\n.nav-pills-warning > li.active > a:hover,\r\n.nav-pills-warning > li.active > a:focus,\r\n.pagination-warning > li > a:hover,\r\n.pagination-warning > li > a:focus,\r\n.pagination-warning > li > a:active,\r\n.pagination-warning > li.active > a,\r\n.pagination-warning > li.active > span,\r\n.pagination-warning > li.active > a:hover,\r\n.pagination-warning > li.active > span:hover,\r\n.pagination-warning > li.active > a:focus,\r\n.pagination-warning > li.active > span:focus{\r\n   background-color: $warning-color !important;\r\n   border-color: $warning-color !important;\r\n   color: $white-color;\r\n}\r\n\r\n.nav-pills-danger > li > a,\r\n.pagination-danger > li > a,\r\n.pagination-danger > li > span,\r\n.pagination-danger > li:first-child > a,\r\n.pagination-danger > li:first-child > span,\r\n.pagination-danger > li:last-child > a,\r\n.pagination-danger > li:last-child > span{\r\n    border: 2px solid $danger-color;\r\n    color: $danger-color;\r\n}\r\n\r\n.nav-pills-danger > li.active > a,\r\n.nav-pills-danger > li.active > a:hover,\r\n.nav-pills-danger > li.active > a:focus,\r\n.pagination-danger > li > a:hover,\r\n.pagination-danger > li > a:focus,\r\n.pagination-danger > li > a:active,\r\n.pagination-danger > li.active > a,\r\n.pagination-danger > li.active > span,\r\n.pagination-danger > li.active > a:hover,\r\n.pagination-danger > li.active > span:hover,\r\n.pagination-danger > li.active > a:focus,\r\n.pagination-danger > li.active > span:focus{\r\n   background-color: $danger-color !important;\r\n   border-color: $danger-color !important;\r\n   color: $white-color;\r\n}\r\n\r\n.nav-text, .nav-icons{\r\n    margin: $margin-bottom;\r\n\r\n    > li > a{\r\n        display: block;\r\n        padding: 0px $padding-base-horizontal;\r\n        color: $dark-gray;\r\n        text-align: center;\r\n        @include opacity(0.8);\r\n\r\n        &:hover,\r\n        &:focus{\r\n            background-color: $transparent-bg;\r\n            @include opacity(1);\r\n        }\r\n    }\r\n    > li:first-child a{\r\n        padding-left: 0;\r\n    }\r\n    > li.active a{\r\n       color: $info-color;\r\n    }\r\n}\r\n.nav-icons > li{\r\n    display: inline-block;\r\n     > a{\r\n        padding: 0 10px;\r\n        margin-bottom: 10px;\r\n    }\r\n    > a i{\r\n        font-size: $font-size-h4;\r\n        margin-bottom: 10px;\r\n        width: $font-size-h4;\r\n    }\r\n}\r\n.nav-icons.nav-stacked > li{\r\n    display: block;\r\n    > a {\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n.nav-blue > li.active a{\r\n    color: $primary-color;\r\n}\r\n.nav-azure > li.active a{\r\n    color: $info-color;\r\n}\r\n.nav-green > li.active a{\r\n    color: $success-color;\r\n}\r\n.nav-orange > li.active a{\r\n    color: $warning-color;\r\n}\r\n.nav-red > li.active a{\r\n    color: $danger-color;\r\n}\r\n\r\n.nav-text{\r\n    margin: $margin-bottom;\r\n\r\n    > li > a{\r\n        font-size: $font-size-h6;\r\n        text-transform: uppercase;\r\n        padding: 3px 0;\r\n        text-align: left;\r\n        font-weight: $font-weight-semi;\r\n\r\n    }\r\n    > li:first-child > a{\r\n        padding-top: 0;\r\n    }\r\n    h4{\r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n.nav-text:not(.nav-stacked){\r\n    > li{\r\n        display: inline-block;\r\n    }\r\n    > li > a{\r\n        margin-right: 15px;\r\n    }\r\n}\r\n\r\n// Stefan making edits\r\n\r\n\r\n.page-item:first-child .page-link,\r\n.page-item:last-child .page-link{\r\n    border-bottom-left-radius: 20px;\r\n\tborder-top-left-radius: 20px;\r\n    border-bottom-right-radius: 20px;\r\n    border-top-right-radius: 20px;\r\n}\r\n.nav-pills-default .nav-item.show .nav-link,\r\n.nav-pills-default .nav-link.active{\r\n    background-color: $default-color !important;\r\n}\r\n.nav-pills-primary .nav-item.show .nav-link,\r\n.nav-pills-primary .nav-link.active{\r\n    background-color: $primary-color !important;\r\n}\r\n.nav-pills-info .nav-item.show .nav-link,\r\n.nav-pills-info .nav-link.active{\r\n    background-color: $info-color !important;\r\n}\r\n.nav-pills-warning .nav-item.show .nav-link,\r\n.nav-pills-warning .nav-link.active{\r\n    background-color: $warning-color !important;\r\n}\r\n.nav-pills-success .nav-item.show .nav-link,\r\n.nav-pills-success .nav-link.active{\r\n    background-color: $success-color !important;\r\n}\r\n.nav-pills-danger .nav-item.show .nav-link,\r\n.nav-pills-danger .nav-link.active{\r\n    background-color: $danger-color !important;\r\n}\r\n.pagination > li > a:hover,\r\n.pagination > li > a:focus,\r\n.pagination > li > a:active,\r\n.pagination > li.active > a,\r\n.pagination > li.active > span,\r\n.pagination > li.active > a:hover,\r\n.pagination > li.active > span:hover,\r\n.pagination > li.active > a:focus,\r\n.pagination > li.active > span:focus{\r\n    background-color: $danger-color;\r\n    border-color: $danger-color;\r\n    color: $white-color;\r\n}\r\n\r\n.page-item.active .page-link{\r\n    background-color: $danger-color;\r\n    color: white;\r\n    border-color: $danger-color;\r\n}\r\n.nav-pills .nav-link{\r\n    border-radius: 0;\r\n}\r\n\r\n.pagination {\r\n  .page-link {\r\n    box-shadow: none;\r\n  }\r\n}\r\n","/*           Font Smoothing      */\r\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6, p, .navbar, .brand, a, .td-name, td, button, input, select, textarea{\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-font-smoothing: antialiased;\r\n    font-family: $font-family-sans-serif;\r\n    font-weight: $font-weight-light;\r\n}\r\n\r\nh1, .h1, h2, .h2, h3, .h3, h4, .h4{\r\n    margin: $margin-large-vertical 0 0;\r\n}\r\nh1, .h1 {\r\n    font-size: $font-size-h1;\r\n}\r\nh2, .h2{\r\n    font-size: $font-size-h2;\r\n}\r\nh3, .h3{\r\n    font-size: $font-size-h3;\r\n    line-height: 1.4;\r\n    margin: 20px 0 0px;\r\n}\r\nh4, .h4{\r\n    font-size: $font-size-h4;\r\n    line-height: 1.2em;\r\n}\r\nh5, .h5 {\r\n    font-size: $font-size-h5;\r\n    line-height: 1.4em;\r\n}\r\nh6, .h6{\r\n    font-size: $font-size-h6;\r\n    font-weight: $font-weight-bold;\r\n    text-transform: uppercase;\r\n    line-height: 1.5em;\r\n}\r\np{\r\n    font-size: $font-paragraph;\r\n    line-height: $line-height-general;\r\n    margin-bottom: 5px;\r\n}\r\n\r\nh1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {\r\n    color: $dark-gray;\r\n    line-height: $line-height-general;\r\n}\r\n\r\nh1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {\r\n    font-size: 60%;\r\n}\r\n\r\n.title,\r\n.card-title,\r\n.info-title,\r\n.footer-brand,\r\n.footer-big h5,\r\n.footer-big h4,\r\n.media .media-heading{\r\n    font-family: $font-family-sans-serif;;\r\n\r\n    &,\r\n    a{\r\n        color: $card-black-color;\r\n        text-decoration: none;\r\n    }\r\n}\r\n.title-uppercase{\r\n    text-transform: uppercase;\r\n}\r\n.description{\r\n    color: $dark-gray;\r\n}\r\nblockquote small{\r\n    font-style: normal;\r\n}\r\n.text-muted{\r\n    color: $medium-gray;\r\n}\r\n.text-primary, .text-primary:hover{\r\n    color: $primary-color !important;\r\n}\r\n.text-info, .text-info:hover{\r\n    color: $info-color !important;\r\n}\r\n.text-success, .text-success:hover{\r\n    color: $success-color !important;\r\n}\r\n.text-warning, .text-warning:hover{\r\n    color: $warning-color !important;\r\n}\r\n.text-danger, .text-danger:hover{\r\n    color: $danger-color !important;\r\n}\r\n.glyphicon{\r\n    line-height: 1;\r\n}\r\n\r\n// Pulsing Heart (footer)\r\n.heart {\r\n  color: #EB5E28;\r\n  animation: heathing 1s ease infinite,;\r\n}\r\n\r\n@keyframes heathing {\r\n  0% { transform: scale( .75 ); }\r\n  20% { transform: scale( 1 ); }\r\n  40% { transform: scale( .75 ); }\r\n  60% { transform: scale( 1 ); }\r\n  80% { transform: scale( .75 ); }\r\n  100% { transform: scale( .75 ); }\r\n}\r\n.footer .credits,\r\n.footer-nav{\r\n    line-height: 85px;\r\n}\r\n.footer .btn{\r\n    margin-bottom: 0;\r\n}\r\n.blockquote{\r\n    border-left: 0 none;\r\n    border-bottom: 1px solid #CCC5B9;\r\n    border-top: 1px solid #CCC5B9;\r\n    font-weight: 300;\r\n    margin: 15px 0 10px;\r\n    text-align: center;\r\n}\r\n.title{\r\n    margin-top: 30px;\r\n    margin-bottom: 25px;\r\n    min-height: 32px;\r\n}\r\n.title.text-center{\r\n    margin-bottom: 50px;\r\n}\r\n","/*     General overwrite     */\r\nbody{\r\n    color: $white-color;\r\n    font-size: $font-size-base;\r\n    font-weight: $font-weight-bold;\r\n    font-family: 'Montserrat', \"Helvetica\", Arial, sans-serif;\r\n}\r\na{\r\n  color: $info-color;\r\n\r\n  &:hover, &:focus{\r\n     color: $info-states-color;\r\n     text-decoration: none;\r\n  }\r\n\r\n  // @include transition($fast-transition-time, linear);\r\n}\r\nhr{\r\n    border-color: $medium-pale-bg;\r\n}\r\n.icon{\r\n    fill: $font-color;\r\n}\r\n.fa-base{\r\n    font-size: 1.25em !important;\r\n}\r\na:focus, a:active,\r\nbutton::-moz-focus-inner,\r\ninput[type=\"reset\"]::-moz-focus-inner,\r\ninput[type=\"button\"]::-moz-focus-inner,\r\ninput[type=\"submit\"]::-moz-focus-inner,\r\nselect::-moz-focus-inner,\r\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner {\r\n    outline : 0;\r\n}\r\n.ui-slider-handle:focus,\r\n.navbar-toggle {\r\n    outline : 0 !important;\r\n}\r\n\r\n\r\n/*           Animations              */\r\n.form-control,\r\n.input-group-addon,\r\n.tagsinput,\r\n.navbar,\r\n.navbar .alert,\r\n.carousel-control.right,\r\n.carousel-control.left\r\n{\r\n    @include transition($general-transition-time, linear);\r\n}\r\n.tagsinput .tag,\r\n.tagsinput-remove-link,\r\n.filter,\r\n.btn-hover,\r\n[data-toggle=\"collapse\"] i,\r\n.animation-transition-fast,\r\n.dropdown-menu .dropdown-item{\r\n    @include transition($fast-transition-time, linear);\r\n}\r\n\r\n.btn-morphing .fa,\r\n.btn-morphing .circle,\r\n.gsdk-collapse{\r\n    @include transition($slow-transition-time, linear);\r\n}\r\n\r\n.fa{\r\n    width: 18px;\r\n    text-align: center;\r\n}\r\n.margin-top{\r\n    margin-top: 50px;\r\n}\r\n\r\n.iframe-container iframe{\r\n    box-shadow: 0 16px 38px -12px rgba(0,0,0,.56), 0 4px 25px 0 rgba(0,0,0,.12), 0 8px 10px -5px rgba(0,0,0,.2);\r\n}\r\n\r\n/*       CT colors          */\r\n.ct-blue{\r\n    color: $primary-color;\r\n}\r\n.ct-azure{\r\n    color: $info-color;\r\n}\r\n.ct-green{\r\n    color: $success-color;\r\n}\r\n.ct-orange{\r\n    color: $warning-color;\r\n}\r\n.ct-red{\r\n    color: $danger-color;\r\n}\r\n\r\n//stefan changes\r\n\r\n.pagination .page-item .page-link .fa{\r\n    width: auto;\r\n    font-weight: $font-weight-bold;\r\n}\r\n\r\n.bg-primary{\r\n    @include navbar-color($bg-primary !important);\r\n}\r\n.bg-info{\r\n    @include navbar-color($bg-info !important);\r\n}\r\n.bg-success{\r\n    @include navbar-color($bg-success !important);\r\n}\r\n.bg-warning{\r\n    @include navbar-color($bg-warning !important);\r\n}\r\n.bg-danger{\r\n    @include navbar-color($bg-danger !important);\r\n}\r\n\r\n\r\n.wrapper {\r\n  -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\r\n  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\r\n  left: 0;\r\n  background-color: $white-color;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n// Pulsing Heart (footer)\r\n.heart {\r\n  color: #EB5E28;\r\n  animation: heathing 1s ease infinite,;\r\n}\r\n\r\n@keyframes heathing {\r\n  0% { transform: scale( .75 ); }\r\n  20% { transform: scale( 1 ); }\r\n  40% { transform: scale( .75 ); }\r\n  60% { transform: scale( 1 ); }\r\n  80% { transform: scale( .75 ); }\r\n  100% { transform: scale( .75 ); }\r\n}\r\n\r\n\r\n.bd-docs {\r\n  .page-header {\r\n    min-height: 50vh;\r\n  }\r\n}\r\n\r\n.offline-doc {\r\n  .navbar.navbar-transparent{\r\n    padding-top: 25px;\r\n    border-bottom: none;\r\n\r\n    .navbar-minimize {\r\n      display: none;\r\n    }\r\n    .navbar-brand,\r\n    .collapse .navbar-nav .nav-link {\r\n      color: $white-color !important;\r\n    }\r\n  }\r\n\r\n  .footer{\r\n    position: absolute;\r\n    width: 100%;\r\n    background: transparent;\r\n    bottom: 0;\r\n    z-index: 3;\r\n\r\n    nav > ul a:not(.btn),\r\n    .copyright {\r\n      color: $white-color !important;\r\n    }\r\n  }\r\n\r\n  .page-header{\r\n      .page-header-image {\r\n        position: absolute;\r\n        background-size: cover;\r\n        background-position: center center;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: -1;\r\n      }\r\n    .container {\r\n      z-index: 3;\r\n    }\r\n    &:after {\r\n      background-color: rgba(0, 0, 0, 0.5);\r\n      content: \"\";\r\n      display: block;\r\n      height: 100%;\r\n      left: 0;\r\n      position: absolute;\r\n      top: 0;\r\n      width: 100%;\r\n      z-index: 2;\r\n    }\r\n  }\r\n}\r\n\r\n.main .section:first-of-type {\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n","@mixin navbar-color($color){\r\n    background-color: $color;\r\n}\r\n\r\n@mixin center-item(){\r\n    left: 0;\r\n    right: 0;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n    position: absolute;\r\n}","/*           Labels & Progress-bar              */\r\n.label{\r\n    padding: 0.2em 0.6em;\r\n    border-radius: 10px;\r\n    color: #FFFFFF;\r\n    font-weight: 500;\r\n    font-size: 0.75em;\r\n    text-transform: uppercase;\r\n    display: inline-block;\r\n    margin-bottom: 3px;\r\n    line-height: 17px;\r\n}\r\n.label-primary{\r\n    background-color: $primary-color;\r\n}\r\n.label-info{\r\n    background-color: $info-color;\r\n}\r\n.label-success{\r\n    background-color: $success-color;\r\n}\r\n.label-warning{\r\n    background-color: $warning-color;\r\n}\r\n.label-danger{\r\n    background-color: $danger-color;\r\n}\r\n.label-default{\r\n    background-color: $default-color;\r\n}\r\n","/*--------------------------------\r\n\r\nnucleo-icons Web Font - built using nucleoapp.com\r\nLicense - nucleoapp.com/license/\r\n\r\n-------------------------------- */\r\n@font-face {\r\n  font-family: 'nucleo-icons';\r\n  src: url('~assets/fonts/nucleo-icons.eot');\r\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n/*------------------------\r\n\tbase class definition\r\n-------------------------*/\r\n.nc-icon {\r\n  display: inline-block;\r\n  font: normal normal normal 14px/1 'nucleo-icons';\r\n  font-size: inherit;\r\n  speak: none;\r\n  text-transform: none;\r\n  /* Better Font Rendering */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n/*------------------------\r\n  change icon size\r\n-------------------------*/\r\n.nc-icon.lg {\r\n  font-size: 1.33333333em;\r\n  vertical-align: -16%;\r\n}\r\n.nc-icon.x2 {\r\n  font-size: 2em;\r\n}\r\n.nc-icon.x3 {\r\n  font-size: 3em;\r\n}\r\n/*----------------------------------\r\n  add a square/circle background\r\n-----------------------------------*/\r\n.nc-icon.square,\r\n.nc-icon.circle {\r\n  padding: 0.33333333em;\r\n  vertical-align: -16%;\r\n  background-color: #eee;\r\n}\r\n.nc-icon.circle {\r\n  border-radius: 50%;\r\n}\r\n/*------------------------\r\n  list icons\r\n-------------------------*/\r\n.nc-icon-ul {\r\n  padding-left: 0;\r\n  margin-left: 2.14285714em;\r\n  list-style-type: none;\r\n}\r\n.nc-icon-ul > li {\r\n  position: relative;\r\n}\r\n.nc-icon-ul > li > .nc-icon {\r\n  position: absolute;\r\n  left: -1.57142857em;\r\n  top: 0.14285714em;\r\n  text-align: center;\r\n}\r\n.nc-icon-ul > li > .nc-icon.lg {\r\n  top: 0;\r\n  left: -1.35714286em;\r\n}\r\n.nc-icon-ul > li > .nc-icon.circle,\r\n.nc-icon-ul > li > .nc-icon.square {\r\n  top: -0.19047619em;\r\n  left: -1.9047619em;\r\n}\r\n/*------------------------\r\n  spinning icons\r\n-------------------------*/\r\n.nc-icon.spin {\r\n  -webkit-animation: nc-icon-spin 2s infinite linear;\r\n  -moz-animation: nc-icon-spin 2s infinite linear;\r\n  animation: nc-icon-spin 2s infinite linear;\r\n}\r\n@-webkit-keyframes nc-icon-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n  }\r\n}\r\n@-moz-keyframes nc-icon-spin {\r\n  0% {\r\n    -moz-transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -moz-transform: rotate(360deg);\r\n  }\r\n}\r\n@keyframes nc-icon-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    -moz-transform: rotate(0deg);\r\n    -ms-transform: rotate(0deg);\r\n    -o-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    -moz-transform: rotate(360deg);\r\n    -ms-transform: rotate(360deg);\r\n    -o-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n/*------------------------\r\n  rotated/flipped icons\r\n-------------------------*/\r\n.nc-icon.rotate-90 {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\r\n  -webkit-transform: rotate(90deg);\r\n  -moz-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg);\r\n  -o-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n.nc-icon.rotate-180 {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n  -webkit-transform: rotate(180deg);\r\n  -moz-transform: rotate(180deg);\r\n  -ms-transform: rotate(180deg);\r\n  -o-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n.nc-icon.rotate-270 {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\r\n  -webkit-transform: rotate(270deg);\r\n  -moz-transform: rotate(270deg);\r\n  -ms-transform: rotate(270deg);\r\n  -o-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n}\r\n.nc-icon.flip-y {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\r\n  -webkit-transform: scale(-1, 1);\r\n  -moz-transform: scale(-1, 1);\r\n  -ms-transform: scale(-1, 1);\r\n  -o-transform: scale(-1, 1);\r\n  transform: scale(-1, 1);\r\n}\r\n.nc-icon.flip-x {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n  -webkit-transform: scale(1, -1);\r\n  -moz-transform: scale(1, -1);\r\n  -ms-transform: scale(1, -1);\r\n  -o-transform: scale(1, -1);\r\n  transform: scale(1, -1);\r\n}\r\n/*------------------------\r\n\tfont icons\r\n-------------------------*/\r\n\r\n.nc-air-baloon::before {\r\n    content: \"\\ea01\";\r\n}\r\n\r\n.nc-album-2::before {\r\n    content: \"\\ea02\";\r\n}\r\n\r\n.nc-alert-circle-i::before {\r\n    content: \"\\ea04\";\r\n}\r\n\r\n.nc-align-center::before {\r\n    content: \"\\ea03\";\r\n}\r\n\r\n.nc-align-left-2::before {\r\n    content: \"\\ea05\";\r\n}\r\n\r\n.nc-ambulance::before {\r\n    content: \"\\ea06\";\r\n}\r\n\r\n.nc-app::before {\r\n    content: \"\\ea07\";\r\n}\r\n\r\n.nc-atom::before {\r\n    content: \"\\ea08\";\r\n}\r\n\r\n.nc-badge::before {\r\n    content: \"\\ea09\";\r\n}\r\n\r\n.nc-bag-16::before {\r\n    content: \"\\ea0a\";\r\n}\r\n\r\n.nc-bank::before {\r\n    content: \"\\ea0b\";\r\n}\r\n\r\n.nc-basket::before {\r\n    content: \"\\ea0c\";\r\n}\r\n\r\n.nc-bell-55::before {\r\n    content: \"\\ea0d\";\r\n}\r\n\r\n.nc-bold::before {\r\n    content: \"\\ea0e\";\r\n}\r\n\r\n.nc-book-bookmark::before {\r\n    content: \"\\ea0f\";\r\n}\r\n\r\n.nc-bookmark-2::before {\r\n    content: \"\\ea10\";\r\n}\r\n\r\n.nc-box-2::before {\r\n    content: \"\\ea11\";\r\n}\r\n\r\n.nc-box::before {\r\n    content: \"\\ea12\";\r\n}\r\n\r\n.nc-briefcase-24::before {\r\n    content: \"\\ea13\";\r\n}\r\n\r\n.nc-bulb-63::before {\r\n    content: \"\\ea14\";\r\n}\r\n\r\n.nc-bullet-list-67::before {\r\n    content: \"\\ea15\";\r\n}\r\n\r\n.nc-bus-front-12::before {\r\n    content: \"\\ea16\";\r\n}\r\n\r\n.nc-button-pause::before {\r\n    content: \"\\ea17\";\r\n}\r\n\r\n.nc-button-play::before {\r\n    content: \"\\ea18\";\r\n}\r\n\r\n.nc-button-power::before {\r\n    content: \"\\ea19\";\r\n}\r\n\r\n.nc-calendar-60::before {\r\n    content: \"\\ea1a\";\r\n}\r\n\r\n.nc-camera-compact::before {\r\n    content: \"\\ea1b\";\r\n}\r\n\r\n.nc-caps-small::before {\r\n    content: \"\\ea1c\";\r\n}\r\n\r\n.nc-cart-simple::before {\r\n    content: \"\\ea1d\";\r\n}\r\n\r\n.nc-chart-bar-32::before {\r\n    content: \"\\ea1e\";\r\n}\r\n\r\n.nc-chart-pie-36::before {\r\n    content: \"\\ea1f\";\r\n}\r\n\r\n.nc-chat-33::before {\r\n    content: \"\\ea20\";\r\n}\r\n\r\n.nc-check-2::before {\r\n    content: \"\\ea21\";\r\n}\r\n\r\n.nc-circle-10::before {\r\n    content: \"\\ea22\";\r\n}\r\n\r\n.nc-cloud-download-93::before {\r\n    content: \"\\ea23\";\r\n}\r\n\r\n.nc-cloud-upload-94::before {\r\n    content: \"\\ea24\";\r\n}\r\n\r\n.nc-compass-05::before {\r\n    content: \"\\ea25\";\r\n}\r\n\r\n.nc-controller-modern::before {\r\n    content: \"\\ea26\";\r\n}\r\n\r\n.nc-credit-card::before {\r\n    content: \"\\ea27\";\r\n}\r\n\r\n.nc-delivery-fast::before {\r\n    content: \"\\ea28\";\r\n}\r\n\r\n.nc-diamond::before {\r\n    content: \"\\ea29\";\r\n}\r\n\r\n.nc-email-85::before {\r\n    content: \"\\ea2a\";\r\n}\r\n\r\n.nc-favourite-28::before {\r\n    content: \"\\ea2b\";\r\n}\r\n\r\n.nc-glasses-2::before {\r\n    content: \"\\ea2c\";\r\n}\r\n\r\n.nc-globe-2::before {\r\n    content: \"\\ea2d\";\r\n}\r\n\r\n.nc-globe::before {\r\n    content: \"\\ea2e\";\r\n}\r\n\r\n.nc-hat-3::before {\r\n    content: \"\\ea2f\";\r\n}\r\n\r\n.nc-headphones::before {\r\n    content: \"\\ea30\";\r\n}\r\n\r\n.nc-html5::before {\r\n    content: \"\\ea31\";\r\n}\r\n\r\n.nc-image::before {\r\n    content: \"\\ea32\";\r\n}\r\n\r\n.nc-istanbul::before {\r\n    content: \"\\ea33\";\r\n}\r\n\r\n.nc-key-25::before {\r\n    content: \"\\ea34\";\r\n}\r\n\r\n.nc-laptop::before {\r\n    content: \"\\ea35\";\r\n}\r\n\r\n.nc-layout-11::before {\r\n    content: \"\\ea36\";\r\n}\r\n\r\n.nc-lock-circle-open::before {\r\n    content: \"\\ea37\";\r\n}\r\n\r\n.nc-map-big::before {\r\n    content: \"\\ea38\";\r\n}\r\n\r\n.nc-minimal-down::before {\r\n    content: \"\\ea39\";\r\n}\r\n\r\n.nc-minimal-left::before {\r\n    content: \"\\ea3a\";\r\n}\r\n\r\n.nc-minimal-right::before {\r\n    content: \"\\ea3b\";\r\n}\r\n\r\n.nc-minimal-up::before {\r\n    content: \"\\ea3c\";\r\n}\r\n\r\n.nc-mobile::before {\r\n    content: \"\\ea3d\";\r\n}\r\n\r\n.nc-money-coins::before {\r\n    content: \"\\ea3e\";\r\n}\r\n\r\n.nc-note-03::before {\r\n    content: \"\\ea3f\";\r\n}\r\n\r\n.nc-palette::before {\r\n    content: \"\\ea40\";\r\n}\r\n\r\n.nc-paper::before {\r\n    content: \"\\ea41\";\r\n}\r\n\r\n.nc-pin-3::before {\r\n    content: \"\\ea42\";\r\n}\r\n\r\n.nc-planet::before {\r\n    content: \"\\ea43\";\r\n}\r\n\r\n.nc-refresh-69::before {\r\n    content: \"\\ea44\";\r\n}\r\n\r\n.nc-ruler-pencil::before {\r\n    content: \"\\ea45\";\r\n}\r\n\r\n.nc-satisfied::before {\r\n    content: \"\\ea46\";\r\n}\r\n\r\n.nc-scissors::before {\r\n    content: \"\\ea47\";\r\n}\r\n\r\n.nc-send::before {\r\n    content: \"\\ea48\";\r\n}\r\n\r\n.nc-settings-gear-65::before {\r\n    content: \"\\ea49\";\r\n}\r\n\r\n.nc-settings::before {\r\n    content: \"\\ea4a\";\r\n}\r\n\r\n.nc-share-66::before {\r\n    content: \"\\ea4b\";\r\n}\r\n\r\n.nc-shop::before {\r\n    content: \"\\ea4c\";\r\n}\r\n\r\n.nc-simple-add::before {\r\n    content: \"\\ea4d\";\r\n}\r\n\r\n.nc-simple-delete::before {\r\n    content: \"\\ea4e\";\r\n}\r\n\r\n.nc-simple-remove::before {\r\n    content: \"\\ea4f\";\r\n}\r\n\r\n.nc-single-02::before {\r\n    content: \"\\ea50\";\r\n}\r\n\r\n.nc-single-copy-04::before {\r\n    content: \"\\ea51\";\r\n}\r\n\r\n.nc-sound-wave::before {\r\n    content: \"\\ea52\";\r\n}\r\n\r\n.nc-spaceship::before {\r\n    content: \"\\ea53\";\r\n}\r\n\r\n.nc-sun-fog-29::before {\r\n    content: \"\\ea54\";\r\n}\r\n\r\n.nc-support-17::before {\r\n    content: \"\\ea55\";\r\n}\r\n\r\n.nc-tablet-2::before {\r\n    content: \"\\ea56\";\r\n}\r\n\r\n.nc-tag-content::before {\r\n    content: \"\\ea57\";\r\n}\r\n\r\n.nc-tap-01::before {\r\n    content: \"\\ea58\";\r\n}\r\n\r\n.nc-tie-bow::before {\r\n    content: \"\\ea59\";\r\n}\r\n\r\n.nc-tile-56::before {\r\n    content: \"\\ea5a\";\r\n}\r\n\r\n.nc-time-alarm::before {\r\n    content: \"\\ea5b\";\r\n}\r\n\r\n.nc-touch-id::before {\r\n    content: \"\\ea5c\";\r\n}\r\n\r\n.nc-trophy::before {\r\n    content: \"\\ea5d\";\r\n}\r\n\r\n.nc-tv-2::before {\r\n    content: \"\\ea5e\";\r\n}\r\n\r\n.nc-umbrella-13::before {\r\n    content: \"\\ea5f\";\r\n}\r\n\r\n.nc-user-run::before {\r\n    content: \"\\ea60\";\r\n}\r\n\r\n.nc-vector::before {\r\n    content: \"\\ea61\";\r\n}\r\n\r\n.nc-watch-time::before {\r\n    content: \"\\ea62\";\r\n}\r\n\r\n.nc-world-2::before {\r\n    content: \"\\ea63\";\r\n}\r\n\r\n.nc-zoom-split::before {\r\n    content: \"\\ea64\";\r\n}\r\n\r\n\r\n/* all icon font classes list here */\r\n",".btn-twitter{\r\n    color: $social-twitter !important;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active{\r\n        color: $social-twitter !important;\r\n    }\r\n}\r\n\r\n.btn-facebook{\r\n    color: $social-facebook !important;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active{\r\n        color: $social-facebook !important;\r\n    }\r\n}\r\n\r\n.btn-google{\r\n    color: $social-google !important;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active{\r\n        color: $social-google !important;\r\n    }\r\n}\r\n\r\n.btn-linkedin{\r\n    color: $social-linkedin !important;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active{\r\n        color: $social-linkedin !important;\r\n    }\r\n}\r\n.btn-twitter-bg{\r\n    background-color: $social-twitter !important;\r\n    border-color: $social-twitter !important;\r\n    &:hover{\r\n        background-color: darken($social-twitter, 5%) !important;\r\n        border-color: darken($social-twitter, 5%) !important;\r\n    }\r\n}\r\n.btn-facebook-bg{\r\n    background-color: $social-facebook !important;\r\n    border-color: $social-facebook !important;\r\n    &:hover{\r\n        background-color: darken($social-facebook, 5%) !important;\r\n        border-color: darken($social-facebook, 5%) !important;\r\n    }\r\n}\r\n.btn-google-bg{\r\n    background-color: $social-google !important;\r\n    border-color: $social-google !important;\r\n    &:hover{\r\n        background-color: darken($social-google, 5%) !important;\r\n        border-color: darken($social-google, 5%) !important;\r\n    }\r\n}\r\n.btn-github-bg{\r\n    background-color: #767676 !important;\r\n    border-color: #767676 !important;\r\n    &:hover{\r\n        background-color: darken(#767676, 5%) !important;\r\n        border-color: darken(#767676, 5%) !important;\r\n    }\r\n}\r\n","/*             Navigation menu                */\r\n\r\n/*             Navigation Tabs                 */\r\n.nav-tabs-navigation{\r\n    text-align: center;\r\n    border-bottom: 1px solid $medium-pale-bg;\r\n    margin-bottom: 30px;\r\n\r\n    .nav > .nav-item > .nav-link{\r\n        padding-bottom: 20px;\r\n    }\r\n}\r\n.nav-tabs-wrapper{\r\n    display: inline-block;\r\n    margin-bottom: -6px;\r\n    margin-left: 1.25%;\r\n    margin-right: 1.25%;\r\n    position: relative;\r\n    width: auto;\r\n}\r\n.nav-tabs {\r\n        border-bottom: 0 none;\r\n        font-size: $font-size-medium;\r\n        font-weight: $font-weight-bold;\r\n        .nav-item{\r\n            .nav-link{\r\n                border: 0 none;\r\n                color: $other-medium-gray;\r\n                background-color: transparent;\r\n            }\r\n            .nav-link:hover{\r\n                color: $font-color;\r\n            }\r\n            .nav-link.active{\r\n                color: $font-color;\r\n            }\r\n        }\r\n\r\n        .nav-item{\r\n            color: $font-color;\r\n            position: relative;\r\n\r\n\r\n            .nav-link.active,\r\n            .nav-link.active:hover,\r\n            .nav-link.active:focus{\r\n                background-color: transparent;\r\n                border: 0 none;\r\n                //height: 50px;\r\n                &:after{\r\n                    border-bottom: 11px solid $white-color;\r\n                    border-left: 11px solid rgba(0, 0, 0, 0);\r\n                    border-right: 11px solid rgba(0, 0, 0, 0);\r\n                    content: \"\";\r\n                    display: inline-block;\r\n                    position: absolute;\r\n                    right: 40%;\r\n                    bottom: 5px;\r\n                }\r\n\r\n                &:before{\r\n                    border-bottom: 11px solid $medium-pale-bg;\r\n                    border-left: 11px solid rgba(0, 0, 0, 0);\r\n                    border-right: 11px solid rgba(0, 0, 0, 0);\r\n                    content: \"\";\r\n                    display: inline-block;\r\n                    position: absolute;\r\n                    right: 40%;\r\n                    bottom: 6px;\r\n                }\r\n            }\r\n\r\n        }\r\n        .nav-item.show .nav-link{\r\n            background-color: transparent;\r\n        }\r\n        .dropdown-menu{\r\n            margin-top: -6px;\r\n            margin-left: -46px;\r\n            border-radius: 8px;\r\n\r\n            .dropdown-item:hover,\r\n            .dropdown-item.active{\r\n                color: #FFFFFF;\r\n                background-color: #68B3C8;\r\n            }\r\n            :before{\r\n                border-bottom: 11px solid $medium-pale-bg;\r\n                border-left: 11px solid rgba(0, 0, 0, 0);\r\n                border-right: 11px solid rgba(0, 0, 0, 0);\r\n                content: \"\";\r\n                display: inline-block;\r\n                position: absolute;\r\n                right: 12px;\r\n                top: -11px;\r\n            }\r\n            :after{\r\n                border-bottom: 11px solid $pale-bg;\r\n                border-left: 11px solid rgba(0, 0, 0, 0);\r\n                border-right: 11px solid rgba(0, 0, 0, 0);\r\n                content: \"\";\r\n                display: inline-block;\r\n                position: absolute;\r\n                right: 12px;\r\n                top: -10px;\r\n            }\r\n        }\r\n}\r\n.profile-content{\r\n    & .tab-content{\r\n        & .tab-pane{\r\n            min-height: 200px;\r\n        }\r\n        & #tweets, #connections, #media{\r\n            height: 100%;\r\n        }\r\n    }\r\n}\r\n/*             Navigation Pills               */\r\n\r\n.nav-pills {\r\n    .nav-item + .nav-link {\r\n        margin-left: 0;\r\n    }\r\n    .nav-item .nav-link {\r\n        border: 1px solid $default-color;\r\n        border-radius: 0;\r\n        color: $default-color;\r\n        font-weight: $font-weight-bold;\r\n        margin-left: -1px;\r\n        padding: 10px 25px;\r\n\r\n    }\r\n    .nav-item.active .nav-link,\r\n    .nav-item.active .nav-link:hover,\r\n    .nav-item.active .nav-link:focus {\r\n        background-color: $default-color;\r\n        color: #FFFFFF;\r\n    }\r\n    .nav-item:first-child .nav-link{\r\n        border-radius: 30px 0 0 30px !important;\r\n        margin: 0;\r\n    }\r\n    .nav-item:last-child .nav-link{\r\n        border-radius: 0 30px 30px 0 !important;\r\n    }\r\n    .nav-item .nav-link.active{\r\n        background-color: $default-color;\r\n        color: $white-color;\r\n    }\r\n\r\n}\r\n.nav-pills-primary{\r\n    .nav-item{\r\n        .nav-link{\r\n            border: 1px solid $primary-color !important;\r\n            color: $primary-color !important;\r\n            &.active{\r\n                border: 1px solid $primary-color !important;\r\n                color: $white-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n.nav-pills-danger{\r\n    .nav-item{\r\n        .nav-link{\r\n            border: 1px solid $danger-color !important;\r\n            color: $danger-color !important;\r\n            &.active{\r\n                border: 1px solid $danger-color !important;\r\n                color: $white-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n.nav-pills-info{\r\n    .nav-item{\r\n        .nav-link{\r\n            border: 1px solid $info-color !important;\r\n            color: $info-color !important;\r\n            &.active{\r\n                border: 1px solid $info-color !important;\r\n                color: $white-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n.nav-pills-success{\r\n    .nav-item{\r\n        .nav-link{\r\n            border: 1px solid $success-color !important;\r\n            color: $success-color !important;\r\n            &.active{\r\n                border: 1px solid $success-color !important;\r\n                color: $white-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n.nav-pills-warning{\r\n    .nav-item{\r\n        .nav-link{\r\n            border: 1px solid $warning-color !important;\r\n            color: $warning-color !important;\r\n            &.active{\r\n                border: 1px solid $warning-color !important;\r\n                color: $white-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n","\r\n.nav {\r\n  .nav-item{\r\n    .nav-link:hover,\r\n    .nav-link:focus{\r\n        background-color: transparent;\r\n    }\r\n  }\r\n}\r\n.navbar {\r\n    border: $none;\r\n    font-size: $font-size-base;\r\n    transition: all 0.4s;\r\n    -webkit-transition: all 0.4s;\r\n    padding: 0;\r\n    background: $white-color;\r\n    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);\r\n\r\n    .navbar-brand {\r\n        font-weight: $font-weight-bold;\r\n        margin: $navbar-margin-brand;\r\n        padding: $navbar-padding-brand;\r\n        font-size: $font-size-base;\r\n        color: $default-color;\r\n        text-transform: uppercase;\r\n    }\r\n    .navbar-toggler:focus {\r\n      outline: none;\r\n    }\r\n    .form-control-feedback {\r\n      padding-left: 0px;\r\n    }\r\n\r\n    &:not([class*=\"bg\"]) {\r\n      .navbar-toggler {\r\n        .navbar-toggler-bar {\r\n          background: $default-color !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar-nav {\r\n        .nav-item .nav-link {\r\n            line-height: 1.6;\r\n            margin: $navbar-margin-a;\r\n            padding: $navbar-padding-a;\r\n            opacity: .8;\r\n            font-size: $font-size-small;\r\n            text-transform: uppercase;\r\n            font-weight: 600;\r\n            color: $default-color;\r\n\r\n            p {\r\n              margin: 0px 0px;\r\n              text-transform: uppercase;\r\n              font-weight: 600;\r\n              font-size: 12px;\r\n              line-height: 1.5em;\r\n              padding: 15px 0;\r\n            }\r\n         }\r\n        .nav-item .nav-link.btn {\r\n            margin: $navbar-margin-a-btn;\r\n            padding: 9px;\r\n\r\n         }\r\n        .nav-item .nav-link [class^=\"fa\"] {\r\n            font-size: 17px;\r\n            position: relative;\r\n            right: 5px;\r\n        }\r\n        .dropdown-menu {\r\n            border-radius: $border-radius-extreme;\r\n            margin-top: 1px;\r\n        }\r\n        .nav-item {\r\n          .btn {\r\n            i {\r\n              color: $white-color;\r\n            }\r\n          }\r\n        }\r\n    }\r\n    .navbar-collapse{\r\n        & .nav-item{\r\n            & .nav-link{\r\n                p{\r\n                    display: inline;\r\n                }\r\n            }\r\n            & .dropdown-item{\r\n                i{\r\n                    margin: 0 10px;\r\n                    margin: 0 10px 0px 5px;\r\n                    font-size: 18px;\r\n                    position: relative;\r\n                    top: 3px;\r\n                }\r\n            }\r\n        }\r\n        &.show{\r\n            & .navbar-nav{\r\n                & .nav-item{\r\n                    padding-right: 10px;\r\n                }\r\n            }\r\n        }\r\n\r\n        &:after {\r\n          background-color: #FFFCF5;\r\n        }\r\n    }\r\n    #navbarSupportedContent{\r\n        .nav-item{\r\n            position: relative;\r\n        }\r\n    }\r\n    .notification-bubble{\r\n        padding: 0.4em 0.6em;\r\n        position: absolute;\r\n        top: 10px;\r\n        right: -2px;\r\n    }\r\n    .btn{\r\n       margin: 14px 3px;\r\n       font-size: $font-size-small;\r\n       i{\r\n           font-size: 14px;\r\n           position: relative;\r\n           top: 2px;\r\n       }\r\n    }\r\n    .btn-simple{\r\n        font-size: $font-size-medium;\r\n    }\r\n    .caret{\r\n       @include center-item();\r\n    }\r\n    &.navbar-transparent {\r\n      background: transparent !important;\r\n      padding-top: 25px;\r\n      box-shadow: none;\r\n\r\n      .navbar-brand {\r\n        color: $white-color;\r\n      }\r\n\r\n      .navbar-nav {\r\n        .nav-item .nav-link {\r\n          color: $white-color;\r\n        }\r\n      }\r\n\r\n      .navbar-toggler {\r\n        .navbar-toggler-bar {\r\n          background: $white-color !important;\r\n        }\r\n      }\r\n    }\r\n    .logo-container{\r\n        margin-top: 5px;\r\n        .logo{\r\n            overflow: hidden;\r\n            border-radius: 50%;\r\n            border: 1px solid #333333;\r\n            width: 50px;\r\n            float: left;\r\n\r\n            img{\r\n                width: 100%;\r\n            }\r\n        }\r\n        .brand{\r\n            font-size: 18px;\r\n            color: #FFFFFF;\r\n            line-height: 20px;\r\n            float: left;\r\n            margin-left: 10px;\r\n            margin-top: 5px;\r\n            width: 75px;\r\n            height: 50px;\r\n            }\r\n    }\r\n    .navbar-toggler .navbar-toggler-bar + .navbar-toggler-bar,\r\n    .navbar-toggler .navbar-toggler-icon + .navbar-toggler-icon{\r\n        margin-top: 4px;\r\n    }\r\n    .navbar-toggler {\r\n      .navbar-toggler-bar {\r\n        background: $white-color !important;\r\n        display: block;\r\n        position: relative;\r\n        width: 24px;\r\n        height: 2px;\r\n        border-radius: 1px;\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n}\r\n\r\n.navbar-transparent, [class*=\"bg\"]{\r\n    .navbar-brand{\r\n        color: $white-color;\r\n        @include opacity(.9);\r\n\r\n        &:focus,\r\n        &:hover{\r\n            background-color: transparent;\r\n            @include opacity(1);\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    .navbar-nav{\r\n        .nav-item .nav-link:not(.btn){\r\n            color: $white-color;\r\n            border-color: $white-color;\r\n        }\r\n        .active .nav-link\r\n        .active .nav-link:hover,\r\n        .active .nav-link:focus,\r\n        .nav-item .nav-link:hover,\r\n        .nav-item .nav-link:focus{\r\n            background-color: transparent;\r\n            color: $white-color;\r\n            @include opacity(1);\r\n        }\r\n        .nav .nav-item a.btn:hover{\r\n            background-color: transparent;\r\n        }\r\n\r\n        .dropdown .nav-link .caret,\r\n        .dropdown .nav-link:hover .caret,\r\n        .dropdown .nav-link:focus .caret{\r\n            border-bottom-color: $white-color;\r\n            border-top-color: $white-color;\r\n        }\r\n\r\n        .open .nav-link,\r\n        .open .nav-link:hover,\r\n        .open .nav-link:focus {\r\n            background-color: transparent;\r\n            color: $default-color;\r\n            @include opacity(1);\r\n        }\r\n    }\r\n\r\n    .btn-default.btn-fill{\r\n        color: $dark-gray;\r\n        background-color: $white-color;\r\n        @include opacity(.9);\r\n    }\r\n    .btn-default.btn-fill:hover,\r\n    .btn-default.btn-fill:focus,\r\n    .btn-default.btn-fill:active,\r\n    .btn-default.btn-fill.active,\r\n    .open .dropdown-toggle.btn-fill.btn-default{\r\n        border-color: $white-color;\r\n        @include opacity(1);\r\n    }\r\n\r\n}\r\n\r\n.navbar-absolute{\r\n    position: absolute;\r\n    width: 100%;\r\n    padding-top: 10px;\r\n    z-index: 1029;\r\n}\r\n\r\n.bd-docs {\r\n  .navigation-example {\r\n    .navbar.navbar-transparent {\r\n      padding-top: 0;\r\n      padding: 20px 0;\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n}\r\n",".dropdown {\r\n  > .dropdown-menu:first-of-type {\r\n    display: block;\r\n    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0s, opacity 0.3s ease 0s, height 0s linear 0.35s;\r\n  }\r\n  .dropdown-menu{\r\n      @include opacity(0);\r\n      @include box-shadow($dropdown-shadow);\r\n      visibility: hidden;\r\n      position: absolute;\r\n      \r\n      &[x-placement=\"top-start\"]{\r\n          @include transform-translate-y-dropdown(0px);\r\n\r\n      }\r\n      &[x-placement=\"bottom-start\"]{\r\n          @include transform-translate-y-dropdown(0px);\r\n      }\r\n  }\r\n\r\n  &.show .dropdown-menu{\r\n      @include opacity(1);\r\n      visibility: visible;\r\n\r\n      &[x-placement=\"top-start\"]{\r\n          @include transform-translate-y-dropdown(-50px);\r\n          top: auto !important;\r\n          bottom: 0 !important;\r\n\r\n      }\r\n      &[x-placement=\"bottom-start\"]{\r\n          @include transform-translate-y-dropdown(40px);\r\n          bottom: auto !important;\r\n          top: 0 !important;\r\n      }\r\n  }\r\n}\r\n\r\n.dropdown-menu{\r\n    background-color: $white-color;\r\n    border: 0 none;\r\n    border-radius: $border-radius-extreme;\r\n    margin-top: 10px;\r\n    padding: 0px;\r\n\r\n    .divider{\r\n        background-color: $medium-pale-bg;\r\n        margin: 0px;\r\n    }\r\n\r\n    .dropdown-header{\r\n        color: $dark-gray;\r\n        font-size: $font-size-small;\r\n        padding: $padding-dropdown-vertical $padding-dropdown-horizontal;\r\n    }\r\n\r\n    .no-notification{\r\n        color: #9A9A9A;\r\n        font-size: 1.2em;\r\n        padding: 30px 30px;\r\n        text-align: center;\r\n    }\r\n\r\n    .dropdown-item{\r\n        color: $font-color;\r\n        font-size: $font-size-base;\r\n        padding: 10px 45px 10px 15px;\r\n        clear: both;\r\n        white-space: nowrap;\r\n        width: 100%;\r\n        display: block;\r\n\r\n       img{\r\n           margin-top: -3px;\r\n       }\r\n\r\n    }\r\n    .dropdown-item:focus{\r\n        outline: 0 !important;\r\n    }\r\n\r\n    .btn-group.select &{\r\n        min-width: 100%;\r\n    }\r\n\r\n    .dropdown-item:first-child {\r\n       border-top-left-radius: $border-radius-extreme;\r\n       border-top-right-radius: $border-radius-extreme;\r\n    }\r\n\r\n    .dropdown-item:last-child {\r\n        border-bottom-left-radius: $border-radius-extreme;\r\n        border-bottom-right-radius: $border-radius-extreme;\r\n    }\r\n\r\n    .dropdown-item.dropdown-toggle:last-of-type{\r\n      border-bottom-left-radius: $border-radius-extreme;\r\n      border-bottom-right-radius: $border-radius-extreme;\r\n\r\n      +.dropdown-menu {\r\n        &.show {\r\n          left: 100% !important;\r\n        }\r\n        .dropdown-item.dropdown-toggle {\r\n          border-bottom-left-radius: 0;\r\n          border-bottom-right-radius: 0;\r\n        }\r\n        li .dropdown-item.dropdown-toggle {\r\n          border-top-left-radius: 0;\r\n          border-top-right-radius: 0;\r\n          border-bottom-left-radius: $border-radius-extreme;\r\n          border-bottom-right-radius: $border-radius-extreme;\r\n        }\r\n      }\r\n    }\r\n\r\n    .select & .dropdown-item:first-child{\r\n        border-radius: 0;\r\n        border-bottom: 0 none;\r\n    }\r\n\r\n    .dropdown-item:hover,\r\n    .dropdown-item:focus{\r\n        color: $white-color !important;\r\n        opacity: 1;\r\n        text-decoration: none;\r\n\r\n    }\r\n    .dropdown-item:hover,\r\n    .dropdown-item:focus{\r\n        background-color: $default-color;\r\n    }\r\n\r\n    &.dropdown-primary .dropdown-item:hover,\r\n    &.dropdown-primary .dropdown-item:focus{\r\n        background-color: $bg-primary;\r\n    }\r\n    &.dropdown-info .dropdown-item:hover,\r\n    &.dropdown-info .dropdown-item:focus{\r\n        background-color: $bg-info;\r\n    }\r\n    &.dropdown-success .dropdown-item:hover,\r\n    &.dropdown-success .dropdown-item:focus{\r\n        background-color: $bg-success;\r\n    }\r\n    &.dropdown-warning .dropdown-item:hover,\r\n    &.dropdown-warning .dropdown-item:focus{\r\n        background-color: $bg-warning;\r\n    }\r\n    &.dropdown-danger .dropdown-item:hover,\r\n    &.dropdown-danger .dropdown-item:focus{\r\n        background-color: $bg-danger;\r\n    }\r\n\r\n}\r\n.dropdown-divider {\r\n    margin: 0 !important;\r\n}\r\n\r\n//fixed the bug for the select items in btn-group\r\n\r\n.btn-group.select.open {\r\n  overflow: visible;\r\n}\r\n.dropdown-menu-right {\r\n  right: -2px;\r\n  left: auto;\r\n}\r\n",".alert{\r\n    border: 0;\r\n    border-radius: 0;\r\n    color: $white-color;\r\n    padding: 10px 15px;\r\n    font-size: 14px;\r\n\r\n    & .close{\r\n        font-size: $font-size-large;\r\n        color: $white-color;\r\n    }\r\n\r\n    .container &{\r\n        border-radius: 4px;\r\n\r\n    }\r\n    .navbar &{\r\n        border-radius: 0;\r\n        left: 0;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 85px;\r\n        width: 100%;\r\n        z-index: 3;\r\n    }\r\n    .navbar:not(.navbar-transparent) &{\r\n        top: 70px;\r\n    }\r\n    .alert-icon{\r\n        display: block;\r\n        font-size: 30px;\r\n        left: 15px;\r\n        position: absolute;\r\n        top: 50%;\r\n        margin-top: -22px;\r\n    }\r\n    .alert-wrapper {\r\n        &.message{\r\n            padding-right: 60px;\r\n        }\r\n        i{\r\n            position: relative;\r\n            font-size: 20px;\r\n            top: 5px;\r\n            margin-top: -5px;\r\n            font-weight: $font-weight-bold;\r\n        }\r\n    }\r\n}\r\n.alert-info{\r\n    background-color: $bg-info;\r\n}\r\n.alert-success {\r\n    background-color: $bg-success;\r\n}\r\n.alert-warning {\r\n    background-color: $bg-warning;\r\n}\r\n.alert-danger {\r\n    background-color: $bg-danger;\r\n}\r\n",".img-rounded{\r\n    border-radius: $border-radius-extreme;\r\n    transition: opacity 0.5s ease 0s;\r\n    max-width: 100%;\r\n}\r\n.img-details{\r\n    min-height: 50px;\r\n    padding: 0 4px 0.5em;\r\n\r\n}\r\n.img-details img{\r\n    width: 50px;\r\n}\r\n.img-details .author{\r\n    margin-left: 10px;\r\n    margin-top: -21px;\r\n    width: 40px;\r\n}\r\n.img-circle{\r\n    background-color: $white-color;\r\n    margin-bottom: 10px;\r\n    padding: 4px;\r\n    border-radius: 50% !important;\r\n    max-width: 100%;\r\n}\r\n.img-thumbnail{\r\n    border: 0 none;\r\n    border-radius: $border-radius-extreme;\r\n    box-shadow: 0 1px 2px rgba(164, 158, 147, 0.6);\r\n    margin-bottom: 10px;\r\n}\r\n.img-no-padding{\r\n    padding: 0px;\r\n}\r\n.example-page .img-rounded{\r\n    margin: 50px 0 20px;\r\n}\r\n.img-shadow{\r\n    box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14),\r\n                0 3px 14px 2px rgba(0, 0, 0, 0.12),\r\n                0 5px 5px -3px rgba(0, 0, 0, 0.2)\r\n}\r\n.images-title{\r\n    margin-bottom: 20px;\r\n    height: 50px;\r\n}\r\n.nav-link .profile-photo-small{\r\n    width: 40px;\r\n    height: 30px;\r\n    margin: -10px 0 0 -15px;\r\n}\r\n.profile-picture{\r\n    margin: 0 auto;\r\n    .fileinput-new img{\r\n        width: 150px;\r\n        height: 150px;\r\n        border-radius: 50%;\r\n        margin-bottom: 10px;\r\n    }\r\n    .fileinput-exists img{\r\n        max-width: 150px;\r\n        max-height: 150px;\r\n        border-radius: 50%;\r\n        margin-bottom: 10px;\r\n    }\r\n}\r\n",".tooltip {\r\n    font-size: $font-size-small;\r\n    font-weight: $font-weight-normal;\r\n}\r\n\r\n.tooltip-inner {\r\n    background-color: $white-color;\r\n    border-radius: $border-radius-base;\r\n    box-shadow: 0 1px 13px rgba(0, 0, 0, 0.14), 0 0 0 1px rgba(115, 71, 38, 0.23);\r\n    color: $default-color;\r\n    max-width: 200px;\r\n    padding: 10px 10px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n}\r\n.tooltip-inner:after {\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n}\r\n.tooltip-inner:before {\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n}\r\n\r\n//tooltip arrow positioning\r\n//onLeft\r\n.tooltip.fade.bs-tooltip-left,\r\n.tooltip.fade.bs-tooltip-left.show{\r\n    left: -5px !important;\r\n    .arrow{\r\n        border-left: 11px solid rgba(0, 0, 0, 0.2);\r\n        border-top: 11px solid transparent;\r\n        border-bottom: 11px solid transparent;\r\n        right: -6px;\r\n        left: auto;\r\n        margin-left: 0;\r\n        top: -8px;\r\n\r\n        &::before{\r\n            border-left: 11px solid #FFFFFF;\r\n            border-top: 11px solid transparent;\r\n            border-bottom: 11px solid transparent;\r\n            right: 1px;\r\n            left: auto;\r\n            margin-left: 0;\r\n            top: -8px;\r\n        }\r\n    }\r\n}\r\n\r\n//onRight\r\n.tooltip.fade.bs-tooltip-right,\r\n.tooltip.fade.bs-tooltip-right.show{\r\n    left: 6px !important;\r\n    .arrow{\r\n        border-right: 11px solid rgba(0, 0, 0, 0.2);\r\n        border-top: 11px solid transparent;\r\n        border-bottom: 11px solid transparent;\r\n        left: -6px;\r\n        right: auto;\r\n        margin-right: 0;\r\n        top: -8px;\r\n\r\n        &::before{\r\n            border-right: 11px solid #FFFFFF;\r\n            border-top: 11px solid transparent;\r\n            border-bottom: 11px solid transparent;\r\n            left: 1px;\r\n            right: auto;\r\n            margin-right: 0;\r\n            top: -8px;\r\n        }\r\n    }\r\n}\r\n\r\n//onTop\r\n.tooltip.fade.bs-tooltip-top,\r\n.tooltip.fade.bs-tooltip-top.show{\r\n    top: -6px !important;\r\n\r\n    .arrow{\r\n        border-top: 11px solid rgba(0, 0, 0, 0.2);\r\n        border-left: 11px solid transparent;\r\n        border-right: 11px solid transparent;\r\n        right: auto;\r\n        margin-right: 0;\r\n        top: 43px;\r\n\r\n        &::before{\r\n            border-top: 11px solid #FFFFFF;\r\n            border-left: 11px solid transparent;\r\n            border-right: 11px solid transparent;\r\n            left: -8px;\r\n            right: auto;\r\n            top: -12px;\r\n        }\r\n    }\r\n }\r\n\r\n//onBottom\r\n.tooltip.fade.bs-tooltip-bottom,\r\n.tooltip.fade.bs-tooltip-bottom.show{\r\n    top: 6px!important;\r\n\r\n    .arrow{\r\n        border-bottom: 11px solid rgba(0, 0, 0, 0.2);\r\n        border-left: 11px solid transparent;\r\n        border-right: 11px solid transparent;\r\n        right: auto;\r\n        margin-right: 0;\r\n        top: -6px;\r\n\r\n        &::before{\r\n            border-bottom: 11px solid #FFFFFF;\r\n            border-left: 11px solid transparent;\r\n            border-right: 11px solid transparent;\r\n            left: -8px;\r\n            right: auto;\r\n            top: 1px;\r\n        }\r\n    }\r\n}\r\n\r\n.tooltip.show{\r\n    opacity: 1 !important;\r\n}\r\n\r\n.popover{\r\n    border: 0;\r\n    border-radius: 4px;\r\n    background-color: $white-color;\r\n    color: #66615b;\r\n    font-weight: 400;\r\n    padding: 0;\r\n    z-index: 1031;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    text-align: center;\r\n}\r\n.popover-header{\r\n    background-color: #FFFCF5;\r\n    border-bottom: 0 none;\r\n    font-size: $font-paragraph;\r\n    font-weight: normal;\r\n    line-height: 22px;\r\n    padding: 15px 15px 0px 15px;\r\n    margin: 0;\r\n    color: #66615b;\r\n    text-align: center;\r\n    border-radius: $border-radius-base $border-radius-base 0 0;\r\n    margin-bottom: -10px;\r\n}\r\n.popover-header{\r\n    background-color: $white-color !important;\r\n    text-align: center;\r\n}\r\n.popover-body{\r\n    padding: 15px;\r\n    text-align: center;\r\n}\r\n.popover .arrow{\r\n    border: 0;\r\n}\r\n.popover.top .arrow{\r\n    margin-left: 0;\r\n}\r\n.popover.bottom .arrow:after{\r\n    border-bottom-color: $bg-danger;\r\n}\r\n.popover-filter{\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    z-index: 1030;\r\n    background-color: #000000;\r\n    @include opacity(0);\r\n    visibility: hidden;\r\n\r\n    transition: visibility 0s linear 0.3s,opacity 0.3s linear;\r\n}\r\n.popover-filter.in{\r\n     visibility:visible;\r\n     @include opacity(0.2);\r\n     transition-delay: 0s;\r\n}\r\n.popover.left > .arrow::after{\r\n    border-left-color: $bg-danger;\r\n    bottom: -20px;\r\n}\r\n.popover.top > .arrow::after{\r\n    border-top-color: $bg-danger;\r\n}\r\n.popover.right > .arrow::after{\r\n    border-right-color: $bg-danger;\r\n}\r\n\r\n.popover.left::before{\r\n    border-left-color: $bg-danger;\r\n    bottom: -20px;\r\n}\r\n\r\n.popover-filter.in{\r\n     visibility:visible;\r\n     @include opacity(0.2);\r\n     transition-delay: 0s;\r\n}\r\n.popover-primary{\r\n    @include popover-style($bg-primary);\r\n}\r\n.popover-info{\r\n    @include popover-style($bg-info);\r\n}\r\n.popover-success {\r\n    @include popover-style($bg-success);\r\n}\r\n.popover-warning {\r\n    @include popover-style($bg-warning);\r\n}\r\n.popover-danger {\r\n    @include popover-style($bg-danger);\r\n}\r\n\r\n// popover color\r\n.popover-primary.bs-tether-element-attached-bottom::after,\r\n.popover-primary.bs-tether-element-attached-bottom::before,\r\n.popover-primary.popover-top::after,\r\n.popover-primary.popover-top::before{\r\n    border-top-color: $bg-primary !important;\r\n }\r\n\r\n.popover.popover-info.bs-tether-element-attached-top::after,\r\n.popover.popover-info.popover-bottom::after,\r\n.popover.popover-info.bs-tether-element-attached-top::before,\r\n.popover.popover-info.popover-bottom::before{\r\n    border-bottom-color: $bg-info !important;\r\n}\r\n\r\n.popover-success.bs-tether-element-attached-left::after,\r\n.popover-success.bs-tether-element-attached-left::before,\r\n.popover-success.popover-right::after,\r\n.popover-success.popover-right::before{\r\n    border-right-color: $bg-success !important;\r\n}\r\n\r\n.popover.popover-warning.bs-tether-element-attached-right::after,\r\n.popover.popover-warning.bs-tether-element-attached-right::before,\r\n.popover.popover-warning.popover-left::after,\r\n.popover.popover-warning.popover-left::before{\r\n    border-left-color: $bg-warning !important;\r\n}\r\n\r\n.popover.popover-danger.bs-tether-element-attached-right::after,\r\n.popover.popover-danger.bs-tether-element-attached-right::before,\r\n.popover.popover-danger.popover-left::after,\r\n.popover.popover-danger.popover-left::before{\r\n    border-left-color: $bg-danger !important;\r\n}\r\n\r\n.popover.bs-tether-element-attached-top::after, .popover.popover-bottom::after,\r\n.popover.bs-tether-element-attached-top::before, .popover.popover-bottom::before{\r\n    border-bottom-color: #fff !important;\r\n}\r\n","@mixin popover-style($background-color){\r\n    background-color: $background-color;\r\n    color: $white-color;\r\n    .popover-title{\r\n        background-color: $background-color;\r\n        color: rgba(0, 0, 0, 0.56);\r\n    }\r\n    &.bottom .arrow:after{\r\n        border-bottom-color: $background-color;\r\n    }\r\n    &.left > .arrow::after{\r\n        border-left-color: $background-color;\r\n    }\r\n    &.top > .arrow::after{\r\n        border-top-color: $background-color;\r\n    }\r\n    &.right > .arrow::after{\r\n        border-right-color: $background-color;\r\n    }\r\n\r\n}\r\n",".modal-header {\r\n    border-bottom: 1px solid $medium-gray;\r\n    padding: 20px;\r\n    text-align: center;\r\n    display: block !important;\r\n\r\n    &.no-border-header{\r\n        border-bottom: 0 none !important;\r\n        & .modal-title{\r\n            margin-top: 20px;\r\n\r\n        }\r\n    }\r\n    button.close{\r\n      &:focus {\r\n        outline: none;\r\n      }\r\n    }\r\n}\r\n.modal-dialog{\r\n    &.modal-sm,\r\n    &.modal-register{\r\n        .modal-header{\r\n            button.close{\r\n                margin-top: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modal-content {\r\n    border: 0 none;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\r\n    .modal-header{\r\n        h6{\r\n            margin-top: 10px;\r\n        }\r\n    }\r\n}\r\n\r\n.modal-dialog {\r\n    padding-top: 60px;\r\n}\r\n.modal-body{\r\n    padding: 20px 50px;\r\n    color: #000;\r\n}\r\n.modal-footer {\r\n    border-top: 1px solid $medium-gray;\r\n    padding: 0px;\r\n\r\n    &.no-border-footer{\r\n        border-top: 0 none;\r\n    }\r\n}\r\n.modal-footer .left-side, .modal-footer .right-side{\r\n    display: inline-block;\r\n    text-align: center;\r\n    width: 49%;\r\n}\r\n.modal-footer .btn-link{\r\n    padding: 20px;\r\n    width: 100%\r\n}\r\n.modal-footer .divider{\r\n    background-color: $medium-gray;\r\n    display: inline-block;\r\n    float: inherit;\r\n    height: 63px;\r\n    margin: 0px -3px;\r\n    // position: absolute;\r\n    width: 1px;\r\n}\r\n\r\n.modal-register .modal-footer{\r\n    text-align: center;\r\n    margin-bottom: 25px;\r\n    padding: 20px 0 15px;\r\n    span{\r\n        width: 100%;\r\n    }\r\n}\r\n.modal-header:after {\r\n     display: table;\r\n     content: \" \";\r\n}\r\n.modal-header:before{\r\n    display: table;\r\n    content: \" \";\r\n}\r\n","\r\n.section-nucleo-icons{\r\n    padding: 100px 0;\r\n\r\n    .icons-container{\r\n        position: relative;\r\n        max-width: 450px;\r\n        height: 300px;\r\n        max-height: 300px;\r\n        margin: 0 auto;\r\n\r\n        i{\r\n            font-size: 34px;\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n\r\n            &:nth-child(1){\r\n                top: 5%;\r\n                left: 7%;\r\n            }\r\n            &:nth-child(2){\r\n                top: 28%;\r\n                left: 24%;\r\n            }\r\n            &:nth-child(3){\r\n                top: 40%;\r\n            }\r\n            &:nth-child(4){\r\n                top: 18%;\r\n                left: 62%;\r\n            }\r\n            &:nth-child(5){\r\n                top: 74%;\r\n                left: 3%;\r\n            }\r\n            &:nth-child(6){\r\n                top: 36%;\r\n                left: 44%;\r\n                font-size: 65px;\r\n                color: $danger-color;\r\n                padding: 1px;\r\n            }\r\n            &:nth-child(7){\r\n                top: 59%;\r\n                left: 26%;\r\n            }\r\n            &:nth-child(8){\r\n                top: 60%;\r\n                left: 69%;\r\n            }\r\n            &:nth-child(9){\r\n                top: 72%;\r\n                left: 47%;\r\n            }\r\n            &:nth-child(10){\r\n                top: 88%;\r\n                left: 27%;\r\n            }\r\n            &:nth-child(11){\r\n                top: 31%;\r\n                left: 80%;\r\n            }\r\n            &:nth-child(12){\r\n                top: 88%;\r\n                left: 68%;\r\n            }\r\n            &:nth-child(13){\r\n                top: 5%;\r\n                left: 81%;\r\n            }\r\n            &:nth-child(14){\r\n                top: 58%;\r\n                left: 90%;\r\n            }\r\n            &:nth-child(15){\r\n                top: 6%;\r\n                left: 40%;\r\n            }\r\n        }\r\n    }\r\n}\r\n.section-dark{\r\n    .icons-container{\r\n        color: $white-color;\r\n    }\r\n}\r\n.info{\r\n    .icon{\r\n        margin-top: 0;\r\n        font-size: 3.4em;\r\n    }\r\n}\r\n.icon-primary{\r\n    color: $primary-color;\r\n}\r\n.icon-info{\r\n    color: $info-color;\r\n}\r\n.icon-success{\r\n    color: $success-color;\r\n}\r\n.icon-warning{\r\n    color: $warning-color;\r\n}\r\n.icon-danger{\r\n    color: $danger-color;\r\n}\r\n.icon-neutral{\r\n    color: $white-color;\r\n}\r\n",".carousel-control{\r\n    background-color: $danger-color;\r\n    border-radius: 50%;\r\n    opacity: 1;\r\n    text-shadow: none;\r\n\r\n    &:hover,\r\n    &:focus{\r\n        opacity: 1;\r\n        background-color: $danger-states-color;\r\n    }\r\n}\r\n\r\n.carousel-control.left{\r\n    height: 30px;\r\n    top: 50%;\r\n    width: 30px;\r\n    left: 25px;\r\n    opacity: 0;\r\n}\r\n.carousel-control.right{\r\n    height: 30px;\r\n    right: 25px;\r\n    top: 50%;\r\n    width: 30px;\r\n    opacity: 0;\r\n}\r\n.carousel-control .icon-prev, .carousel-control .icon-next, .carousel-control .fa, .carousel-control .fa {\r\n    display: inline-block;\r\n    z-index: 5;\r\n}\r\n.carousel-control .fa{\r\n    font-size: 26px;\r\n    margin: 2px;\r\n}\r\n.carousel-control.left, .carousel-control.right {\r\n    background-image: none;\r\n}\r\n\r\n .page-carousel{\r\n    border-radius: $border-radius-extreme !important;\r\n    border: none !important;\r\n    width: 100%;\r\n}\r\n\r\n.carousel-inner {\r\n  > .carousel-item > img,\r\n  > .carousel-item > a > img {\r\n      border-radius: $border-radius-extreme;\r\n      box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);\r\n  }\r\n  .carousel-item img {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.carousel-indicators > li{\r\n    background-color: rgba(204, 204, 204, 0.49);\r\n    border: 0 none;\r\n}\r\n.carousel-indicators .active{\r\n    background-color: $danger-color;\r\n}\r\n.page-carousel:hover{\r\n    .carousel-control.right,\r\n    .carousel-control.left{\r\n        opacity: 1;\r\n        z-index: 1;\r\n    }\r\n}\r\n.card {\r\n    .carousel {\r\n        .carousel-indicators {\r\n            bottom: 0;\r\n        }\r\n        a {\r\n            position: absolute;\r\n            color: $white-color !important;\r\n        &:hover {\r\n            color: $white-color !important;\r\n        }\r\n        .fa-angle-left:before {\r\n            padding-right: 3px;\r\n        }\r\n        .fa-angle-right:before {\r\n            padding-left: 3px;\r\n        }\r\n        }\r\n    }\r\n}\r\n",".footer{\r\n    background-attachment: fixed;\r\n    position: relative;\r\n    line-height: 20px;\r\n\r\n    .footer-nav{\r\n        ul{\r\n            padding-left: 0;\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n}\r\n.footer nav > ul {\r\n  list-style: none;\r\n  font-weight: normal;\r\n}\r\n.footer nav > ul > li{\r\n    display: inline-block;\r\n    padding: 10px 15px;\r\n    margin: 15px 3px;\r\n    line-height: 20px;\r\n    text-align: center;\r\n}\r\n.footer nav > ul a:not(.btn) {\r\n    color: #777777;\r\n    display: block;\r\n    margin-bottom: 3px;\r\n    line-height: 1.6;\r\n    opacity: .8;\r\n    font-size: 12px;\r\n    text-transform: uppercase;\r\n    font-weight: 600;\r\n}\r\n.footer nav > ul a:not(.btn):hover,\r\n.footer nav > ul a:not(.btn):focus {\r\n  color: #777777;\r\n  opacity: 1;\r\n}\r\n.footer .copyright {\r\n  color: #777777;\r\n  padding: 10px 0px;\r\n  font-size: 14px;\r\n  margin: 15px 3px;\r\n  line-height: 20px;\r\n  text-align: center;\r\n}\r\n.footer .heart{\r\n    color: #EB5E28;\r\n}\r\n.footer{\r\n    background-color: $white-color;\r\n    line-height: $line-height;\r\n\r\n    &.footer-black{\r\n        h4{\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    .links{\r\n        display: inline-block;\r\n\r\n        ul{\r\n            list-style: none;\r\n            margin: 0;\r\n            padding: 0;\r\n            font-weight: $font-weight-bold;\r\n\r\n            > li{\r\n                display: inline-block;\r\n                padding-right: 20px;\r\n            }\r\n            > li:last-child{\r\n                padding-right: 0px;\r\n            }\r\n\r\n            a:not(.btn){\r\n                color: $font-color;\r\n                display: block;\r\n                font-size: $font-size-h6;\r\n                margin-bottom: 3px;\r\n                &:hover,\r\n                &:focus{\r\n                    color: $default-states-color;\r\n                }\r\n            }\r\n\r\n            &.uppercase-links{\r\n                text-transform: uppercase;\r\n            }\r\n            &.stacked-links{\r\n                margin-top: 10px;\r\n\r\n                > li{\r\n                    display: block;\r\n                    line-height: 26px;\r\n                }\r\n                h4{\r\n                    margin-top: 0px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .social-area{\r\n        padding: 15px 0;\r\n        .btn{\r\n            margin-bottom: 3px;\r\n            padding: 8px;\r\n            i{\r\n                margin-right: 0 !important;\r\n                color: #fff;\r\n            }\r\n        }\r\n    }\r\n    hr{\r\n        border-color: $medium-gray;\r\n        border-width: 1px 0 0;\r\n        margin-top: 5px;\r\n        margin-bottom: 5px;\r\n    }\r\n    .copyright{\r\n        color: $brown-font-color;\r\n        font-size: 0.9em;\r\n        ul > li{\r\n            padding-right: 0px;\r\n        }\r\n    }\r\n    .title{\r\n        color: $default-states-color;\r\n    }\r\n}\r\n",".card {\r\n    border-radius: $border-radius-extreme;\r\n    box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);\r\n    background-color: #FFFFFF;\r\n    color: $card-black-color;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n    z-index: 1;\r\n    border: 0 none;\r\n\r\n    -webkit-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\r\n    -moz-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\r\n    -o-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\r\n    -ms-transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\r\n    transition: transform 300ms cubic-bezier(0.34, 2, 0.6, 1), box-shadow 200ms ease;\r\n\r\n    &:not(.card-plain):hover {\r\n      box-shadow: 0px 12px 19px -7px rgba(0, 0, 0, 0.3);\r\n      transform: translateY(-10px);\r\n      -webkit-transform: translateY(-10px);\r\n      -ms-transform: translateY(-10px);\r\n      -moz-transform: translateY(-10px);\r\n    }\r\n\r\n    &.no-transition:hover,\r\n    &.page-carousel:hover,\r\n    &.card-refine:hover,\r\n    &.card-register:hover{\r\n        box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);\r\n        transform: none;\r\n        -webkit-transform: none;\r\n        -ms-transform: none;\r\n        -moz-transform: none;\r\n    }\r\n\r\n    a:not(.btn){\r\n        color: $black-hr;\r\n\r\n        &:hover,\r\n        &:focus{\r\n            color: $black-color;\r\n        }\r\n    }\r\n    .card-description{\r\n        color: $dark-gray;\r\n        margin-bottom: 5px;\r\n        margin-top: 15px;\r\n    }\r\n\r\n    img{\r\n        max-width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n        border-radius: $border-radius-extreme $border-radius-extreme 0 0;\r\n    }\r\n\r\n    &[data-radius=\"none\"]{\r\n        border-radius: $border-radius-none;\r\n\r\n        .header{\r\n            border-radius: $border-radius-none-top;\r\n\r\n            img{\r\n                border-radius: $border-radius-none-top;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.card-plain{\r\n        background-color: transparent;\r\n        box-shadow: none;\r\n        border-radius: 0;\r\n\r\n\r\n        .card-body{\r\n            padding-left: 5px;\r\n            padding-right: 5px;\r\n        }\r\n\r\n        img{\r\n            border-radius: $border-radius-extreme;\r\n        }\r\n    }\r\n\r\n    .card-link{\r\n        color: $white-color;\r\n    }\r\n\r\n    .card-background-image ul li{\r\n        color: #FFF;\r\n        border-color: rgba(255,255,255,.3);\r\n    }\r\n    &.card-blog,\r\n    &.card-testimonial .card-description + .card-title{\r\n        margin-top: 30px;\r\n\r\n        & .card-image{\r\n            .img{\r\n                border-radius: $border-radius-extreme;\r\n            }\r\n\r\n            .card-title{\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n    &.card:not(.card-plain){\r\n        .card-image{\r\n            .img{\r\n                border-bottom-left-radius: 0px;\r\n                border-bottom-right-radius: 0px;\r\n            }\r\n        }\r\n    }\r\n    &.card-blog{\r\n        margin-top: 5px;\r\n\r\n        .btn{\r\n            margin: 0 auto;\r\n        }\r\n\r\n    }\r\n\r\n    .author{\r\n        display: inline-block;\r\n        .avatar{\r\n            width: 30px;\r\n            height: 30px;\r\n            overflow: hidden;\r\n            border-radius: 50%;\r\n            margin-right: 5px;\r\n        }\r\n\r\n        .avatar-big{\r\n            width: 100px;\r\n            height: 100px;\r\n            border-radius: 50% !important;\r\n            position: relative;\r\n            margin-bottom: 15px;\r\n\r\n            &.border-white{\r\n                border: 4px solid $white-color;\r\n            }\r\n            &.border-gray{\r\n                border: 4px solid $card-muted-color;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .clearfix + .author{\r\n        margin-top: 15px;\r\n    }\r\n\r\n    .stats{\r\n        display: inline-block;\r\n        float: right;\r\n        color: $dark-gray;\r\n        font-size: $font-size-small;\r\n        margin-top: 6px;\r\n\r\n        i{\r\n            font-size: 16px;\r\n            position: relative;\r\n            text-align: center;\r\n            top: 1px;\r\n            margin-left: 5px;\r\n            margin-top: -1px;\r\n            opacity: .6;\r\n        }\r\n    }\r\n    .card-category{\r\n        color: $dark-gray;\r\n    }\r\n    .category-social .fa{\r\n        font-size: 24px;\r\n        position: relative;\r\n        margin-top: -4px;\r\n        top: 2px;\r\n        margin-right: 5px;\r\n    }\r\n    .card-title-uppercase{\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .header{\r\n        position: relative;\r\n        border-radius: $border-radius-small-top;\r\n        z-index: 3;\r\n\r\n        &.header-with-icon{\r\n            height: 150px;\r\n        }\r\n        img{\r\n            width: 100%;\r\n        }\r\n\r\n        .card-category{\r\n            padding: 15px;\r\n        }\r\n\r\n    }\r\n\r\n    .card-body{\r\n        .card-footer{\r\n            padding: 0;\r\n        }\r\n        .card-description + .card-footer{\r\n            padding-top: 10px;\r\n        }\r\n    }\r\n    .more{\r\n        float: right;\r\n        z-index: 4;\r\n        display: block;\r\n        padding-top: 10px;\r\n        padding-right: 10px;\r\n        position: relative;\r\n    }\r\n\r\n    .filter,\r\n    .header .actions{\r\n        position: absolute;\r\n        z-index: 2;\r\n        background-color: rgba(0,0,0,.76);\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        text-align: center;\r\n\r\n        opacity: 0;\r\n    }\r\n\r\n    .header .actions{\r\n        background-color: transparent;\r\n        z-index: 3;\r\n\r\n        .btn{\r\n            @include vertical-align();\r\n        }\r\n    }\r\n\r\n    &:hover{\r\n        .filter{\r\n            opacity: .7;\r\n        }\r\n\r\n        .header .social-line,\r\n        .header .actions{\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    .card-category,\r\n    .label{\r\n        i{\r\n            font-size: $font-paragraph;\r\n        }\r\n    }\r\n\r\n    > .card-title{\r\n       margin: 0;\r\n       padding: 30px 0 0;\r\n    }\r\n\r\n    .card-body{\r\n        padding: 20px;\r\n\r\n        .card-title{\r\n            margin: 5px 0 0 0;\r\n        }\r\n        .card-category ~ .card-title{\r\n            margin-top: 5px;\r\n        }\r\n    }\r\n\r\n    .card-text{\r\n        font-size: $font-paragraph;\r\n        color: $font-color;\r\n        padding-bottom: 15px;\r\n    }\r\n\r\n    h6{\r\n        font-size: $font-size-small;\r\n        margin: 0;\r\n    }\r\n\r\n    .card-footer{\r\n        padding: 15px;\r\n        background: transparent ;\r\n        border-top: 0 none;\r\n\r\n        .social-line{\r\n            .btn:first-child{\r\n                border-radius: 0 0 0 6px;\r\n            }\r\n            .btn:last-child{\r\n                border-radius: 0 0 6px 0;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &.card-separator:after{\r\n        height: 100%;\r\n        right: -15px;\r\n        top: 0;\r\n        width: 1px;\r\n        background-color: $medium-gray;\r\n        content: \"\";\r\n        position: absolute;\r\n    }\r\n\r\n    .card-icon{\r\n        display: block;\r\n        margin: 0 auto;\r\n        position: relative;\r\n        text-align: center;\r\n        padding: 30px 0 10px;\r\n\r\n        i{\r\n            font-size: 40px;\r\n            width: 105px;\r\n            border: 2px solid $card-muted-color;\r\n            border-radius: 50%;\r\n            height: 105px;\r\n            line-height: 105px;\r\n        }\r\n\r\n    }\r\n\r\n    .col-lg-4 &{\r\n        .card-icon{\r\n            i{\r\n                font-size: 80px;\r\n                padding: 22px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.card-with-border{\r\n        .card-body{\r\n            padding: 15px 15px 25px 15px;\r\n        }\r\n\r\n        .card-footer{\r\n            padding-bottom: 25px;\r\n        }\r\n    }\r\n\r\n    &.card-with-border:after{\r\n        position: absolute;\r\n        display: block;\r\n        width: calc(100% - 10px);\r\n        height: calc(100% - 10px);\r\n        content: \"\";\r\n        top: 5px;\r\n        left: 5px;\r\n        border: 1px solid rgba(0,0,0, 0.15);\r\n        z-index: 1;\r\n        border-radius: 5px;\r\n    }\r\n\r\n    &.card-just-text{\r\n        .card-body{\r\n            padding: 50px 65px;\r\n            text-align: center;\r\n        }\r\n        #dLabel{\r\n            float: right;\r\n            i{\r\n                font-size: 20px;\r\n            }\r\n        }\r\n        .dropdown-menu{\r\n            margin-top: 55px;\r\n        }\r\n    }\r\n\r\n    &[data-background=\"image\"]{\r\n        background-position: center center;\r\n        background-size: cover;\r\n        text-align: center;\r\n\r\n        .card-body{\r\n            position: relative;\r\n            z-index: 2;\r\n            min-height: 280px;\r\n            padding-top: 40px;\r\n            padding-bottom: 40px;\r\n            max-width: 440px;\r\n            margin: 0 auto;\r\n            text-align: center;\r\n        }\r\n        .card-title{\r\n            color: #FFF;\r\n            margin-top: 10px;\r\n        }\r\n        &:after{\r\n            position: absolute;\r\n            z-index: 1;\r\n            width: 100%;\r\n            height: 100%;\r\n            display: block;\r\n            left: 0;\r\n            top: 0;\r\n            content: \"\";\r\n            background-color: rgba(0,0,0,.56);\r\n            border-radius: $border-radius-extreme;\r\n        }\r\n        .card-category{\r\n            color: $white-color;\r\n        }\r\n    }\r\n\r\n    &[data-background=\"image\"],\r\n    &[data-background=\"color\"],\r\n    &[data-color]{\r\n        .image{\r\n            border-radius: $border-radius-large;\r\n        }\r\n\r\n        .filter{\r\n            border-radius: $border-radius-large;\r\n        }\r\n        .card-description{\r\n            color: rgba(255,255,255,.8);\r\n        }\r\n\r\n        .card-title,\r\n        .card-category,\r\n        .card-text,\r\n        .card-body,\r\n        .card-footer,\r\n        .stats,\r\n        small,\r\n        [class*=\"text-\"],\r\n        ul li b,\r\n        a:not(.btn){\r\n            color: $white-color !important;\r\n        }\r\n\r\n        a:not(.btn):hover,\r\n        a:not(.btn):focus{\r\n            color: $white-color;\r\n        }\r\n\r\n        .card-icon{\r\n            i{\r\n                color: #FFFFFF;\r\n                border: 2px solid rgba(255,255,255,.3);\r\n            }\r\n        }\r\n\r\n        &.card-with-border:after{\r\n            border: 1px solid rgba(255, 255, 255, 0.45);\r\n        }\r\n    }\r\n\r\n    &[data-background=\"image\"]{\r\n\r\n        .filter{\r\n            @include opacity(0.55);\r\n        }\r\n\r\n        &:hover .filter{\r\n            @include opacity(0.75);\r\n        }\r\n\r\n    }\r\n\r\n    &[data-color=\"blue\"]{\r\n        background: $bg-info;\r\n    }\r\n\r\n    &[data-color=\"green\"]{\r\n        background: $bg-success\r\n    }\r\n\r\n    &[data-color=\"yellow\"]{\r\n        background: $bg-warning;\r\n    }\r\n\r\n    &[data-color=\"brown\"]{\r\n        background: $bg-brown;\r\n    }\r\n\r\n    &[data-color=\"purple\"]{\r\n        background: $bg-purple;\r\n    }\r\n\r\n    &[data-color=\"orange\"]{\r\n        background: $bg-danger;\r\n    }\r\n}\r\n\r\n.btn-center{\r\n    text-align: center;\r\n}\r\n\r\n.card-big-shadow{\r\n    max-width: 320px;\r\n    position: relative;\r\n\r\n    &:before{\r\n        background-image: url(\"http://static.tumblr.com/i21wc39/coTmrkw40/shadow.png\");\r\n        background-position: center bottom;\r\n        background-repeat: no-repeat;\r\n        background-size: 100% 100%;\r\n        bottom: -12%;\r\n        content: \"\";\r\n        display: block;\r\n        left: -12%;\r\n        position: absolute;\r\n        right: 0;\r\n        top: 0;\r\n        z-index: 0;\r\n    }\r\n}\r\n.card-image{\r\n    &.card-big-shadow{\r\n        max-width: 100%;\r\n    }\r\n    .card{\r\n        background-size: cover;\r\n        min-height: 430px;\r\n        width: 100%;\r\n    }\r\n    .img-raised{\r\n        margin-top: -20px;\r\n    }\r\n}\r\n\r\n\r\n.page-header{\r\n    .card-pricing.card-plain{\r\n        .card-category,\r\n        .card-title{\r\n            color: $white-color;\r\n        }\r\n    }\r\n}\r\n\r\n.card-plain{\r\n  .card-avatar{\r\n      margin-top: 0;\r\n    }\r\n}\r\n\r\n.card-refine {\r\n  .panel-title {\r\n      font-size: 1em;\r\n  }\r\n}\r\n",".card-plain {\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n  border-radius: 0;\r\n\r\n  .card-body {\r\n      padding-left: 5px;\r\n      padding-right: 5px;\r\n  }\r\n\r\n  img {\r\n      border-radius: $border-radius-extreme;\r\n  }\r\n}\r\n",".card-register {\r\n  background-color: #FF8F5E;\r\n  border-radius: 8px;\r\n  color: #fff;\r\n  max-width: 350px;\r\n  margin: 20px 0 70px;\r\n  min-height: 400px;\r\n  padding: 30px;\r\n\r\n  & label {\r\n    margin-top: 15px;\r\n  }\r\n  & .card-title {\r\n    color: #B33C12;\r\n    text-align: center;\r\n  }\r\n  & .btn {\r\n    margin-top: 30px;\r\n  }\r\n  & .forgot {\r\n    text-align: center;\r\n  }\r\n\r\n  .input-group-text {\r\n    border: 1px solid $white-color;\r\n  }\r\n}\r\n",".card-profile {\r\n  margin-top: 30px;\r\n  text-align: center;\r\n\r\n  .card-cover {\r\n    height: 130px;\r\n    background-position: center center;\r\n    background-size: cover;\r\n    border-radius: $border-radius-extreme $border-radius-extreme 0 0;\r\n  }\r\n\r\n  .card-body {\r\n    .card-title {\r\n      margin-top: 5px !important;\r\n    }\r\n    .card-category {\r\n      margin-bottom: 5px;\r\n      margin-top: 5px;\r\n    }\r\n  }\r\n\r\n  .card-avatar {\r\n    max-width: 120px;\r\n    max-height: 120px;\r\n    margin: -60px auto 0;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n\r\n    &.border-white {\r\n        border: 4px solid $white-color;\r\n    }\r\n    &.border-gray {\r\n        border: 4px solid $card-muted-color;\r\n    }\r\n  }\r\n\r\n}\r\n\r\n.section {\r\n  .card-profile {\r\n    margin-top: 100px;\r\n  }\r\n}\r\n",".landing-alert{\r\n    margin-bottom: 0;\r\n}\r\n.page-header{\r\n    background-color: #B2AFAB;\r\n    background-position: center center;\r\n    background-size: cover;\r\n    min-height: 100vh;\r\n    max-height: 999px;\r\n    overflow: hidden;\r\n    position: relative;\r\n    width: 100%;\r\n    z-index: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    .filter::after{\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n        content: \"\";\r\n        display: block;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        position: absolute;\r\n        width: 100%;\r\n        z-index: 1;\r\n    }\r\n    &.page-header-small{\r\n        min-height: 65vh !important;\r\n        max-height: 700px;\r\n    }\r\n    &.page-header-xs{\r\n        min-height: 30vh !important;\r\n    }\r\n\r\n    &.section-dark{\r\n        .content-center,\r\n        .category-absolute{\r\n            z-index: 1;\r\n        }\r\n    }\r\n}\r\n.page-header .motto{\r\n    text-align: left;\r\n    z-index: 3;\r\n    color: #fff;\r\n    position: relative;\r\n\r\n}\r\n.landing-section{\r\n    padding: 100px 0;\r\n    z-index: 1;\r\n}\r\n.section-buttons{\r\n    z-index: 1;\r\n}\r\n.landing-section .btn-simple{\r\n    padding: 0;\r\n}\r\n.landing-section .column{\r\n    padding: 0 75px 0 25px;\r\n}\r\n.team-player .img-circle, .team-player .img-thumbnail{\r\n    display: block;\r\n    margin-top: 50px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 120px;\r\n}\r\n.contact-form{\r\n    margin-top: 30px;\r\n}\r\n.contact-form label{\r\n    margin-top: 15px;\r\n}\r\n.contact-form .btn{\r\n    margin-top: 30px;\r\n}\r\n\r\n.navbar-relative{\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n#register-navbar a{\r\n    color: #FFF;\r\n}\r\n.register-background .container{\r\n    margin-top: 11%;\r\n    position: relative;\r\n    z-index: 3;\r\n}\r\n.register-footer{\r\n    bottom: 20px;\r\n    position: absolute;\r\n    z-index: 1;\r\n    width: 100%;\r\n    background: transparent;\r\n    color: $white-color;\r\n}\r\n.register-footer .fa-heart{\r\n    color: #EB5E28;\r\n}\r\n\r\n.register-card label{\r\n    margin-top: 15px;\r\n}\r\n.register-card .title{\r\n    color: #B33C12;\r\n    text-align: center;\r\n}\r\n.register-card .btn{\r\n    margin-top: 30px;\r\n}\r\n.register-card .forgot{\r\n    text-align: center;\r\n}\r\n\r\n.profile-content{\r\n    position: relative;\r\n}\r\n.owner{\r\n    text-align: center;\r\n}\r\n.owner .avatar{\r\n    padding: 15px;\r\n    max-width: 180px;\r\n    margin: -85px auto 0;\r\n    display: inline-block;\r\n}\r\n.owner .name h4{\r\n    margin-top: 10px;\r\n}\r\n.profile-tabs{\r\n    margin: 50px 0;\r\n    min-height: 300px;\r\n}\r\n#following h3{\r\n    margin: 20px 0 40px 0;\r\n}\r\n\r\n#follows .follows .unfollow .checkbox{\r\n    margin-top: -15px;\r\n}\r\n#follows .follows h6{\r\n    margin-top: 15px;\r\n}\r\n.follows hr{\r\n    margin-top: 10px;\r\n}\r\n.alert h5{\r\n    // margin-bottom: 10px;\r\n}\r\n.title-brand{\r\n    max-width: 730px;\r\n    margin: 0 auto;\r\n    position: relative;\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    display: block;\r\n\r\n    .type{\r\n        position: absolute;\r\n        font-size: 20px;\r\n        background: #132026;\r\n        padding: 6px 10px;\r\n        border-radius: 4px;\r\n        top: 0;\r\n        font-weight: 600;\r\n        margin-top: 10px;\r\n        right: -15px;\r\n    }\r\n}\r\n\r\n.presentation-title{\r\n    font-size: 8em;\r\n    font-weight: 700;\r\n    margin: 0;\r\n    color: #FFFFFF;\r\n    background: #fbf8ec;\r\n    background: -moz-linear-gradient(top, #FFFFFF 35%, #4e6773 100%);\r\n    background: -webkit-linear-gradient(top, #FFFFFF 35%,#4e6773 100%);\r\n    background: -ms-linear-gradient(top, #FFFFFF 35%,#4e6773 100%);\r\n    background: linear-gradient(to bottom, #FFFFFF 35%,#4e6773 100%);\r\n\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n}\r\n.presentation-subtitle{\r\n    font-size: 1.7em;\r\n    color: #FFFFFF;\r\n}\r\n\r\n.category-absolute{\r\n    position: absolute;\r\n    text-align: center;\r\n    top: 100vh;\r\n    margin-top: -60px;\r\n    padding: 0 15px;\r\n    width: 100%;\r\n    color: rgba(255, 255, 255, 0.5);\r\n\r\n    .creative-tim-logo {\r\n        max-width: 140px;\r\n        top: -2px;\r\n        left: 3px;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n.fog-low{\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n    margin-left: -35%;\r\n    margin-bottom: -50px;\r\n    width: 110%;\r\n    opacity: .85;\r\n\r\n    img{\r\n        width: 100%;\r\n    }\r\n\r\n    &.right{\r\n        margin-left: 30%;\r\n        opacity: 1;\r\n    }\r\n}\r\n.page-header{\r\n    .content-center{\r\n        margin-top: 85px;\r\n    }\r\n}\r\n.moving-clouds{\r\n    position: absolute;\r\n    z-index: 1;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 250.625em;\r\n    height: 43.75em;\r\n    -webkit-animation: cloudLoop 80s linear infinite;\r\n    animation: cloudLoop 80s linear infinite;\r\n}\r\n\r\n@keyframes cloudLoop{   0%{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}\r\n                        100%{-webkit-transform:translate3d(-50%,0,0);\r\n                        transform:translate3d(-50%,0,0)}\r\n                    }\r\n.following{\r\n    img{\r\n        max-width: 70px;\r\n    }\r\n}\r\n\r\n\r\n.profile-content{\r\n    & .tab-content{\r\n        & .tab-pane{\r\n            min-height: 200px;\r\n        }\r\n        & #tweets, #connections, #media{\r\n            height: 100%;\r\n        }\r\n    }\r\n}\r\n",".section{\r\n    padding: 70px 0;\r\n    position: relative;\r\n    background-color: #FFFFFF;\r\n}\r\n.section-with-space{\r\n    padding: 60px 0;\r\n}\r\n.section-gray{\r\n    background-color: #EEEEEE;\r\n}\r\n.section-nude{\r\n    background-color: $bg-nude;\r\n}\r\n.section-gold{\r\n    background-color: #caac90;\r\n    color: $white-color;\r\n}\r\n.section-brown{\r\n    background-color: #A59E94;\r\n    color: $white-color;\r\n}\r\n.section-light-blue{\r\n    background-color: $primary-color;\r\n    color: $white-color;\r\n}\r\n.section-dark-blue{\r\n    background-color: #506367;\r\n    color: $white-color;\r\n}\r\n.section-dark{\r\n    background-color: #000000;\r\n    background-image: url('../../img/market/472096920_10160995047266938_7458755462453693494_n.jpg');\r\n    background-position: center;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n}\r\n.section-image,\r\n.section-gold,\r\n.section-dark{\r\n    position: relative;\r\n\r\n    .title,\r\n    .info-title,\r\n    .card-plain .card-title{\r\n        color: $white-color !important;\r\n    }\r\n    .category,\r\n    .description,\r\n    .card-plain .card-description,\r\n    .card-plain .card-category{\r\n        color: rgba($white-color, .7);\r\n    }\r\n    hr{\r\n        border-color: rgba(255, 255, 255, 0.19);\r\n    }\r\n}\r\n.page-header,\r\n.carousel-caption{\r\n    .title,\r\n    .info-title{\r\n        color: $white-color;\r\n    }\r\n}\r\n[class*=\"features-\"],\r\n[class*=\"team-\"],\r\n[class*=\"projects-\"],\r\n[class*=\"pricing-\"],\r\n[class*=\"testimonials-\"],\r\n[class*=\"contactus-\"]{\r\n    padding: 80px 0;\r\n}\r\n.section-image{\r\n    background-position: center center;\r\n    background-size: cover;\r\n\r\n    &:before{\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n        content: \"\";\r\n        display: block;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        position: absolute;\r\n        width: 100%;\r\n        z-index: 1;\r\n    }\r\n    & .container{\r\n        position: relative;\r\n        z-index: 2;\r\n    }\r\n}\r\n\r\n.section-login{\r\n    min-height: 700px;\r\n}\r\n\r\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\r\n    /* IE10+ CSS styles go here */\r\n    .page-header{\r\n        .content-center{\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translate(-50%, -75%);\r\n        }\r\n        .presentation-title{\r\n            background: none !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n[class*=\"features-\"],\r\n[class*=\"team-\"],\r\n[class*=\"projects-\"],\r\n[class*=\"pricing-\"],\r\n[class*=\"testimonials-\"],\r\n[class*=\"contactus-\"] {\r\n    padding: 80px 0;\r\n}\r\n.section-image {\r\n    background-position: center center;\r\n    background-size: cover;\r\n\r\n    &:before {\r\n        background-color: rgba(0, 0, 0, 0.5);\r\n        content: \"\";\r\n        display: block;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        position: absolute;\r\n        width: 100%;\r\n        z-index: 1;\r\n    }\r\n    & .container {\r\n        position: relative;\r\n        z-index: 2;\r\n    }\r\n}\r\n","/*          Changes for small display      */\r\n\r\n@media (max-width: 767px){\r\n    #cd-vertical-nav {\r\n        display: none !important;\r\n    }\r\n    .coloured-cards {\r\n      .card-big-shadow {\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n\r\n    .register-page {\r\n      .page-header {\r\n        max-height: 2000px;\r\n      }\r\n    }\r\n\r\n    .section-testimonials{\r\n        .our-clients{\r\n            margin-top: 0 !important;\r\n        }\r\n    }\r\n    .navbar-transparent{\r\n        background-color: rgba(0, 0, 0, 0.45);\r\n    }\r\n    .register{\r\n        .page-header{\r\n            max-height: fit-content;\r\n        }\r\n    }\r\n\r\n    .form-group.has-danger {\r\n      margin-bottom: 30px;\r\n    }\r\n\r\n    body {\r\n         position: relative;\r\n         font-size: $font-size-small;\r\n    }\r\n    h6{\r\n        font-size: 1em;\r\n    }\r\n    .navbar .container{\r\n         left: 0;\r\n          width: 100%;\r\n         @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n         position: relative;\r\n    }\r\n    .navbar .navbar-nav .dropdown-menu{\r\n        height: 400px;\r\n        overflow-y: scroll;\r\n    }\r\n    .demo-header .motto{\r\n        padding-top: 30% !important;\r\n    }\r\n    .navbar-toggle .icon-bar {\r\n          display: block;\r\n          position: relative;\r\n          background: #fff;\r\n          width: 24px;\r\n          height: 2px;\r\n          border-radius: 1px;\r\n          margin: 0 auto;\r\n    }\r\n\r\n    .navbar-header .navbar-toggle {\r\n        margin-top: 12px;\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n    .bar1,\r\n    .bar2,\r\n    .bar3 {\r\n      outline: 1px solid transparent;\r\n    }\r\n    .bar1 {\r\n      top: 0px;\r\n      @include bar-animation($topbar-back);\r\n    }\r\n    .bar2 {\r\n      opacity: 1;\r\n    }\r\n    .bar3 {\r\n      bottom: 0px;\r\n      @include bar-animation($bottombar-back);\r\n    }\r\n    .toggled .bar1 {\r\n      top: 6px;\r\n      @include bar-animation($topbar-x);\r\n    }\r\n    .toggled .bar2 {\r\n      opacity: 0;\r\n    }\r\n    .toggled .bar3 {\r\n      bottom: 6px;\r\n      @include bar-animation($bottombar-x);\r\n    }\r\n\r\n    @include topbar-x-rotation();\r\n    @include topbar-back-rotation();\r\n    @include bottombar-x-rotation();\r\n    @include bottombar-back-rotation();\r\n\r\n    @-webkit-keyframes fadeIn {\r\n      0% {opacity: 0;}\r\n      100% {opacity: 1;}\r\n    }\r\n    @-moz-keyframes fadeIn {\r\n      0% {opacity: 0;}\r\n      100% {opacity: 1;}\r\n    }\r\n    @keyframes fadeIn {\r\n      0% {opacity: 0;}\r\n      100% {opacity: 1;}\r\n    }\r\n\r\n    .navbar-nav {\r\n        margin: 1px -15px;\r\n\r\n        .open .dropdown-menu > li {\r\n            & > a{\r\n                padding: 15px 15px 5px 50px;\r\n            }\r\n\r\n            &:first-child > a{\r\n                padding: 5px 15px 5px 50px;\r\n            }\r\n\r\n            &:last-child > a {\r\n                padding: 15px 15px 25px 50px;\r\n            }\r\n        }\r\n    }\r\n\r\n    [class*=\"navbar-\"] .navbar-nav {\r\n        & > li > a, > li > a:hover, > li > a:focus, .active > a, .active > a:hover, .active > a:focus, .open .dropdown-menu > li > a, .open .dropdown-menu > li > a:hover, .open .dropdown-menu > li > a:focus, .navbar-nav .open .dropdown-menu > li > a:active {\r\n            color: white;\r\n\r\n        }\r\n\r\n        & > li > a:not(.btn),\r\n        > li > a:hover,\r\n        > li > a:focus,\r\n        .open .dropdown-menu > li > a:not(.btn),\r\n        .open .dropdown-menu > li > a:hover,\r\n        .open .dropdown-menu > li > a:focus{\r\n            opacity: .7;\r\n            background: transparent;\r\n        }\r\n\r\n        &.navbar-nav .open .dropdown-menu > li > a:active {\r\n            opacity: 1;\r\n        }\r\n\r\n        & .dropdown > a{\r\n            &:hover .caret {\r\n                border-bottom-color: #777;\r\n                border-top-color: #777;\r\n            }\r\n            &:active .caret {\r\n                border-bottom-color: white;\r\n                border-top-color: white;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .footer{\r\n        .footer-nav,\r\n        .credits{\r\n            margin: 0 auto;\r\n        }\r\n    }\r\n\r\n    #typography{\r\n        .typography-line{\r\n            .note{\r\n                margin-left: 7px !important;\r\n            }\r\n        }\r\n    }\r\n    .dropdown-menu {\r\n        display: none;\r\n    }\r\n    .navbar-fixed-top {\r\n        -webkit-backface-visibility: hidden;\r\n    }\r\n\r\n    .social-line .btn{\r\n        margin: $margin-bottom;\r\n    }\r\n    .subscribe-line .form-control{\r\n        margin: $margin-bottom;\r\n    }\r\n    .social-line.pull-right{\r\n        float: none;\r\n    }\r\n    .footer nav.pull-left{\r\n        float: none !important;\r\n    }\r\n    .footer:not(.footer-big) nav > ul li{\r\n        float: none;\r\n    }\r\n    .social-area.pull-right{\r\n        float: none !important;\r\n    }\r\n    .form-control + .form-control-feedback{\r\n        margin-top: 5px;\r\n    }\r\n    .form-control.form-control-danger.no-border{\r\n        margin-top: 15px;\r\n    }\r\n    .navbar-toggle:hover,.navbar-toggle:focus {\r\n        background-color: transparent !important;\r\n    }\r\n    .btn.dropdown-toggle{\r\n        margin-bottom: 0;\r\n    }\r\n    .media-post .author{\r\n        width: 25%;\r\n        float: none !important;\r\n        display: block;\r\n        margin: 0 auto 10px;\r\n    }\r\n    .media-post .media-body{\r\n        width: 100%;\r\n    }\r\n    .modal-footer .btn-simple {\r\n        padding: 15px;\r\n    }\r\n    .table-responsive {\r\n        width: 100%;\r\n        margin-bottom: 15px;\r\n        overflow-x: scroll;\r\n        overflow-y: hidden;\r\n        border: 1px solid #dddddd;\r\n        -ms-overflow-style: -ms-autohiding-scrollbar;\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n    .typography-line{\r\n        padding-left: 100px !important;\r\n    }\r\n\r\n    .projects-1{\r\n        & .project-pills{\r\n            & .nav.nav-pills{\r\n                display: block !important;\r\n                .nav-item{\r\n                    &:first-child .nav-link{\r\n                        border-radius: 12px 12px 0 0 !important;\r\n                        margin-left: -1px;\r\n                    }\r\n                    &.active:first-child .nav-link{\r\n                        border-radius: 12px 12px 0 0 !important;\r\n                        margin-left: -1px;\r\n                    }\r\n\r\n                    &:last-child .nav-link{\r\n                        border-radius: 0 0 12px 12px !important;\r\n                        margin-left: -1px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .testimonials-2,\r\n    .section-testimonials{\r\n        .testimonials-people{\r\n            img{\r\n                display: none !important;\r\n            }\r\n        }\r\n    }\r\n    .presentation-page .components-container .card{\r\n        margin-bottom: 40px !important;\r\n    }\r\n    .btn-wd{\r\n        min-width: 280px;\r\n    }\r\n    .presentation-page .title-brand .type{\r\n        font-size: 16px;\r\n        transform: translateY(-28px);\r\n        -webkit-transform: translateY(-28px);\r\n        -moz-transform: translateY(-28px);\r\n        -o-transform: translateY(-28px);\r\n    }\r\n    .presentation-page{\r\n        .section-cards,\r\n        .section-components{\r\n            overflow: hidden;\r\n            .first-card{\r\n                top: 750px !important;\r\n                .grid__link{\r\n                    max-width: 200px !important;\r\n                }\r\n            }\r\n            .fourth-card{\r\n                top: 940px !important;\r\n                .grid__link{\r\n                    max-width: 200px !important;\r\n                }\r\n            }\r\n            .fifth-card{\r\n                top: 950px !important;\r\n                left: 220px !important;\r\n                .grid__link{\r\n                    max-width: 200px !important;\r\n                }\r\n            }\r\n            .sixth-card{\r\n                top: 1335px !important;\r\n                left: 220px !important;\r\n                .grid__link{\r\n                    max-width: 200px !important;\r\n                }\r\n            }\r\n            .seventh-card {\r\n                top: 1155px !important;\r\n                .grid__link{\r\n                    max-width: 200px !important;\r\n                }\r\n            }\r\n        }\r\n        .section-content{\r\n            .image-container{\r\n                .add-animation{\r\n                    max-height: 250px !important;\r\n                    max-width: 180px !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        .section-components{\r\n            .image-container{\r\n                .components-macbook{\r\n                    max-width: 580px !important;\r\n                    max-height: 400px !important;\r\n                }\r\n                .social-img,\r\n                .share-btn-img{\r\n                    display: none;\r\n                }\r\n            }\r\n            .title{\r\n                margin-top: -100px !important;\r\n            }\r\n        }\r\n\r\n        .section-examples{\r\n            padding-top: 0 !important;\r\n            margin-top: 10px !important;\r\n        }\r\n\r\n        .section-icons{\r\n            .icons-nucleo{\r\n                .nc-icon:not(.ninth-left-icon):not(.seventh-left-icon):not(.third-left-icon){\r\n                    display: none !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .bootstrap-datetimepicker-widget{\r\n        visibility: visible !important;\r\n    }\r\n\r\n    .presentation-page{\r\n        .fog-low{\r\n            margin-bottom: -35px;\r\n        }\r\n        .presentation-title{\r\n            font-size: 5em;\r\n        }\r\n        .presentation-subtitle{\r\n            margin-top: 40px;\r\n        }\r\n        .title-brand{\r\n            max-width: 450px;\r\n            .type{\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .demo-icons ul li {\r\n      width: 20%;\r\n      float: left;\r\n    }\r\n    .info.info-separator:after{\r\n        display: none;\r\n    }\r\n\r\n    .pricing-5{\r\n        .choose-plan{\r\n            text-align: center;\r\n\r\n            .nav.nav-pills{\r\n                display: inline-flex;\r\n            }\r\n        }\r\n        .description{\r\n            text-align: center;\r\n        }\r\n    }\r\n    .page-carousel{\r\n        .carousel-inner{\r\n            [class*='col-md']{\r\n                margin-left: 0 !important;\r\n            }\r\n        }\r\n        .right.carousel-control{\r\n            margin-right: 0 !important;\r\n        }\r\n        .left.carousel-control{\r\n            margin-left: 0 !important;\r\n        }\r\n    }\r\n\r\n    .subscribe-line {\r\n      .form-control {\r\n        border: 1px solid $medium-gray;\r\n        padding-left: 10px;\r\n      }\r\n      .btn {\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n}\r\n@media screen and (max-width: 991px){\r\n    .navbar-collapse {\r\n        position: fixed;\r\n        display: block !important;\r\n        top: 0;\r\n        height: 100%;\r\n        width: 230px;\r\n        right: 0;\r\n        z-index: 1032;\r\n        visibility: visible;\r\n        background-color: #999;\r\n        overflow-y: visible;\r\n        border-top: none;\r\n        text-align: left;\r\n        border-left: 1px solid #CCC5B9;\r\n        padding-right: 0px;\r\n        padding-left: 40px;\r\n        padding-top: 15px;\r\n\r\n        @include transform-translate-x(230px);\r\n        @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n        ul {\r\n            position: relative;\r\n            z-index: 3;\r\n            height: 95%;\r\n        }\r\n        .navbar-nav > .nav-item {\r\n            &:last-child {\r\n            border-bottom: 0;\r\n            }\r\n            & > .nav-link{\r\n                margin: 0px 0px;\r\n                color: $dark-gray !important;\r\n                text-transform: uppercase;\r\n                font-weight: 600;\r\n                font-size: $font-size-small;\r\n                line-height: $line-height-general;\r\n                padding: 15px 0;\r\n                &:hover,\r\n                &:active{\r\n                    color: $default-states-color !important;\r\n                }\r\n            }\r\n        }\r\n        &::after{\r\n            top: 0;\r\n            left: 0;\r\n            height: 100%;\r\n            width: 100%;\r\n            position: absolute;\r\n            background-color: $bg-nude;\r\n            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(112, 112, 112, 0) 60%, rgba(186, 186, 186, 0.15) 100%);\r\n            display: block;\r\n            content: \"\";\r\n            z-index: 1;\r\n        }\r\n        &.has-image::after{\r\n            @include black-filter(.8);\r\n        }\r\n    }\r\n\r\n    .nav-open{\r\n        & .navbar-collapse{\r\n            @include transform-translate-x(0px);\r\n        }\r\n        & .wrapper{\r\n            left: 0;\r\n            @include transform-translate-x(-230px);\r\n        }\r\n        & .navbar-translate{\r\n            @include transform-translate-x(-230px);\r\n        }\r\n    }\r\n    .wrapper .navbar-collapse{\r\n        display: none;\r\n    }\r\n\r\n    .register-page.full-screen {\r\n      .page-header .container {\r\n        margin-top: 30%;\r\n      }\r\n    }\r\n\r\n\r\n    .dropdown.show .dropdown-menu,\r\n    .dropdown .dropdown-menu{\r\n        border: 0;\r\n        transition: none;\r\n        -webkit-box-shadow: none;\r\n        box-shadow: none;\r\n        width: auto;\r\n        height: auto;\r\n\r\n        .dropdown-item:hover,\r\n        .dropdown-item:focus{\r\n            background-color: transparent;\r\n            border-radius:0;\r\n        }\r\n\r\n        .dropdown-item a{\r\n\r\n            &:hover,\r\n            &:focus{\r\n                color: $default-states-color;\r\n            }\r\n        }\r\n\r\n        &:before,\r\n        &:after{\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .dropdown{\r\n        .dropdown-menu{\r\n           display: none;\r\n       }\r\n\r\n       &.show .dropdown-menu{\r\n          display: block;\r\n          position: static;\r\n          float: none;\r\n          background: transparent !important;\r\n       }\r\n    }\r\n\r\n    .navbar-translate{\r\n        width: 100%;\r\n        position: relative;\r\n        display: flex;\r\n        -ms-flex-pack: justify !important;\r\n        justify-content: space-between !important;\r\n        -ms-flex-align: center;\r\n        align-items: center;\r\n        @include transform-translate-x(0);\r\n        @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n    }\r\n\r\n    #bodyClick {\r\n      height: 100%;\r\n      width: 100%;\r\n      position: fixed;\r\n      opacity: 0;\r\n      top: 0;\r\n      left: auto;\r\n      right: 230px;\r\n      content: \"\";\r\n      z-index: 1029;\r\n      overflow-x: hidden;\r\n    }\r\n\r\n    .wrapper{\r\n    //    @include transform-translate-x(0px);\r\n       @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n       left: 0;\r\n       background-color: white;\r\n    }\r\n    .container-cards{\r\n        [class*=\"col-md-\"]{\r\n            padding-left: 5px;\r\n            padding-right: 5px;\r\n        }\r\n        .social-buttons{\r\n            z-index: 1;\r\n        }\r\n    }\r\n    .full-screen.login{\r\n        .page-header{\r\n            display: grid;\r\n        }\r\n    }\r\n    .comments.media-area{\r\n        .media{\r\n            display: block;\r\n\r\n            .media-body{\r\n                margin-left: 2em;\r\n                p{\r\n                    margin-top: 15px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .section-navbars,\r\n    .section-navigation,\r\n    #navbar-dropdown{\r\n        .navbar-collapse{\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    .header-4{\r\n        video{\r\n            width: auto;\r\n            height: 100vh\r\n        }\r\n    }\r\n\r\n    .subscribe-line {\r\n      .btn.btn-block {\r\n        width: auto;\r\n      }\r\n    }\r\n\r\n    .form-control + .form-control-feedback {\r\n      padding-left: 0 !important;\r\n    }\r\n\r\n}\r\n\r\n\r\n\r\n@media screen and (min-width:991px){\r\n    .burger-menu{\r\n        .navbar-collapse {\r\n            position: fixed;\r\n            display: block;\r\n            top: 0;\r\n            height: 100%;\r\n            width: 230px;\r\n            right: 0px;\r\n            z-index: 1032;\r\n            visibility: visible;\r\n            background-color: #999;\r\n            overflow-y: visible;\r\n            border-top: none;\r\n            text-align: left;\r\n            border-left: 1px solid #CCC5B9;\r\n            padding-right: 0px;\r\n            padding-left: 40px;\r\n            padding-top: 15px;\r\n            @include transform-translate-x(230px);\r\n            @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n\r\n            .navbar-nav .nav-item{\r\n                &:last-child {\r\n                    border-bottom: 0;\r\n                }\r\n            }\r\n            .navbar-nav{\r\n                height: 100%;\r\n                z-index: 2;\r\n                position: relative;\r\n                display: -webkit-box;\r\n                display: -webkit-flex;\r\n                display: -ms-flexbox;\r\n                display: flex;\r\n                -webkit-box-orient: vertical;\r\n                -webkit-box-direction: normal;\r\n                -webkit-flex-direction: column;\r\n                -ms-flex-direction: column;\r\n                flex-direction: column;\r\n            }\r\n\r\n            &::after{\r\n                top: 0;\r\n                left: 0;\r\n                height: 100%;\r\n                width: 100%;\r\n                position: absolute;\r\n                background-color: $bg-nude;\r\n                background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(112, 112, 112, 0) 60%, rgba(186, 186, 186, 0.15) 100%);\r\n                display: block;\r\n                content: \"\";\r\n                z-index: 1;\r\n            }\r\n            &.has-image::after{\r\n                @include black-filter(.8);\r\n            }\r\n        }\r\n        .navbar{\r\n            .container{\r\n                .navbar-toggler{\r\n                    display: block;\r\n                    margin-top: 20px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-translate{\r\n            width: 100%;\r\n            position: relative;\r\n            @include transform-translate-x(0);\r\n            @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n        }\r\n\r\n        .wrapper{\r\n            //    @include transform-translate-x(0px);\r\n            @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n            left: 0;\r\n            background-color: white;\r\n        }\r\n\r\n        .body{\r\n            .navbar-collapse.collapse{\r\n                height: 100vh !important;\r\n            }\r\n        }\r\n        .navbar-collapse,\r\n        .navbar-nav{\r\n            &:before,\r\n            &:after{\r\n                display: table;\r\n                content: \" \";\r\n            }\r\n        }\r\n\r\n        .nav-open &{\r\n            .navbar-collapse.collapse{\r\n                @include transform-translate-x(0px);\r\n            }\r\n            .wrapper{\r\n                left: 0;\r\n                @include transform-translate-x(-230px);\r\n            }\r\n            .navbar-translate{\r\n                @include transform-translate-x(-230px);\r\n            }\r\n        }\r\n\r\n        .dropdown.show .dropdown-menu,\r\n        .dropdown .dropdown-menu{\r\n            border: 0;\r\n            transition: none;\r\n            -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n            width: auto;\r\n\r\n            .dropdown-item:hover,\r\n            .dropdown-item:focus{\r\n                background-color: transparent;\r\n                border-radius:0;\r\n            }\r\n\r\n            .dropdown-item a{\r\n\r\n                &:hover,\r\n                &:focus{\r\n                    color: $default-states-color;\r\n                }\r\n            }\r\n\r\n            &:before,\r\n            &:after{\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .dropdown{\r\n            .dropdown-menu{\r\n               display: none;\r\n           }\r\n\r\n           &.show .dropdown-menu{\r\n               display: block;\r\n           }\r\n        }\r\n    }\r\n    .lightbox .modal-dialog{\r\n        width: 960px;\r\n    }\r\n}\r\n@media screen and (min-width: 767px){\r\n    .section-sections{\r\n      .section-cols{\r\n          position: relative;\r\n          z-index: 1;\r\n      }\r\n    }\r\n\r\n    .register-page {\r\n      .page-header .container {\r\n        margin-top: 150px;\r\n      }\r\n    }\r\n}\r\n@media (max-width:1023px) and (min-width:767px) {\r\n    .presentation-page{\r\n        .section-content{\r\n            .image-container{\r\n                .area-img{\r\n                    max-width: 190px;\r\n                    max-height: 270px;\r\n                }\r\n                .info-img{\r\n                    max-width: 190px;\r\n                    max-height: 270px;\r\n                    left: -20%;\r\n                }\r\n            }\r\n            .section-description{\r\n                margin-top: 0 !important;\r\n            }\r\n        }\r\n        .section-components{\r\n            .components-macbook{\r\n                left: -75px !important;\r\n            }\r\n        }\r\n        .section-cards{\r\n            .codrops-header{\r\n                margin-top: 10px !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n@media (max-width:1367px) and (min-width:1024px) {\r\n    .presentation-page{\r\n        .section-components{\r\n            .basic-container{\r\n                margin-left: 5em;\r\n            }\r\n        }\r\n    }\r\n}\r\n@media (max-width: 500px){\r\n    .presentation-page .section-header .card{\r\n        min-height: 230px;\r\n    }\r\n    #cards{\r\n        .card-profile{\r\n            margin-top: 50px;\r\n        }\r\n    }\r\n    .pricing-5{\r\n        .title{\r\n            text-align: center;\r\n        }\r\n    }\r\n    .presentation-page .presentation-title {\r\n        font-size: 4em;\r\n    }\r\n    .presentation-page .title-brand .type {\r\n        font-size: 12px;\r\n        padding: 4px 7px;\r\n        border-radius: 4px;\r\n        top: 0;\r\n        font-weight: 600;\r\n        margin-top: 20px;\r\n        right: 2px;\r\n    }\r\n    .presentation-page{\r\n        .section-cards{\r\n            .codrops-header{\r\n                .description{\r\n                    max-width: 220px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .register-page {\r\n      .page-header .container {\r\n        .info:first-of-type {\r\n          margin-top: 50px;\r\n        }\r\n      }\r\n    }\r\n}\r\n@media screen and (max-width: 1367px){\r\n    .presentation-page{\r\n        .section-cards,\r\n        .section-components{\r\n            overflow: hidden;\r\n        }\r\n\r\n    }\r\n}\r\n@media screen and (min-width: 1025){\r\n    .section-sections{\r\n        .section-cols{\r\n            position: relative;\r\n            z-index: 1;\r\n            .row{\r\n                &:first-of-type{\r\n                    margin-top: 50px;\r\n                    margin-right: -120px;\r\n                    margin-left: -15px;\r\n                    @include transform-translate-x(-80px);\r\n                }\r\n                &:nth-of-type(2){\r\n                    margin-left: -100px;\r\n                    margin-right: -15px;\r\n                    transform: translateX(80px);\r\n                }\r\n                &:nth-of-type(3){\r\n                    margin-right: -120px;\r\n                    margin-left: 0px;\r\n                    transform: translateX(-120px);\r\n                }\r\n                &:nth-of-type(4){\r\n                    margin-right: -100px;\r\n                    margin-left: -15px;\r\n                    transform: translateX(-50px);\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 1024px) {\r\n  .demo-icons ul li {\r\n    width: 12.5%;\r\n    float: left;\r\n    padding: 32px 0;\r\n  }\r\n\r\n}\r\n@media (max-width: 1200px){\r\n    .presentation-page{\r\n        .presentation-title{\r\n            font-size: 7em;\r\n        }\r\n        .title-brand{\r\n            max-width: 650px;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px){\r\n    .presentation .section-images .image img{\r\n        width: 100%;\r\n    }\r\n\r\n}\r\n\r\n\r\n@media screen and (max-width: 374px){\r\n    .footer.footer-big{\r\n        .copyright{\r\n            .pull-left, .pull-right{\r\n                float: none !important;\r\n            }\r\n        }\r\n    }\r\n    .full-screen.login{\r\n        .card.card-register{\r\n            margin-bottom: 20px;\r\n        }\r\n        .demo-footer{\r\n            margin-left: -15px;\r\n        }\r\n    }\r\n    .about-us{\r\n        .header-wrapper{\r\n            height: auto !important;\r\n        }\r\n    }\r\n    .presentation-page{\r\n        .section-content{\r\n            .image-container{\r\n                .area-img{\r\n                    max-width: 170px !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n","/*! nouislider - 14.0.2 - 6/28/2019 */\r\n/* Functional styling;\r\n * These styles are required for noUiSlider to function.\r\n * You don't need to change these rules to apply your design.\r\n */\r\n/*\r\n\r\nThis file was modified by Creative-Tim\r\n\r\n*/\r\n.noUi-target,\r\n.noUi-target * {\r\n  -webkit-touch-callout: none;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n  -webkit-user-select: none;\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  -ms-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.noUi-target {\r\n  position: relative;\r\n  direction: ltr;\r\n}\r\n.noUi-base,\r\n.noUi-connects {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n/* Wrapper for all connect elements.\r\n */\r\n.noUi-connects {\r\n  overflow: hidden;\r\n  z-index: 0;\r\n}\r\n.noUi-connect,\r\n.noUi-origin {\r\n  will-change: transform;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  -ms-transform-origin: 0 0;\r\n  -webkit-transform-origin: 0 0;\r\n  -webkit-transform-style: preserve-3d;\r\n  transform-origin: 0 0;\r\n  transform-style: flat;\r\n}\r\n.noUi-connect {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.noUi-origin {\r\n  height: 10%;\r\n  width: 10%;\r\n}\r\n/* Offset direction\r\n */\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\r\n  left: auto;\r\n  right: 0;\r\n}\r\n/* Give origins 0 height/width so they don't interfere with clicking the\r\n * connect elements.\r\n */\r\n.noUi-vertical .noUi-origin {\r\n  width: 0;\r\n}\r\n.noUi-horizontal .noUi-origin {\r\n  height: 0;\r\n}\r\n.noUi-handle {\r\n  -webkit-backface-visibility: hidden;\r\n  backface-visibility: hidden;\r\n  position: absolute;\r\n  outline: none;\r\n}\r\n.noUi-touch-area {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n.noUi-state-tap .noUi-connect,\r\n.noUi-state-tap .noUi-origin {\r\n  -webkit-transition: transform 0.3s;\r\n  transition: transform 0.3s;\r\n}\r\n.noUi-state-drag * {\r\n  cursor: inherit !important;\r\n}\r\n/* Slider size and handle placement;\r\n */\r\n.noUi-horizontal {\r\n  height: 1px;\r\n}\r\n.noUi-horizontal .noUi-handle {\r\n  width: 15px;\r\n  height: 15px;\r\n  left: -7px;\r\n  top: -6px;\r\n  border-radius: 50%;\r\n}\r\n.noUi-vertical {\r\n  width: 18px;\r\n}\r\n.noUi-vertical .noUi-handle {\r\n  width: 15px;\r\n  height: 15px;\r\n  left: 0px;\r\n  top: -7px;\r\n}\r\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\r\n  right: -7px;\r\n  left: auto;\r\n}\r\n/* Styling;\r\n * Giving the connect element a border radius causes issues with using transform: scale\r\n */\r\n.noUi-target {\r\n  background-color: rgba(182, 182, 182, 0.3);\r\n  border-radius: 3px;\r\n}\r\n.noUi-connects {\r\n  border-radius: 3px;\r\n}\r\n.noUi-connect {\r\n  background: #3FB8AF;\r\n}\r\n/* Handles and cursors;\r\n */\r\n.noUi-draggable {\r\n  cursor: ew-resize;\r\n}\r\n.noUi-vertical .noUi-draggable {\r\n  cursor: ns-resize;\r\n}\r\n.noUi-handle {\r\n  border-radius: 3px;\r\n  background: #FFF;\r\n  cursor: default;\r\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;\r\n}\r\n.noUi-active {\r\n  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\r\n}\r\n/* Disabled state;\r\n */\r\n[disabled] .noUi-connect {\r\n  background: #B8B8B8;\r\n}\r\n[disabled].noUi-target,\r\n[disabled].noUi-handle,\r\n[disabled] .noUi-handle {\r\n  cursor: not-allowed;\r\n}\r\n/* Base;\r\n *\r\n */\r\n.noUi-pips,\r\n.noUi-pips * {\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n.noUi-pips {\r\n  position: absolute;\r\n  color: #999;\r\n}\r\n/* Values;\r\n *\r\n */\r\n.noUi-value {\r\n  position: absolute;\r\n  white-space: nowrap;\r\n  text-align: center;\r\n}\r\n.noUi-value-sub {\r\n  color: #ccc;\r\n  font-size: 10px;\r\n}\r\n/* Markings;\r\n *\r\n */\r\n.noUi-marker {\r\n  position: absolute;\r\n  background: #CCC;\r\n}\r\n.noUi-marker-sub {\r\n  background: #AAA;\r\n}\r\n.noUi-marker-large {\r\n  background: #AAA;\r\n}\r\n/* Horizontal layout;\r\n *\r\n */\r\n.noUi-pips-horizontal {\r\n  padding: 10px 0;\r\n  height: 80px;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n}\r\n.noUi-value-horizontal {\r\n  -webkit-transform: translate(-50%, 50%);\r\n  transform: translate(-50%, 50%);\r\n}\r\n.noUi-rtl .noUi-value-horizontal {\r\n  -webkit-transform: translate(50%, 50%);\r\n  transform: translate(50%, 50%);\r\n}\r\n.noUi-marker-horizontal.noUi-marker {\r\n  margin-left: -1px;\r\n  width: 2px;\r\n  height: 5px;\r\n}\r\n.noUi-marker-horizontal.noUi-marker-sub {\r\n  height: 10px;\r\n}\r\n.noUi-marker-horizontal.noUi-marker-large {\r\n  height: 15px;\r\n}\r\n/* Vertical layout;\r\n *\r\n */\r\n.noUi-pips-vertical {\r\n  padding: 0 10px;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 100%;\r\n}\r\n.noUi-value-vertical {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  padding-left: 25px;\r\n}\r\n.noUi-rtl .noUi-value-vertical {\r\n  -webkit-transform: translate(0, 50%);\r\n  transform: translate(0, 50%);\r\n}\r\n.noUi-marker-vertical.noUi-marker {\r\n  width: 5px;\r\n  height: 2px;\r\n  margin-top: -1px;\r\n}\r\n.noUi-marker-vertical.noUi-marker-sub {\r\n  width: 10px;\r\n}\r\n.noUi-marker-vertical.noUi-marker-large {\r\n  width: 15px;\r\n}\r\n.noUi-tooltip {\r\n  display: block;\r\n  position: absolute;\r\n  border: 1px solid #D9D9D9;\r\n  border-radius: 3px;\r\n  background: #fff;\r\n  color: #000;\r\n  padding: 5px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n.noUi-horizontal .noUi-tooltip {\r\n  -webkit-transform: translate(-50%, 0);\r\n  transform: translate(-50%, 0);\r\n  left: 50%;\r\n  bottom: 120%;\r\n}\r\n.noUi-vertical .noUi-tooltip {\r\n  -webkit-transform: translate(0, -50%);\r\n  transform: translate(0, -50%);\r\n  top: 50%;\r\n  right: 120%;\r\n}\r\n","/*!\r\n* https://github.com/YouCanBookMe/react-datetime\r\n*/\r\n.rdt {\r\n  position: relative;\r\n  .rdtPicker{\r\n    -webkit-transition: all 150ms linear;\r\n    -moz-transition: all 150ms linear;\r\n    -o-transition: all 150ms linear;\r\n    -ms-transition: all 150ms linear;\r\n    transition: all 150ms linear;\r\n    margin-top: -20px;\r\n    visibility: hidden;\r\n    display: block;\r\n    opacity: 0;\r\n  }\r\n  &.rdtOpen{\r\n    .rdtPicker{\r\n      opacity: 1;\r\n      visibility: visible;\r\n      margin-top: 0;\r\n    }\r\n  }\r\n}\r\n.rdtPicker {\r\n  display: none;\r\n  position: absolute;\r\n  width: 260px;\r\n  padding: 4px;\r\n  margin-top: 1px;\r\n  z-index: 99999 !important;\r\n  background: #fff;\r\n  border-radius: 0.125rem;\r\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n  -webkit-background-clip: padding-box;\r\n  background-clip: padding-box;\r\n  min-width: 160px;\r\n\r\n  &:before{\r\n    display: inline-block;\r\n    position: absolute;\r\n    width: 0;\r\n    height: 0;\r\n    vertical-align: middle;\r\n    content: \"\";\r\n    top: -5px;\r\n    left: 10px;\r\n    right: auto;\r\n    color: #FFFFFF;\r\n    border-bottom: .4em solid;\r\n    border-right: .4em solid transparent;\r\n    border-left: .4em solid transparent;\r\n  }\r\n  &:after{\r\n    border-bottom: .4em solid #FFFFFF;\r\n    border-right: .4em solid transparent;\r\n    border-left: .4em solid transparent;\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: -5px;\r\n    left: 10px;\r\n  }\r\n}\r\n\r\n.rdtPicker {\r\n  display: block;\r\n  top: 40px;\r\n}\r\n.rdtStatic .rdtPicker {\r\n  box-shadow: none;\r\n  position: static;\r\n}\r\n\r\n.rdtPicker .rdtTimeToggle {\r\n  text-align: center;\r\n  padding: 5px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.rdtPicker table {\r\n  width: 100%;\r\n  margin: 0;\r\n  border-color: $white-color !important;\r\n}\r\n.rdtPicker td,\r\n.rdtPicker th {\r\n  text-align: center;\r\n  padding: 1px;\r\n}\r\n.rdtPicker td {\r\n  cursor: pointer;\r\n}\r\n.rdtDay{\r\n  height: 30px;\r\n  line-height: 33px;\r\n  width: 30px;\r\n  text-align: center;\r\n  padding: 0px;\r\n  border-radius: 50%;\r\n  &.rdtToday.rdtActive,\r\n  &.rdtActive,\r\n  &.rdtActive:hover {\r\n    background-color: $primary-color !important;\r\n    color: $white-color;\r\n  }\r\n}\r\n.rdtDays{\r\n  tr{\r\n    .dow{\r\n      text-align: center;\r\n      border-bottom: 1px solid #E3E3E3;\r\n      font-size: 12px;\r\n      text-transform: uppercase;\r\n      font-weight: inherit;\r\n      padding-bottom: 5px;\r\n      padding-top: 10px;\r\n    }\r\n    .rdtOld,\r\n    .rdtNew{\r\n      color: $medium-gray;\r\n    }\r\n  }\r\n}\r\n\r\n.rdtPicker td.rdtDay:hover,\r\n.rdtPicker td.rdtHour:hover,\r\n.rdtPicker td.rdtMinute:hover,\r\n.rdtPicker td.rdtSecond:hover,\r\n.rdtPicker .rdtTimeToggle:hover {\r\n  background: #eeeeee;\r\n  cursor: pointer;\r\n}\r\n.rdtPicker td.rdtToday {\r\n  position: relative;\r\n}\r\n.rdtPicker td.rdtActive.rdtToday:before {\r\n  border-bottom-color: #fff;\r\n}\r\n.rdtPicker td.rdtDisabled,\r\n.rdtPicker td.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.rdtPicker td span.rdtOld {\r\n  color: #999999;\r\n}\r\n.rdtPicker td span.rdtDisabled,\r\n.rdtPicker td span.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n.rdtPicker .dow {\r\n  width: 14.2857%;\r\n  border-bottom: none;\r\n}\r\n.rdtPicker th.rdtSwitch {\r\n  width: 50px;\r\n  padding: 5px;\r\n  border-radius: 4px;\r\n}\r\n.rdtPicker th.rdtNext,\r\n.rdtPicker th.rdtPrev {\r\n  font-size: 21px;\r\n  vertical-align: top;\r\n  border-radius: 50%;\r\n  line-height: 33px;\r\n}\r\n\r\n.rdtPicker{\r\n  .dow,\r\n  th.rdtSwitch,\r\n  th.rdtNext,\r\n  th.rdtPrev,\r\n  .rdtTimeToggle{\r\n    color: $primary-color;\r\n  }\r\n}\r\n\r\n\r\n.rdtPrev span,\r\n.rdtNext span {\r\n  display: block;\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none;   /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none;    /* Konqueror */\r\n  -moz-user-select: none;      /* Firefox */\r\n  -ms-user-select: none;       /* Internet Explorer/Edge */\r\n  user-select: none;\r\n\r\n}\r\n\r\n.rdtPicker th.rdtDisabled,\r\n.rdtPicker th.rdtDisabled:hover {\r\n  background: none;\r\n  color: #999999;\r\n  cursor: not-allowed;\r\n}\r\n.rdtPicker thead tr:first-child th {\r\n  cursor: pointer;\r\n}\r\n.rdtPicker thead tr:first-child th:hover {\r\n  background: #eeeeee;\r\n}\r\n\r\n\r\n.rdtPicker button {\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n}\r\n.rdtPicker button:hover {\r\n  background-color: #eee;\r\n}\r\n\r\n.rdtPicker thead button {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\ntd.rdtMonth,\r\ntd.rdtYear {\r\n  height: 50px;\r\n  width: 25%;\r\n  cursor: pointer;\r\n}\r\ntd.rdtMonth:hover,\r\ntd.rdtYear:hover {\r\n  background: #eee;\r\n}\r\n\r\n.rdtCounters {\r\n  display: inline-block;\r\n}\r\n\r\n.rdtCounters{\r\n  > div {\r\n    float: left;\r\n    width: 40px;\r\n    font-weight: inherit;\r\n    margin: 3px;\r\n    border-radius: 50%;\r\n  }\r\n  .rdtCounterSeparator{\r\n    width: 0;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n\r\n.rdtCounter {\r\n  height: 100px;\r\n}\r\n\r\n.rdtCounter {\r\n  width: 40px;\r\n  .rdtCount{\r\n    padding: 7px;\r\n    height: 40px;\r\n    border: 1px solid transparent;\r\n  }\r\n}\r\n.rdtCounters{\r\n  .rdtCounter:last-child{\r\n    .rdtCount{\r\n      color: $primary-color;\r\n      border-radius: 50%;\r\n      border: 1px solid $primary-color;\r\n    }\r\n  }\r\n}\r\n\r\n.rdtCounterSeparator {\r\n  padding: 7px;\r\n  line-height: 100px;\r\n}\r\n.rdtCounter .rdtBtn {\r\n  line-height: 40px;\r\n  cursor: pointer;\r\n  display: block;\r\n  border-radius: 50%;\r\n  color: $medium-gray;\r\n  -webkit-transition: all 60ms ease-in;\r\n  -moz-transition: all 60ms ease-in;\r\n  -o-transition: all 60ms ease-in;\r\n  -ms-transition: all 60ms ease-in;\r\n  transition: all 60ms ease-in;\r\n\r\n\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none;   /* Chrome/Safari/Opera */\r\n  -khtml-user-select: none;    /* Konqueror */\r\n  -moz-user-select: none;      /* Firefox */\r\n  -ms-user-select: none;       /* Internet Explorer/Edge */\r\n  user-select: none;\r\n}\r\n.rdtCounter .rdtBtn:hover {\r\n  background: #eee;\r\n  color: #797979;\r\n}\r\n.rdtCounter .rdtCount {\r\n  font-size: inherit;\r\n  line-height: 25px;\r\n}\r\n\r\n.rdtMilli {\r\n  vertical-align: middle;\r\n  padding-left: 8px;\r\n  width: 48px;\r\n}\r\n\r\n.rdtMilli input {\r\n  width: 100%;\r\n  font-size: inherit;\r\n  margin-top: 37px;\r\n}\r\n.rdtMonths,\r\n.rdtYears{\r\n  padding-bottom: 10px;\r\n  .rdtMonth,\r\n  .rdtYear{\r\n    display: inline-block;\r\n    width: 56px;\r\n    height: 56px;\r\n    line-height: 56px;\r\n    margin: 3px 3px;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n\r\n    &.rdtActive{\r\n      background-color: $primary-color !important;\r\n      color: $white-color;\r\n    }\r\n  }\r\n}\r\n\r\n.form-group .rdt {\r\n  margin-bottom: 0;\r\n  flex: 1 1 auto;\r\n  width: 1%;\r\n}\r\n\r\n.input-group .input-group-prepend + .rdt .form-control {\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n  border-left: 0;\r\n  padding-left: 0;\r\n  border-right: 1px solid $medium-gray;\r\n}\r\n\r\n.input-group>.rdt:not(:last-child) .form-control {\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n  border-right: 0;\r\n  padding-right: 0;\r\n  border-left: 1px solid $medium-gray;\r\n  padding-left: .75rem;\r\n}\r\n",".dropdown {\r\n  .dropdown-menu{\r\n    &[x-placement=\"top-start\"]{\r\n      @include transform-translate-y-dropdown(0px);\r\n\r\n    }\r\n    &[x-placement=\"bottom-start\"]{\r\n      @include transform-translate-y-dropdown(0px);\r\n    }\r\n  }\r\n\r\n  &.show .dropdown-menu{\r\n    &[x-placement=\"top-start\"]{\r\n      @include transform-translate-y-dropdown(-50px);\r\n      top: auto !important;\r\n      bottom: 0 !important;\r\n    }\r\n    &[x-placement=\"bottom-start\"]{\r\n      @include transform-translate-y-dropdown(40px);\r\n      bottom: auto !important;\r\n      top: 0 !important;\r\n    }\r\n  }\r\n}\r\n",".input-group .input-group-append .input-group-text {\r\n  border-right: 1px solid $medium-gray;\r\n}\r\n","@media screen and (max-width: 991px) {\r\n  .navbar-collapse {\r\n    height: 100% !important;\r\n  }\r\n}\r\n","@media screen and (max-width: 320px){\r\n  .index {\r\n    .presentation-subtitle {\r\n      margin-bottom: 100px;\r\n    }\r\n    .category.category-absolute {\r\n      margin-top: 20px;\r\n    }\r\n  }\r\n}\r\n@media screen and (max-width: 374px){\r\n  .index {\r\n    .presentation-subtitle {\r\n      margin-bottom: 100px;\r\n    }\r\n  }\r\n  nav[aria-label=\"pagination\"] {\r\n    justify-content: center;\r\n    text-align: center;\r\n    .pagination {\r\n      display: inline-block;\r\n      .page-item {\r\n        margin-bottom: 5px;\r\n      }\r\n    }\r\n  }\r\n  .register-page .page-header .container {\r\n    margin-top: 7rem!important;\r\n  }\r\n}\r\n",".custom-switch {\r\n  padding-left: 3.25rem;\r\n  min-height: 2rem;\r\n  display: flex;\r\n  .custom-control-label {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    &::after {\r\n      height: calc(1.625rem - 4px);\r\n      width: calc(1.625rem - 4px);\r\n      left: calc(-3.25rem + 2px);\r\n      border-radius: 2.5rem;\r\n      background-color: white;\r\n    }\r\n    &::before {\r\n      height: 1.625rem;\r\n      width: 3rem;\r\n      left: -3.25rem;\r\n      border-radius: 2.5rem;\r\n      background-color: #adb5bd;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::after {\r\n      transform: translateX(1.35rem);\r\n    }\r\n    &::before {\r\n      background-color: $info-color;\r\n      border-color: $info-color;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      // background-color: $info-color;\r\n    }\r\n  }\r\n}\r\n",".popover {\r\n  box-shadow: 0 10px 50px 0 rgba(0,0,0,.2);\r\n  z-index: 1050;\r\n}\r\n.bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {\r\n  border-left-color: rgba(0,0,0,.25);\r\n}\r\n.bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {\r\n  border-top-color: rgba(0,0,0,.25);\r\n}\r\n.bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {\r\n  border-right-color: rgba(0,0,0,.25);\r\n}\r\n.bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {\r\n  border-bottom-color: rgba(0,0,0,.25);\r\n}\r\n.bs-tooltip-auto[x-placement^=top] .arrow::after, .bs-tooltip-top .arrow::after,\r\n.bs-tooltip-auto[x-placement^=left] .arrow::after, .bs-tooltip-left .arrow::after,\r\n.bs-tooltip-auto[x-placement^=right] .arrow::after, .bs-tooltip-right .arrow::after,\r\n.bs-tooltip-auto[x-placement^=bottom] .arrow::after, .bs-tooltip-bottom .arrow::after {\r\n  position: absolute;\r\n  display: block;\r\n  content: \"\";\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n.bs-tooltip-auto[x-placement^=left] .arrow::after, .bs-tooltip-left .arrow::after {\r\n  right: 1px;\r\n  border-width: .4rem 0 .4rem .4rem;\r\n  border-left-color: #fff;\r\n}\r\n.bs-tooltip-auto[x-placement^=top] .arrow::after, .bs-tooltip-top .arrow::after {\r\n  bottom: 1px;\r\n  border-width: .4rem .4rem 0;\r\n  border-top-color: #fff;\r\n}\r\n.bs-tooltip-auto[x-placement^=right] .arrow::after, .bs-tooltip-right .arrow::after {\r\n  left: 1px;\r\n  border-width: .4rem .4rem .4rem 0;\r\n  border-right-color: #fff;\r\n}\r\n.bs-tooltip-auto[x-placement^=bottom] .arrow::after, .bs-tooltip-bottom .arrow::after {\r\n  top: 1px;\r\n  border-width: 0 .4rem .4rem .4rem;\r\n  border-bottom-color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
